/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54ed94d9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54ed94d9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"e59bd929-fbe6-4ce6-914c-3c5c7bcfc20b","title":"Informações sobre a impressora","link":"finding-information-about-printer-topic.html","desc":"Localizando informações sobre a impressora","descFull":"Localizando informações sobre a impressora Recursos e onde encontrá-los O que você está procurando? Encontre aqui Instruções de configuração inicial Consulte a documentação de configuração fornecida com a impressora. Software da impressora Driver de impressão ou de fax Firmware da impressora Utilitário Acesse  www.lexmark.com/downloads , procure o modelo da impressora e, no menu Tipo, selecione o driver, o firmware ou o utilitário de que você precisa. Selecionando e armazenando papéis e mídias especiais Carregamento de papel Configurando as definições da impressora Exibindo e imprimindo documentos e fotografias Configurando a impressora na rede Cuidados e manutenção da impressora Solucionando problemas Centro de Informações – acesse  https://infoserve.lexmark.com . Vídeos instrucionais – acesse  https://infoserve.lexmark.com/idv/ . Guia na Tela Sensível ao Toque —Acesse  http://support.lexmark.com . Como configurar e definir os recursos de acessibilidade da impressora Guia de acessibilidade da Lexmark —Acesse  http://support.lexmark.com . Informações de ajuda para uso do software da impressora. Ajuda para os sistemas operacionais Microsoft Windows ou Macintosh - Abra o aplicativo ou programa de software da impressora e clique em  Ajuda . Clique em   para visualizar as informações contextuais. A ajuda é instalada automaticamente com o software da impressora. Dependendo do sistema operacional, o software da impressora estará localizado na pasta de programas da impressora ou na área de trabalho. Documentação Suporte via bate-papo em tempo real Suporte via e-mail Suporte a voz Acesse  http://support.lexmark.com . Selecione seu país ou sua região e depois seu produto para ver o site de suporte apropriado. Você pode encontrar informações de contato de suporte para sua região ou seu país no site ou na garantia impressa fornecida com a impressora. Tenha em mãos as seguintes informações ao entrar em contato com o suporte ao cliente: Local e a data da compra Tipo de máquina e número de série Para mais informações, consulte  . Informações sobre segurança Informações regulamentares Informações sobre garantia Informações ambientais As informações de garantia variam de acordo com o país ou região: Nos EUA — Consulte a Declaração de garantia limitada que acompanha a impressora ou acesse  http://support.lexmark.com . Em outros países e regiões — Consulte a garantia impressa que acompanha a impressora. Guia de informações do produto —Consulte a documentação fornecida com a impressora ou acesse  http://support.lexmark.com . Informações sobre o passaporte digital da Lexmark Acesse  https://csr.lexmark.com/digital-passport.php . informações da impressora localização localização de informações sobre a impressora"},{"UUID":"32b64da1-5ac7-41f6-a23c-6a39c7ee123e","title":"Informações sobre a impressora","link":"finding-printer-serial-number-topic.html","desc":"Localização do número de série","descFull":"Localização do número de série da impressora Abra a porta frontal. Localize o número de série no lado esquerdo da impressora. localização do número de série da impressora número de série, impressora localização"},{"UUID":"e0089783-d2c2-4cde-991b-6f8b13ffd78c","title":"Informações sobre a impressora","link":"printer-configurations-topic.html","desc":"Configurações da impressora Certifique-se de","descFull":"Configurações da impressora Certifique-se de configurar a impressora em uma superfície plana, firme e estável. Modelo básico Peças do modelo básico de impressora 1 Alimentador Automático de Documentos (ADF) 2 Bandeja do ADF 3 Bandeja do ADF 4 Bandeja padrão 5 Bandeja padrão para 520 folhas 6 Alimentador multiúso 7 Painel de controle Modelo configurado A instalação de uma ou mais opções em sua impressora ou MFP pode exigir uma base com rodinhas, mobília ou outro recurso para evitar instabilidades que causem possíveis lesões. Para obter mais informações sobre configurações compatíveis, visite o site  www.lexmark.com/multifunctionprinters . A instalação de uma ou mais opções em sua impressora ou MFP pode exigir uma base com rodinhas, mobília ou outro recurso para evitar instabilidades que causem possíveis lesões. Para obter mais informações sobre configurações compatíveis, entre em contato com o local em que você adquiriu a impressora. Para reduzir o risco de instabilidade do equipamento, carregue cada bandeja separadamente. Mantenha todas as outras bandejas fechadas até serem necessárias. Peças do modelo de impressora configurada 1 Encadernador Não suportado se outro encadernador estiver instalado. 2 Bandeja padrão para 520 folhas 3 Bandeja opcional para 3 x 520 folhas 4 Encadernador, perfurador Compatível somente se bandejas opcionais estiverem instaladas. 5 Bandeja dupla opcional para 2520 folhas 6 Bandeja opcional para 2000 folhas Talvez nem todas as opções estejam disponíveis. Para obter mais informações, entre em contato com o local em que você adquiriu a impressora. configurações da impressora configuração básica da impressora impressora totalmente configurada"},{"UUID":"ebced178-3755-41c4-aa95-b8ef8ea1d2cc","title":"Informações sobre a impressora","link":"using-control-panel-topic.html","desc":"Uso do painel de controle","descFull":"Uso do painel de controle Partes e funções do painel de controle Parte do painel de controle Função 1 Botão Liga/Desliga Ligar ou desligar a impressora. para desligar a impressora, mantenha o botão Liga/Desliga pressionado por cinco segundos. Ajustar a impressora para o modo de Suspensão ou Hibernação. Tirar a impressora do modo de Suspensão ou Hibernação. 2 Exibir Exibir as mensagens da impressora e o status dos suprimentos. Configurar e operar a impressora. 3 Luz indicadora Verificar o status da impressora. painel de controle uso como usar o painel de controle"},{"UUID":"867b3133-e6ab-4e6a-8663-1764bde55b59","title":"Informações sobre a impressora","link":"understanding-status-of-power-button-and-indicator-light-topic.html","desc":"Compreendendo o status da luz","descFull":"Compreendendo o status da luz indicadora A cor da luz indicadora e o correspondente status da impressora Luz indicadora Status da impressora Desativado A impressora está desligada. Azul sólido A impressora está pronta. Azul intermitente A impressora está imprimindo ou processando dados. Vermelho piscando A impressora exigir intervenção do usuário. Âmbar sólido A impressora está no modo de suspensão. Pisca em âmbar A impressora está no modo de suspensão profunda ou de hibernação. luz indicadora noções básicas sobre o status status da impressora"},{"UUID":"cfe79b2d-8ff1-4442-8346-8e515046e86f","title":"Como selecionar o papel","link":"selecting-paper-group.html","desc":"Diretrizes de papel O uso","descFull":"Diretrizes de papel O uso do papel apropriado evita atolamentos e ajuda a garantir uma impressão livre de problemas. Sempre use mídia nova e que não esteja danificada. Antes de carregar o papel, saiba o lado de impressão recomendado. Essa informação está normalmente indicada no pacote da mídia. Não use papel que tenha sido cortado ou aparado à mão. Não misture tamanhos, pesos ou tipos de papel diferentes na mesma bandeja; a mistura causa atolamentos. Não use mídias revestidas, a menos que tenham sido projetadas especificamente para impressão eletrofotográfica. Para obter mais informações, consulte o  Guia de papel e mídia especial . papel seleção instruções sobre papel"},{"UUID":"e2cbe7a1-5f6b-4653-bfc4-2c3a02240520","title":"Como selecionar o papel","link":"selecting-paper-group.html","desc":"Características do papel As seguintes","descFull":"Características do papel As seguintes características do papel afetam a qualidade e a confiabilidade da impressão. Considere estes fatores antes de imprimir. Peso As bandejas podem alimentar papel de pesos variados. O papel com peso inferior a 60 g/m 2  (16 lb) pode não ser firme o suficiente para ser alimentado adequadamente e poderá causar atolamentos. Para obter mais informações, consulte o tópico \"Pesos de papel suportados\". Curva Curva é a tendência do papel de se curvar nas bordas. Curvas excessivas podem causar problemas na alimentação de papel. As curvas podem ocorrer depois que o papel passa pela impressora, onde é exposto a altas temperaturas. O armazenamento do papel fora da embalagem em condições de calor, umidade, frio ou ar seco pode contribuir para a ocorrência de curvas antes da impressão, podendo causar problemas de alimentação. Lisura A lisura do papel afeta diretamente a qualidade da impressão. Se o papel for muito áspero, o toner não se fundirá no papel adequadamente. Se o papel for liso demais, poderá causar problemas de alimentação ou qualidade de impressão. Recomendamos o uso de papel com 50 pontos Sheffield. Conteúdo de umidade A quantidade de umidade no papel afeta a qualidade de impressão e a capacidade da impressora de alimentar o papel adequadamente. Mantenha o papel na embalagem original até usá-lo. A exposição do papel a variações de umidade pode degradar seu desempenho. Antes de imprimir, armazene o papel em sua embalagem original entre 24 e 48 horas. O ambiente no qual o papel está armazenado deve ser o mesmo da impressora. Prolongue o tempo para vários dias se o ambiente de armazenamento ou transporte for muito diferente do ambiente da impressora. O papel espesso também pode exigir um período de condicionamento mais longo. Direção das fibras As fibras referem-se ao alinhamento das fibras do papel em uma folha. O papel pode ter  fibras longas , que se estendem ao longo do comprimento do papel, ou  fibras curtas , que se estendem ao longo da largura do papel. Para obter a direção recomendada das fibras, consulte o tópico \"pesos de papel suportados\". Conteúdo de fibras A maior parte do papel xerográfico de alta qualidade é feita de madeira em polpa 100% tratada quimicamente. Esse conteúdo confere ao papel um alto grau de estabilidade, resultando em menos problemas de alimentação e melhor qualidade de impressão. O papel que contém fibras, como as de algodão, pode dificultar o manuseio. características do papel"},{"UUID":"71eeab66-f5eb-4204-9402-e7f45a363a01","title":"Como selecionar o papel","link":"selecting-paper-group.html","desc":"Papel inaceitável Os tipos de","descFull":"Papel inaceitável Os tipos de mídia a seguir não são recomendados para uso na impressora: Papéis quimicamente tratados que são usados para fazer cópias sem papel carbono. Eles também são conhecidos como papéis sem carbono, papel comum sem carbono (CCP) ou papel sem necessidade de carbono (NCR). Mídias pré-impressas com elementos químicos que possam contaminar a impressora. Papéis pré-impressos que possam ser afetados pela temperatura no fusor da impressora. Papéis pré-impressos que exijam um registro (a exata localização da impressão na página) superior a ±2,3 mm (±0,09 pol.). Por exemplo, formulários de reconhecimento óptico de caracteres (OCR). Às vezes, o registro pode ser ajustado com um aplicativo de software para imprimir nesses formulários com êxito. Papéis revestidos (bond apagáveis), sintéticos e térmicos. Papéis com bordas ásperas, papéis ásperos ou altamente texturizados ou papéis com curvas. Papéis reciclados em desacordo com a norma (europeia) EN12281:2002. Papéis com peso inferior a 60g/m 2  (16lb). Formulários ou documentos com várias vias. papel inaceitável"},{"UUID":"01beb0ac-697a-4c42-a19e-a7bee0a64537","title":"Como selecionar o papel","link":"selecting-paper-group.html","desc":"Armazenamento do papel Use estas","descFull":"Armazenamento do papel Use estas diretrizes de armazenamento de papel para ajudar a evitar atolamentos e qualidade de impressão irregular: Condicione o papel antes da impressão armazenando-o em sua embalagem original no mesmo ambiente da impressora por 24 a 48 horas. Prolongue o tempo para vários dias se o ambiente de armazenamento ou transporte for muito diferente do ambiente da impressora. O papel espesso também pode exigir um período de condicionamento mais longo. Para obter os melhores resultados, armazene o papel em um local onde a temperatura seja de 21°C (70°F) e a umidade relativa do ar seja de 40%. A maioria dos fabricantes de etiquetas recomenda a impressão em um intervalo de temperatura de 18 a 24°C (65 a 75°F), com umidade relativa do ar de 40 a 60%. Armazene o papel em caixas e sobre um pallet ou uma prateleira, ao invés de no chão. Armazene os pacotes individuais sobre uma superfície plana. Não armazene nenhum objeto sobre os pacotes de papel individuais. Retire o papel da caixa ou da embalagem somente quando estiver pronto para carregá-lo na impressora. A caixa e a embalagem ajudam a manter o papel limpo, seco e plano. armazenamento do papel"},{"UUID":"d7ddff49-8b1a-4a08-8b88-a035a5a1d95a","title":"Como selecionar o papel","link":"selecting-paper-group.html","desc":"Seleção de formulários pré-impressos e","descFull":"Seleção de formulários pré-impressos e papel timbrado Use papel com fibras longas. Use somente formulários e papel timbrado impressos por meio de um processo offset litográfico ou gravado. Evite papéis com superfícies ásperas ou excessivamente texturizadas. Use tintas que não sejam afetadas pela resina contida no toner. As tintas definidas por oxidação ou à base de óleo geralmente atendem a esses requisitos; as tintas látex podem não atender. Imprima amostras nos papeis timbrados e formulários pré-impressos que pretende usar antes de comprar grandes quantidades. Essa ação determina se a tinta no formulário ou papel timbrado pré-impresso afetará a qualidade da impressão. Em caso de dúvida, entre em contato com o fornecedor do papel. Ao imprimir em papel timbrado, coloque o papel na orientação correta para a sua impressora. Para obter mais informações, consulte o  Guia de papel e mídia especial . papel formulários pré-impressos formulários pré-impressos seleção papel papel timbrado papel timbrado seleção"},{"UUID":"c3bb1bd8-ee95-4b25-8ecc-19d160f9e783","title":"Como selecionar o papel","link":"selecting-paper-group.html","desc":"Tamanhos de papel compatíveis Tamanhos","descFull":"Tamanhos de papel compatíveis Tamanhos de papel compatíveis com a bandeja padrão, MPF, bandeja de envelopes e impressão em frente e verso Tamanho do papel Bandeja padrão para 520 folhas Alimentador multiúso Bandeja de envelope Impressão em frente e verso 1  Carrega apenas na orientação de borda curta. 2  Carrega apenas na orientação de borda longa. 3  Suporta tamanhos de papel que variam de 139,7 x 181,86 mm (5,5 x 7,16 pol.) a 296,93 x 431,8 mm (11,69 x 17 pol.). 4  Suporta tamanhos de papel que variam de 88,9 x 98,38 mm (3,5 x 3,87 pol.) a 296,93 x 482,6 mm (11,69 x 19 pol.). 5  Suporta tamanhos de papel que variam de 128 x 139,7 mm (5 x 5,5 pol.) a 296,93 x 482,6 mm (11,69 x 19 pol.). A3 1 297 x 420 mm (11,69 x 16,54 pol.) X A4 210 x 297 mm (8,27 x 11,7 pol.) 2 X A5 148 x 210 mm (5,83 x 8,27 pol.) 1 2 X A6 105 x 148 mm (4,13 x 5,83 pol.) X 1 X X Executivo 184,2 x 266,7 mm (7,25 x 10,5 pol.) 2 X Ofício 2 1 215,9 x 330,2 mm (8,5 x 13 pol.) X Hagaki 100 x 148 mm (3,94 x 5,83 pol.) X 1 X X JIS B4 1 257 x 364 mm (10,12 x 14,33 pol.) X JIS B5 182 x 257 mm (7,17 x 10,1 pol.) 2 X Ledger 1 279,4 x 4431,8 mm (11 x 17 pol.) X Ofício 1 215,9 x 355,6 mm (8,5 x 14 pol.) X Carta 215,9 x 279,4 mm (8,5 x 11 pol.) 2 X Ofício (México) 1 215,9 x 340,4 mm (8,5 x 13,4 pol.) X Statement 139,7 x 215,9 mm (5,5 x 8,5 pol.) 1 2 X Universal 3 4 X 5 Envelope 7 3/4 98,4 x 190,5 mm (3,875 x 7,5 pol.) X 2 X Envelope 9 98,4 x 225,4 mm (3,875 x 8,9 pol.) X 2 X Envelope 10 104,8 x 241,3 mm (4,12 x 9,5 pol.) X 2 X Envelope B5 176 x 250 mm (6,93 x 9,84 pol.) X 1 X Envelope C5 162 x 229 mm (6,38 x 9,01 pol.) X 2 X Envelope DL 110 x 220 mm (4,33 x 8,66 pol.) X 2 X O ADF suporta tamanhos de papel que variam de 125 x 85 mm (4,92 x 3,35 pol.) a 297 x 431,8 mm (11,69 x 17 pol.). O scanner de mesa suporta tamanho de papel máximo de 297 x 431,8 mm (11,69 x 17 pol.). Tamanhos de papel compatíveis com as bandejas opcionais Tamanho do papel Bandeja opcional para 520 folhas, bandeja opcional para 520 folhas com gabinete e bandeja opcional para 3 x 520 folhas Bandeja dupla opcional para 2520 folhas Bandeja opcional para 2000 folhas 1  Carrega apenas na orientação de borda curta. 2  Carrega apenas na orientação de borda longa. 3  Suporta tamanhos de papel que variam de 139,7 x 181,86 mm (5,5 x 7,16 pol.) a 296,93 x 431,8 mm (11,69 x 17 pol.). A3 1 297 x 420 mm (11,69 x 16,54 pol.) X A4 210 x 297 mm (8,27 x 11,7 pol.) 2 A5 1 148 x 210 mm (5,83 x 8,27 pol.) X A6 105 x 148 mm (4,13 x 5,83 pol.) X X X Executivo 184,2 x 266,7 mm (7,25 x 10,5 pol.) 2 Ofício 2 1 215,9 x 330,2 mm (8,5 x 13 pol.) X Hagaki 100 x 148 mm (3,94 x 5,83 pol.) X X X JIS B4 1 257 x 364 mm (10,12 x 14,33 pol.) X JIS B5 182 x 257 mm (7,17 x 10,1 pol.) 2 Ledger 1 279,4 x 4431,8 mm (11 x 17 pol.) X Ofício 1 215,9 x 355,6 mm (8,5 x 14 pol.) X Carta 215,9 x 279,4 mm (8,5 x 11 pol.) 2 Ofício (México) 1 215,9 x 340,4 mm (8,5 x 13,4 pol.) X Statement (US) 1 139,7 x 215,9 mm (5,5 x 8,5 pol.) X Universal 3 3 3 Envelope 7 3/4 98,4 x 190,5 mm (3,875 x 7,5 pol.) X X X Envelope 9 98,4 x 225,4 mm (3,875 x 8,9 pol.) X X X Envelope 10 104,8 x 241,3 mm (4,12 x 9,5 pol.) X X X Envelope B5 176 x 250 mm (6,93 x 9,84 pol.) X X X Envelope C5 162 x 229 mm (6,38 x 9,01 pol.) X X X Envelope DL 110 x 220 mm (4,33 x 8,66 pol.) X X X Tamanhos de papel compatíveis com as bandejas de saída Tamanho do papel Bandeja padrão Compartimento superior Empilhar Separação Empilhar 1  Carrega apenas na orientação de borda curta. 2  Carrega apenas na orientação de borda longa. 3  Suporta tamanhos de papel que variam de 88,9 x 98,38 mm (3,5 x 3,87 pol.) a 296,93 x 482,6 mm (11,69 x 19 pol.). 4  Suporta tamanhos de papel que variam de 88,9 x 98,38 mm (3,5 x 3,87 pol.) a 296,93 x 431,8 mm (11,69 x 17 pol.). A3 1 297 x 420 mm (11,69 x 16,54 pol.) A4 210 x 297 mm (8,27 x 11,7 pol.) A5 148 x 210 mm (5,83 x 8,27 pol.) A6 1 105 x 148 mm (4,13 x 5,83 pol.) Executivo 184,2 x 266,7 mm (7,25 x 10,5 pol.) Ofício 2 1 215,9 x 330,2 mm (8,5 x 13 pol.) Hagaki 1 100 x 148 mm (3,94 x 5,83 pol.) JIS B4 1 257 x 364 mm (10,12 x 14,33 pol.) JIS B5 182 x 257 mm (7,17 x 10,1 pol.) Ledger 1 279,4 x 4431,8 mm (11 x 17 pol.) Ofício 1 215,9 x 355,6 mm (8,5 x 14 pol.) Carta 215,9 x 279,4 mm (8,5 x 11 pol.) Ofício (México) 1 215,9 x 340,4 mm (8,5 x 13,4 pol.) Statement 139,7 x 215,9 mm (5,5 x 8,5 pol.) Universal 3 4 X Envelope 7 3/4 2 98,4 x 190,5 mm (3,875 x 7,5 pol.) Envelope 9 2 98,4 x 225,4 mm (3,875 x 8,9 pol.) Envelope 10 2 104,8 x 241,3 mm (4,12 x 9,5 pol.) Envelope B5 2 176 x 250 mm (6,93 x 9,84 pol.) Envelope C5 2 162 x 229 mm (6,38 x 9,01 pol.) Envelope DL 2 110 x 220 mm (4,33 x 8,66 pol.) Tamanhos de papel suportados pelos finalizadores Tamanho do papel Encadernador Encadernador, perfurador Empilhar Separação Grampear Empilhar Separação Grampear Perfuração 1  Carrega apenas na orientação de borda curta. 2  Carrega apenas na orientação de borda longa. 3  Suporta tamanhos de papel que variam de 88,9 x 98,38 mm (3,5 x 3,87 pol.) a 296,93 x 431,8 mm (11,69 x 17 pol.). 4  Suporta tamanhos de papel que variam de 190 x 139,7 mm (7,48 x 5,5 pol.) a 296,93 x 431,8 mm (11,69 x 17 pol.). 5  Suporta tamanhos de papel que variam de 202,9 x 182,03 mm (7,99 x 7,17 pol.) a 296,93 x 431,8 mm (11,69 x 17 pol.). 6  Suporta apenas até 2 furos. 7  Suporta apenas até 2 furos quando carregado na orientação pela borda curta. 8  Suporta tamanhos de papel que variam de 88,9 x 98,38 mm (3,5 x 3,87 pol.) a 320,04 x 1320,8 mm (12,6 x 52 pol.). 9  Suporta tamanhos de papel que variam de 209,97 x 148 mm (8,27 x 5,83 pol.) a 296,93 x 431,8 mm (11,69 x 17 pol.). A3 1 297 x 420 mm (11,69 x 16,54 pol.) A4 210 x 297 mm (8,27 x 11,7 pol.) A5 148 x 210 mm (5,83 x 8,27 pol.) 2 X 2 2 6 A6 105 x 148 mm (4,13 x 5,83 pol.) X X X X X Faixa Largura máxima: 215,9 mm (8,5 pol.) Extensão máxima: 1320,8 mm (52 pol.) 1 X X 1 X X X Executivo 184,2 x 266,7 mm (7,25 x 10,5 pol.) 2 2 2 2 2 2 Ofício 2 1 215,9 x 330,2 mm (8,5 x 13 pol.) Hagaki 100 x 148 mm (3,94 x 5,83 pol.) X X X X X JIS B4 1 257 x 364 mm (10,12 x 14,33 pol.) JIS B5 182 x 257 mm (7,17 x 10,1 pol.) 2 2 2 2 7 Ledger 1 279,4 x 4431,8 mm (11 x 17 pol.) Ofício 1 215,9 x 355,6 mm (8,5 x 14 pol.) Carta 215,9 x 279,4 mm (8,5 x 11 pol.) Ofício (México) 1 215,9 x 340,4 mm (8,5 x 13,4 pol.) Statement 139,7 x 215,9 mm (5,5 x 8,5 pol.) 2 X X X X X Universal 3 4 5 8 9 9 X Envelope 7 3/4 98,4 x 190,5 mm (3,875 x 7,5 pol.) X X X X X X Envelope 9 98,4 x 225,4 mm (3,875 x 8,9 pol.) X X X X X X Envelope 10 104,8 x 241,3 mm (4,12 x 9,5 pol.) X X X X X X Envelope B5 176 x 250 mm (6,93 x 9,84 pol.) 2 X X X X X X Envelope C5 162 x 229 mm (6,38 x 9,01 pol.) 1 X X X X X X Envelope DL 110 x 220 mm (4,33 x 8,66 pol.) X X X X X X tamanhos de papel compatíveis tamanhos de papel, suportados"},{"UUID":"5a9cd789-8f85-4a01-b26b-b15afde2803a","title":"Como selecionar o papel","link":"selecting-paper-group.html","desc":"Tipos de papel compatíveis Tipos","descFull":"Tipos de papel compatíveis Tipos de papel compatíveis Tipos de papel compatíveis com a bandeja padrão, MPF, bandeja de envelopes e impressão em frente e verso Tipo de papel Bandeja padrão para 520 folhas Alimentador multiúso Bandeja de envelope Impressão em frente e verso Encorpado X Cartão  X Papel colorido X Tipo personalizado X Envelope X X Brilhoso X Brilhoso pesado X Papel com alta gramatura X Etiquetas X X Papel timbrado X Papel com gramatura menor X Papel comum X Pré-impresso X Reciclado X Envelope áspero X X Algodão áspero X Etiquetas de vinil X X X X Tipos de papel compatíveis com as bandejas opcionais Tipo de papel Bandeja opcional para 520 folhas, bandeja opcional para 520 folhas com gabinete e bandeja opcional para 3 x 520 folhas Bandeja dupla opcional para 2520 folhas Bandeja opcional para 2000 folhas Encorpado Cartão  Papel colorido Tipo personalizado Envelope X X X Brilhoso Brilhoso pesado Papel com alta gramatura Etiquetas Papel timbrado Papel com gramatura menor Papel comum Pré-impresso Reciclado Envelope áspero X X X Algodão áspero Etiquetas de vinil X X X Tipos de papel compatíveis com as bandejas de saída Tipo de papel Bandeja padrão Compartimento superior Empilhar Separação Empilhar Encorpado Cartão  Papel colorido Tipo personalizado Envelope Brilhoso Brilhoso pesado Papel com alta gramatura Etiquetas Papel timbrado Papel com gramatura menor Papel comum Pré-impresso Reciclado Envelope áspero Algodão áspero Etiquetas de vinil X X X Tipos de papel suportados pelos finalizadores Tipo de papel Encadernador Encadernador, perfurador Empilhar Separação Grampear Empilhar Separação Grampear Perfuração Encorpado Cartão  X X Papel colorido Tipo personalizado Envelope X X X X X X Brilhoso Brilhoso pesado X X Papel com alta gramatura X X Etiquetas X X X X X Papel timbrado Papel com gramatura menor Papel comum Pré-impresso Reciclado Envelope áspero X X X X X X Algodão áspero X X Etiquetas de vinil X X X X X X X tipos de papel compatíveis tipos de papel compatíveis"},{"UUID":"089d836c-1103-4cd1-a8f4-ff8d574bbcf4","title":"Como selecionar o papel","link":"selecting-paper-group.html","desc":"Pesos de papel compatíveis Gramaturas","descFull":"Pesos de papel compatíveis Gramaturas de papel compatíveis com a impressora bandeja para 520 folhas, bandeja para 520 folhas com gabinete, bandeja para 3 x 520 folhas e bandeja dupla para 2520 folhas Alimentador multiúso Bandeja de envelope Bandeja opcional para 2000 folhas 60 a 256 g/m 2 (De 12 a 68 lb) 60 a 216 g/m 2 (De 12 a 57 lb) 75 a 90 g/m 2 (De 20 a 24 lb) 60 a 216 g/m 2 (De 12 a 57 lb) Para papel de 60 a 176 g/m 2  (16 a 47lb, encorpado), recomendam-se fibras longas. Papel com peso inferior a 75 g/m 2  (20lb, encorpado) deve ser impresso com  Tipo de papel  definido como  Papel leve . Caso contrário, o papel pode ser excessivamente curvado, o que pode causar problemas na alimentação, especialmente em ambientes mais úmidos. A impressão em frente e verso suporta papel com peso de 60 a 162 g/m 2  (de 16 a 43lb, encorpado). Conteúdo 100% algodão, o peso máximo é de 90 g/m 2  (24lb, encorpado). pesos de papel compatíveis pesos de papel compatíveis"},{"UUID":"52e39874-eb55-428a-8b8f-aa2fce66e731","title":"Instalação e configuração","link":"selecting-location-printer-topic.html","desc":"Seleção de um local para","descFull":"Seleção de um local para a impressora Deixe espaço suficiente para instalar opções de hardware e para abrir bandejas, tampas e portas. Instale a impressora perto de uma tomada elétrica. Para evitar o risco de incêndio ou choque elétrico, conecte o cabo de energia em uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja perto do produto. Para evitar risco de choque elétrico, não coloque ou use este produto perto da água ou em locais molhados. Verifique se o fluxo de ar no ambiente está de acordo com a última revisão da norma ASHRAE 62 ou da norma CEN/TC 156. Use uma superfície plana, firme e estável. Mantenha a impressora: Limpa, seca e livre de poeira. Longe de grampos e clipes de papel soltos. Longe da corrente de ar direta do ar-condicionado, da calefação ou dos ventiladores. Longe da luz direta do sol e da umidade excessiva. Observe as temperaturas recomendadas e evite variações: Temperaturas recomendadas Temperatura ambiente Temperatura de armazenamento Deixe a seguinte quantidade de espaço recomendado ao redor da impressora para obter a ventilação adequada: Espaços recomendados ao redor da impressora 1 Superior 2 Atrás 3 Lado direito 4 Frente 5 Lado esquerdo impressora seleção de um local para seleção de um local para a impressora impressora espaços livres mínimos transporte da impressora"},{"UUID":"1e395401-e4d3-4381-a6f7-ea056a308ce6","title":"Instalação e configuração","link":"attaching-cables-topic.html","desc":"Conectando os cabos Para evitar","descFull":"Conectando os cabos Para evitar o risco de choque elétrico, não instale este produto nem faça conexões elétricas ou a cabo, como recursos do fax, cabos de energia ou telefone, durante tempestades com relâmpago. Para evitar o risco de incêndio ou choque elétrico, conecte o cabo de energia em uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja perto do produto. Para evitar o risco de incêndio ou choque elétrico, utilize somente o cabo de energia fornecido com este produto ou um cabo de energia de substituição fornecido por um fabricante autorizado. Para reduzir o risco de incêndio, use apenas um cabo de 26 AWG ou um fio de telecomunicações (RJ-11) maior ao conectar o produto à rede de telefone pública conectada. Para os usuários na Austrália, o cabo deve ser aprovado pelo Australian Communications and Media Authority. Para evitar avaria ou perda de dados da impressora, não toque no cabo USB, em qualquer adaptador de rede sem fio ou em qualquer área exposta da impressora enquanto estiver imprimindo. Portas da impressora, soquetes e suas funções Porta da impressora Função 1 Porta USB Acoplar um teclado ou qualquer opcional compatível. 2 porta USB de impressora Conecta a impressora ao computador. 3 porta Ethernet Conectar a impressora à rede. 4 porta LINE Disponível somente quando uma placa de fax está instalada. Conecta a impressora à linha telefônica ativa por uma tomada padrão (RJ‑11), um filtro DSL, um adaptador VoIP ou qualquer outro adaptador que permita acessar a linha telefônica para enviar e receber fax. 5 Soquete do cabo de energia Conecte a impressora a uma tomada elétrica devidamente aterrada. conexão de cabos portas da impressora Cabo USB Cabo Ethernet Porta USB porta Ethernet soquete do cabo de alimentação."},{"UUID":"17cc742a-5c9a-4ac7-809f-196cda4f4967","title":"Configuração e uso dos aplicativos da tela inicial","link":"using-home-screen-topic.html","desc":"Usando a tela inicial Sua","descFull":"Usando a tela inicial Sua tela inicial pode variar dependendo de suas configurações personalizadas, de sua configuração administrativa e das soluções incorporadas ativas. Ícones e funções da tela inicial # Ícone Função 1 Botão Parar ou Cancelar Interromper o trabalho atual. 2 Cópia Fazer cópias 3 Alterar idioma Alterar o idioma no visor da impressora. 4 E-mail Enviar e-mails. 5 Configurações Acessar os menus da impressora. 6 Fax Enviar fax. 7 Catálogo de endereços Acessar, criar e organizar contatos. 8 Status/suprimentos Exibir um aviso ou mensagem de erro da impressora sempre que ela exigir intervenção para continuar o processo. Ver mais informações sobre avisos ou mensagens da impressora e como limpá-los. Você também pode acessar essa definição tocando na parte superior da tela inicial. 9 Trabalhos suspensos Exibir todos os trabalhos suspensos de impressão no momento. 10 Fila de trabalhos Exibir todos os trabalhos de impressão atuais. Você também pode acessar essa definição tocando na parte superior da tela inicial. 11 Unidade USB Exibir, selecionar ou imprimir fotografias e documentos de uma unidade flash. 12 Perfis de digitalização Digitalizar e salvar documentos diretamente no computador. 13 FTP Digitalizar e salvar documentos diretamente em um servidor de FTP. 14 Marcadores Organizar todos os marcadores. 15 Disco rígido Exibir, selecionar e gerenciar documentos de um disco rígido ou uma unidade de armazenamento inteligente. 16 Pasta de rede Digitalizar para uma pasta de rede ou para um local da rede. 17 Botão Iniciar Iniciar um trabalho, dependendo do modo selecionado. 18 Teclado na tela Digitar números ou símbolos em um campo de entrada. como usar a tela inicial tela inicial uso"},{"UUID":"5b27bcd2-4191-4219-8b8c-dbdb58d4b78f","title":"Configuração e uso dos aplicativos da tela inicial","link":"using-home-screen-topic.html","desc":"Personalização da tela inicial Abra","descFull":"Personalização da tela inicial Abra o navegador da Web e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido em quatro conjuntos de números separados por pontos, por exemplo: 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Clique em  Configurações Dispositivo Personalização da tela inicial . Execute uma ou mais das seguintes opções: Para adicionar um ícone à tela inicial, clique em  , selecione o nome do aplicativo e, em seguida, clique em  Adicionar . Para remover um ícone da tela inicial, selecione o nome do aplicativo e clique em  Remover . Para personalizar o nome de um aplicativo, selecione o nome do aplicativo, clique em  Editar  e atribua um nome. Para restaurar o nome de um aplicativo, selecione o nome do aplicativo, clique em  Editar  e selecione  Restaurar etiqueta do aplicativo . Para adicionar um espaço entre aplicativos, clique em  , selecione  ESPAÇO EM BRANCO  e clique em  Adicionar . Arraste os nomes dos aplicativos para colocá-los na ordem desejada. Para restaurar a exibição padrão da tela inicial, clique em  Restaurar tela inicial . Aplique as alterações. ícones da tela inicial exibição ícones da tela inicial mostrando tela inicial personalização exibição de aplicativos na tela inicial adição de aplicativos à tela inicial"},{"UUID":"862c2bbc-2ac8-4f9b-9b9b-0fa1d263d000","title":"Configuração e uso dos aplicativos da tela inicial","link":"using-home-screen-topic.html","desc":"Aplicativos suportados Scan Center Shortcut","descFull":"Aplicativos suportados Scan Center Shortcut Center Cópia de cartão Cópia de cartão aplicativos suportados"},{"UUID":"55df6128-b410-4e2c-bafa-0af481aaedc1","title":"Configuração e uso dos aplicativos da tela inicial","link":"using-home-screen-topic.html","desc":"Configuração do Scan Center Na","descFull":"Configuração do Scan Center Na tela inicial, toque em  Scan Center . Selecione e crie um destino e, então, defina as configurações. Ao criar um destino de rede, certifique-se de validar e ajustar as configurações até nenhum erro ocorrer. Somente destinos criados a partir do Servidor da Web Incorporado são salvos. Para obter mais informações, consulte a documentação fornecida com a solução. Aplique as alterações. Scan Center configuração"},{"UUID":"9ea399f9-25ff-49a3-a07a-2fdccb509de0","title":"Configuração e uso dos aplicativos da tela inicial","link":"using-home-screen-topic.html","desc":"Criando um atalho Na tela","descFull":"Criando um atalho Na tela inicial, toque em  Centro de atalhos . O ícone e nome podem ter sido alterados. Para obter mais informações, entre em contato com o administrador. Selecione uma função de impressora e toque em  Criar atalho . A função de e-mail seguro não é suportada. Configure as definições e toque em  Salvar . Digite um nome de atalho exclusivo. Para evitar nomes cortados na tela inicial, digite no máximo 25 caracteres. Toque em  OK . O aplicativo gera automaticamente um número exclusivo de atalho. Para iniciar o atalho, toque em  , toque em  #  e, em seguida, insira o número de atalho. como criar atalhos atalhos criação atalho Cópia atalho E-mail atalho Fax atalho FTP"},{"UUID":"97359e19-80b7-4125-a586-8ef69ffe3ea5","title":"Configuração e uso dos aplicativos da tela inicial","link":"using-home-screen-topic.html","desc":"Configuração de Cópia de cartão","descFull":"Configuração de Cópia de cartão Abra o navegador da Web e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Clique em  Aplicativos Cópia de cartão Configurar . Certifique-se de que a opção  Exibir ícone  esteja ativada. Certifique-se de que as opções  Configurações de e-mail  e  Configurações de compartilhamento de rede  estejam configuradas. Quando digitalizar um cartão, certifique-se de que a resolução de digitalização não ultrapasse 200dpi para digitalização colorida e 400dpi para digitalização em preto-e-branco. Quando digitalizar vários cartões, certifique-se de que a resolução de digitalização não ultrapasse 150dpi para digitalização colorida e 300dpi para digitalização em preto-e-branco. Aplique as alterações. É necessário um disco rígido da impressora ou uma unidade de armazenamento inteligente para digitalizar vários cartões. Cópia de cartão configuração"},{"UUID":"d5a0b702-cba6-4cf5-9795-b06cba87d882","title":"Configuração e uso dos aplicativos da tela inicial","link":"using-home-screen-topic.html","desc":"Usando a Personalização da exibição","descFull":"Usando a Personalização da exibição Antes de usar o aplicativo, certifique-se de fazer o seguinte: No Embedded Web Server, clique em  Aplicativos Exibir personalização Configurar . Habilite e configure as definições de proteção de tela, da apresentação de slides e do papel de parede. Gerenciamento de imagens de proteção de tela e apresentação de slides Na seção de imagens de Proteção de tela e Apresentação de slides, adicione, edite ou exclua uma imagem. Você pode adicionar até 10 imagens. Quando ativados, os ícones de status são exibidos na proteção de tela somente quando há erros, avisos ou notificações baseadas na nuvem. Aplique as alterações. Alteração da imagem de papel de parede Na tela Bem-vindo, toque em  Alterar papel de parede . Selecione uma imagem que deseja usar. Aplique as alterações. Execução de uma apresentação de slides de uma unidade flash Insira uma unidade flash na porta USB. Na tela inicial, toque em  Apresentação de slides . As imagens aparecem em ordem alfabética. É possível remover a unidade flash após o início da apresentação de slides, mas as imagens não serão armazenadas na impressora. Se a apresentação de slides for interrompida, insira a unidade flash novamente para visualizar as imagens. Exibir personalização usando usando a Personalização da exibição personalizando a exibição alterando o papel de parede executando uma apresentação de slides Gerenciando a proteção de tela"},{"UUID":"95fa3c36-dd9b-49c1-8f9f-3f07c67cd576","title":"Configuração e uso dos aplicativos da tela inicial","link":"using-home-screen-topic.html","desc":"Uso do Suporte ao cliente","descFull":"Uso do Suporte ao cliente Esse aplicativo é suportado apenas em alguns modelos de impressora. Para obter mais informações, consulte  . Esse aplicativo é suportado apenas em alguns modelos de impressora. Para obter informações sobre como configurar o aplicativo, consulte o  Guia do administrador para o Suporte ao cliente. Na tela inicial, toque em  Suporte ao cliente . Imprima ou envie um e-mail sobre as informações. Suporte ao cliente uso uso do  Suporte ao cliente"},{"UUID":"35350e93-278f-479a-9105-2089496e4617","title":"Configuração e uso dos aplicativos da tela inicial","link":"using-home-screen-topic.html","desc":"Como configurar o aplicativo de","descFull":"Como configurar o aplicativo de cotas do dispositivo Esse aplicativo é suportado apenas em alguns modelos de impressora. Para obter mais informações, consulte  . Esse aplicativo é suportado apenas em alguns modelos de impressora. Para obter informações sobre como configurar o aplicativo, consulte o  Guia do administrador para Gestão de cotas . Abra o navegador da Web e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Clique em  Aplicativos Cotas do dispositivo Configurar . Na seção  Contas de usuário , adicione ou edite um usuário e, em seguida, configure a cota do usuário. Aplique as alterações. configuração do  Gestão de cotas Gestão de cotas configuração"},{"UUID":"009845d6-a1da-4ac0-b3e4-17b8971a4ca1","title":"Como gerenciar marcadores","link":"using-home-screen-topic.html","desc":"Criação de marcadores Use marcadores","descFull":"Criação de marcadores Use marcadores para imprimir documentos acessados com frequência que são armazenados em servidores ou na internet. Abra o navegador da Web e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Clique em  Marcadores Adicionar Marcador  e, em seguida, digite um nome para o marcador. Selecione um tipo de protocolo de  Endereço  e siga um dos seguintes procedimentos: Para HTTP e HTTPS, digite a URL que deseja marcar. Para HTTPS, use o nome do host em vez do endereço IP. Por exemplo, digite  myWebsite.com/sample.pdf  em vez de digitar  123.﻿123.123.123/sample.pdf . Verifique se o nome do host também corresponde ao valor do nome comum (CN) no certificado de servidor. Para mais informações sobre como obter o valor do CN no certificado de servidor, consulte as informações de ajuda para seu navegador da Web. Para FTP, digite o endereço de FTP. Por exemplo,  myServer/myDirectory . Digite o número da porta do FTP. A porta 21 é a porta padrão para envio de comandos. Para SMB, digite o endereço da pasta da rede. Por exemplo,  myServer/myShare/myFile.pdf . Digite o nome de domínio da rede. Se necessário, selecione o tipo de  Autenticação  para FTP e SMB. Para limitar o acesso ao marcador, insira um PIN. O aplicativo é compatível com os seguintes tipos de arquivo: PDF, JPEG e TIFF. Outros tipos de arquivo, como DOCX e XLSX, são compatíveis com alguns modelos de impressora. Clique em  Salvar . marcadores criação como criar marcadores"},{"UUID":"92d19ad4-8970-437c-bb97-1b80267c7f80","title":"Como gerenciar marcadores","link":"using-home-screen-topic.html","desc":"Criação de pastas Abra o","descFull":"Criação de pastas Abra o navegador da internet e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para carregar a página da Web corretamente. Clique em  Marcadores Adicionar Pasta  e, em seguida, digite um nome para a pasta. Para limitar o acesso à pasta, insira um PIN. Clique em  Salvar . Você pode criar pastas ou marcadores dentro de uma pasta. Para criar um marcador, consulte  . marcadores criando pastas para criando pastas para marcadores"},{"UUID":"93bf91d2-38b0-4ac9-bfa0-f578ba9fff59","title":"Configuração e uso dos aplicativos da tela inicial","link":"using-home-screen-topic.html","desc":"Catálogo de endereços Como gerenciar","descFull":"Catálogo de endereços Como gerenciar contatos Na tela inicial, toque em  Catálogo de endereços. Execute uma ou mais das seguintes opções: Para adicionar um contato, toque em   na parte superior da tela e, em seguida, em  Criar contato . Se necessário, especifique um método de login para permitir o acesso à aplicação. Para excluir um contato, toque em   na parte superior da tela, em  Excluir contatos  e selecione o contato. Para editar as informações de contato, toque no nome do contato. Para criar um grupo, toque em   na parte superior da tela e, em seguida, em  Criar grupo . Se necessário, especifique um método de login para permitir o acesso à aplicação. Para excluir um grupo, toque em   na parte superior da tela, em  Excluir grupos  e selecione o grupo. Para editar um grupo de contatos, toque em  GRUPOS selecione o nome de um grupo  e escolha ação que deseja realizar. Aplique as alterações. como adicionar contatos como excluir contatos adicionar grupos de contato excluir grupos de contatos como editar contatos Catálogo de endereços uso"},{"UUID":"d514672c-ce49-44a8-b677-c8ede4e22006","title":"Configuração e uso dos recursos de acessibilidade","link":"activating-voice-guidance-topic.html","desc":"Ativação do Voice Guidance Na","descFull":"Ativação do Voice Guidance Na tela inicial Em um movimento e usando um dedo, deslize lentamente para a esquerda e para cima na tela até ouvir uma mensagem de voz. Com dois dedos, toque em  OK . Se o gesto não funcionar, aplique mais pressão. No teclado Mantenha a tecla  5  pressionada até ouvir uma mensagem de voz. Pressione  Tab  para navegar com o cursor de foco até o botão OK e, em seguida, pressione  Enter . Quando o Voice Guidance estiver ativado, sempre use dois dedos para selecionar qualquer item na tela. O Voice Guidance tem suporte a idiomas limitado. Voice Guidance ativação como ativar o Voice Guidance"},{"UUID":"6b86c591-b44d-48b7-b4d1-adcd4bac62c1","title":"Configuração e uso dos recursos de acessibilidade","link":"activating-voice-guidance-topic.html","desc":"Desativação do Voice Guidance Em","descFull":"Desativação do Voice Guidance Em um movimento e usando um dedo, deslize lentamente para a esquerda e para cima na tela até ouvir uma mensagem de voz. Usando dois dedos, siga um destes procedimentos: Toque em  Voice Guidance  e, em seguida, em  OK . Toque em  Cancelar . Se o gesto não funcionar, aplique mais pressão. Você também pode desativar o Voice Guidance seguindo um destes procedimentos: Com dois dedos, toque duas vezes na tela inicial. Pressione o botão Liga/Desliga para tirar a impressora do modo de Suspensão ou de Hibernação. Voice Guidance desativação desativação do Voice Guidance"},{"UUID":"22a61f11-d5eb-401e-a846-9bd352b079f0","title":"Configuração e uso dos recursos de acessibilidade","link":"activating-voice-guidance-topic.html","desc":"Navegando pela tela usando gestos","descFull":"Navegando pela tela usando gestos A maioria dos gestos é aplicável somente com o Voice Guidance ativado. Ative Ampliação para usar gestos de zoom e panorama. Use um teclado físico para digitar caracteres e ajustar determinadas configurações. Gestos e suas funções Gesto Função Deslize para a esquerda e para cima usando um dedo Inicie o modo Acessibilidade. Use o mesmo gesto para sair do modo Acessibilidade. Esse gesto também é aplicável quando a impressora está no modo normal. Toque duas vezes com um dedo Selecionar uma opção ou item na tela. Toque duas vezes no ícone inicial usando dois dedos Desative o modo Acessibilidade. Toque três vezes com um dedo Ampliar ou reduzir textos e imagens. Deslize para a direita ou para baixo usando um dedo Seguir para o próximo item na tela. Deslize para a esquerda ou para cima usando um dedo Seguir para o item anterior na tela. Deslize para cima e para baixo usando um dedo Mover para o primeiro item na tela. Panorama Acessar partes da imagem ampliada que estão além do limite da tela. Use dois dedos para arrastar uma imagem com zoom. Deslize para cima e para a direita usando um dedo Aumente o volume. Esse gesto também é aplicável quando a impressora está no modo normal. Deslize para baixo e para a direita usando um dedo Diminua o volume. Esse gesto também é aplicável quando a impressora está no modo normal. Deslize para cima e para a esquerda usando um dedo Sair de um aplicativo e retornar à tela inicial. Deslize para baixo e para a esquerda usando um dedo Voltar para a configuração anterior. como navegar pela tela como usar gestos como navegar pela tela usando gestos"},{"UUID":"3f2bbc95-d8c9-40cb-9dd5-a4fa99e265b3","title":"Configuração e uso dos recursos de acessibilidade","link":"activating-voice-guidance-topic.html","desc":"Usando o teclado na tela","descFull":"Usando o teclado na tela Quando o teclado na tela for exibido, siga um ou mais dos procedimentos a seguir: Toque em uma tecla para anunciar e digitar o caractere no campo. Arraste um dedo pelos diferentes caracteres para anunciar e digitar o caractere no campo. Toque em uma caixa de texto usando dois dedos para anunciar os caracteres no campo. Toque em  Backspace  para excluir caracteres. teclado na tela uso"},{"UUID":"96309e45-bb64-40ee-865d-250824731408","title":"Configuração e uso dos recursos de acessibilidade","link":"activating-voice-guidance-topic.html","desc":"Ativando modo de ampliação Em","descFull":"Ativando modo de ampliação Em um movimento e usando um dedo, deslize lentamente para a esquerda e para cima na tela até ouvir uma mensagem de voz. Para modelos de impressora sem alto-falantes integrados, use fones de ouvido para ouvir a mensagem. Usando dois dedos, faça o seguinte: Toque em  Modo de Ampliação . Toque em  OK . Se o gesto não funcionar, aplique mais pressão. Para obter mais informações sobre a navegação em uma tela ampliada, consulte  . Modo de ampliação ativando como ativar o modo de ampliação"},{"UUID":"e6419b3d-41d9-4de9-82c1-f32b913cd669","title":"Configuração e uso dos recursos de acessibilidade","link":"activating-voice-guidance-topic.html","desc":"Ajustando a velocidade de fala","descFull":"Ajustando a velocidade de fala no Voice Guidance Na tela inicial, toque em  Configurações Dispositivo Acessibilidade Velocidade de fala . Selecione a velocidade de fala. Voice Guidance velocidade de fala Velocidade de fala no Voice Guidance ajustando como ajustar a velocidade de fala Voice Guidance"},{"UUID":"1e13261a-015d-4943-9ba0-07d4923fa86e","title":"Configuração e uso dos recursos de acessibilidade","link":"activating-voice-guidance-topic.html","desc":"Ajustando o volume padrão dos","descFull":"Ajustando o volume padrão dos fones de ouvido Na tela inicial, toque em  Configurações Dispositivo Acessibilidade . Ajustar o volume do fone de ouvido. O volume voltará ao valor padrão após o usuário sair do modo Acessibilidade ou quando a impressora sair do modo de Suspensão ou Hibernação. volume padrão dos fones de ouvido ajustando como ajustar o volume padrão fones de ouvido"},{"UUID":"0a28d819-0e56-49c2-8117-24c681b3615c","title":"Configuração e uso dos recursos de acessibilidade","link":"activating-voice-guidance-topic.html","desc":"Ajustando o volume padrão do","descFull":"Ajustando o volume padrão do alto-falante interno Na tela inicial, toque em  . Ajuste o volume. Se o Modo silencioso estiver ativado, os alertas audíveis serão desligados. Essa definição também diminui o desempenho da impressora. O volume voltará ao valor padrão após o usuário sair do modo Acessibilidade ou quando a impressora sair do modo de Suspensão ou Hibernação. volume do alto-falante padrão ajustando como ajustar o volume padrão alto-falante"},{"UUID":"22dc640e-095e-49e8-8a77-c8bd876cee4d","title":"Configuração e uso dos recursos de acessibilidade","link":"activating-voice-guidance-topic.html","desc":"Ativando senhas ou números de","descFull":"Ativando senhas ou números de identificação pessoal falados Na tela inicial, selecione  Configurações Dispositivo Acessibilidade Senhas/PINs falados . Ative a configuração. senhas faladas ativando números de identificação pessoal ativando como ativar senhas faladas como ativar números de identificação pessoal"},{"UUID":"5af8739e-a0f4-49c2-bfd8-92b9893e1d17","title":"Configurando a impressora para enviar fax","link":"setting-up-printer-to-fax-group.html","desc":"Fax compatível Fax analógico Precisa","descFull":"Fax compatível Fax analógico Precisa de uma placa de fax instalada. Para obter mais informações, entre em contato com o local em que você adquiriu a impressora. etherFAX Precisa de uma assinatura. Para mais informações, visite  https://www.etherfax.net/lexmark  ou entre em contato com o local onde você adquiriu a impressora. Fax sobre IP (FoIP) Precisa de um pacote de licença instalado. Para obter mais informações, entre em contato com o local em que você adquiriu a impressora. Servidor de fax fax compatível"},{"UUID":"edf886f9-012d-40ff-b1a9-d23fde59fecc","title":"Configurando a impressora para enviar fax","link":"setting-up-printer-to-fax-group.html","desc":"Como configurar a função de","descFull":"Como configurar a função de fax usando o fax analógico Uma placa de fax deve ser instalada para que a impressora use o fax analógico. Alguns métodos de conexão são aplicáveis apenas em alguns países ou regiões. Se a função de fax estiver ativada e não estiver completamente configurada, a luz indicadora poderá piscar em vermelho. Se você não tiver um ambiente de TCP/IP, use o painel de controle para configurar o fax. Para evitar perda de dados ou mal funcionamento da impressora, não toque nos cabos ou na área indicada da impressora enquanto estiver enviando ou recebendo um fax. Como usar o menu  Configurações  na impressora Na tela inicial, toque em  Configurações Fax Configuração de fax Configurações gerais de fax . Defina as configurações. Uso do Embedded Web Server Abra o navegador da Web e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Clique em  Configurações Fax Configuração de fax Configurações gerais de fax . Defina as configurações. Aplique as alterações. fax analógico configuração configuração fax analógico"},{"UUID":"4faf5b16-680a-45b8-802c-f31166f1a339","title":"Configurando a impressora para enviar fax","link":"setting-up-printer-to-fax-group.html","desc":"Como configurar a função de","descFull":"Como configurar a função de fax usando o etherFAX É necessário que o firmware da impressora esteja atualizado. Para obter mais informações, consulte  . É necessário que haja um pacote de licenças apropriado instalado na impressora. Para mais informações, entre em contato com o etherFAX. Certifique-se de que a impressora esteja registrada no portal etherFAX. Para mais informações, visite  https://www.etherfax.net/lexmark . O registro exige o número de série da impressora. Para localizar o número de série, consulte  . Abra o navegador da Web e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Clique em  Configurações Fax Configuração de fax Configurações gerais de fax . A opção  Configuração de fax  é exibida somente se a opção  Modo fax  estiver definida como  Fax . No campo  Nome do fax , digite um nome exclusivo. No campo  Número do fax , digite o número do fax fornecido pelo etherFAX. No menu  Transporte de fax , selecione  etherFAX . Este menu é exibido apenas quando há mais de um transporte de fax disponível. Se a impressora tiver apenas etherFAX instalado, ela será configurada automaticamente. Aplique as alterações. etherFAX como configurar a função de fax como configurar a função de fax usando etherFAX"},{"UUID":"ca685705-ad25-4b13-8c9d-4db19a563b14","title":"Configurando a impressora para enviar fax","link":"setting-up-printer-to-fax-group.html","desc":"Como configurar a função de","descFull":"Como configurar a função de fax usando o servidor de fax Esse recurso permite o envio de mensagens de fax a um provedor de serviços de fax compatível com o recebimento de e‑mail. Esse recurso é compatível apenas com mensagens de fax enviadas. Para aceitar o recebimento de fax, certifique-se de que tenha um recurso de fax, como fax analógico, etherFAX ou Fax sobre IP (FoIP), configurado na impressora. Abra o navegador da Web e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial. O endereço IP é exibido em quatro conjuntos de números separados por pontos, por exemplo: 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Clique em  Configurações Fax . No menu  Modo Fax , selecione  Servidor de fax  e clique em  Salvar . Clique em  Configuração de servidor de fax . No campo  Formato de destino , digite  [#]@myfax.com , onde  [#]  é o número do fax e  myfax.com  é o domínio do provedor de fax. Se necessário, configure os campos  Endereço de resposta ,  Assunto  ou  Mensagem . Para permitir que a impressora receba mensagens de fax, ative as configurações de recebimento de fax no dispositivo. Certifique-se de que tenha um recurso de fax configurado no dispositivo. Clique em  Salvar . Clique em  Configurações de e-mail do servidor de fax  e execute um dos seguintes procedimentos: Ative  Utilizar servidor SMTP de e-mail . Se as configurações de SMTP de e‑mail não foram definidas, consulte  . Defina as configurações de SMTP. Para obter mais informações, entre em contato com o provedor de serviços de e‑mail. Aplique as alterações. servidor de fax, usando como configurar a função de fax como configurar a função de fax usando o servidor de fax"},{"UUID":"8218977d-4312-4487-83de-5d8a47da8f67","title":"Configurando a impressora para enviar fax","link":"setting-up-printer-to-fax-group.html","desc":"Configurando fax usando uma linha","descFull":"Configurando fax usando uma linha de telefone padrão Estas instruções são aplicáveis somente a impressoras compatíveis com o fax analógico. Para mais informações, consulte  . Estas instruções são aplicáveis somente a impressoras compatíveis com o fax analógico. Para evitar o risco de choque elétrico, não instale este produto nem faça conexões elétricas ou a cabo, como recursos do fax, cabos de energia ou telefone, durante tempestades com relâmpago. Para evitar o risco de choque elétrico, não use o recurso de fax durante tempestades com relâmpago. Para reduzir o risco de incêndio, use apenas um cabo de 26 AWG ou um fio de telecomunicações (RJ-11) maior ao conectar o produto à rede de telefone pública conectada. Para os usuários na Austrália, o cabo deve ser aprovado pelo Australian Communications and Media Authority. Configuração 1: A impressora está conectada a uma linha de fax dedicada Conecte uma extremidade do cabo de telefone à porta line da impressora. Conecte a outra extremidade do cabo a uma tomada de telefone analógica ativa. Você pode definir a impressora para receber fax automaticamente (defina   Atendimento automático  como  Ativado ) ou manualmente (defina o  Atendimento automático  como  Desativado ). Para receber faxes automaticamente, configure a impressora para atender após um número específico de toques. Configuração 2: A impressora compartilha a linha com uma secretária eletrônica Se você assina um serviço de toque diferente, configure o padrão de toque correto para a impressora. Caso contrário, a impressora não receberá fax, mesmo que você a defina para receber automaticamente. Conectada a tomadas diferentes Conecte uma extremidade do cabo de telefone à porta line da impressora. Conecte a outra extremidade do cabo a uma tomada de telefone analógica ativa. Se houver apenas um número de telefone em sua linha, configure a impressora para receber faxes automaticamente. Configure a impressora para atender chamadas dois toques depois da secretária eletrônica. Por exemplo, se a secretária eletrônica atender as chamadas após quatro toques, ajuste a definição  Toques para atender  da impressora para  seis . como configurar o fax conexão de linha telefônica padrão configuração de fax conexão de linha telefônica padrão secretária eletrônica como configurar"},{"UUID":"27526eb6-74c7-4226-af8e-782211c547a5","title":"Configurando a impressora para enviar fax","link":"setting-up-printer-to-fax-group.html","desc":"Como configurar fax em países","descFull":"Como configurar fax em países ou regiões com diferentes tomadas e plugues telefônicos Estas instruções são aplicáveis somente a impressoras compatíveis com o fax analógico. Para mais informações, consulte  . Estas instruções são aplicáveis somente a impressoras compatíveis com o fax analógico. Para evitar o risco de choque elétrico, não instale este produto nem faça conexões elétricas ou a cabo, como recursos do fax, cabos de energia ou telefone, durante tempestades com relâmpago. Para evitar o risco de choque elétrico, não use o recurso de fax durante tempestades com relâmpago. Para reduzir o risco de incêndio, use apenas um cabo de 26 AWG ou um fio de telecomunicações (RJ-11) maior ao conectar o produto à rede de telefone pública conectada. Para os usuários na Austrália, o cabo deve ser aprovado pelo Australian Communications and Media Authority. A tomada padrão adotada pela maioria dos países ou regiões é a RJ‑11. Se a tomada telefônica ou equipamento em seu local não for compatível com este tipo de conexão, então use um adaptador de telefone. Um adaptador para seu país ou região pode não vir com a impressora e você precisará comprá-lo separadamente. Pode existir um plugue adaptador conectado à porta telefônica da impressora. Não remova o plugue adaptador da porta telefônica da impressora se você for conectar em um sistema telefônico em cascata ou serial. Número da peça do plugue adaptador Nome da peça Número de peça Plugue adaptador Lexmark 40X8519 Como conectar a impressora a uma tomada diferente da RJ-11 Conecte uma extremidade do cabo de telefone à porta line da impressora. Conecte a outra extremidade do cabo ao adaptador RJ‑11 e depois conecte o adaptador na tomada. Se quiser conectar outro dispositivo com um conector diferente do RJ‑11 à mesma tomada, conecte-o diretamente ao adaptador de telefone. configuração de fax específica de país ou região como configurar o fax específica de país ou região adaptador RJ-11 plugue adaptador"},{"UUID":"908f0582-cc4f-4db2-82d5-274391fc27ad","title":"Configurando a impressora para enviar fax","link":"setting-up-printer-to-fax-group.html","desc":"Conectando-se a um serviço de","descFull":"Conectando-se a um serviço de toques distintos Um toque distinto permite que você tenha diversos números de telefone em uma única linha. Cada número de telefone é atribuído a um padrão de toque diferente. Estas instruções são aplicáveis somente a impressoras compatíveis com o fax analógico. Para mais informações, consulte  . Estas instruções são aplicáveis somente a impressoras compatíveis com o fax analógico. Na tela inicial, toque em  Configurações Fax Configuração de fax Configurações de recebimento de fax Controles de administrador Atendimento ativado . Selecione um padrão de toque. serviço de toque distinto, fax ativação como conectar a impressora ao serviço de toque distinto como atribuir um padrão de toque à impressora"},{"UUID":"6366e492-c3cc-495f-9e44-142fab15c5c0","title":"Configurando a impressora para enviar fax","link":"setting-up-printer-to-fax-group.html","desc":"Configuração da data e hora","descFull":"Configuração da data e hora do fax Certifique-se de que o fax esteja configurado. Para obter mais informações, consulte os  Configuração da impressora para envio de fax  a seção. Na tela inicial, toque em  Configurações Dispositivo Preferências Data e hora Configurar . Defina as configurações. fax como configurar data e hora data e hora configurações de fax"},{"UUID":"35e3e2c3-1e6e-4d65-89a3-db41d61b9743","title":"Configurando a impressora para enviar fax","link":"setting-up-printer-to-fax-group.html","desc":"Configurando o horário de verão","descFull":"Configurando o horário de verão Certifique-se de que o fax esteja configurado. Para obter mais informações, consulte a seção  Configurando a impressora para enviar fax . Na tela inicial, toque em  Configurações Dispositivo Preferências Data e hora Configurar . No menu  Fuso horário , selecione  Personalizar (UTC+usuário) . Toque em  Separar UTC (GMT)  e, em seguida, defina as configurações. como configurar o horário de verão horário de verão configuração"},{"UUID":"e373728e-fa05-4c78-830d-dced7c3ac8dc","title":"Configurando a impressora para enviar fax","link":"setting-up-printer-to-fax-group.html","desc":"Definição das configurações do alto-falante","descFull":"Definição das configurações do alto-falante do fax Certifique-se de que o fax esteja configurado. Para obter mais informações, consulte a seção  Configurando a impressora para enviar fax . Na tela inicial, toque em  Configurações Fax Configuração de fax Configurações do alto-falante . Faça o seguinte: Ajuste o  Modo do alto-falante  em  Sempre ligado . Ajuste o  Volume do alto-falante  em  Alto . Ative  Volume do toque . como configurar o alto-falante do fax configurações do alto-falante do fax configuração"},{"UUID":"cd6235a7-8a1b-455a-8339-3fb5295d1ffc","title":"Instalação e configuração","link":"configuring-smtp-server-for-e-mail-topic.html","desc":"Como configurar o SMTP de","descFull":"Como configurar o SMTP de e-mail Defina as configurações do Simple Mail Transfer Protocol (SMTP) para enviar um documento digitalizado por e-mail. As configurações variam de acordo com cada provedor de serviços de e‑mail. Antes de começar, certifique-se de que a impressora esteja conectada à rede, e de que a rede esteja conectada à Internet. Uso do Embedded Web Server Abra o navegador da Web e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Clique em  Configurações E-mail . Na seção  Configuração de e-mail , confirme as configurações. Para obter mais informações, consulte a lista de  provedores de serviços de e‑mail . Para provedores de serviços de e‑mail não mencionados na lista, entre em contato com seu provedor e solicite as configurações. Clique em  Salvar . Como usar o menu  Configurações  na impressora Na tela principal, toque em  Configurações E-mail Configuração de e-mail . Defina as configurações. Para obter mais informações, consulte a lista de  provedores de serviços de e‑mail . Para provedores de serviços de e‑mail não mencionados na lista, entre em contato com seu provedor e solicite as configurações. Provedores de serviços de e‑mail AOL Mail Comcast Mail Gmail iCloud Mail Mail.com NetEase Mail (mail.126.com) NetEase Mail (mail.163.com) NetEase Mail (mail.yeah.net) Outlook Live ou Microsoft 365 QQ Mail Sina Mail Sohu Mail Yahoo! Mail Zoho Mail Se você encontrar erros usando as configurações fornecidas, entre em contato com o provedor de serviços de e‑mail. Para provedores de serviços de e‑mail não mencionados na lista, entre em contato com seu provedor. AOL Mail Como configurar o AOL Mail Configuração Valor Gateway SMTP primário smtp.aol.com Porta do gateway SMTP primário 587 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Senha do aplicativo  Para criar uma senha do aplicativo, acesse a página de  Segurança da conta da AOL , faça login em sua conta e clique em  Gerar senha do aplicativo . Comcast Mail Configurações do Comcast Mail Configuração Valor Gateway SMTP primário smtp.comcast.net Porta do gateway SMTP primário 587 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Senha da conta Certifique-se de que a configuração Segurança de acesso de terceiros esteja ativada em sua conta. Para obter mais informações, acesse a página de ajuda do  Comcast Xfinity Connect . Gmail Certifique-se de que a verificação de duas etapas esteja ativada na sua conta do Google. Para ativar a verificação de duas‑etapas, acesse a página de  Segurança da Conta do Google , faça login na sua conta e, na seção \" Entrar no Google \", clique em  Verificação em duas etapas . Configurações de SMTP para o Gmail Configuração Valor Gateway SMTP primário smtp.gmail.com Porta do gateway SMTP primário 587 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Senha do aplicativo Para criar uma senha do aplicativo, acesse a página de  Segurança da conta do Google , faça login em sua conta e, na seção \" Entrar no Google \", clique em  Senhas do aplicativo . A opção \" Senhas do aplicativo \" é exibida apenas se a verificação em duas etapas estiver ativada. iCloud Mail Certifique-se de que a verificação de duas etapas esteja ativada em sua conta. Configurações do iCloud Mail Configuração Valor Gateway SMTP primário smtp.mail.me.com Porta do gateway SMTP primário 587 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Senha do aplicativo Para criar uma senha do aplicativo, acesse a página de  Gerenciamento de conta do iCloud , faça login em sua conta e, na seção  Segurança , clique em  Gerar senha . Mail.com Configurações do Mail.com Configuração Valor Gateway SMTP primário smtp.mail.com Porta do gateway SMTP primário 587 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Senha da conta NetEase Mail (mail.126.com) Certifique-se de que o serviço SMTP esteja ativado na sua conta. Para ativar o serviço, na página inicial do NetEase Mail, clique em  Configurações POP3/SMTP/IMAP  e depois ative  Serviço IMAP/SMTP  ou  Serviço POP3/SMTP . Configurações do NetEase Mail (mail.126.com) Configuração Valor Gateway SMTP primário smtp.126.com Porta do gateway SMTP primário 465 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Senha de autorização A senha de autorização é fornecida quando o  Serviço IMAP/SMTP  ou o  Serviço POP3/SMTP  está ativado. NetEase Mail (mail.163.com) Certifique-se de que o serviço SMTP esteja ativado na sua conta. Para ativar o serviço, na página inicial do NetEase Mail, clique em  Configurações POP3/SMTP/IMAP  e depois ative  Serviço IMAP/SMTP  ou  Serviço POP3/SMTP . Configurações do NetEase Mail (mail.163.com) Configuração Valor Gateway SMTP primário smtp.163.com Porta do gateway SMTP primário 465 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Senha de autorização A senha de autorização é fornecida quando o  Serviço IMAP/SMTP  ou o  Serviço POP3/SMTP  está ativado. NetEase Mail (mail.yeah.net) Certifique-se de que o serviço SMTP esteja ativado na sua conta. Para ativar o serviço, na página inicial do NetEase Mail, clique em  Configurações POP3/SMTP/IMAP  e depois ative  Serviço IMAP/SMTP  ou  Serviço POP3/SMTP . Configurações do NetEase Mail (mail.yeah.net) Configuração Valor Gateway SMTP primário smtp.yeah.net Porta do gateway SMTP primário 465 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Senha de autorização A senha de autorização é fornecida quando o  Serviço IMAP/SMTP  ou o  Serviço POP3/SMTP  está ativado. Outlook Live ou Microsoft 365 Essas configurações se aplicam aos domínios de e‑mail outlook.com e hotmail.com, bem como às contas do Microsoft 365. Configurações do Outlook Live ou do Microsoft 365 Configuração Valor Gateway SMTP primário smtp.office365.com Porta do gateway SMTP primário 587 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Senha da conta ou do aplicativo Para contas em que a verificação de duas etapas está desativada, use a senha da conta. Para contas outlook.com ou hotmail.com em que a verificação de duas etapas está ativada, use a senha do aplicativo. Para criar uma senha do aplicativo, acesse a página de  Gerenciamento de conta do Outlook Live  e faça login em sua conta. Para obter opções de configuração adicionais para empresas que usam o Microsoft 365, acesse  a página de ajuda do Microsoft 365 . QQ Mail Certifique-se de que o serviço SMTP esteja ativado na sua conta. Para ativar o serviço, na página inicial do QQ Mail, clique em  Configurações Conta  Na seção  Serviço POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV , ative  Serviço POP3/SMTP  ou  Serviço IMAP/SMTP . Configurações do QQ Mail Configuração Valor Gateway SMTP primário smtp.qq.com Porta do gateway SMTP primário 587 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Código de autorização Para gerar um código de autorização, na página inicial do QQ Mail, clique em  Configurações Conta  e, na seção  Serviço POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV , clique em  Gerar código de autorização . Sina Mail Certifique-se de que o serviço POP3/SMTP esteja ativado na sua conta. Para ativar o serviço, na página inicial do Sina Mail, clique em  Configurações Mais configurações POP/IMAP/SMTP na extremidade do usuário  e depois ative  Serviço POP3/SMTP . Configurações do Sina Mail Configuração Valor Gateway SMTP primário smtp.sina.com Porta do gateway SMTP primário 587 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Código de autorização Para criar um código de autorização, na página inicial do e-mail, clique em  Configurações Mais configurações POP/IMAP/SMTP na extremidade do usuário  e depois ative  Status do código de autorização . Sohu Mail Certifique-se de que o serviço SMTP esteja ativado na sua conta. Para ativar o serviço, na página inicial do Sohu Mail Mail, clique em  Opções Configurações POP3/SMTP/IMAP  e depois ative  Serviço IMAP/SMTP  ou  Serviço POP3/SMTP . Configurações do Sohu Mail Configuração Valor Gateway SMTP primário smtp.sohu.com Porta do gateway SMTP primário 465 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Senha independente A senha independente é fornecida quando o  Serviço IMAP/SMTP  ou o  Serviço POP3/SMTP  está ativado. Yahoo! Mail Configurações do Yahoo! Mail Configuração Valor Gateway SMTP primário smtp.mail.yahoo.com Porta do gateway SMTP primário 587 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Senha do aplicativo  Para criar uma senha do aplicativo, acesse a página de  Segurança da conta do Yahoo , faça login em sua conta e clique em  Gerar senha do aplicativo . Zoho Mail Configurações do Zoho Mail Configuração Valor Gateway SMTP primário smtp.zoho.com Porta do gateway SMTP primário 587 Usar SSL/TLS Desejado Certificado de confiança obrigatório Desativado Endereço de resposta Seu endereço de e-mail Autenticação do servidor SMTP Login/Comum E-mail iniciado por dispositivo Utilizar credenciais de dispositivo SMTP ID do usuário do dispositivo Seu endereço de e-mail Senha do dispositivo Senha da conta ou do aplicativo Para contas em que a verificação de duas etapas está desativada, use a senha da conta. Para contas em que a verificação de duas etapas está ativada, use a senha do aplicativo. Para criar uma senha do aplicativo, acesse a página de  Segurança da conta do Zoho Mail , faça login em sua conta e, na seção  Senhas específicas de aplicativos , clique em  Gerar nova senha . provedores de serviços de e‑mail como configurar o servidor de e-mail Configurações SMTP configuração função de e-mail configuração servidor de e-mail configuração"},{"UUID":"ed3d1198-9a76-4654-ae8e-b86008f050a6","title":"Carregamento de papel e mídia especial","link":"loading-trays-group.html","desc":"definindo o tamanho e o","descFull":"definindo o tamanho e o tipo da mídia especial As bandejas detectam automaticamente o tamanho do papel comum. Para mídias especiais, como etiquetas, cartões ou envelopes, faça o seguinte: Na tela inicial, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel  selecione a origem do papel. Defina o tamanho e o tipo da mídia especial. definindo o tamanho do papel definindo o tipo de papel tamanho do papel configuração tipo de papel configuração"},{"UUID":"f549361e-d9f9-4c27-b2c9-5c57d78298dd","title":"Carregamento de papel e mídia especial","link":"loading-trays-group.html","desc":"Definição das configurações do papel","descFull":"Definição das configurações do papel Universal Na tela inicial, toque em  Configurações Papel Configurações de mídia Configurações universais . Configure as definições. papel Definição de tamanho Universal definindo o tamanho de papel Universal Tamanho de papel universal configuração"},{"UUID":"465cd6c8-e65a-4eb9-b042-05b474ab723a","title":"Carregamento de papel e mídia especial","link":"loading-trays-group.html","desc":"Ativação da configuração  Vários","descFull":"Ativação da configuração  Vários tamanhos universais Na tela inicial, toque em  Configurações Dispositivo Manutenção Menu Configuração Configuração de bandeja . Ative a configuração  Vários tamanhos universais . Vários tamanhos universais ativando configuração do tamanho do papel Vários tamanhos universais"},{"UUID":"b5452a63-0962-4a74-809b-c2db58e4ae25","title":"Carregamento de papel e mídia especial","link":"loading-trays-group.html","desc":"Carregamento da bandeja para 520","descFull":"Carregamento da bandeja para 520 folhas Para reduzir o risco de instabilidade do equipamento, carregue cada bandeja separadamente. Mantenha todas as outras bandejas fechadas até serem necessárias. Puxe a bandeja para fora. Para evitar atolamentos, não remova as bandejas durante as impressões. Ajuste as guias para que correspondam ao tamanho do papel que está sendo carregado. Use os indicadores na parte inferior da bandeja para posicionar as guias. Flexione, ventile e alinhe as margens do papel antes de carregá-lo. Carregue a pilha de papel com o lado para impressão voltado para cima. Ao carregar papel timbrado ou papel perfurado, execute um dos seguintes procedimentos: Para impressão em um lado e com margem longa Carregue o papel timbrado com a face voltada para cima e o cabeçalho voltado para a parte traseira da bandeja. Carregue o papel perfurado com a face voltada para cima e os furos para a lateral esquerda da bandeja. Para impressão em um lado, com margem curta Carregue o papel timbrado com a face voltada para cima e o cabeçalho voltado para a parte esquerda da bandeja. Carregue o papel perfurado com a face voltada para cima e os furos para a frente da bandeja. Para impressão frente e verso com margem longa Carregue o papel timbrado com a face voltada para baixo e o cabeçalho voltado para a parte traseira da bandeja. Carregue o papel perfurado com a face voltada para baixo e os furos para a lateral direita da bandeja. Para impressão frente e verso com margem curta Carregue o papel timbrado com a face voltada para baixo e o cabeçalho voltado para a parte esquerda da bandeja. Carregue o papel perfurado com a face voltada para baixo e os furos para as costas da bandeja. Não deslize o papel na bandeja. Certifique-se de que as guias laterais se ajustem com firmeza ao papel. Certifique-se de que a altura da pilha de papel esteja abaixo dos indicadores de carregamento máximo de papel. O excesso pode causar atolamentos de papel. Insira a bandeja. Se necessário, ajuste o tamanho e tipo de papel para corresponderem ao papel colocado na bandeja. Quando um finalizador está instalado, as imagens são giradas em 180 graus quando impressas. bandeja para 520 folhas carregamento carregamento da bandeja para 520 folhas carregamento das bandejas"},{"UUID":"adb75058-da84-41ee-8d76-432ab588a2f1","title":"Carregamento de papel e mídia especial","link":"loading-trays-group.html","desc":"Carregamento da bandeja dupla para","descFull":"Carregamento da bandeja dupla para 2520 folhas Para reduzir o risco de instabilidade do equipamento, carregue cada bandeja separadamente. Mantenha todas as outras bandejas fechadas até serem necessárias. Puxe a bandeja para fora. Para evitar atolamentos, não remova as bandejas durante as impressões. Ajuste as guias para que correspondam ao tamanho do papel que está sendo carregado. Flexione, ventile e alinhe as margens do papel antes de carregá-lo. Carregue o papel. Para impressão em um lado, carregue o papel com o lado para impressão voltado para cima. Para impressão em frente e verso, carregue o papel com o lado para impressão voltado para baixo. Ao carregar papel timbrado ou papel perfurado, execute um dos seguintes procedimentos: Impressão em um lado Carregue o papel timbrado com a face voltada para cima e o cabeçalho voltado para a parte traseira da bandeja. Carregue o papel perfurado com a face voltada para cima e os furos para a lateral esquerda da bandeja. Para impressão em frente e verso Carregue o papel timbrado com a face voltada para baixo e o cabeçalho voltado para a parte traseira da bandeja. Carregue o papel perfurado com a face voltada para baixo e os furos para o lado direito da bandeja. Não deslize o papel na bandeja. Certifique-se de que a altura da pilha de papel esteja abaixo dos indicadores de carregamento máximo de papel. O excesso pode causar atolamentos de papel. Insira a bandeja. Se necessário, ajuste o tamanho e tipo de papel para corresponderem ao papel colocado na bandeja. Quando um finalizador está instalado, as imagens são giradas em 180 graus quando impressas. bandeja dupla para 2520 folhas carregamento carregamento da bandeja dupla para 2520 folhas carregamento das bandejas"},{"UUID":"687d90d9-db70-47a7-ad7c-cb95508a24ae","title":"Carregamento de papel e mídia especial","link":"loading-trays-group.html","desc":"Carregamento da bandeja para 2000","descFull":"Carregamento da bandeja para 2000 folhas Para reduzir o risco de instabilidade do equipamento, carregue cada bandeja separadamente. Mantenha todas as outras bandejas fechadas até serem necessárias. Tire a bandeja e abra a porta da bandeja lateral. Para evitar atolamentos, não remova as bandejas durante as impressões. Ajuste a guia na parte traseira da bandeja. Faça o mesmo na parte frontal da bandeja. Ajuste a alavanca na porta lateral da bandeja. Flexione, ventile e alinhe as margens do papel antes de carregá-lo. Carregue a pilha de papel com o lado para impressão voltado para cima. Ao carregar papel timbrado ou papel perfurado, execute um dos seguintes procedimentos: Impressão em um lado Carregue o papel timbrado com a face voltada para baixo e o cabeçalho voltado para a parte traseira da bandeja. Carregue o papel perfurado com a face voltada para baixo e os furos para a lateral esquerda da bandeja. Para impressão em frente e verso Carregue o papel timbrado com a face voltada para cima e o cabeçalho voltado para a parte traseira da bandeja. Carregue o papel perfurado com a face voltada para cima e os furos para a lateral esquerda da bandeja. Certifique-se de que a altura da pilha de papel esteja abaixo dos indicadores de carregamento máximo de papel. O excesso pode causar atolamentos de papel. Feche a porta da bandeja lateral e insira a bandeja. Se necessário, ajuste o tamanho e tipo de papel para corresponderem ao papel colocado na bandeja. Quando um finalizador está instalado, as imagens são giradas em 180 graus quando impressas. bandeja dupla para 2520 folhas carregamento carregamento da bandeja dupla para 2520 folhas"},{"UUID":"decfcd9e-8459-43d9-818d-f8a70381ce01","title":"Carregamento de papel e mídia especial","link":"loading-trays-group.html","desc":"Carregamento da bandeja para envelopes","descFull":"Carregamento da bandeja para envelopes Para reduzir o risco de instabilidade do equipamento, carregue cada bandeja separadamente. Mantenha todas as outras bandejas fechadas até serem necessárias. Puxe para fora a bandeja para envelopes. Para evitar atolamentos, não remova as bandejas durante as impressões. Flexione, ventile e alinhe as margens do envelope antes de carregá-lo. Ajuste as guias para que correspondam ao tamanho do envelope que está sendo carregado. Use os indicadores na parte inferior da bandeja para posicionar as guias. Carregue os envelopes com a aba voltada para baixo no lado esquerdo da bandeja. Certifique-se de que as guias laterais se ajustem com firmeza aos envelopes. Certifique-se de que a altura da pilha esteja abaixo dos indicadores de carregamento máximo de papel. O excesso pode causar atolamentos de papel. Insira a bandeja. Se necessário, ajuste o tamanho e tipo de papel para corresponderem ao envelope colocado na bandeja. bandeja de envelope carregamento carregamento da bandeja de envelopes"},{"UUID":"e9da4341-6c8c-4666-bb77-9db18e7f9b47","title":"Carregamento de papel e mídia especial","link":"loading-trays-group.html","desc":"Como carregar o alimentador multiúso","descFull":"Como carregar o alimentador multiúso Abra o alimentador multiúso. Ajuste as guias laterais para que correspondam ao tamanho do papel que está sendo carregado. Flexione, ventile e alinhe as margens do papel antes de carregá-lo. Carregue o papel. Certifique-se de que as guias laterais se ajustem com firmeza ao papel. Para alimentação de margem longa: Para impressão em um lado, carregue o papel timbrado com a face voltada para baixo e o cabeçalho para a parte traseira da impressora. Carregue o papel perfurado com a face voltada para baixo e os furos no lado direito do papel. Para impressão em frente e verso, carregue o papel timbrado com a face voltada para cima e o cabeçalho para a parte traseira da impressora. Carregue o papel perfurado com a face voltada para cima e os furos no lado esquerdo do papel. Para alimentação de margem curta: Para impressão em um lado, carregue o papel timbrado com a face voltada para baixo e o cabeçalho para a parte esquerda do papel. Carregue o papel perfurado com a face voltada para baixo e os furos na frente da impressora. Para impressão em frente e verso, carregue o papel timbrado com a face voltada para cima e o cabeçalho para o lado esquerdo do papel. Carregue o papel perfurado com a face voltada para cima e os furos em direção à parte traseira da impressora. Quando um finalizador está instalado, a impressora gira as imagens em 180 graus. alimentador multiuso carregamento carregamento do alimentador multiuso carregando o papel timbrado carregamento de papel perfurado"},{"UUID":"ca6d0680-d856-43ab-bda3-999025ad66cb","title":"Carregamento de papel e mídia especial","link":"loading-trays-group.html","desc":"Vinculação de bandejas Na tela","descFull":"Vinculação de bandejas Na tela inicial, toque em  Configurações Papel Configurações de bandeja selecione a origem do papel. Defina o mesmo tamanho e tipo de papel das bandejas que você está vinculando. Na tela inicial, toque em  Configurações Dispositivo Manutenção Menu Configuração Configuração de bandeja Vincular bandeja . Toque em  Automático . Para desvincular as bandejas, certifique-se de que não haja bandejas com o mesmo tamanho e tipo de papel. A temperatura do fusor varia de acordo com o tipo de papel especificado. Para evitar problemas de impressão, equipare as definições de tipo de papel na impressora às do papel carregado na bandeja. desvinculação de bandejas vinculação de bandejas bandejas vinculação bandejas desvinculação"},{"UUID":"0f07be46-7c81-418e-a086-7e8b697a8219","title":"Como instalar e atualizar software, drivers e firmware","link":"installing-printer-software-topic.html","desc":"Como instalar o software da","descFull":"Como instalar o software da impressora O driver de impressão está incluído no pacote instalador do software. Para computadores Macintosh com o MacOS versão 10.7 ou posterior, não é necessário instalar o driver para imprimir em uma impressora certificada pelo AirPrint. Se você quiser recursos de impressão personalizados, faça download do driver de impressão. Obtenha uma cópia do pacote instalador do software. No CD do software fornecido com a impressora Acesse  www.lexmark.com/downloads . Acesse  www.dell.com/support/printers . No nosso website ou no local onde você adquiriu a impressora. Execute a instalação e siga as instruções exibidas na tela do computador. como instalar o software da impressora software da impressora instalação como instalar o driver de impressão driver de impressão instalação"},{"UUID":"f697e5ac-1df0-4e69-89c9-f56fd5222d53","title":"Como instalar e atualizar software, drivers e firmware","link":"installing-printer-software-topic.html","desc":"Como instalar o driver de","descFull":"Como instalar o driver de fax Acesse  www.lexmark.com/downloads , procure o modelo da sua impressora e faça o download do pacote de instalação apropriado. Acesse nosso website ou o local onde você adquiriu a impressora para obter o pacote de instalação. Acesse  www.dell.com/support  e faça o download do pacote de instalação apropriado. No computador, clique em  Propriedades da impressora  e navegue até a guia  Configuração . Execute a instalação e siga as instruções exibidas na tela do computador. Selecione  Fax  e clique em  Aplicar . driver de fax instalação como instalar o driver de fax"},{"UUID":"c881769d-8ddc-483c-aa14-dfe833cc5222","title":"Como instalar e atualizar software, drivers e firmware","link":"installing-printer-software-topic.html","desc":"Atualizando o firmware Para melhorar","descFull":"Atualizando o firmware Para melhorar o desempenho da impressora e corrigir problemas, atualize o firmware da impressora regularmente. Para obter mais informações sobre como atualizar o firmware, entre em contato com o seu representante Lexmark. Para obter mais informações sobre como atualizar o firmware, entre em contato com seu representante Dell. Para obter mais informações sobre como atualizar o firmware, entre em contato com seu representante de vendas. Para obter o firmware mais recente, acesse  www.lexmark.com/downloads  e procure o modelo da impressora. Abra o navegador da Web e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Clique em  Configurações Dispositivo Atualizar firmware . Execute um dos seguintes procedimentos: Clique em  Verificar se há atualizações Eu concordo, iniciar atualização . Carregue o arquivo flash. Navegue até o arquivo flash. Verifique se você extraiu o arquivo ZIP do firmware. Clique em  Carregar Iniciar . como atualizar firmware firmware, atualização"},{"UUID":"6a2b2416-5312-46ef-b5b2-5cad55642b0c","title":"Como instalar e atualizar software, drivers e firmware","link":"installing-printer-software-topic.html","desc":"Como adicionar impressoras a um","descFull":"Como adicionar impressoras a um computador Antes de começar, execute um dos seguintes procedimentos: Conecte a impressora e o computador à mesma rede. Para obter mais informações sobre como conectar a impressora à rede, consulte  . Conecte o computador à impressora. Para mais informações, consulte  . Conecte a impressora ao computador utilizando um cabo USB. Para mais informações, consulte  . O cabo USB é vendido separadamente. Para usuários do Windows Instale o driver de impressão no computador. Para mais informações, consulte  . Abra  Impressoras e scanners  e clique em  Adicionar uma impressora ou scanner . Dependendo da conexão da sua impressora, execute um dos seguintes procedimentos: Selecione a impressora na lista e clique em  Adicionar dispositivo . Clique em  Mostrar impressoras Wi‑Fi Direct , selecione uma impressora e clique em  Adicionar dispositivo . Clique em  A impressora que desejo não está na lista  e, na janela  Adicionar impressora , execute este procedimento: Selecione  Adicionar uma impressora usando um endereço TCP/IP ou nome de host  e clique em  Avançar . No campo \" Nome do host ou Endereço IP \", digite o Endereço IP da impressora e clique em  Avançar . Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido em quatro conjuntos de números separados por pontos, por exemplo: 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Selecione um driver de impressão e clique em  Avançar . Selecione  Usar o driver de impressão já instalado (recomendado)  e clique em  Avançar . Digite um nome para a impressora e clique em  Avançar . Selecione uma opção de compartilhamento de impressora e clique em  Avançar . Clique em  Concluir . Para usuários do Macintosh Em um computador, abra  Impressoras e Scanners . Clique   e selecione uma impressora. No menu  Usar , selecione um driver de impressão. Para usar o driver de impressão para Macintosh, selecione  AirPrint  ou  Secure AirPrint . Se quiser recursos de impressão personalizados, selecione o driver de Lexmark Print. Para instalar o driver, consulte  . Se quiser recursos de impressão personalizados, selecione o driver de impressão do fabricante. Para instalar o driver, consulte  . Adicione a impressora. como adicionar impressoras a um computador"},{"UUID":"ea84aa29-4400-44bf-a348-da765d579733","title":"Como instalar e atualizar software, drivers e firmware","link":"installing-printer-software-topic.html","desc":"Exportando ou importando um arquivo","descFull":"Exportando ou importando um arquivo de configuração Você pode exportar as definições de configuração da impressora para um arquivo de texto e importar esse arquivo a fim de aplicar as definições em outras impressoras. Abra o navegador da Internet e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para carregar a página da web corretamente. No Servidor da Web incorporado, clique em  Exportar configurações  ou  Importar configurações . Siga as instruções exibidas na tela. Se a impressora for compatível com aplicativos, faça o seguinte: Clique em  Aplicativos selecione o aplicativo Configurar . Clique em  Exportar  ou  Importar . exportação de um arquivo de configuração usando o Embedded Web Server importação de um arquivo de configuração usando o Embedded Web Server"},{"UUID":"a08232c0-5626-42c8-8c51-df02a5415ee3","title":"Como instalar e atualizar software, drivers e firmware","link":"installing-printer-software-topic.html","desc":"Adicionar opções disponíveis ao driver","descFull":"Adicionar opções disponíveis ao driver de impressão Para usuários do Windows Abra a pasta de impressoras. Selecione a impressora que você deseja atualizar e execute os seguintes procedimentos: No Windows 7 ou posterior, selecione  Propriedades da impressora . Em versões anteriores, selecione  Propriedades . Navegue até a guia Configuração e selecione  Atualizar agora ‑ Perguntar à impressora . Aplique as alterações. Para usuários do Macintosh Em Preferências do sistema no menu da Apple, navegue até a impressora e selecione  Opções e suprimentos . Navegue até a lista de opções de hardware e, em seguida, adicione qualquer uma das opções instaladas. Aplique as alterações. adicionando opções de hardware driver de impressão driver de impressão opções de hardware, adicionando adicionando opções internas driver de impressão opções de hardware, adicionando driver de impressão opções internas, adicionando driver de impressão"},{"UUID":"9dc7dd3a-0339-4aca-9fb2-8accdebbf1c7","title":"Instalação de hardware opcional","link":"installing-envelope-tray-topic.html","desc":"Instalação da bandeja de envelope","descFull":"Instalação da bandeja de envelope Remova a bandeja padrão. Não jogue a bandeja padrão fora. Remova toda a embalagem da bandeja de envelope. Insira a bandeja de envelope. Para disponibilizar a bandeja de envelope para os trabalhos de impressão, na tela inicial, toque em  Configurações Dispositivo Manutenção Menu Configuração Configuração de bandeja Configuração da bandeja de envelopes Ativar . instalação da bandeja de envelope bandeja de envelope instalação opções de hardware bandeja de envelope"},{"UUID":"291c72bf-fe5c-4beb-a2e2-5b20b948d644","title":"Instalação de hardware opcional","link":"installing-envelope-tray-topic.html","desc":"Instalação da bandeja opcional para","descFull":"Instalação da bandeja opcional para 520 folhas Para evitar o risco de choque elétrico, se você for acessar a placa do controlador ou instalar hardware opcional ou dispositivos de memória algum tempo após configurar a impressora, desligue a impressora e desconecte o cabo de energia da tomada elétrica antes de continuar. Se houver outros dispositivos conectados à impressora, desligue-os também e desconecte os cabos que entram na impressora. Desligue a impressora. Desconecte o cabo de energia da tomada elétrica e da impressora. Remova toda a embalagem da bandeja opcional. Alinhe a impressora à bandeja opcional e encaixe a impressora no lugar. Se a impressora pesar mais de 20 kg (44 lb), então poderão ser necessárias duas ou mais pessoas para movê-la com segurança. Remova a bandeja padrão. Fixe a bandeja opcional na impressora usando os parafusos. Insira a bandeja padrão. Remova a tampa do conector da parte traseira da impressora. Ligue o conector da bandeja à impressora e, em seguida, encaixe a tampa. Fixe a parte traseira da bandeja opcional na impressora. Conecte o cabo de energia à impressora e à tomada elétrica. Para evitar o risco de incêndio ou choque elétrico, conecte o cabo de energia em uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja perto do produto. Ligue a impressora. Adicione a bandeja no driver de impressão para que ela fique disponível para os trabalhos de impressão. Para obter mais informações, consulte  . instalação da bandeja para 520 folhas bandeja para 520 folhas instalação opções de hardware bandeja para 520 folhas"},{"UUID":"526f844d-37f8-4adb-8b7e-b2a734a26a43","title":"Instalação de hardware opcional","link":"installing-envelope-tray-topic.html","desc":"Instalação da bandeja opcional para","descFull":"Instalação da bandeja opcional para 520 folhas com gabinete Para evitar o risco de choque elétrico, se você for acessar a placa do controlador ou instalar hardware opcional ou dispositivos de memória algum tempo após configurar a impressora, desligue a impressora e desconecte o cabo de energia da tomada elétrica antes de continuar. Se houver outros dispositivos conectados à impressora, desligue-os também e desconecte os cabos que entram na impressora. Desligue a impressora. Desconecte o cabo de energia da tomada elétrica e da impressora. Remova toda a embalagem da bandeja opcional. Trave os rodízios para impedir que o gabinete se mova. Alinhe a impressora à bandeja opcional e encaixe a impressora no lugar. Se a impressora pesar mais de 20 kg (44 lb), então poderão ser necessárias duas ou mais pessoas para movê-la com segurança. Remova a bandeja padrão. Fixe a bandeja opcional na impressora usando os parafusos. Insira a bandeja padrão. Remova a tampa do conector da parte traseira da impressora. Ligue o conector da bandeja à impressora e, em seguida, encaixe a tampa. Fixe a parte traseira da bandeja opcional na impressora. Ajuste os parafusos de nivelamento para garantir que todos os lados das impressoras tenham a mesma altura. Conecte o cabo de energia à impressora e à tomada elétrica. Para evitar o risco de incêndio ou choque elétrico, conecte o cabo de energia em uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja perto do produto. Ligue a impressora. Adicione a bandeja no driver de impressão para que ela fique disponível para os trabalhos de impressão. Para mais informações, consulte  . instalação da bandeja para 520 folhas com gabinete bandeja para 520 folhas com gabinete instalação opção de hardware bandeja para 520 folhas com gabinete"},{"UUID":"bc205dbd-5730-4a70-9267-15bc397b50bf","title":"Instalação de hardware opcional","link":"installing-envelope-tray-topic.html","desc":"Instalação da bandeja opcional para","descFull":"Instalação da bandeja opcional para 3 x 520 folhas Para evitar o risco de choque elétrico, se você for acessar a placa do controlador ou instalar hardware opcional ou dispositivos de memória algum tempo após configurar a impressora, desligue a impressora e desconecte o cabo de energia da tomada elétrica antes de continuar. Se houver outros dispositivos conectados à impressora, desligue-os também e desconecte os cabos que entram na impressora. Desligue a impressora. Desconecte o cabo de energia da tomada elétrica e da impressora. Remova toda a embalagem da bandeja opcional. Trave os rodízios para impedir que a bandeja se mova. Alinhe a impressora à bandeja opcional e encaixe a impressora no lugar. Se a impressora pesar mais de 20 kg (44 lb), então poderão ser necessárias duas ou mais pessoas para movê-la com segurança. Remova a bandeja padrão. Fixe a bandeja opcional na impressora usando os parafusos. Insira a bandeja padrão. Remova a tampa do conector da parte traseira da impressora. Ligue o conector da bandeja à impressora e, em seguida, encaixe a tampa. Fixe a parte traseira da bandeja opcional na impressora. Ajuste os parafusos de nivelamento para garantir que todos os lados da impressora tenham a mesma altura. Conecte o cabo de energia à impressora e à tomada elétrica. Para evitar o risco de incêndio ou choque elétrico, conecte o cabo de energia em uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja perto do produto. Ligue a impressora. Adicione a bandeja no driver de impressão para que ela fique disponível para os trabalhos de impressão. Para obter mais informações, consulte  . instalação da bandeja para 3 x 520 folhas bandeja para 3 x 520 folhas instalação opções de hardware bandeja para 3 x 520 folhas"},{"UUID":"713c38ec-ef0f-4ce0-8713-4a82f34d80ef","title":"Instalação de hardware opcional","link":"installing-envelope-tray-topic.html","desc":"Instalação da bandeja dupla opcional","descFull":"Instalação da bandeja dupla opcional para 2520 folhas Para evitar o risco de choque elétrico, se você for acessar a placa do controlador ou instalar hardware opcional ou dispositivos de memória algum tempo após configurar a impressora, desligue a impressora e desconecte o cabo de energia da tomada elétrica antes de continuar. Se houver outros dispositivos conectados à impressora, desligue-os também e desconecte os cabos que entram na impressora. Desligue a impressora. Desconecte o cabo de energia da tomada elétrica e da impressora. Remova toda a embalagem da bandeja opcional. Trave os rodízios para impedir que a bandeja se mova. Alinhe a impressora à bandeja opcional e encaixe a impressora no lugar. Se a impressora pesar mais de 20 kg (44 lb), então poderão ser necessárias duas ou mais pessoas para movê-la com segurança. Remova a bandeja padrão. Fixe a bandeja opcional na impressora usando os parafusos. Insira a bandeja padrão. Remova a tampa do conector da parte traseira da impressora. Ligue o conector da bandeja à impressora e, em seguida, encaixe a tampa. Fixe a parte traseira da bandeja opcional na impressora. Ajuste os parafusos de nivelamento para garantir que todos os lados das impressoras tenham a mesma altura. Conecte o cabo de energia à impressora e à tomada elétrica. Para evitar o risco de incêndio ou choque elétrico, conecte o cabo de energia em uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja perto do produto. Ligue a impressora. Adicione a bandeja no driver de impressão para que ela fique disponível para os trabalhos de impressão. Para mais informações, consulte  . instalação da bandeja para 2520 folhas bandeja para 2520 folhas instalação opções de hardware bandeja para 2520 folhas"},{"UUID":"dbd8dfec-eb79-49b4-a2aa-6f343d171430","title":"Instalação de hardware opcional","link":"installing-envelope-tray-topic.html","desc":"Instalação da bandeja opcional para","descFull":"Instalação da bandeja opcional para 2000 folhas Para evitar o risco de choque elétrico, se você for acessar a placa do controlador ou instalar hardware opcional ou dispositivos de memória algum tempo após configurar a impressora, desligue a impressora e desconecte o cabo de energia da tomada elétrica antes de continuar. Se houver outros dispositivos conectados à impressora, desligue-os também e desconecte os cabos que entram na impressora. Desligue a impressora. Desconecte o cabo de energia da tomada elétrica e da impressora. Remova toda a embalagem da bandeja opcional. Remova o parafuso de nivelamento da lateral esquerda da impressora. Não jogue o parafuso fora. Coloque o suporte de acoplamento na impressora. Use o suporte de acoplamento fornecido com a bandeja opcional. Instale a bandeja opcional. Conecte o conector da bandeja à impressora. Ajuste os parafusos de nivelamento para garantir que a bandeja tenha a mesma altura da impressora. Conecte o cabo de energia à impressora e à tomada elétrica. Para evitar o risco de incêndio ou choque elétrico, conecte o cabo de energia em uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja perto do produto. Ligue a impressora. Adicione a bandeja no driver de impressão para que ela fique disponível para os trabalhos de impressão. Para obter mais informações, consulte  . instalação da bandeja para 2000 folhas Bandeja de 2000 folhas instalação opções de hardware Bandeja de 2000 folhas"},{"UUID":"a92a8a45-90a0-4880-952f-e5a170240f1c","title":"Instalação de hardware opcional","link":"installing-envelope-tray-topic.html","desc":"Como instalar uma placa de","descFull":"Como instalar uma placa de fax Como instalar uma placa de fax Para evitar o risco de choque elétrico, se você for acessar a placa do controlador ou instalar hardware opcional ou dispositivos de memória algum tempo após configurar a impressora, desligue a impressora e desconecte o cabo de energia da tomada elétrica antes de continuar. Se houver outros dispositivos conectados à impressora, desligue-os também e desconecte os cabos que entram na impressora. Desligue a impressora. Desconecte o cabo de energia da tomada elétrica e da impressora. Usando uma chave de fenda, retire a tampa do fax. Remova a tampa do disco rígido. Remova a proteção da placa do controlador. Desembale a placa de fax. Fixe a placa de fax na tampa do disco rígido. Insira o cabo do conector de fax no compartimento da placa do controlador. Fixe a tampa do disco rígido. Conecte o cabo do conector do fax à placa do controlador. Fixe a blindagem da placa do controlador. Conecte o cabo de energia à impressora e à tomada elétrica. Para evitar riscos de incêndio ou choque elétrico, conecte o cabo de energia a uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja próxima ao produto. Ligue a impressora. placa de fax instalação Instalação de opções internas placa de fax"},{"UUID":"dd22af91-7834-473e-a7b6-10d11684fcdc","title":"Instalação de hardware opcional","link":"installing-envelope-tray-topic.html","desc":"Instalação de um disco rígido","descFull":"Instalação de um disco rígido na impressora Instalação de um disco rígido na impressora Para evitar o risco de choque elétrico, se você for acessar a placa do controlador ou instalar hardware opcional ou dispositivos de memória algum tempo após configurar a impressora, desligue a impressora e desconecte o cabo de energia da tomada elétrica antes de continuar. Se houver outros dispositivos conectados à impressora, desligue-os também e desconecte os cabos que entram na impressora. Desligue a impressora. Desconecte o cabo de energia da tomada elétrica e da impressora. Desembale o disco rígido e remova o suporte. Não toque nem pressione o centro do disco rígido. Remova a tampa do disco rígido. Remova a proteção da placa do controlador. Insira o conector do disco rígido ao compartimento da placa do controlador. Posicione o disco rígido sobre os orifícios de montagem e pressione até que ele  encaixe  no lugar. Fixe a tampa do disco rígido. Conecte o cabo do disco rígido à placa do controlador. Fixe a blindagem da placa do controlador. Conecte o cabo de energia à tomada elétrica e ligue a impressora. Para evitar riscos de incêndio ou choque elétrico, conecte o cabo de energia a uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja próxima ao produto. disco rígido da impressora instalação instalação de opções disco rígido da impressora"},{"UUID":"833dede5-5cb8-452a-b410-936caf019cff","title":"Instalação de hardware opcional","link":"installing-envelope-tray-topic.html","desc":"Instalação da prateleira de trabalho","descFull":"Instalação da prateleira de trabalho Desligue a impressora. Usando uma chave de fenda, remova as placas da tampa. Desembale a prateleira de trabalho. Conecte a prateleira de trabalho à impressora. Fixe a prateleira à impressora. Ligue a impressora. instalação da prateleira de trabalho prateleira de trabalho instalação"},{"UUID":"b9cd8c78-46c7-42f4-8e81-814662215e85","title":"Instalação de hardware opcional","link":"installing-envelope-tray-topic.html","desc":"Instalação da bandeja de coleta","descFull":"Instalação da bandeja de coleta dupla Desembale a bandeja de coleta dupla. Conecte a bandeja de coleta dupla à impressora. Para disponibilizar a bandeja para trabalhos de impressão, na tela inicial, toque em  Configurações Dispositivo Manutenção Menu Configuração Configuração do finalizador Definição da bandeja de saída 2 Ativado . instalação da bandeja de coleta dupla bandeja de coleta dupla instalação"},{"UUID":"addc4d96-be89-4151-a049-e7a0ba7c4482","title":"Instalação de hardware opcional","link":"installing-envelope-tray-topic.html","desc":"Instalando o grampeador Para evitar","descFull":"Instalando o grampeador Para evitar o risco de choque elétrico, se você for acessar a placa do controlador ou instalar hardware opcional ou dispositivos de memória algum tempo após configurar a impressora, desligue a impressora e desconecte o cabo de energia da tomada elétrica antes de continuar. Se houver outros dispositivos conectados à impressora, desligue-os também e desconecte os cabos que entram na impressora. Desligue a impressora. Desconecte o cabo de energia da tomada elétrica e da impressora. Remova a bandeja padrão. Não jogue a bandeja fora. Abra a porta frontal e remova o botão azul. Não jogue o botão fora. Remova a tampa lateral da bandeja padrão. Não jogue a tampa lateral da bandeja fora. Desembale o encadernador e remova o material de embalagem. Posicione o grampeador na traseira e remova o material de embalagem. Ajuste o suporte. Insira o encadernador. Feche a porta frontal. Fixe o encadernador na impressora. Use os parafusos fornecidos com o encadernador. Prenda o cabo do finalizador à impressora. Use os grampos fornecidos com o encadernador. Conecte o cabo do encadernador à impressora. Conecte o cabo de energia à impressora e à tomada elétrica. Para evitar o risco de incêndio ou choque elétrico, conecte o cabo de energia em uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja perto do produto. Ligue a impressora. Adicione o encadernador no driver de impressão para que fique disponível para trabalhos de impressão. Para obter mais informações, consulte  . instalando o encadernador encadernador instalação opções de hardware encadernador"},{"UUID":"3e3578e9-8c19-450f-a23c-34c82521642f","title":"Instalação de hardware opcional","link":"installing-envelope-tray-topic.html","desc":"Instalando o grampeador e perfurador","descFull":"Instalando o grampeador e perfurador Para evitar o risco de choque elétrico, se você for acessar a placa do controlador ou instalar hardware opcional ou dispositivos de memória algum tempo após configurar a impressora, desligue a impressora e desconecte o cabo de energia da tomada elétrica antes de continuar. Se houver outros dispositivos conectados à impressora, desligue-os também e desconecte os cabos que entram na impressora. Desligue a impressora. Desconecte o cabo de energia da tomada elétrica e da impressora. Remova toda a embalagem do finalizador de grampeamento e perfuração. Insira o suporte do cartucho de grampos no finalizador. Usando uma chave de fenda, fixe os suportes ao finalizador. Insira a bandeja no finalizador. Remova a bandeja padrão. Não jogue a bandeja padrão fora. Abra a porta frontal e remova o botão azul. Não jogue o botão fora. Remova a tampa lateral da bandeja padrão. Não jogue a tampa lateral da bandeja fora. Usando uma chave de fenda, fixe os suportes no lado direito da impressora. Insira o transporte de papel e prenda-o com parafusos. Use os parafusos fornecidos com o encadernador. Feche a porta frontal. Encaixe o encadernador na impressora. Ajuste os parafusos de nivelamento para garantir que todos os lados do finalizador tenham a mesma altura da impressora. Abra a porta do finalizador e instale o parafuso em sua parte esquerda. Feche a porta do encadernador. Conecte o transportador de papel à parte traseira do finalizador. Conecte o cabo do encadernador à parte traseira da impressora. Conecte o cabo de energia à impressora e à tomada elétrica. Para evitar o risco de incêndio ou choque elétrico, conecte o cabo de energia em uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja perto do produto. Ligue a impressora. Adicione o encadernador no driver de impressão para que fique disponível para trabalhos de impressão. Para obter mais informações, consulte  . Para disponibilizar o encadernador para os trabalhos de impressão, na tela inicial, toque em  Configurações Dispositivo Manutenção Menu Configuração Configuração do finalizador Configuração de perfuração  e selecione uma configuração. instalando o encadernador de perfuração e grampeamento instalação encadernador, perfurador"},{"UUID":"cd66e94f-8c13-47f0-b329-008bcef2a2d6","title":"Instalação do servidor de impressão sem fio","link":"installing-envelope-tray-topic.html","desc":"Instalando o Servidor de impressão","descFull":"Instalando o Servidor de impressão sem fio MarkNet N8372 Desligue a impressora. Aplique álcool isopropílico em um pano úmido, macio e sem fiapos e limpe a superfície ao redor da porta USB. Instale o módulo sem fio. Aplique pressão firme para garantir que a fita fique presa à superfície da impressora. Certifique-se de que a superfície da impressora esteja seca e sem umidade condensada. O módulo é melhor vinculado à impressora após 72 horas. Verifique se há uma folga entre o módulo e a impressora e, em seguida, prenda o módulo espaçador, se necessário. Conecte o cartão NFC. Ligue a impressora. servidor de impressão sem fio instalação instalação do servidor de impressão sem fio Servidor de impressão sem fio MarkNet N8372"},{"UUID":"e8067714-46ff-4088-8212-a632ad3bc106","title":"Colocando em rede","link":"networking-intro-topic.html","desc":"Este produto não inclui tecnologia","descFull":"Este produto não inclui tecnologia de rede sem fio. Para ativar a rede sem fio, adquira e instale o seguinte item opcional: As instruções a seguir somente serão aplicáveis se o item opcional estiver instalado. Para obter mais informações sobre a instalação do item opcional, consulte a seção \"Instalação do servidor de impressão sem fio\"."},{"UUID":"5a7b7e79-a3f3-40f8-9b72-a2586d4fda93","title":"Colocando em rede","link":"networking-intro-topic.html","desc":"Como conectar a impressora a","descFull":"Como conectar a impressora a uma rede sem fio Antes de começar, verifique se: O módulo sem fio está instalado na impressora. A opção  Adaptador ativo  está definida como  Automático . Na tela inicial, toque em  Configurações Rede/Portas Visão geral da rede Adaptador ativo . Uso do painel de controle Na tela inicial, toque em  Configurações Rede/Portas Sem fio Configurar no painel da impressora Escolher rede . Selecione uma rede Wi‑Fi e, em seguida, digite a senha da rede. Para impressoras prontas para rede Wi-Fi, um aviso solicitando a configuração da rede Wi-Fi será exibido durante a configuração inicial. Como usar o Lexmark Mobile Assistant Dependendo do dispositivo móvel, baixe o aplicativo Lexmark Mobile Assistant na App Store ou  Google Play . Na tela inicial, toque em  Configurações Rede/Portas Sem fio Configurar utilizando o aplicativo móvel ID da impressora . No dispositivo móvel, abra o aplicativo e aceite os Termos de uso. Se necessário, conceda permissões. Toque em  Conectar à impressora Ir para configurações de Wi-Fi . Conecte seu dispositivo móvel à rede sem fio da impressora. Retorne para o aplicativo e, em seguida, toque em  Configurar conexão Wi-Fi Selecione uma rede Wi-Fi e, em seguida, digite a senha da rede. Toque em  Concluído . rede sem fio conexão da impressora a como conectar a impressora a uma rede sem fio rede sem fio"},{"UUID":"27f70adf-04d3-44d1-8859-e6b845558e95","title":"Colocando em rede","link":"networking-intro-topic.html","desc":"Conectando a impressora em uma","descFull":"Conectando a impressora em uma rede sem fio usando o Wi-Fi Protected Setup (WPS) Antes de começar, verifique se: O ponto de acesso (roteador sem fio) é certificado para WPS ou compatível com WPS. Para obter mais informações, consulte a documentação fornecida com o ponto de acesso. Um adaptador de rede sem fio está instalado na impressora. Para obter mais informações, consulte as instruções fornecidas com o adaptador. O  Adaptador ativo  está definido como  Automático . Na tela inicial, toque em  Configurações Rede/Portas Visão geral da rede Adaptador ativo . Usando o método de botão de controle Na tela inicial, toque em  Configurações Rede/Portas Sem fio Configuração protegida de Wi-Fi Iniciar método de botão de controle . Siga as instruções exibidas no visor. Use o método de número de identificação pessoal (PIN) Na tela inicial, toque em  Configurações Rede/Portas Sem fio Configuração protegida de Wi-Fi Iniciar método de PIN . Copiar WPS PIN de oito dígitos. Abra um navegador da Web e digite o endereço IP do ponto de acesso no campo de endereços. Para saber o endereço IP, consulte a documentação fornecida com o ponto de acesso. Se você estiver usando um servidor proxy, desative-o temporariamente para carregar a página da Web corretamente. Acesse as definições WPS. Para obter mais informações, consulte a documentação fornecida com o ponto de acesso. Digite o PIN de oito dígitos e salve as alterações. Configuração protegida de Wi-Fi rede sem fio rede sem fio Configuração protegida de Wi-Fi conectando a uma rede sem fio usando o método de PIN método com número de identificação pessoal conectando a uma rede sem fio usando o método Push Button (botão de controle) método acionado por botão"},{"UUID":"87e82643-dab7-4aca-a449-c35c8a0ad9f5","title":"Colocando em rede","link":"networking-intro-topic.html","desc":"Como configurar o Wi‑Fi Direct","descFull":"Como configurar o Wi‑Fi Direct Wi-Fi Direct  é uma tecnologia ponto a ponto com base em Wi-Fi que permite que dispositivos sem fio se conectem diretamente a uma impressora habilitada para Wi-Fi Direct sem usar um ponto de acesso (roteador sem fio). Na tela inicial, toque em  Configurações Rede/Portas Wi-Fi Direct . Defina as configurações. Ativar Wi‑Fi Direct : permite que a impressora transmita sua própria rede Wi-Fi Direct. Nome do Wi‑Fi Direct : atribui um nome para a rede Wi-Fi Direct. Senha do Wi‑Fi Direct : atribui a senha para negociar a segurança sem fio ao usar a conexão ponto a ponto. Mostrar senha na página de configuração : mostra a senha na Página de configuração de rede. Aceitar automaticamente as solicitações do botão de controle : permite que a impressora aceite solicitações de conexão automaticamente. A opção para aceitar solicitações de botão de controle automaticamente não está protegida. Por padrão, a senha de rede Wi-Fi Direct não fica visível no visor da impressora. Para visualizar a senha, ative o ícone exibir senha. Na tela inicial, toque em  Configurações Segurança Diversos Ativar revelação de senha/PIN . Para saber a senha da rede Wi-Fi Direct sem mostrá-la no visor da impressora, na tela inicial, toque em  Configurações Relatórios Rede Página de configuração de rede . Wi-Fi Direct configuração como configurar o Wi‑Fi Direct"},{"UUID":"6620d1ea-a3ca-49d5-9382-bde131c5fb32","title":"Colocando em rede","link":"networking-intro-topic.html","desc":"Como conectar um dispositivo móvel","descFull":"Como conectar um dispositivo móvel à impressora Antes de conectar seu dispositivo móvel, verifique se o Wi‑Fi Direct foi configurado. Para mais informações, consulte  . Como conectar via Wi‑Fi Direct Estas instruções são aplicáveis somente aos dispositivos móveis Android. No dispositivo móvel, acesse o menu de configurações. Ative o  Wi-Fi  e toque em  Wi-Fi Direct . Selecione o nome Wi-Fi Direct da impressora. Confirme a conexão no painel de controle da impressora. Como conectar via Wi‑Fi No dispositivo móvel, acesse o menu de configurações. Toque em  Wi‑Fi  e, em seguida, selecione o nome do Wi-Fi Direct da impressora. A cadeia de caracteres DIRECT-xy (em que x e y representam dois caracteres aleatórios) é adicionada antes do nome do Wi-Fi Direct. Digite a senha do Wi-Fi Direct. como conectar o dispositivo móvel à impressora dispositivo móvel como conectar com a impressora Wi-Fi Direct ativação como ativar o Wi‑Fi Direct"},{"UUID":"445dd128-224d-4a81-bce3-c439ce8ae3fa","title":"Colocando em rede","link":"networking-intro-topic.html","desc":"Wi-Fi Direct Como conectar um","descFull":"Wi-Fi Direct Como conectar um computador à impressora Antes de conectar o computador, verifique se o Wi‑Fi Direct foi configurado. Para mais informações, consulte  . Para usuários do Windows Abra  Impressoras e scanners  e clique em  Adicionar uma impressora ou scanner . Clique em  Mostrar impressoras Wi-Fi Direct  e selecione o nome do Wi‑Fi Direct da impressora. Anote o PIN de oito dígitos exibido no visor da impressora. Insira o PIN no computador. Se o driver da impressora ainda não estiver instalado, o Windows fará o download do driver apropriado. Para usuários do Macintosh Clique no ícone da conexão sem fio e selecione o nome do Wi‑Fi Direct da impressora. A cadeia de caracteres DIRECT-xy (em que x e y representam dois caracteres aleatórios) é adicionada antes do nome do Wi-Fi Direct. Digite a senha do Wi‑Fi Direct. Alterne o computador de volta para a rede anterior depois de desconectar-se da rede Wi-Fi Direct. computador como se conectar à impressora como conectar um computador à impressora"},{"UUID":"128d0269-fe45-4471-8155-47043d5b79e8","title":"Colocando em rede","link":"networking-intro-topic.html","desc":"Desativando a rede Wi-Fi Na","descFull":"Desativando a rede Wi-Fi Na tela inicial, toque em  Configurações Rede/Portas Visão geral da rede Adaptador ativo Rede padrão . Siga as instruções exibidas no visor. Rede Wi-Fi desativação desativando a rede Wi-Fi"},{"UUID":"ab157bdb-b582-41c6-a4a2-b29af7d87edd","title":"Colocando em rede","link":"networking-intro-topic.html","desc":"Verificação da conectividade da impressora","descFull":"Verificação da conectividade da impressora Na tela inicial, toque em  Configurações Relatórios Rede Página de configurações de rede . Consulte a primeira seção da página de configurações de rede e confirme se o status está definido como conectado. Se o status estiver definido como não conectado, talvez o ponto de rede esteja inativo ou o cabo de rede não esteja funcionando corretamente. Entre em contato com o administrador para assistência. impressão página de configuração de rede impressão de uma página de configuração de rede página de configuração de rede impressão"},{"UUID":"9d6f3dfa-c555-487d-802d-ffc87fecb4ee","title":"Instalação e configuração","link":"setting-up-serial-printing-topic.html","desc":"Configuração da impressão serial (somente","descFull":"Configuração da impressão serial (somente no Windows) Antes de começar, certifique-se de que uma porta serial de soluções internas esteja instalada na impressora. Configure os parâmetros da impressora. No painel de controle da impressora, navegue até o menu com as configurações da porta. Localize o menu das configurações da porta serial e ajuste-as, caso necessário. Aplique as alterações. No computador, abra a pasta de impressoras e selecione a impressora. Abra as propriedades da impressora e, em seguida, selecione a porta COM da lista. Configure os parâmetros da porta COM no Gerenciador de dispositivos. A impressão serial reduz a velocidade de impressão. Verifique se o cabo serial está conectado à porta serial na impressora. configurando a impressão serial impressão serial configuração"},{"UUID":"781f11bc-001e-4fb7-a096-68285b1eede0","title":"Proteção da impressora","link":"locating-security-slot-topic.html","desc":"Localização do slot de segurança","descFull":"Localização do slot de segurança A impressora é equipada com um recurso de trava de segurança. Conecte uma trava de segurança compatível com a maioria dos computadores laptop no local mostrado para prender a impressora e o disco rígido no local. slot de segurança localização como localizar slot de segurança"},{"UUID":"85c6f437-9db0-48e3-9d8d-fa9f93677956","title":"Proteção da impressora","link":"erasing-printer-memory-topic.html","desc":"Apagar a memória da impressora","descFull":"Apagar a memória da impressora Para apagar a memória volátil ou dados armazenados em buffer na impressora, desligue a impressora. Para apagar a memória não-volátil, configurações de dispositivo e de rede, configurações de segurança e soluções incorporadas, faça o seguinte: Na tela inicial, toque em  Configurações Dispositivo Manutenção Apagamento fora de serviço . Toque em  Limpar todas as informações da memória não volátil  e toque em  APAGAR . Toque em  Iniciar assistente de configuração inicial  ou  Deixar impressora desligada  e, em seguida, toque em  Avançar . Inicie a operação. Esse processo também destrói a chave de criptografia usada para proteger os dados do usuário. Destruir a chave de criptografia torna os dados irrecuperáveis. memória volátil limpando memória não volátil limpando memória da impressora limpando limpando memória da impressora"},{"UUID":"18f02888-21a9-4b5c-8a15-ab0630956b47","title":"Proteção da impressora","link":"erasing-printer-storage-drive-topic.html","desc":"Como apagar a unidade de","descFull":"Como apagar a unidade de armazenamento da impressora Na tela inicial, toque em  Configurações Dispositivo Manutenção Apagamento fora de serviço . Dependendo da unidade de armazenamento instalada na impressora, siga um destes procedimentos: Para disco rígido, toque na caixa de seleção  Apagar todas as informações no disco rígido , toque em  APAGAR  e selecione um método para apagar dados. Esse processo de apagar o disco rígido pode levar de vários minutos até mais de uma hora, tornando a impressora indisponível para outras tarefas. Para a unidade de armazenamento inteligente (ISD), toque em  Apagar unidade de armazenamento inteligente  e, em seguida, toque em  APAGAR  para apagar todos os dados do usuário. Inicie a operação. unidade de armazenamento limpando como apagar a unidade de armazenamento da impressora disco rígido limpando unidade de armazenamento inteligente limpando"},{"UUID":"079f5b65-8dee-4a14-905d-a6bc51028dc3","title":"Proteção da impressora","link":"restoring-factory-default-settings-topic.html","desc":"Restauração das configurações padrão de","descFull":"Restauração das configurações padrão de fábrica Na tela inicial, toque em  Configurações Dispositivo Restaurar os padrões de fábrica . Toque em  Restaurar configurações selecione as configurações que deseja restaurar. RESTAURAR . Inicie a operação. configurações padrão de fábrica restaurando configurações da impressora restaurando para os padrões de fábrica"},{"UUID":"676de736-8f40-4e2e-9835-d42f18cef9b2","title":"Proteção da impressora","link":"statement-of-volatility-topic.html","desc":"Declaração de volatilidade Tipos de","descFull":"Declaração de volatilidade Tipos de memórias e suas descrições Tipo de memória Descrição Memória volátil A impressora usa a memória RAM padrão para armazenar em buffer temporariamente os dados do usuário durante os trabalhos de cópia ou de impressão simples. Memória não volátil A impressora pode usar duas formas de memória não volátil: EEPROM e NAND (memória flash). Ambos os tipos armazenam o sistema operacional, as configurações da impressora e as informações de rede. Eles também armazenam configurações de scanner e marcador, além de soluções incorporadas. Unidade de armazenamento em disco rígido Algumas impressoras possuem uma unidade de disco rígido instalada. O disco rígido da impressora foi desenvolvido para funcionalidade específica de impressora. O disco rígido permite que a impressora retenha os dados do usuário armazenados em buffer de trabalhos de impressão complexos, dados de formulários e dados de fontes. Unidade de armazenamento inteligente (ISD) Algumas impressoras podem ter um ISD instalado. O ISD usa memória flash não volátil para armazenar dados do usuário de trabalhos de impressão complexos, dados de formulários e dados de fontes. Apague o conteúdo de qualquer memória de impressora instalada nas seguintes circunstâncias: A impressora está desativada. O disco rígido da impressora ou ISD foi substituído. A impressora foi movida para um outro departamento ou local. A impressora está em manutenção por uma pessoa fora da sua organização. A impressora foi removida de seu local para passar por manutenção. A impressora foi vendida para outra organização. Para descartar uma unidade de armazenamento, siga as políticas e os procedimentos da sua organização. declaração de volatilidade memória volátil memória não volátil unidade de armazenamento em disco rígido unidade de armazenamento inteligente como limpar a memória da impressora proteger os dados da impressora"},{"UUID":"228da0d9-b7cb-43bc-b947-09b4fe46c88e","title":"Print","link":"printing-from-computer-h2-topic.html","desc":"Impressão de um computador Para","descFull":"Impressão de um computador Para etiquetas, cartões e envelopes, defina o tipo e o tamanho do papel na impressora antes de imprimir o documento. No documento que deseja imprimir, abra a caixa de diálogo Imprimir. Se necessário, ajuste as definições. Imprima o documento. impressão de um computador documentos, impressão de um computador imprimindo de um computador"},{"UUID":"270a20d9-b8bc-44ad-bee9-929adb4cf86a","title":"Impressão a partir de um dispositivo móvel","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Imprima de um dispositivo móvel","descFull":"Imprima de um dispositivo móvel utilizando o Lexmark Mobile Print Imprima de um dispositivo móvel utilizando o Lexmark Mobile Print Lexmark  O Mobile Print permite enviar documentos e imagens diretamente para um dispositivo da Lexmark. Abra o documento, e depois envie ou compartilhe o documento para o Mobile Print. Alguns aplicativos de terceiros podem não suportar o recurso de envio ou compartilhamento. Para obter mais informações, consulte a documentação que acompanha o aplicativo. Selecione uma impressora. Imprima o documento. Lexmark Mobile Print uso documentos, impressão de um dispositivo móvel dispositivo móvel impressão a partir de"},{"UUID":"99d676e2-e474-45e5-84ed-ee491aa3f21f","title":"Impressão a partir de um dispositivo móvel","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Imprimir de um dispositivo móvel","descFull":"Imprimir de um dispositivo móvel utilizando o Lexmark Print Lexmark  A impressão é uma solução de mobile printing para dispositivos móveis que operam com  Android  versão 6.0 ou posterior. Ele permite que você envie documentos e imagens para impressoras conectadas em rede e servidores de gerenciamento de impressão. Faça o download do aplicativo Lexmark Print na loja  Google Play  e habilite-o no dispositivo móvel. Verifique se a impressora e o dispositivo móvel estão conectados à mesma rede. No dispositivo móvel, selecione um documento no gerenciador de arquivos. Enviar ou compartilhar o documento para Impressão da Lexmark. Alguns aplicativos de terceiros podem não suportar o recurso de envio ou compartilhamento. Para obter mais informações, consulte a documentação que acompanha o aplicativo. Selecione uma impressora e depois ajuste as configurações, se necessário. Imprima o documento. Impressão Lexmark uso documentos, impressão de um dispositivo móvel dispositivo móvel impressão a partir de"},{"UUID":"12967d68-d25d-4f69-9b3c-795b63bab47b","title":"Impressão a partir de um dispositivo móvel","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Imprimindo a partir de um","descFull":"Imprimindo a partir de um dispositivo móvel utilizando o serviço de impressão Mopria Mopria  O serviço de impressão é uma solução de mobile printing para dispositivos móveis que operam com o  Android  versão 5.0 ou posterior. Permite que você imprima diretamente em qualquer impressora certificada da Mopria. Faça o download do aplicativo de serviço de impressão Mopria na loja do  Google Play  e habilite-o no dispositivo móvel. No seu dispositivo móvel Android, inicie um aplicativo compatível ou selecione um documento do gerenciador de arquivos. Toque em  Imprimir . Selecione uma impressora e depois ajuste as as configurações, se necessário. Toque no  . serviço de impressão Mopria impressão a partir de um dispositivo móvel dispositivo móvel como imprimir a partir de impressão como usar o serviço de impressão Mopria"},{"UUID":"fa240803-de1d-4a1e-a57b-9e1eeb0414b4","title":"Impressão a partir de um dispositivo móvel","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Impressão a partir de um","descFull":"Impressão a partir de um dispositivo móvel com AirPrint O recurso de software AirPrint é uma solução de mobile printing que permite imprimir diretamente de dispositivos da Apple em uma impressora certificada da AirPrint. Certifique-se de que o dispositivo Apple e a impressora estejam conectados à mesma rede. Se a rede contém diversos hubs sem fio, certifique-se de que os dispositivos estejam conectados à mesma sub-rede. Esse aplicativo está disponível apenas em alguns dispositivos da Apple. Do dispositivo móvel, selecione um documento através do gerenciador de arquivos ou inicie um aplicativo compatível. Toque em  Imprimir . Selecione uma impressora e depois ajuste as as configurações, se necessário. Imprima o documento. AirPrint uso impressão a partir de um dispositivo móvel dispositivo móvel como imprimir a partir de"},{"UUID":"73c89781-5889-4d05-b860-227e29360fb5","title":"Impressão a partir de um dispositivo móvel","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Imprimindo a partir de um","descFull":"Imprimindo a partir de um dispositivo móvel com o Wi‑Fi Direct® Wi-Fi Direct  é um serviço de impressão que permite imprimir em qualquer impressora pronta para Wi‑Fi Direct®. Verifique se o dispositivo móvel está conectado à rede sem fio da impressora. Para mais informações, consulte  . No seu dispositivo móvel, inicie um aplicativo compatível ou selecione um documento do gerenciador de arquivos. Dependendo do dispositivo móvel, faça o seguinte: Toque em  Imprimir . Toque em  Imprimir . Toque em  Imprimir . Selecione uma impressora e depois ajuste as as configurações, se necessário. Imprima o documento. Wi-Fi Direct como imprimir a partir de um dispositivo móvel impressão a partir de um dispositivo móvel dispositivo móvel como imprimir a partir de impressão como usar o Wi‑Fi Direct"},{"UUID":"11cdda7e-ef27-4390-b6a7-20de1b282f67","title":"Print","link":"printing-from-flash-drive-topic.html","desc":"Impressão a partir de uma","descFull":"Impressão a partir de uma unidade flash Insira a unidade flash. Se você inserir a unidade flash e uma mensagem de erro for exibida, a impressora está ignorando a unidade flash. Se você inserir a unidade flash enquanto a impressora estiver processando outros trabalhos de impressão, a mensagem  Ocupada  será exibida. No visor, toque no documento que você deseja imprimir. Se necessário, configure as definições de impressão. Imprima o documento. Para imprimir outro documento, toque em  Unidade USB . Para evitar avaria ou perda de dados da impressora, não toque na unidade flash nem na impressora na área mostrada enquanto a impressora estiver imprimindo ativamente, lendo ou gravando no dispositivo de memória. impressão de uma unidade flash unidade flash como imprimir a partir de"},{"UUID":"6860e94a-9649-4328-9b7a-db0850d1f9ed","title":"Print","link":"supported-flash-drives-and-file-types-topic.html","desc":"Unidades flash e tipos de","descFull":"Unidades flash e tipos de arquivo suportados Unidades flash Lexar JumpDrive S70 (16 GB e 32 GB) SanDisk Cruzer Micro (16 GB e 32 GB) PNY Attaché (16GB e 32GB) A impressora suporta unidades flash de alta velocidade com padrão de velocidade máxima. Unidades flash devem ser compatíveis com o sistema de arquivos FAT (File Allocation Tables). Tipos de arquivo Tipos de arquivo suportados Documentos Imagens PDF (versão 1.7 ou anterior) Formatos de arquivos da Microsoft (DOC, DOCX, XLS, XLSX, PPT e PPTX) JPEG ou JPG TIFF ou TIF GIF BMP PNG PCX DCX unidades de flash suportadas unidades flash suportados tipos de arquivo suportados tipos de arquivo suportados"},{"UUID":"1c6a3cd9-51cb-4205-a4e1-bde4c241267e","title":"Print","link":"configuring-confidential-jobs-topic.html","desc":"Configurar trabalhos confidenciais Na tela","descFull":"Configurar trabalhos confidenciais Na tela inicial, toque em  Configurações Segurança Configurações de impressão confidencial . Defina as configurações. Itens e descrições do menu  Configuração de impressão confidencial Configuração Descrição Máximo de PINs inválidos Defina o limite para inserir um PIN inválido. Quando o limite é alcançado, os trabalhos de impressão desse nome de usuário são excluídos. Expiração de trabalho confidencial Defina individualmente o tempo de expiração para cada trabalho suspenso antes que ele seja excluído automaticamente da memória da impressora, do disco rígido ou da unidade de armazenamento inteligente. Um trabalho suspenso pode estar com o status  Confidencial ,  Repetir ,  Reservar  ou  Verificar . Expiração de trabalho para repetição Defina o tempo de expiração para os trabalhos de impressão que deseja repetir. Expiração de trabalho para verificação Defina o tempo de expiração para a impressão da cópia de um trabalho para que você verifique a qualidade antes de imprimir as cópias restantes. Expiração de trabalho para reserva Defina o tempo de expiração para os trabalhos que deseja armazenar na impressora para impressões posteriores. Exigir que todos os trabalhos sejam mantidos Configure a impressora para suportar todos os trabalhos de impressão. Manter documentos duplicados Programe a impressora para manter todos os documentos com o mesmo nome de arquivo. trabalhos de impressão confidenciais configuração trabalhos suspensos definição do tempo de expiração armazenando trabalhos de impressão repetir trabalhos de impressão verificar trabalhos de impressão"},{"UUID":"e43a2b19-43d0-477d-bd86-e5a37e96d01b","title":"Print","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"Como imprimir trabalhos confidenciais e","descFull":"Como imprimir trabalhos confidenciais e outros trabalhos suspensos Para usuários do Windows Com um documento aberto, clique em  Arquivo Imprimir . Selecione um impressora e clique em  Propriedades ,  Preferências ,  Opções  ou  Configuração . Clique em  Imprimir e reter . Selecione  Usar imprimir e reter  e atribua um nome de usuário. Selecione o tipo do trabalho de impressão (Confidencial, Repetir, Reservar ou Verificar). Se você selecionar  Confidencial , proteja o trabalho de impressão com um número de identificação pessoal (PIN). Clique em  OK  ou em  Imprimir . Na tela inicial da impressora, libere o trabalho de impressão. Para trabalhos de impressão confidenciais, toque em  Trabalhos suspensos  selecione o nome de usuário Confidencial  digite o PIN  selecione o trabalho de impressão  defina as configurações Imprimir . Para outros trabalhos de impressão, toque em  Trabalhos suspensos  selecione o nome de usuário  selecione o trabalho de impressão  defina as configurações Imprimir . Para usuários do Macintosh Como usar o AirPrint Com um documento aberto, escolha  Arquivo Imprimir . Selecione uma impressora e, no menu suspenso próximo ao menu  Orientação , escolha  Impressão por PIN . Ative  Imprimir com PIN  e digite um PIN de quatro dígitos. Clique em  Imprimir . Na tela inicial da impressora, libere o trabalho de impressão. Toque em  Trabalhos suspensos  Selecione o nome do seu computador Confidencial  Digite o PIN Selecione o trabalho de impressão Imprimir . Como usar o driver de impressão Com um documento aberto, escolha  Arquivo Imprimir . Selecione uma impressora e, no menu suspenso próximo ao menu  Orientação , escolha  Imprimir e reter . Escolha  Impressão confidencial  e insira um PIN de quatro dígitos. Clique em  Imprimir . Na tela inicial da impressora, libere o trabalho de impressão. Toque em  Trabalhos suspensos  Selecione o nome do seu computador Confidencial Selecione o trabalho de impressão  Digite o PIN Imprimir . imprimindo trabalhos suspensos imprimindo trabalhos de impressão confidenciais trabalhos de impressão confidenciais imprimindo trabalhos suspensos imprimindo"},{"UUID":"df7dc6a3-572e-43bb-bdcc-f4300d3a01a8","title":"Print","link":"printing-font-sample-list-h2-topic.html","desc":"Imprimindo uma lista de amostras","descFull":"Imprimindo uma lista de amostras de fontes Na tela inicial, toque em  Configurações  Relatórios Imprimir Imprimir fontes . Toque em  Fontes PCL  ou  Fontes PS . imprimindo lista de amostra de fontes imprimindo uma lista de amostra de fontes lista de amostra de fontes imprimindo"},{"UUID":"535b89db-6dce-41e0-a49d-38c6f0be290f","title":"Print","link":"printing-directory-list-h2-topic.html","desc":"Impressão de uma lista de","descFull":"Impressão de uma lista de diretórios Na tela inicial, toque em  Configurações Relatórios Imprimir Imprimir diretório . impressão lista de diretórios impressão de uma lista de diretórios lista de diretórios impressão"},{"UUID":"3495cfba-ec2b-49b1-80d5-d245fa0f283d","title":"Print","link":"placing-separator-sheets-topic.html","desc":"Folhas separadoras entre as cópias","descFull":"Folhas separadoras entre as cópias Na tela inicial, toque em  Configurações Imprimir Layout Folhas separadoras Entre cópias . Imprima o documento. folhas separadoras colocando inserindo folhas separadoras"},{"UUID":"97a73c1c-4cd4-4c77-a2e0-21b066b21b36","title":"Print","link":"stapling-printed-sheets-topic.html","desc":"Grampeamento de folhas impressas Para","descFull":"Grampeamento de folhas impressas Para usuários do Windows Com um documento aberto, clique em  Arquivo Imprimir . Selecione um impressora e clique em  Propriedades ,  Preferências ,  Opções  ou  Configuração . Clique em  Papel/Finalizador . Se necessário, defina as configurações de Papel. No menu Concluindo, selecione a configuração de grampeamento. Clique em  OK  ou em  Imprimir . Para usuários do Macintosh Com um documento aberto, escolha  Arquivo Imprimir . Selecione uma impressora e, em seguida, no menu suspenso próximo ao menu  Orientação , escolha  Concluindo . Clique em  Grampear  e selecione uma configuração. Clique em  Imprimir . grampeamento de folhas impressas folhas impressas grampeamento"},{"UUID":"be58ca93-6846-47e6-825c-4f3d5c89c1eb","title":"Print","link":"punching-holes-printed-sheets-topic.html","desc":"Perfuração em folhas impressas Antes","descFull":"Perfuração em folhas impressas Antes de começar, certifique-se de que as configurações de perfuração estejam definidas. Na tela inicial da impressora, toque em  Configurações Dispositivo Manutenção Menu Configuração Configuração do finalizador Configuração de perfuração   selecione uma configuração. Para usuários do Windows Com um documento aberto, clique em  Arquivo Imprimir . Selecione um impressora e clique em  Propriedades ,  Preferências ,  Opções  ou  Configuração . Clique em  Papel/Finalizador . Se necessário, defina as configurações de Papel. No menu Concluindo, selecione a configuração de perfuração. Clique em  OK  ou em  Imprimir . Para usuários do Macintosh Com um documento aberto, escolha  Arquivo Imprimir . Selecione uma impressora e, em seguida, no menu suspenso próximo ao menu Orientação, escolha  Concluindo . Clique em  Perfurar  e selecione uma configuração. Clique em  Imprimir . perfuração em folhas impressas folhas impressas perfuração"},{"UUID":"49f1528e-f104-4b7e-9f04-c9f4766eacf5","title":"Print","link":"using-offset-stacking-printed-sheets-topic.html","desc":"Como usar o empilhamento de","descFull":"Como usar o empilhamento de separação em folhas impressas Para usuários do Windows Com um documento aberto, clique em  Arquivo Imprimir . Selecione um impressora e clique em  Propriedades ,  Preferências ,  Opções  ou  Configuração . Clique em  Papel/Finalizador . Se necessário, defina as configurações de Papel. No menu Concluindo, selecione a configuração Separação. Clique em  OK  ou em  Imprimir . Para usuários do Macintosh Com um documento aberto, escolha  Arquivo Imprimir . Selecione uma impressora e, em seguida, no menu suspenso próximo ao menu  Orientação , escolha  Concluindo . Clique em  Separação  e selecione uma configuração. Clique em  Imprimir . empilhamento em folhas impressas folhas impressas empilhamento com separação"},{"UUID":"8cf08d56-e5e9-4c90-b9b7-955fc01c5178","title":"Print","link":"canceling-print-job-topic.html","desc":"Cancelamento de um trabalho de","descFull":"Cancelamento de um trabalho de impressão Na tela inicial, toque em  . Selecione o trabalho a ser cancelado. Você também pode cancelar um trabalho tocando em  Fila de trabalhos . trabalho de impressão cancelamento cancelamento de um trabalho de impressão"},{"UUID":"9f5c5eaf-e269-4c30-b2a5-8b7836115a7c","title":"Print","link":"adjusting-toner-darkness-topic.html","desc":"Ajustando a tonalidade do toner","descFull":"Ajustando a tonalidade do toner Na tela inicial, toque em  Configurações Qualidade de Impressão . No menu Tonalidade do toner, ajuste a configuração. tonalidade do toner ajuste ajuste da tonalidade do toner"},{"UUID":"6531f2c4-5a63-4825-975f-4e191a960db5","title":"Copiar","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"Usando o alimentador automático de","descFull":"Usando o alimentador automático de documentos e o vidro do scanner Carregando papel na bandeja do ADF e no vidro do scanner Alimentador Automático de Documentos (ADF) Vidro do scanner Use o ADF para várias páginas ou documentos frente e verso. Coloque um documento original voltado para cima. Para documentos de várias páginas, certifique-se de alinhar a borda principal antes de carregar. Ajuste as guias do ADF para que correspondam ao tamanho do papel que está sendo carregado. Use o vidro do scanner para páginas únicas de documentos, páginas de livros, itens pequenos (como cartões-postais ou fotografias), transparências, papel fotográfico ou mídia muito fina (como recortes de revistas). Coloque o documento voltado para baixo no canto com a seta. copiar como usar o alimentador automático de documentos (ADF) copiar como usar o vidro do scanner"},{"UUID":"02dde4ea-f026-40f4-9046-8832790ae9e2","title":"Copiar","link":"making-copies-topic.html","desc":"Cópias Coloque o documento original","descFull":"Cópias Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Para evitar imagens cortadas, confira se o documento original e a saída possuem o mesmo tamanho de papel. Na tela inicial, toque em  Copiar  e especifique o número de cópias. Se necessário, ajuste as definições de cópia. Copie o documento. Para fazer uma cópia rápida, na tela inicial, toque em  . como fazer cópias uso do ADF cópia usando o vidro do scanner cópia como copiar fotos para bandeja selecionada cópia de tamanhos de papel diferentes tamanhos de papel diferentes, copiando"},{"UUID":"00b400df-0da7-4abe-8fb7-80ea6dd690d2","title":"Copiar","link":"copying-photos-topic.html","desc":"Cópia de fotos Coloque uma","descFull":"Cópia de fotos Coloque uma foto no vidro do scanner. Na tela inicial, toque em  Copiar Conteúdo Tipo de conteúdo Fotografia . Toque em  Origem do conteúdo  e escolha a definição que melhor corresponda à fotografia original. Copiar a fotografia. copiar fotos fotos, copiar"},{"UUID":"2cbb2f1e-89a2-44b4-a9c7-fd652bc9bffa","title":"Copiar","link":"copying-transparencies-or-letterhead-topic.html","desc":"Copiando em papel timbrado Coloque","descFull":"Copiando em papel timbrado Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Na tela inicial, toque em  Copiar Copiar de e selecione o tamanho do documento original. Clique em  Copiar para  e selecione a origem do papel que contém o papel timbrado. Se você carregou o papel timbrado no alimentador multifuncional, toque em  Copiar para Alimentador multifuncional selecione um tamanho de papel Papel timbrado . Copie o documento. cópia em papel timbrado papel timbrado cópia em"},{"UUID":"1336a7ed-823c-4338-8d08-6f325142dc72","title":"Copiar","link":"copying-on-both-sides-of-paper-topic.html","desc":"Cópia nos dois lados do","descFull":"Cópia nos dois lados do papel Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Na tela inicial, toque em  Copiar Lados . Toque em  Simples para frente e verso  ou  Frente e verso para frente e verso . Copie o documento. copiar Impressão nos dois lados do papel cópia em frente e verso"},{"UUID":"35f59496-1ca9-4a7d-bae3-e81a3196ab49","title":"Copiar","link":"reducing-enlarging-copies-topic.html","desc":"Redução ou ampliação de cópias","descFull":"Redução ou ampliação de cópias Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Na tela inicial, toque em  Copiar Dimensionar selecione um valor de ajuste. A alteração do tamanho do documento original ou saída após definir a opção  Ajustar  restaura o valor para  Automático . Copie o documento. redução de um tamanho de cópia ampliação de um tamanho de cópia"},{"UUID":"d9bb6908-6b88-4662-807f-8a671294fc51","title":"Copiar","link":"collating-copies-topic.html","desc":"Agrupamento de cópias Carregue um","descFull":"Agrupamento de cópias Carregue um documento original na bandeja do ADF ou no vidro do scanner. Na tela inicial, toque em  Copiar Agrupar Ativado [1,2,1,2,1,2 ] . Copie o documento. agrupando cópias separando várias cópias"},{"UUID":"60a3a1b7-b7e1-4687-88c2-2ebd3dd141a4","title":"Copiar","link":"placing-separator-sheets-between-copies-topic.html","desc":"Folhas separadoras entre as cópias","descFull":"Folhas separadoras entre as cópias Carregue um documento original na bandeja do ADF ou no vidro do scanner. Na tela inicial, toque em  Copiar Folhas separadoras . Ajuste as configurações. Envie o trabalho de cópia. Folhas separadoras entre as cópias cópia"},{"UUID":"7f07f0c3-7ab6-465f-8155-5c4cbc27dd20","title":"Copiar","link":"saving-paper-topic.html","desc":"Para copiar várias páginas em","descFull":"Para copiar várias páginas em uma única folha Carregue um documento original na bandeja do ADF ou no vidro do scanner. Na tela inicial, toque em  Copiar Páginas por lado . Ajuste as configurações. Copie o documento. copiar várias páginas em uma única folha economia de papel economia de toner"},{"UUID":"45ba9ba4-d25a-41d4-a46e-70d2ceeda02c","title":"Copiar","link":"copying-cards-topic.html","desc":"Cópia de cartões Coloque um","descFull":"Cópia de cartões Coloque um cartão no vidro do scanner. Na tela inicial, toque em  Copiar Copiar de . Toque em  cartão de ID . Copie o cartão. cópia cartões cartões cópia"},{"UUID":"be29c336-8f54-4ec0-9538-ea0fb9dcd43b","title":"Copiar","link":"stapling-copies-topic.html","desc":"Grampeamento de cópias Coloque o","descFull":"Grampeamento de cópias Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Para evitar imagens cortadas, confira se o documento original e a saída possuem o mesmo tamanho de papel. Na tela inicial, toque em  Copiar  e especifique o número de cópias. Se necessário, ajuste as definições de cópia. Toque em  Concluindo Grampear  e selecione a configuração de grampo. Copie o documento. grampeamento de cópias Cópias grampeamento"},{"UUID":"1b63d0d2-ae6d-4638-a374-e2738decc4a5","title":"Copiar","link":"punching-holes-copies-topic.html","desc":"Perfuração em cópias Coloque o","descFull":"Perfuração em cópias Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Para evitar imagens cortadas, confira se o documento original e a saída possuem o mesmo tamanho de papel. Na tela inicial, toque em  Copiar  e especifique o número de cópias. Se necessário, ajuste as definições de cópia. Toque em  Concluindo  Perfurar  e selecione a configuração de perfuração. Copie o documento. perfuração em cópias Cópias perfuração"},{"UUID":"def192c2-e9d2-436a-9a2a-ebc35dfe3d9f","title":"Copiar","link":"using-offset-stacking-copies-topic.html","desc":"Usando empilhamento de separação em","descFull":"Usando empilhamento de separação em cópias Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Para evitar imagens cortadas, confira se o documento original e a saída possuem o mesmo tamanho de papel. Na tela inicial, toque em  Copiar  e especifique o número de cópias. Se necessário, ajuste as definições de cópia. Toque em  Páginas de separação  e, sem seguida, selecione uma configuração. Copie o documento. empilhamento em cópias Cópias empilhamento com separação"},{"UUID":"80872a0a-9f6c-44ae-a59d-c69fe6c754c0","title":"Copiar","link":"creating-copy-shortcut-topic.html","desc":"Criando um atalho de cópia","descFull":"Criando um atalho de cópia Na tela inicial, toque em  Copiar . Ajuste as configurações e toque em  . Crie um atalho. criando um atalho cópia adicionando um atalho cópia atalho, criando uma cópia"},{"UUID":"163bd3fe-10a5-4548-8377-e624075d4b76","title":"E-mail","link":"using-ADF-and-scanner-glass-e-mail-topic.html","desc":"Usando o alimentador automático de","descFull":"Usando o alimentador automático de documentos e o vidro do scanner Carregando papel na bandeja do ADF e no vidro do scanner Alimentador Automático de Documentos (ADF) Vidro do scanner Use o ADF para várias páginas ou documentos frente e verso. Coloque um documento original voltado para cima. Para documentos de várias páginas, certifique-se de alinhar a borda principal antes de carregar. Ajuste as guias do ADF para que correspondam ao tamanho do papel que está sendo carregado. Use o vidro do scanner para páginas únicas de documentos, páginas de livros, itens pequenos (como cartões-postais ou fotografias), transparências, papel fotográfico ou mídia muito fina (como recortes de revistas). Coloque o documento voltado para baixo no canto com a seta. envio de e-mail como usar o alimentador automático de documentos (ADF) envio de e-mail como usar o vidro do scanner"},{"UUID":"a018dddd-9401-4b35-b897-f18883145739","title":"E-mail","link":"sending-email-topic.html","desc":"Como enviar e- mail Antes","descFull":"Como enviar e- mail Antes de começar, certifique-se de que as configurações SMTP de e-mail estejam configuradas. Para obter mais informações, consulte  . Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Na tela inicial, toque em  E-mail  e, em seguida, insira as informações necessárias. Se necessário, defina as configurações de digitalização. Envie o e-mail. e-mail envio como enviar e-mail"},{"UUID":"8bf940cf-85de-479f-b2ef-9b4938970288","title":"E-mail","link":"creating-email-shortcut-topic.html","desc":"Criação de um atalho de","descFull":"Criação de um atalho de e-mail Na tela inicial, toque em  E-mail . Ajuste as configurações e toque em  . Crie um atalho. criando o atalho e-mail adicionando atalhos e-mail atalhos, criação e-mail atalhos de e-mail criação"},{"UUID":"7cbd1947-db75-4d4b-b3db-8d8a556f1483","title":"Fax","link":"using-ADF-and-scanner-glass-fax-topic.html","desc":"Usando o alimentador automático de","descFull":"Usando o alimentador automático de documentos e o vidro do scanner Carregando papel na bandeja do ADF e no vidro do scanner Alimentador Automático de Documentos (ADF) Vidro do scanner Use o ADF para várias páginas ou documentos frente e verso. Coloque um documento original voltado para cima. Para documentos de várias páginas, certifique-se de alinhar a borda principal antes de carregar. Ajuste as guias do ADF para que correspondam ao tamanho do papel que está sendo carregado. Use o vidro do scanner para páginas únicas de documentos, páginas de livros, itens pequenos (como cartões-postais ou fotografias), transparências, papel fotográfico ou mídia muito fina (como recortes de revistas). Coloque o documento voltado para baixo no canto com a seta. fax como usar o alimentador automático de documentos (ADF) fax como usar o vidro do scanner"},{"UUID":"ba8fa336-b202-4492-b4b1-a307261d4d3f","title":"Fax","link":"sending-fax-topic.html","desc":"Como enviar um fax Certifique-se","descFull":"Como enviar um fax Certifique-se de que o fax esteja configurado. Para obter mais informações, consulte os  Configuração da impressora para envio de fax  a seção. Uso do painel de controle Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Na tela inicial, toque em  Fax  e insira as informações necessárias. Se necessário, ajuste as configurações. Envie o fax. Como usar o computador Antes de começar, verifique se o driver do fax está instalado. Para mais informações, consulte  . Para usuários do Windows No documento que você está tentando enviar por fax, abra a caixa de diálogo  Imprimir . Selecione a impressora e clique em  Propriedades ,  Preferências ,  Opções  ou  Configurar . Clique em  Fax Ativar fax Sempre exibir configurações de fax antes de enviá-lo  e digite o número do destinatário. Se necessário, defina outras configurações de fax. Envie o fax. Para usuários do Macintosh Com um documento aberto, escolha  Arquivo Imprimir . Selecione a impressora que possui  – Fax  adicionado após seu nome. No campo  Para , insira o número do destinatário. Se necessário, defina outras configurações de fax. Envie o fax. como enviar fax fax enviando"},{"UUID":"eb9fb862-7d4a-4576-8b47-4bf0a187986c","title":"Fax","link":"scheduling-fax-topic.html","desc":"Programação do envio de um","descFull":"Programação do envio de um fax Certifique-se de que o fax esteja configurado. Para obter mais informações, consulte a seção  Configurando a impressora para enviar fax . Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Na tela inicial, toque em  Fax Para insira o número do fax Concluído . Toque em  Tempo de envio , configure a data e a hora e, em seguida, toque em  OK . Envie o fax. como programar o envio de um fax fax, programação"},{"UUID":"42174e16-7a3e-487b-bb37-b7d8da5eab22","title":"Fax","link":"creating-fax-destination-shortcut-topic.html","desc":"Criando um atalho de destino","descFull":"Criando um atalho de destino de fax Certifique-se de que o fax esteja configurado. Para obter mais informações, consulte a seção  Configurando a impressora para enviar fax . Na tela inicial, toque em  Fax Para . Digite o número de fax do destinatário e toque em  Concluído . Ajuste as configurações e toque em  . Crie um atalho. como criar atalho destino de fax como adicionar atalhos destino de fax atalho, criando destino de fax atalho de destino do fax criação"},{"UUID":"03353d52-7f16-4a63-815e-1fce1362ed27","title":"Fax","link":"changing-fax-resolution-topic.html","desc":"Como alterar a resolução do","descFull":"Como alterar a resolução do fax Certifique-se de que o fax esteja configurado. Para obter mais informações, consulte os  Configuração da impressora para envio de fax  a seção. Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Na tela inicial, toque em  Fax  e insira as informações necessárias. Toque em  Resolução  e selecione uma configuração. Envie o fax. resolução de fax alteração alterando resolução do fax"},{"UUID":"ebb8d13e-1370-47d6-800b-03697aa9422a","title":"Fax","link":"adjusting-fax-darkness-topic.html","desc":"Como ajustar a tonalidade do","descFull":"Como ajustar a tonalidade do fax Certifique-se de que o fax esteja configurado. Para obter mais informações, consulte os  Configuração da impressora para envio de fax  a seção. Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Na tela inicial, toque em  Fax  e insira as informações necessárias. Toque em  Tonalidade  e ajuste a configuração. Envie o fax. como ajustar a tonalidade do fax tonalidade do fax ajuste"},{"UUID":"73d8100d-2180-46ce-aaee-f78d7ccd1371","title":"Fax","link":"printing-fax-log-topic.html","desc":"Impressão de um log de","descFull":"Impressão de um log de fax Certifique-se de que o fax analógico ou o etherFAX esteja configurado. Para obter mais informações, consulte os  Configuração da impressora para envio de fax  a seção. Na tela inicial, toque em  Configurações Relatórios Fax . Toque em  Log de trabalhos de fax  ou em  Log de chamadas de fax . registro de fax impressão impressão de um log de fax"},{"UUID":"62198ffd-d8e1-4d7b-bb7e-289ca08fb7b6","title":"Fax","link":"blocking-junk-faxes-topic.html","desc":"Como bloquear faxes indesejados Certifique-se","descFull":"Como bloquear faxes indesejados Certifique-se de que o fax analógico ou o etherFAX esteja configurado. Para obter mais informações, consulte os  Configuração da impressora para envio de fax  a seção. Na tela inicial, toque em  Configurações Fax Configurações de fax Configurações de recebimento de fax Controles administrativos . Defina  Bloquear fax sem nome  para  Ativado . faxes indesejados bloqueando como bloquear faxes indesejados"},{"UUID":"1382d335-895f-4293-8c6e-7a4078690912","title":"Fax","link":"holding-faxes-topic.html","desc":"Como reter fax Certifique-se de","descFull":"Como reter fax Certifique-se de que o fax analógico ou o etherFAX esteja configurado. Para obter mais informações, consulte os  Configuração da impressora para envio de fax  a seção. Na tela inicial, toque em  Definições Fax Configuração de fax Configurações de recebimento de fax Reter fax . Selecione um modo. como reter fax faxes recebidos reter fax reter"},{"UUID":"8fb9f603-b71f-4c0b-90b6-013a15450f9b","title":"Fax","link":"forwarding-fax-topic.html","desc":"Como encaminhar fax Certifique-se de","descFull":"Como encaminhar fax Certifique-se de que o fax analógico ou o etherFAX esteja configurado. Para obter mais informações, consulte os  Configuração da impressora para envio de fax  a seção. Crie um atalho de destino. Abra o navegador da Web e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial. O endereço IP é exibido em quatro conjuntos de números separados por pontos, por exemplo: 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Clique em  Atalhos Adicionar atalho . Selecione um tipo de atalho e, em seguida, defina as configurações. Anote o número do atalho. Aplique as alterações. Clique em  Configurações Fax Configuração de fax Configurações de recebimento de fax Controles do administrador . No menu  Encaminhamento de fax , selecione  Encaminhar  ou  Imprimir e encaminhar . No menu  Encaminhar para , selecione o tipo de destino e digite o número do atalho. Aplique as alterações. como encaminhar fax fax encaminhando"},{"UUID":"1ac3f3ea-4047-47a0-aa87-c0dcf82662d9","title":"Examinar","link":"using-ADF-and-scanner-glass-scan-topic.html","desc":"Usando o alimentador automático de","descFull":"Usando o alimentador automático de documentos e o vidro do scanner Carregando papel na bandeja do ADF e no vidro do scanner Alimentador Automático de Documentos (ADF) Vidro do scanner Use o ADF para várias páginas ou documentos frente e verso. Coloque um documento original voltado para cima. Para documentos de várias páginas, certifique-se de alinhar a borda principal antes de carregar. Ajuste as guias do ADF para que correspondam ao tamanho do papel que está sendo carregado. Use o vidro do scanner para páginas únicas de documentos, páginas de livros, itens pequenos (como cartões-postais ou fotografias), transparências, papel fotográfico ou mídia muito fina (como recortes de revistas). Coloque o documento voltado para baixo no canto com a seta. como digitalizar como usar o alimentador automático de documentos (ADF) como digitalizar como usar o vidro do scanner"},{"UUID":"b46dc71b-257f-4ad6-a956-bb6819723c9a","title":"Examinar","link":"scanning-to-computer-topic.html","desc":"Digitalização para um computador Antes","descFull":"Digitalização para um computador Antes de começar, certifique-se de que o computador e a impressora estejam conectados à mesma rede. Para usuários do Windows Como usar o Lexmark ScanBack Utility No computador, execute o Lexmark ScanBack Utility e clique em  Avançar . Para baixar o utilitário, acesse  www.lexmark.com/downloads . Clique em  Configurar  e adicione o endereço IP da impressora. Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Clique em  Fechar Avançar . Selecione o tamanho do documento original e clique em  Avançar . Selecione um formato de arquivo e uma resolução de digitalização e clique em  Avançar . Digite um nome de perfil de digitalização exclusivo e clique em  Avançar . Navegue até o local onde deseja salvar o documento digitalizado, crie um o nome do arquivo e clique em  Avançar . Para reutilizar o perfil de digitalização, habilite a opção  Criar atalho  e crie um nome de atalho exclusivo. Clique em  Concluir . Carregue um documento original no alimentador automático de documentos ou no vidro do scanner. Na tela inicial da impressora, toque em  Perfis de digitalização Digitalização para computador  e, em seguida, selecione um perfil de digitalização. Verifique se  Perfis de digitalização  foi adicionado à tela inicial. Para obter mais informações, consulte  . Para usuários do Windows Como usar o Fax e Scanner do Windows Verifique se a impressora está adicionada ao computador. Para obter mais informações, consulte  . Carregue um documento original no alimentador automático de documentos ou no vidro do scanner. No computador, abra o  Fax e Scanner do Windows . No menu  Fonte , selecione a origem do scanner. Se necessário, altere as configurações de digitalização. Digitalize o documento. Para usuários do Macintosh Verifique se a impressora está adicionada ao computador. Para obter mais informações, consulte  . Carregue um documento original no alimentador automático de documentos ou no vidro do scanner. Na computador, execute um dos seguintes procedimentos: Abra  Captura de imagem . Abra  Impressoras e scanners e selecione uma impressora. Clique em  Digitalizar Abrir scanner . Na janela  Scanner , execute um ou mais dos seguintes procedimentos: Selecione onde deseja salvar o documento digitalizado. Selecione o tamanho do documento original. Para digitalizar do ADF, selecione  Alimentador de documentos  no  Menu Digitalizar  ou ative a opção  Usar alimentador de documentos . Se necessário, defina as configurações de digitalização. Clique em  Digitalizar . digitalização para um computador computador, como digitalizar para Lexmark ScanBack Utility uso"},{"UUID":"030e6eb3-be36-46f6-84e7-8e4c44c1a3f6","title":"Examinar","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"Digitalização para um servidor FTP","descFull":"Digitalização para um servidor FTP Digitalização para um servidor FTP Coloque o documento original na bandeja do ADF ou no vidro do scanner. Na tela inicial, toque em  FTP  e insira as informações necessárias. Se necessário, configure outras definições de FTP. Envie o trabalho de FTP. Servidor FTP, digitalizando para usando o painel de controle digitalização para um servidor FTP digitalização para um servidor FTP usando o painel de controle"},{"UUID":"0e8ebd88-8b98-4ba6-85fd-9e2915f1586f","title":"Examinar","link":"creating-FTP-shortcut-topic.html","desc":"Criação de um atalho de","descFull":"Criação de um atalho de FTP Na tela inicial, toque em  FTP . Digite o endereço do servidor FTP e toque em  . Crie um atalho. criando o atalho Endereço FTP adicionando atalhos Endereço FTP Endereço FTP criando o atalho atalhos, criação Endereço FTP"},{"UUID":"e2d9eb71-0640-4b76-9bf3-1064505ca646","title":"Examinar","link":"s2a-scanning-to-network-folders-topic.html","desc":"Digitalização em uma pasta de","descFull":"Digitalização em uma pasta de rede Coloque o documento na bandeja do ADF ou no vidro do scanner. Na tela inicial, toque em  Scan Center . O ícone e nome podem ter sido alterados. Para obter mais informações, entre em contato com o administrador. Execute um dos seguintes procedimentos: Selecione um destino. Para o SFTP, configure o número da porta para  22 . Use um atalho tocando em   e, em seguida, selecione o atalho na lista. Digitalize o documento. Digitalização em uma pasta de rede Pequenas e médias empresas digitalização"},{"UUID":"be4fe249-ae1f-4ca5-aedf-6432c0ca621d","title":"Examinar","link":"creating-network-folder-shortcut-topic.html","desc":"Criando um atalho para a","descFull":"Criando um atalho para a pasta da rede Abra o navegador da Internet e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para carregar a página da Web corretamente. Clique em  Atalhos Adicionar atalho . No menu Tipo de atalho, selecione  Pasta da rede  e configure as definições. Aplique as alterações. pasta de rede criando um atalho criando um atalho pasta de rede"},{"UUID":"5b5f3b56-4bc9-4ad6-bdc6-06693a94195b","title":"Examinar","link":"scanning-to-flash-drive-topic.html","desc":"Como digitalizar para uma unidade","descFull":"Como digitalizar para uma unidade flash Coloque o documento original na bandeja do ADF ou sobre o vidro do scanner. Insira a unidade flash. Toque em  Digitalizar para USB  e ajuste as configurações, se necessário. Para salvar o documento digitalizado em uma pasta, toque em  Digitalizar para , selecione uma pasta e toque em  Digitalizar aqui . Se a tela  Unidade USB  não for exibida, toque em  Unidade USB  no painel de controle. Digitalize o documento. Para evitar avaria ou perda de dados da impressora, não toque na unidade flash nem na impressora na área mostrada enquanto a impressora estiver imprimindo ativamente, lendo ou gravando no dispositivo de memória. como digitalizar para uma unidade flash unidade flash como digitalizar para"},{"UUID":"bda0e9ac-9ef9-4270-ac2c-5a04e9b17f61","title":"Uso dos menus da impressora","link":"menu-map-mfp-topic.html","desc":"Mapa de menus Dispositivo Preferências","descFull":"Mapa de menus Dispositivo Preferências Modo econômico Painel Operador Remoto Notificações Gerenciamento de energia Coleta anônima de dados Acessibilidade Restaurar padrões de fábrica Manutenção Personalização da tela inicial Sobre esta impressora Print Layout Concluindo Configuração Qualidade Cont. de trabalhos PDF PostScript PCL Imagem Papel Configuração de bandeja Configuração de mídia Cópia Padrões de cópia Fax Padrões de fax E-mail Configuração de e-mail Padrões de e-mail Configuração de link da Web FTP Padrões de FTP Unidade USB Digitalização para a unidade flash Impressão da unidade flash Rede/portas Visão geral da rede Sem fio Wi-Fi Direct AirPrint Gerenciamento de serviços móveis Ethernet TCP/IP SNMP IPSec 802.1x Configuração LPD Configurações de HTTP/FTP ThinPrint USB Restringir acesso à rede externa Segurança Métodos de login Programar dispositivos USB Log de auditoria de segurança Restrições de login Configuração de impressão confidencial Criptografia de disco Apagar arquivos de dados temporários Configurações de soluções LDAP Diversos Serviços na nuvem Registro nos serviços na nuvem Relatórios Página de definições de menu Dispositivo Print Atalhos Fax Rede Solução de problemas Páginas de teste de qualidade de impressão Limpeza do scanner menus da impressora"},{"UUID":"025aa0a3-ff08-4813-ab75-171bf1b4b641","title":"Dispositivo","link":"preferences-topic.html","desc":"Preferências Itens e descrições do","descFull":"Preferências Itens e descrições do menu  Preferências Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Idioma de exibição [Lista de idiomas] Define o idioma do texto exibido no visor. País/região [Lista de países ou regiões] Identificar o país ou região em que a impressora está configurada para operar. Executar configuração inicial Desativado * Ativado Executa o assistente de configuração. Teclado Tipo de teclado [Lista de idiomas] Seleciona um idioma como um tipo de teclado. Todos os valores do  Tipo de teclado  podem não ser exibidos ou podem exigir hardware especial para serem exibidos. Informação exibida Texto de exibição 1  ( endereço IP *) Texto de exibição 2  ( Data/Hora *) Texto personalizado 1 Texto personalizado 2 Especifica as informações a serem exibidas na tela inicial. Data e hora Configurar Data e hora atuais Definir data e hora manualmente Formato de data  (MM‑DD‑AAAA*) Formato de hora  (12 horas AM/PM*) Fuso horário  (UTC‑5:00*) Protocolo de tempo da rede Ativar NTP  ( Ativado *) Servidor NTP Ativar autenticação  ( Nenhuma *) Configura a data e a hora da impressora e o protocolo de tempo da rede. Tamanhos de papel EUA * Métrica Especifica a unidade de medida dos tamanhos de papel. O país ou a região selecionado no assistente de configuração inicial determina a configuração inicial do tamanho do papel. Brilho da tela 20–100% (100*) Ajusta o brilho do monitor. Acesso à unidade flash Desativado Ativado * Ativa o acesso à unidade flash. Permitir remoção de plano de fundo Desativado Ativado * Especifica se a remoção do plano de fundo é permitida. Permitir digitalização de trabalhos personalizados Desativado Ativado * Especifica se a configuração  Digitalização de trabalho personalizado  é exibida para cópia, digitalização e fax. Essa configuração do menu é exibida apenas quando há um disco rígido instalado. Digitalizando uma página do scanner de mesa Desativado * Ativado Configura a impressora para digitalizar qualquer tipo de trabalho que envolva o vidro do scanner como uma página só. A impressora retorna à tela inicial depois de executar uma digitalização do scanner de mesa, em vez de exibir avisos. Sons do dispositivo Silenciar todos os sons  ( Desativado ) Botão Feedback  ( Ativado *) Acessar os comentários sobre o dispositivo  ( Ativado *) Volume  (5*) Bipe de carregamento no ADF  ( Desativado *) Controle de alarme  ( Único ) Alarme do cartucho  ( Simples *) Modo de alto-falante  ( Sempre desativado *) Volume do toque  ( Desativado *) Configure as definições de som da impressora. Tempo limite da tela 5–300 segundos (60*) Define o tempo ocioso, em segundos, antes de o monitor exibir a tela inicial ou antes de a impressora desconectar uma conta de usuário automaticamente. menu Preferências"},{"UUID":"b5d12350-8659-47f3-b40d-da67fab874ca","title":"Dispositivo","link":"preferences-topic.html","desc":"Modo Eco Itens e descrições","descFull":"Modo Eco Itens e descrições do menu  Modo Eco Item do menu Descrição Um asterisco (*) próximo ao valor indica a definição padrão de fábrica. Imprimir Lados Simples * Frente e verso Especificar se a impressão será realizada em um ou em ambos os lados do papel. Imprimir Páginas por lado Desativado * 2 páginas por lado 3 páginas por lado 4 páginas por lado 6 páginas por lado 9 páginas por lado 12 páginas por lado 16 páginas por lado Imprimir imagens de várias páginas em um lado de uma folha de papel. Imprimir Tonalidade do toner 1–10 (8*) Determinar o nível de tonalidade das imagens e textos. Copiar Lados Simples para simples * Simples para frente e verso Frente e verso para simples Frente e verso para frente e verso Especificar o comportamento de digitalização com base no documento original. Copiar Páginas por lado Desativado * 2 páginas em modo retrato 4 páginas em modo retrato 2 páginas em modo paisagem 4 páginas em modo paisagem Especificar o comportamento de digitalização com base no documento original. Copiar Tonalidade 1–9 (5*) Determinar a tonalidade das imagens e textos digitalizados. menu Modo econômico"},{"UUID":"737ea01e-88a4-4d04-94e6-57430878a643","title":"Dispositivo","link":"preferences-topic.html","desc":"Painel Operador Remoto Itens e","descFull":"Painel Operador Remoto Itens e descrições do menu  Painel operador remoto Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração-padrão de fábrica. Conexão VNC externa Não permitir * Permitir Conectar um cliente VNC (Virtual Network Computing) externo ao painel de controle remoto. Tipo de autenticação Nenhum * Autenticação padrão Configure o tipo de autenticação ao acessar o servidor do cliente VNC. Senha do VNC Especifique a senha para se conectar ao servidor do cliente VNC. Esse item de menu será exibido somente se o  Tipo de autenticação  estiver configurado como  Autenticação-padrão . menu Painel Operador Remoto"},{"UUID":"be7c76b7-afd0-4808-9051-77658caffc90","title":"Dispositivo","link":"preferences-topic.html","desc":"Notificações Itens e descrições do","descFull":"Notificações Itens e descrições do menu  Notificações Item do menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Bipe de carregamento no ADF Desativar Ativar * Ativar um alerta sonoro ao carregar papel no alimentador automático de documentos (ADF). Controle de alarme Desativar Único * Contínuo Definir o número de vezes que o alarme é emitido quando a impressora exige intervenção pelo usuário. Suprimentos Mostrar estimativas do suprimento Mostrar estimativas * Não mostrar estimativas Exibir o status estimado dos suprimentos. Suprimentos Alarme do cartucho  ( Simples *) Alarme de grampos  ( Desativado *) Alarme de perfuração  ( Desativado *) Definir o número de vezes que o alarme soa quando o cartucho de toner está baixo, o cartucho de grampos está vazio ou o receptáculo de perfuração está cheio ou ausente, respectivamente. Alarme de grampos  e  Alarme de perfuração  estão disponíveis somente quando estão instaladas opções de saída. Suprimentos Notificações personalizadas de suprimento Coloque a unidade que a impressora usa para calcular utilização do suprimento e acionador notificações personalizadas quando a intervenção do usuário for necessária. Este item de menu é exibido somente no Embedded Web Server. Configuração de alertas de e-mail Configuração de e-mail Gateway SMTP primário Porta do gateway SMTP primário  (25*) Gateway SMTP secundário Porta do gateway SMTP secundário  (25*) Tempo Limite SMTP  (30 segundos*) Endereço de resposta Sempre utilizar o endereço de resposta padrão SMTP  ( Desativado *) Usar SSL/TLS  ( Desativado *) Solicitar certificado confiável  ( Ativar *) Autenticação do servidor SMTP  ( Nenhuma autenticação necessária *) E-mail iniciado por dispositivo  ( Nenhum *) E-mail iniciado por usuário  ( Nenhum *) Utilizar credenciais de dispositivo do Active Directory  ( Desativado *) ID do usuário do dispositivo Senha do dispositivo UNIVERSO Kerberos 5 Domínio NTLM Desativar o erro \"Servidor SMTP não está configurado\"  ( Desativado *) Configurar as definições de e-mail da impressora. Configuração de alertas de e-mail Configurar listas e alertas de e-mail Lista de e-mail 1 Lista de e-mail 2 Eventos de e-mail Especifica os endereços de e‑mail e ativa os eventos de alerta por e‑mail. Este item de menu é exibido somente no Embedded Web Server. Prevenção de erro Assistente de atolamento Desativar Ativar * Configurar a impressora para descarregar automaticamente as páginas em branco ou as páginas com impressão parcial após uma página atolada ser liberada. Prevenção de erro Continuação automática Desativar Ativado * (5 segundos) Permitir que a impressora continue a processar ou a imprimir um trabalho automaticamente depois de remover determinadas condições exigirem a intervenção do usuário. Prevenção de erro Reinicialização automática Reinicialização automática Reinicializar quando ocioso Sempre reinicializar * Nunca reinicializar Definir a reinicialização da impressora quando ocorrer um erro. Prevenção de erro Reinicialização automática Máximo de reinicializações automáticas 1–20 (2*) Definir o número de reinicializações automáticas que a impressora pode executar. Prevenção de erro Reinicialização automática Janela de reinicialização automática 1–525.600 segundos (720*) Define o tempo até a próxima reinicialização automática da impressora. Prevenção de erro Reinicialização automática Contador de reinicialização automática Mostrar uma informação somente leitura do contador de reinicialização. Prevenção de erro Reinicialização automática Redefinir Contador de reinicialização automática Cancelar Continuar Redefine o  Contador de reinicialização automática . Prevenção de erro Exibir erro de papel curto Ativar Limpeza automática * Definir a exibição de uma mensagem quando ocorrer um erro de papel curto na impressora. Papel curto refere-se ao tamanho do papel carregado. Prevenção de erro Proteção de página Desativar * Ativar Configurar a impressora para processar a página inteira na memória antes de imprimi-la. Recuperação de conteúdo de atolamento Recuperação de atolamento Desativar Ativar Automático * Definir uma nova impressão das páginas atoladas na impressora. Recuperação de conteúdo de atolamento Recuperação de atolamento do scanner Nível do trabalho Nível da página * Especificar como reiniciar um trabalho de digitalização após resolver um atolamento de papel. menu Notificações"},{"UUID":"1bdde48f-fa4f-4d59-8618-c52b9943d1c2","title":"Dispositivo","link":"preferences-topic.html","desc":"Gerenciamento de energia Itens e","descFull":"Gerenciamento de energia Itens e descrições do menu  Gerenciamento de energia Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Perfil Modo de suspensão Impressão no modo de Suspensão Permanecer ativa após impressão Entrar no modo de Suspensão após a impressão * Definir a impressora para permanecer no modo ativo ou entrar no modo de Suspensão após a impressão. Perfil Modo de suspensão Toque para sair do modo de suspensão profunda Desativado * Ativado Ative a impressora do modo Suspenso tocando no monitor da impressora. Tempos limite Modo de suspensão De 1 a 114 minutos (15*) Configurar o tempo ocioso antes que a impressora comece a funcionar no modo de Suspensão. Tempos limite Tempo limite de hibernação Desativado 1 hora 2 horas 3 horas 6 horas 1 dia 2 dias 3 dias * 1 semana 2 semanas 1 mês Definir o tempo até a impressora ser desligada. Tempos limite Tempo limite de hibernação na conexão Hibernar Não hibernar * Definir  Tempo limite de hibernação  para desligar a impressora se houver uma conexão Ethernet ativa. Programar modos de energia Programações Adicionar nova programação Programar quando a impressora deve entrar no modo de Suspensão ou de Hibernação. menu Gerenciamento de energia"},{"UUID":"ded74d80-19fc-4822-b92c-58783d54be00","title":"Dispositivo","link":"preferences-topic.html","desc":"Coleta anônima de dados Itens","descFull":"Coleta anônima de dados Itens e descrições do menu  Coleta anônima de dados Item do menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Coleta anônima de dados Informações de uso e desempenho do dispositivo Nenhum * Enviar à Lexmark as informações de uso e de desempenho da impressora. Enviar ao fabricante as informações de uso e de desempenho da impressora. A  Hora de envio de dados anônimos  é exibida somente quando você define  Coleta anônima de dados  como  Uso e desempenho do dispositivo . Hora de envio de dados anônimos Hora de início Hora de término menu Coleta anônima de dados"},{"UUID":"5523a4e8-879d-4c5c-93f2-4e1f9b683ba7","title":"Dispositivo","link":"preferences-topic.html","desc":"Acessibilidade Itens e descrições do","descFull":"Acessibilidade Itens e descrições do menu Acessibilidade Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração-padrão de fábrica. Intervalo de toque duplicado na tecla 0 - 5 (0*) Definir o intervalo em segundos durante o qual a impressora ignora os pressionamentos duplicados de tecla em um teclado acoplado. Atraso inicial de repetição de tecla 0,25 - 5 (1*) Definir a duração inicial do atraso, em segundos, antes de a tecla que se repete começar a repetir. Este item de menu é exibido apenas quando um teclado está conectado à impressora. Taxa de repetição de tecla 0,5 - 30 (30*) Ajustar o número de pressionamentos por segundo para uma tecla que se repete. Este item de menu é exibido apenas quando um teclado está conectado à impressora. Prolong. tempo lim. da tela Desativar * Ativar Permite que o usuário permaneça no mesmo local e redefina  Tempo limite da tela  temporizador quando ele expirar em vez de retornar à tela inicial. Volume do fone 1 - 10 (5*) Ajustar o volume do fone de ouvido. Este item de menu é exibido apenas quando um fone de ouvido está conectado à impressora. Habilitar instruções por voz quando houver fone de ouvido conectado Desativar * Ativar Habilitar instruções por voz quando um fone de ouvido estiver conectado à impressora. Senhas/PINs falados Desativar * Ativar Configurar a impressora para ler senhas ou números de identificação pessoal em voz alta. Este item de menu é exibido apenas quando um fone de ouvido ou um alto-falante estiver conectado à impressora. Velocidade de fala Muito lentamente Devagar Normal * Fácil Mais rapidamente Muito rapidamente Rapidamente Muito rapidamente Mais rapidamente Ajustar a velocidade de fala no Voice Guidance. Este item de menu é exibido apenas quando um fone de ouvido ou um alto-falante estiver conectado à impressora. menu Acessibilidade"},{"UUID":"189274a3-8335-4736-affa-633841799074","title":"Dispositivo","link":"preferences-topic.html","desc":"Restaurar padrões de fábrica Item","descFull":"Restaurar padrões de fábrica Item e descrição do menu  Restaurar padrões de fábrica Item do menu Descrição Rest. definições Restaurar todas as definições Restaurar definições da impressora Restaurar definições de rede Restaurar definições do fax Restaurar definições de aplicativos Restaurar as configurações padrão de fábrica da impressora. menu Restaurar padrões de fábrica"},{"UUID":"abb95d82-3712-4390-8ab9-310baffe2dbe","title":"Manutenção","link":"preferences-topic.html","desc":"Menu Configuração Itens e descrições","descFull":"Menu Configuração Itens e descrições do  Menu Configuração Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Configuração USB PnP USB 1* 2 Altera o modo do driver USB da impressora para aprimorar sua compatibilidade com um computador pessoal. Configuração USB Digitalizar USB para local Ativado * Desativado Especifica se deseja que o driver do dispositivo USB enumere como um dispositivo USB simples (interface única) ou como um dispositivo USB composto (várias interfaces). Configuração USB Velocidade USB Completo Automático * Define a operação da porta USB na velocidade máxima e desativa seus recursos de alta velocidade. Configuração de bandeja Detecção de tamanho Detecçãode bandeja [x] Desativado Ativado * Detecção do Ofício/Fólio Fólio * Ofício (México) Detecção do Statement/A5 Sensor Statement * Detectar A5 Detecção do Executive/B5 Sensor exec. * Detectar B5 Configura a bandeja para detectar automaticamente o tamanho do papel carregado nela. Configuração de bandeja Vincular bandejas Automático * Desativado Define a vinculação das bandejas da impressora com o mesmo tipo de papel e as mesmas configurações de tamanho de papel. Configuração de bandeja Exibir mensagem de encaixe da bandeja Desativado Somente para tamanhos desconhecidos * Sempre Exibe uma mensagem que permite ao usuário alterar as configurações de tipo e tamanho de papel após o encaixe da bandeja. Configuração de bandeja Avisos de papel Automático * Alimentador multiuso Papel manual Define a origem do papel que o usuário preencherá quando um aviso for exibido para carregar papel. Para que o  Alimentador multiúso  seja exibido, no menu  Papel , defina  Configurar MF  como  Cassete . Configuração de bandeja Avisos de envelope Automático * Alimentador multiuso Envelope manual Define a origem do papel que o usuário preencherá quando um aviso for exibido para carregar envelope. Para que o  Alimentador multiúso  seja exibido, no menu  Papel , defina  Configurar MF  como  Cassete . Configuração de bandeja Ação para avisos Avisar usuário * Continuar Usar atual Configura a impressora para determinar avisos de alterações relacionados a papel ou envelope. Configuração de bandeja Configuração da bandeja para envelope Desativado * Ativado Ative a bandeja de envelope para imprimir envelopes. Configuração de bandeja Vários tamanhos universais Desativado * Ativado Defina a bandeja para suportar vários tamanhos de papel universais. Relatórios Página de definições de menu Log de eventos Resumo do log de eventos Imprime relatórios sobre configurações do menu da impressora, status e logs de eventos. Utilização e contadores de suprimento Limpar histórico de utilização de suprimentos Redefine o histórico de utilização de suprimentos, como o número de páginas e dias restantes, para o nível original de fábrica. Utilização e contadores de suprimento Ajustes para mídias grandes Desativado * Ativado Permitir ajustes ao imprimir em mídia grande ou espessa. Emulações da impressora Emulação PPDS Desativado * Ativado Define a impressora de maneira que ela reconheça e utilize o fluxo de dados de impressora pessoal (PPDS). Emulações da impressora Emulação PS Desativado Ativado * Define a impressora de maneira que ela reconheça e utilize o fluxo de dados de impressora pessoal (PS). Emulações da impressora Ativar Prescribe Desativado * Ativado Ativar PRESCRIBE. A licença PRESCRIBE deve estar instalada. Emulações da impressora Segurança do emulador Tempo limite da página 0–60 (60*) Define o tempo limite da página durante a emulação. Emulações da impressora Segurança do emulador Redefinir emulador após trabalho Desativado * Ativado Redefine o emulador depois de um trabalho de impressão. Emulações da impressora Segurança do emulador Desativar acesso à mensagem da impressora Desativado Ativado * Desativa a mensagem de acesso à impressora durante a emulação. Configuração de fax Suporte a fax de baixo consumo Desativar modo de suspensão Permitir modo de suspensão Automático * Programe o fax para entrar no modo de Suspensão sempre que a impressora determinar que é necessário. Configuração de fax Local de armazenamento de fax NAND Disco * Define o local de armazenamento de todos os faxes. Este item de menu é exibido apenas quando há um disco rígido ou ISD instalado. Configuração de impressão Ajuste de fonte 0–150 (24*) Define um valor de tamanho de ponto de texto abaixo do qual as telas de alta frequência são utilizadas ao imprimir dados de fonte. Por exemplo, se o valor for 24, todas as fontes com tamanho de 24 pontos ou menos utilizarão as telas de alta frequência. Operações do dispositivo Modo silencioso Desativado * Ativado Define a operação da impressora como  Modo silencioso . A ativação dessa configuração prejudica o desempenho geral da impressora. Operações do dispositivo Menus do painel Desativado Ativado * Habilite o acesso aos menus da impressora no painel de controle. Operações do dispositivo Modo de segurança Desativado * Ativado Define um modo específico de operação da impressora no qual ela tentará continuar a oferecer a maior funcionalidade possível, apesar dos problemas detectados. Por exemplo, quando definido como  Ativado  e o motor duplex não estiver funcionando, a impressora realizará somente impressões simples, mesmo se o trabalho for uma impressão em frente e verso. Operações do dispositivo Memória de cópia mínima 20 MB* 30 MB 50 MB 80 MB 100 MB Configurar a alocação de memória mínima para armazenar trabalhos de cópia. Operações do dispositivo Limpar status personalizado Apaga as strings definidas pelo usuário para as mensagens personalizadas  Padrão  ou  Alternativa . Operações do dispositivo Limpar todas as mensagens instaladas remotamente Apaga mensagens que foram instaladas remotamente. Operações do dispositivo Exibir telas de erros automaticamente Desativado Ativado * Mostrar as mensagens de erro existentes no monitor após a impressora permanecer inativa na tela inicial durante um período. Operações do dispositivo Honrar a orientação na cópia do caminho rápido Desativado * Ativado Permite que a impressora use a configuração de orientação presente no menu  Copiar  ao enviar trabalhos rápidos de cópia. Configuração de aplicativos Aplicativos do LES Desativado Ativado * Ativar aplicativos do Lexmark Embedded Solutions (LES). Configuração do finalizador Definição da bandeja de saída 2 Desativado * Ativado Ative o uso da segunda bandeja de saída. Configuração do scanner Registro manual do scanner Imprimir teste rápido Imprime uma página de destino de teste rápido. Certifique-se de que o espaçamento da margem na página de destino esteja completamente uniforme. Se ele não estiver, será preciso redefinir as margens da impressora. Configuração do scanner Registro manual do scanner Registro do ADF dianteiro Registro do ADF traseiro Registro da base de cópia Registra manualmente a base de cópia e o alimentador automático de documentos (ADF) após substituir o alimentador automático de documentos, o vidro do scanner ou a placa do controlador. Configuração do scanner Redefinir contador de manutenção Reinicia o contador depois que o kit de manutenção do ADF é substituído. Configuração do scanner Apagar margem Apagar margem da base de cópia  (3*) Apagar margem do ADF  (3*) Define o tamanho, em milímetros, da área de não impressão ao redor de um trabalho de digitalização pelo alimentador automático de documentos ou pela base de cópia. Configuração do scanner Desativar scanner Não * Sim Somente ADF Desativa o scanner caso ele não esteja funcionando corretamente. Configuração do scanner Pedido de bytes Tiff Endianness da CPU * Little Endian Big Endian Define o pedido de bytes de uma saída de digitalização em formato TIFF. Configuração do scanner Linhas Tiff exatas por tira Ativado * Desativado Define o valor da etiqueta RowsPerStrip de uma saída de digitalização de formato TIFF. menu Menu Configuração"},{"UUID":"8665ff6d-d6fa-4753-a56c-46cca63c819f","title":"Manutenção","link":"preferences-topic.html","desc":"Apagamento fora de serviço Itens","descFull":"Apagamento fora de serviço Itens e descrições do menu  Apagamento fora de serviço Item de menu Descrição Apagamento fora de serviço Última limpeza da memória Última limpeza do disco rígido Última exclusão do ISD Mostrar informações somente leitura sobre quando a memória da impressora ou a unidade de armazenamento foi apagada pela última vez. Última limpeza do disco rígido  está disponível somente quando há um disco rígido instalado. Apagamento fora de serviço Limpar todas as informações na memória não volátil Apagar todas as configurações de impressora e de rede Apague todas as configurações dos aplicativos Apagar todos os atalhos e configurações de atalho Apagar todas as informações no disco rígido Apagar downloads (apagar todas as macros, fontes, PFOs etc.) Apagar trabalhos armazenados em buffer Apagar trabalhos suspensos Excluir a unidade de armazenamento inteligente Limpa todas as informações presentes na memória não volátil e na unidade de armazenamento. Apagar todas as informações no disco rígido  está disponível somente quando há um disco rígido instalado. menu Apagamento fora de serviço"},{"UUID":"e19a1399-fb27-4c96-a951-b3bc0acc59a8","title":"Dispositivo","link":"preferences-topic.html","desc":"Personalização da tela inicial Este","descFull":"Personalização da tela inicial Este menu é exibido somente no Embedded Web Server. Item e descrição do menu  Personalização da tela inicial Menu Descrição Cópia E-mail Fax Fax retidos Liberar faxes retidos Status/suprimentos Fila de trabalhos Configurações Alterar idioma Catálogo de endereços Marcadores Trabalhos suspensos Unidade USB FTP Perfis de digitalização Bloquear dispositivo Scan Center Cópia de cartão Shortcut Center Especifique quais ícones são exibidos na tela inicial. menu Personalização da tela inicial"},{"UUID":"fc612c0d-1523-4f68-9682-5a89c413332a","title":"Dispositivo","link":"preferences-topic.html","desc":"Sobre esta impressora Itens e","descFull":"Sobre esta impressora Itens e descrições do menu  Sobre esta impressora Item de menu Descrição Etiqueta de ativo Especificar a identidade da impressora. O comprimento máximo é de 32 caracteres. Localização da impressora Especificar o local da impressora. O comprimento máximo é de 63 caracteres. Contato Especificar as informações de contato para a impressora. O comprimento máximo é de 63 caracteres. Versão do firmware Mostrar a versão do firmware instalada na impressora. Mecanismo Mostrar o número do mecanismo da impressora. Número de série Mostrar o número de série da impressora. Exportar arquivo de configuração para USB Exporta o arquivo de configuração para uma unidade flash. Exportar registros compactados para USB Exporta os arquivos de log compactados para uma unidade flash. Enviar logs Envie informações de registro da impressora à Lexmark. menu Sobre esta impressora"},{"UUID":"d546a286-675b-45da-bef6-4776c22fda68","title":"Print","link":"layout-topic.html","desc":"Layout Itens e descrições do","descFull":"Layout Itens e descrições do menu  Layout Item do menu Descrição Um asterisco (*) próximo ao valor indica a definição padrão de fábrica. Lados Simples * Frente e verso Especifica se a impressão deve ser feita em apenas um lado do papel ou em ambos. Estilo de inversão Margem longa * Margem curta Determina qual lado do papel é encadernado durante a impressão em frente e verso. Páginas em branco Imprimir Não imprimir * Imprimir páginas em branco que estão incluídas em um trabalho de impressão. Agrupar Desativado (1,1,1,2,2,2) Ativado (1,2,1,2,1,2) * Manter as páginas de um trabalho de impressão empilhadas em sequência, especialmente ao imprimir diversas cópias do trabalho. Folhas separadoras Nenhuma * Entre cópias Entre trabalhos Entre páginas Inserir folhas separadoras em branco ao imprimir. Origem das folhas separadoras Bandeja  [x] (1*) Alimentador multiuso Especificar a origem do papel da folha separadora. Páginas por lado Desativado * 2 páginas por lado 3 páginas por lado 4 páginas por lado 6 páginas por lado 9 páginas por lado 12 páginas por lado 16 páginas por lado Imprimir imagens de várias páginas em um lado de uma folha de papel. Páginas organizadas por lado Horizontal * Horizontal inversa Vertical Vertical inversa Especifica o posicionamento de imagens de várias páginas quando a opção  Páginas por lado  é usada. Orientação de páginas por lado Automático * Paisagem Retrato Especifica a orientação de imagens de várias páginas quando a opção  Páginas por lado  é usada. Borda de páginas por lado Nenhuma * Preenchidas Imprime uma borda ao redor de cada imagem de página quando a opção  Páginas por lado  é usada. Cópias 1-9999 (1*) Especificar o número de cópias para cada trabalho de impressão. Área de impressão Normal * Ajustar à página Página completa Configurar a área de impressão em uma folha de papel. menu Layout"},{"UUID":"3c3d1843-956a-4c84-be70-638c7e030141","title":"Print","link":"layout-topic.html","desc":"Concluindo Itens e descrições do","descFull":"Concluindo Itens e descrições do menu  Acabamento Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Grampeamento Desativado * 1 grampo, canto sup. esq 2 grampos, esquerda 1 grampo, canto sup. direito 2 grampos, sup 1 grampo, canto inf. esq 2 grampos, inf 1 grampo, canto inf. direito 2 grampos, dir Especifique a posição de grampeamento de todos os trabalhos de impressão. Esse item de menu só é exibido quando um encadernador está instalado. Teste de grampeamento Iniciar Determine se o encadernador está funcionando adequadamente. Esse item de menu só é exibido quando um encadernador está instalado. Caixa de perfuração Desativado * Ativado Faça furos ao longo da borda da saída impressa. Este item de menu só é exibido quando um encadernador com perfurador e grampeador está instalado. Modo de perfuração 2 furos 3 furos 4 furos Configure o modo de perfuração para a saída impressa. 3 furos  é a configuração padrão de fábrica nos EUA.  4 furos  é a configuração padrão de fábrica internacional. Este item de menu só é exibido quando um encadernador com perfurador e grampeador está instalado. Separar páginas Nenhum * Entre cópias Entre trabalhos Separe a saída de cada trabalho de impressão ou cada cópia de um trabalho de impressão. Entre cópias  separa cada cópia de um trabalho de impressão se  Agrupar  estiver definido como  Ativado  [1,2,1,2,1,2]. Caso a opção  Agrupar  esteja definida como  Desativado  [1,1,1,2,2,2], cada conjunto de páginas impressas será separado, por exemplo, como todas as páginas designadas como 1 e todas as páginas designadas como 2. Entre trabalhos  define a mesma posição de separação para o trabalho inteiro de impressão, independentemente do número de cópias impressas. menu Concluindo"},{"UUID":"219b09c7-0dbd-4a98-bdc8-e7f740f6e315","title":"Print","link":"layout-topic.html","desc":"Configurar Itens e descrições do","descFull":"Configurar Itens e descrições do menu  Configuração Item do menu Descrição um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Idioma da impressora Emulação PCL * Emulação de PS Definir o idioma da impressora. A configuração de um padrão de idioma da impressora não impede que um programa de software envie trabalhos de impressão que usem outro idioma. Espera de trabalho Desligado * Ativado Preservar trabalhos de impressão que requerem suprimentos para que os trabalhos que não requerem os suprimentos ausentes possam ser impressos. Este item de menu é exibido apenas quando há um disco rígido instalado. Tempo limite de retenção do trabalho 0–255 ( 30 *) Definir o tempo, em segundos, que a impressora espera pela intervenção do usuário antes de reter trabalhos que requerem recursos indisponíveis e continuar imprimindo outros trabalhos da fila. Este item de menu é exibido apenas quando há um disco rígido instalado. Destino do download RAM * Disco Especificar o local no qual deseja salvar todos os recursos permanentes, como fontes e macros, que foram transferidos por download para a impressora. Este item de menu é exibido apenas quando há um disco rígido instalado. Economia de recursos Desligado * Ativado Determinar o que a impressora faz com os recursos baixados, como fontes e macros, ao receber um trabalho que requer mais memória do que a disponível. Quando configurado como  Desativar , a impressora mantém os recursos baixados apenas até o momento em que a memória seja necessária. Os recursos associados ao idioma da impressora inativa são excluídos. Quando configurado como  Ativar , a impressora preserva todos os recursos permanentes baixados em todas as trocas de idioma. Quando necessário, a impressora exibe mensagens de memória cheia em vez de excluir recursos permanentes. Ordem de Imprimir tudo Alfabética * Mais recentes primeiro Mais antigos primeiro Especificar a ordem em que os trabalhos suspensos e confidenciais serão impressos quando a opção Imprimir tudo for selecionada. Este item de menu é exibido apenas quando há um disco rígido instalado. menu Configurar"},{"UUID":"a5c16de0-dd51-437b-b25a-54f84fa77d66","title":"Print","link":"layout-topic.html","desc":"Qualidade Itens e descrições do","descFull":"Qualidade Itens e descrições do menu  Qualidade Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Resolução de impressão 600 dpi * Qualidade de imagem 1200 1200 dpi Configurar a resolução de texto e imagens na saída impressa. A resolução é determinada em pontos por polegada ou por qualidade de imagem. Tonalidade do toner 1–10 (8*) Determina o nível de tonalidade das imagens e textos. Sombreado Normal * Detalhes Melhorar a impressão para ter linhas mais suaves com bordas mais nítidas. Brilho ‑6 a 6 (0*) Ajuste do brilho da saída impressa. Contraste 0 - 5 (0*) Ajuste do contraste da saída impressa. Correção de cinza Automático * Desativado Ajustar o aperfeiçoamento de contraste aplicado às imagens. menu Qualidade"},{"UUID":"13701851-f298-42fc-bee1-086fb6f69516","title":"Print","link":"layout-topic.html","desc":"Contagem de trabalhos Itens do","descFull":"Contagem de trabalhos Itens do menu  Contagem de trabalhos  com as respectivas descrições Item do menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Contagem de trabalhos Desativado * Ativado Verificar se a impressora cria um registro dos trabalhos de impressão recebidos. este item do menu é exibido apenas quando há uma memória flash ou um disco rígido instalado. Frequência de registro de contagem Diário Semanalmente Mensalmente * Especificar com que frequência a impressora cria um arquivo de registro. Ação do registro no final da frequência Nenhum * Registro atual do e-mail Enviar por e-mail e excluir registro atual Enviar o registro atual Enviar e excluir registro atual Especificar como a impressora reage quando o limite de frequência expira. o valor definido em  Frequência de registro de contagem  determina quando essa ação é acionada. Registrar Quase cheio Desativado Ativar  (5) Especificar o tamanho máximo do arquivo de registro antes de a impressora executar a ação  Registrar ação em quase cheio . este item do menu é exibido apenas quando há uma memória flash ou um disco rígido instalado. Registrar ação em Quase cheio Nenhum * Registro atual do e-mail Enviar por e-mail e excluir registro atual Enviar por e-mail e excluir registro mais antigo Enviar o registro atual Enviar e excluir registro atual Enviar e excluir registro mais antigo Excluir registro atual Excluir registro mais antigo Excluir todos menos o atual Excluir todos os registros Especificar como a impressora reage quando o disco rígido está quase cheio. o valor definido em  Registrar quase cheio  determina quando essa ação é acionada. Registrar ação em Cheio Nenhum * Enviar por e-mail e excluir registro atual Enviar por e-mail e excluir registro mais antigo Enviar e excluir registro atual Enviar e excluir registro mais antigo Excluir registro atual Excluir registro mais antigo Excluir todos menos o atual Excluir todos os registros Especifica como a impressora reage quando o uso do disco rígido atinge o limite máximo (100 MB). URL para o log Especificar para onde a impressora envia os registros de contagem de trabalho. Endereço de e-mail para enviar registros Especificar o endereço de e‑mail para o qual a impressora envia registros de contabilidade de trabalho. Prefixo do arquivo de registro Especifica o prefixo dos arquivos de log. por padrão, é usado o nome do host atual definido no menu  TCP/IP . menu Contagem de trabalhos"},{"UUID":"3cd32eb3-f4e3-4cab-8b2c-a78e9f4b1974","title":"Print","link":"layout-topic.html","desc":"PDF Itens e descrições do","descFull":"PDF Itens e descrições do menu  PDF Item do menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Ajustar para caber Desativado * Ativado Ajuste o conteúdo da página de acordo com o tamanho de papel selecionado. Anotações Impressão Não imprimir * Especifique se as anotações do PDF serão imprimidas. Imprimir erro de PDF Desativado Ativado * Ativa a impressão de erro de PDF. menu PDF"},{"UUID":"705ed3bc-ecc5-48ec-951d-46e91e4c8c53","title":"Print","link":"layout-topic.html","desc":"PostScript Itens e descrições do","descFull":"PostScript Itens e descrições do menu  PostScript Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Imprimir erro de PS Desativado * Ativado Imprimir uma página que descreve o erro PostScript®. No caso de um erro, o processamento do trabalho será interrompido, a impressora imprimirá uma mensagem de erro e o restante do trabalho de impressão será descarregado. Largura mínima das linhas 1–30 (2*) Definir a largura mínima do traçado. Os trabalhos impressos em 1200 dpi utilizam o valor diretamente. Bloquear modo de inicialização com bloqueio de PS Desativado Ativado * Desativar o arquivo SysStart. A ativação do arquivo SysStart expõe a impressora ou rede a um risco de segurança. Suavizar imagem Desativado * Ativado Aumente o contraste e a nitidez de imagens com baixa resolução. Essa configuração não tem efeito sobre imagens com resolução de 300 dpi ou superior. Prioridade de fontes Residente * Flash/Disco Especificar a ordem de pesquisa de fontes. Residente  configura a impressora para pesquisar sua memória para a fonte solicitada antes de pesquisar o disco rígido ou a unidade de armazenamento inteligente (ISD). Flash/Disco  configura a impressora para pesquisar o disco rígido e a ISD para a fonte solicitada antes de pesquisar a memória da impressora. Este item de menu é exibido apenas quando há um disco rígido ou ISD instalado. Tempo limite de espera Desativado Ativar * ( 40 segundos ) Configurar a impressora de maneira que ela aguarde mais dados antes de cancelar um trabalho de impressão. menu PostScript"},{"UUID":"c9e2961a-d440-4ef6-abfc-0769ee3b8eb1","title":"Print","link":"layout-topic.html","desc":"PCL Itens e descrições do","descFull":"PCL Itens e descrições do menu  PCL Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Origem das fontes Residente * Disco Download Flash Todos Selecionar a origem que contém a seleção de fonte padrão. Os itens de menu  Disco  e  Flash  aparecem somente quando um disco rígido ou memória flash sem defeito e sem proteção está instalado. O item de menu  Download  é exibido somente se as fontes baixadas existirem na memória da impressora. Nome da fonte [Lista de fontes disponíveis] ( Courier *) Seleciona uma fonte da origem de fonte especificada. Conjunto de símbolos [Lista de conjunto de símbolos disponíveis] (10U PC-8*) Especifica o conjunto de símbolos de cada nome de fonte. Um conjunto de símbolos é um conjunto de caracteres alfabéticos e numéricos, pontuação e símbolos especiais. Os conjuntos de símbolos suportam os diferentes idiomas ou programas específicos, como símbolos matemáticos para textos científicos. Pitch 0,08–100,00 (10,00*) Especifica o pitch para fontes fixas ou monoespaçadas. Pitch  refere-se ao número de caracteres de espaço fixo em uma polegada horizontal de tipo. Orientação Retrato * Paisagem Orientação retrato inversa Orientação paisagem inversa Especifica a orientação do texto e dos gráficos na página. Linhas por página 1–255 Especifica o número de linhas de texto para cada página impressa por meio do fluxo de dados do PCL®. Este item do menu ativa o deslocamento vertical que faz com que o número selecionado de linhas solicitadas sejam impressas entre as margens padrão da página. 60 é a configuração padrão de fábrica nos EUA. 64 é a configuração padrão internacional de fábrica. Largura mínima das linhas PCL5 1–30 (2*) Configura a largura mínima inicial do traçado. Largura mínima das linhas PCLXL 1–30 (2*) Largura A4 198 mm* 203 mm Determina a largura da página lógica em papel de tamanho A4. Página Lógica é o espaço na página física onde o conteúdo é impresso. RC automático após AL Ativado Desativado * Configura a impressora para que ela realize um retorno de carro após um comando de controle de alimentação de linha. Retorno de carro é um mecanismo que comanda a impressora para mover a posição do cursor para a primeira posição na mesma linha. AL automático após RC Ativado Desativado * Configura a impressora para que ela realize uma alimentação de linha após um comando de controle de retorno de carro. Renumeração de bandeja Atribuir alimentação MF Atribuir bandeja  [x] Atribuir papel manual Atribuir envelope manual Configura a impressora para trabalhar com um driver de impressão diferente ou um aplicativo personalizado que utilize um conjunto de atribuições de origem diferentes para solicitar uma determinada fonte de papel. Renumeração de bandeja Exibir padrões de fábrica Mostra o valor padrão de fábrica atribuída para cada origem de papel. Renumeração de bandeja Restaurar padrões Restaura os valores de renumeração de bandeja para os padrões de fábrica. Tempo limite de impressão Desativado Ativado * (90 segundos) Definir a impressora para encerrar um trabalho de impressão após ficar ociosa pelo tempo especificado. menu PCL"},{"UUID":"aee57638-d289-45a1-b48a-4ab343d2c023","title":"Print","link":"layout-topic.html","desc":"Imagem Itens e descrições do","descFull":"Imagem Itens e descrições do menu  Imagem Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração-padrão de fábrica. Ajuste automático Ativar Desativar * Selecione o melhor tamanho de papel disponível e configuração de orientação para uma imagem. Quando configurado em  Ativado , esse item de menu substitui as configurações de ajuste e orientação da imagem. Inverter Desativar * Ativar Inverter imagens monocromáticas com dois tons. Esse item de menu não se aplica a formatos de imagens GIF ou JPEG. Dimensionamento Âncora sup. esquerda Mais aproximada * Âncora central Ajustar altura/largura Ajustar altura Ajustar largura Ajuste a imagem de acordo com a área de impressão. Quando a configuração  Ajuste automático  está definida como  Ativado , o  Dimensionamento  é definido automaticamente como  Mais aproximada . Orientação Retrato * Paisagem Retrato invertido Paisagem invertido Definir a orientação do texto e dos gráficos na página. menu Imagem"},{"UUID":"d8917828-1225-4ed9-bb80-89283fe48509","title":"Papel","link":"tray-configuration-topic.html","desc":"Config. de bandeja Itens e","descFull":"Config. de bandeja Itens e descrições do menu  Configuração de bandeja Item do menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Origem padrão Bandeja  [x] (1*) Alimentador multiúso Papel manual Envelope manual Configurar a origem de papel para todos os trabalhos de impressão. Tamanho/tipo de papel Bandeja  [x] Alimentador multiuso Papel manual Envelope manual Especificar o tamanho ou tipo de papel carregado em cada origem do papel. Trocar tamanho Desativar Statement/A5 Carta/A4 11 x 17/A3 Tudo listado * Configurar a impressora para substituir um tamanho de papel especificado caso o tamanho solicitado não esteja carregado em qualquer origem do papel. Desativar  solicita que o usuário carregue o tamanho do papel solicitado. Tudo listado  permite todas as substituições disponíveis. Configurar MF Cassete * Manual Primeira Determinar o comportamento do alimentador multiúso. Cassete  configura o alimentador multiúso como uma origem automática de papel. Manual  define o alimentador multiúso apenas para trabalhos de impressão alimentados manualmente. Primeiro  define o alimentador multiúso como uma origem de papel primária. menu Config. de bandeja"},{"UUID":"aa255b69-e0d3-4971-94a1-a43f0a108d24","title":"Configuração da mídia","link":"tray-configuration-topic.html","desc":"Configuração universal Itens do menu","descFull":"Configuração universal Itens do menu  Configuração universal  com as respectivas descrições Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Unidades de medida Polegadas Milímetros Especificar a unidade de medida do papel universal. Polegadas  é a de fábrica nos EUA.  Milímetros  é a definição padrão de fábrica internacional. Largura de orientação retrato De 3,5 a 19 polegadas (8,5*) De 88,9 a 482,6 mm (216*) Configurar a largura de orientação retrato do papel universal. Altura de orientação retrato De 3,5 a 19 polegadas (14*) De 88,9 a 482,6 mm (356*) Configurar a altura de orientação retrato do papel universal. Direção de alimentação Margem curta * Margem longa Configurar a impressora para pegar o papel na direção da margem curta ou da margem longa. Margem longa  será exibida apenas se a margem mais longa for mais curta que a largura máxima suportada. Vários tamanhos universais Bandeja [x] Alimentador multiuso Atribua uma dimensão exclusiva para vários tamanhos universais carregados em cada origem do papel. Essa configuração é exibida somente quando ativada no menu  Dispositivo . Na tela inicial, toque em  Configurações Dispositivo Manutenção Menu Configuração Configuração de bandeja Vários tamanhos universais . menu Configuração universal"},{"UUID":"b512f074-d008-4786-8a84-c0a74378e9cd","title":"Configuração da mídia","link":"tray-configuration-topic.html","desc":"Tamanhos personalizados de digitalização Itens","descFull":"Tamanhos personalizados de digitalização Itens e descrições do menu  Tamanhos personalizados de digitalização Item de menu Descrição Tamanho personalizado de digitalização  [x] Nome do tamanho de digitalização Largura 1–8,5 polegadas (8,5*) 25,4–215,9 mm (215,9*) Altura 1–25 polegadas (11*) 25,4–635 mm (279,4*) Orientação Retrato * Paisagem 2 digitalizações por lado Desativado * Ativado Atribua um nome do tamanho de digitalização e configure as definições de digitalização. menu Tamanhos personalizados de digitalização"},{"UUID":"389389e4-ef72-4591-863d-debf4098edc8","title":"Configuração da mídia","link":"tray-configuration-topic.html","desc":"Tipos de mídia Item e","descFull":"Tipos de mídia Item e descrição do menu  Tipos de mídia Item de menu Descrição Comum Cartão Reciclado Brilhoso Etiquetas Encorpado Envelope Envelope áspero Papel timbrado Pré-impresso Papel colorido Baixa gramatura Alta gramatura Áspero/algodão Tipo personalizado  [X] Especifica a textura, o peso e a orientação do papel. menu Tipos de mídia"},{"UUID":"fa45f3ac-ff2d-4f09-adf3-7e9d83fb955e","title":"Copiar","link":"copy-defaults-topic.html","desc":"Padrões de cópia Itens e","descFull":"Padrões de cópia Itens e descrições do menu  Padrões de cópia Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Tipo de conteúdo Texto Texto/Fotografia * Fotografia Gráficos Melhora o resultado de saída com base no conteúdo do documento original. Origem do conteúdo Laser preto e branco * Laser colorida Jato de tinta Fotografia/Filme Revista Jornal Imprensa Outros Melhorar o resultado da saída com base na fonte do documento original. Lados Simples para simples * Simples para frente e verso Frente e verso para simples Frente e verso para frente e verso Especificar o comportamento de digitalização com base no documento original. Folhas separadoras Nenhum * Entre cópias Entre trabalhos Entre páginas Especifica se folhas separadoras em branco serão inseridas durante a impressão. Origem das folhas separadoras Bandeja  [x] (1*) Alimentador multiuso Especifica a origem do papel da folha separadora. Páginas por lado Desativado * 2 páginas em orientação retrato 4 páginas em orientação retrato 2 páginas em orientação paisagem 4 páginas em orientação paisagem Especificar o número de imagens da página a ser impresso em um lado de uma folha de papel. Imp. bordas págs. Desativado * Ativado Colocar uma borda ao redor de cada imagem ao imprimir várias páginas em uma única página. Agrupar Desativar [1,1,1,2,2,2] Ativar [1,2,1,2,1,2] * Imprimir várias cópias em sequência. Separar páginas Nenhum * Entre cópias Entre trabalhos Separe a saída de cada trabalho de impressão ou cada cópia de um trabalho de impressão. A função  Entre Cópias  separa cada cópia de um trabalho de impressão caso a opção  Agrupar  esteja definida como  Ativado [1,2,1,2,1,2] . Caso a opção  Agrupar  esteja definida como  Desativado [1,1,1,2,2,2] , cada conjunto de páginas impressas será separado, por exemplo, como todas as páginas designadas como 1 e todas as páginas designadas como 2. Entre trabalhos  define a mesma posição de separação para o trabalho inteiro de impressão, independentemente do número de cópias impressas. Grampear Desativado * 1 grampo, canto sup. esq 2 grampos, esquerda 1 grampo, canto sup. direito 2 grampos, sup 1 grampo, canto inf. esq 2 grampos, inf 1 grampo, canto inf. direito 2 grampos, dir 4 grampos Especifique a posição de grampeamento de todos os trabalhos de impressão. Esse item de menu só é exibido quando um finalizador está instalado. Perfurar Desativado * 2 furos 3 furos 4 furos Perfurar o trabalho impresso. Este item de menu só é exibido quando um encadernador com perfurador e grampeador está instalado. Tamanho \"Copiar de\" [Lista de tamanhos de papel] Define o tamanho do papel do documento original. Carta  é a de fábrica nos EUA.  A4  é a configuração padrão de fábrica internacional. Origem \"Copiar para\" Bandeja  [x] (1*) Alimentador multiuso Ajuste automático de tamanho Especificar a origem do papel para o trabalho de cópia. Temperatura ‑4 a 4 (0*) Especifique se deseja gerar uma saída mais fria ou quente. Tonalidade 1 a 9 (5*) Ajusta a tonalidade da imagem digitalizada. Número de cópias 1–9999 (1*) Especificar o número de cópias. Cabeçalho/Rodapé Cabeçalho à esquerda Cabeçalho ao centro Cabeçalho à direita Rodapé à esquerda Rodapé ao centro Rodapé direito Especifica as informações de cabeçalho ou rodapé na imagem digitalizada. Overlay Confidencial Cópia Rascunho Urgente Personalizado Desativado * Especifica o texto de overlay a ser impresso em cada cópia. Overlay personalizado Permite que você digite um texto para a opção  Personalizado  do menu  Overlay . Imagem avançada Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Diminuição de cor Diminuição de cor  ( Nenhuma *) Percentual mínimo vermelho padrão  (128*) Percentual mínimo verde padrão  (128*) Percentual mínimo azul padrão  (128*) Especificar qual cor será diminuída durante a digitalização e ajustar a configuração de diminuição dessa cor. Contraste A melhor opção para o conteúdo * 0–5 Especifica o contraste da imagem digitalizada. Remoção de plano de fundo Detecção de fundo Com base em conteúdo* Corrigido Nível ‑4 a 4 (0*) Remover a cor do plano de fundo ou o ruído da imagem do documento original. Com base em conteúdo  remove a cor do plano de fundo do documento original. Corrigido  remove o ruído da imagem de uma fotografia. Centralizar automaticamente Desativado * Ativado Alinhar o conteúdo no centro da página. Imagem espelhada Desativado * Ativado Criar uma imagem espelhada do documento original. Imagem negativa Desativado * Ativado Criar uma imagem negativa do documento original. Detalhes de sombras ‑4 a 4 (0*) Ajusta os detalhes de sombra no documento original. Digitalizar de margem a margem Desativado * Ativado Digitaliza o documento original de uma margem a outra. Nitidez 1–5 (3*) Ajuste a nitidez da imagem digitalizada. Controles do administrador Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Permitir cópias com prioridade Desativado Ativado * Interrompe um trabalho de impressão para fazer cópias. Digitalização de trabalho personalizado Desativado * Ativado Programa a impressora para digitalizar o primeiro conjunto de documentos originais usando as configurações especificadas e, depois, digitaliza o próximo conjunto com as mesmas configurações ou com configurações diferentes. Este item de menu é exibido apenas quando há um disco rígido instalado. Permitir salvar como atalho Desativado Ativado * Salva configurações de cópia como atalho. Cópia de amostra Desativado * Ativado Imprime uma cópia de amostra para verificar a qualidade antes de imprimir as outras cópias. Este item de menu é exibido apenas quando há um disco rígido instalado. menu Padrões de cópia"},{"UUID":"a3c62e6b-351b-4f91-9978-436406a1a970","title":"Padrões de fax","link":"fax-defaults-subgroup.html","desc":"Modo Fax Item e descrição","descFull":"Modo Fax Item e descrição do menu  Modo de fax Item do menu Descrição Modo Fax Fax Servidor de fax Desativado Selecione um modo de fax. Dependendo do modelo da impressora, as configurações padrão de fábrica poderão variar. menu Modo Fax"},{"UUID":"819086d5-e495-467b-a706-237298139dc2","title":"Padrões de fax","link":"fax-defaults-subgroup.html","desc":"Configuração de fax Esse menu","descFull":"Configuração de fax Esse menu está disponível somente em impressoras registradas no portal etherFAX ou com uma placa de fax instalada. Configurações gerais de fax Itens e descrições do menu  Configurações gerais de fax Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Nome do fax Identifica a máquina de fax. Número do fax Identifica o número do fax. ID do fax Nome do fax Número do fax * Notifica os destinatários do fax sobre seu nome ou número de fax. Ativar fax manual Desativado * Ativado Ligue a função de fax manual na impressora. Esse item de menu exige um derivador de linha e um fone. Utilize uma linha telefônica comum para atender a um trabalho de fax recebido e para discar um número de fax. Para acessar diretamente a função fax manual, toque em  #  e  0  no teclado numérico. Uso de memória Todos recebidos Receber principalmente Igual * Os mais enviados Todos enviados Define a quantidade de memória interna da impressora alocada para trabalhos de fax. Esse item de menu evita as condições de buffer de memória e fax perdidos. Cancelar fax Permitir * Não permitir Cancele os faxes enviados e recebidos. Identificador de chamadas Desativado Ativado Alternar Ative um padrão de ID do chamador. Essa configuração é exibida somente quando o país ou a região selecionada no assistente de configuração inicial suporta vários padrões de ID de chamadas. Mascaramento de números de fax Desativado * Da esquerda Da direita Especifica o formato para mascarar um número de fax enviado. Dígitos a mascarar 0-58 (0*) Especifica o número de dígitos a mascarar em um número de fax enviado. Ativar detecção de linha conectada Desativado Ativado * Verifica se uma linha telefônica está conectada à impressora. A detecção de eventos é instantânea. Ativar detecção de linha em tomada errada Desativado Ativado * Verifica se uma linha telefônica está conectada à porta correta da impressora. A detecção de eventos é instantânea. Ativar suporte de ramal em uso Desativado Ativado * Verificar se uma linha telefônica é utilizada por outro dispositivo, como outro telefone, na mesma linha. A detecção de eventos é instantânea. Otimizar compatibilidade de fax Configura a funcionalidade de fax da impressora para oferecer a compatibilidade ideal com outros aparelhos de fax. Transporte de fax T.38 Analógico G.711 etherFAX Definir o método de transporte de fax. Esse item do menu será exibido somente se um pacote de licença de etherFAX ou Fax sobre IP (FoIP) estiver instalado na impressora. Configurações HTTPS de fax Esse menu é exibido somente se a opção  Transporte de fax  estiver definida como  etherFAX . Itens e descrições do menu  Configurações HTTPS de fax Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. URL HTTPS do serviço Especificar o URL do serviço etherFAX. Proxy HTTPS Especificar o URL do servidor proxy. Usuário do proxy HTTPS Especificar nome de usuário e senha do servidor proxy. Senha do proxy HTTPS Criptografia de envio de fax Desativado Ativado * Obrigatório Ativar a criptografia para mensagens de fax enviadas. Criptografia de recebimento de fax Desativado Ativado * Obrigatório Ativar a criptografia para mensagens de fax recebidas. Status de fax HTTPS Mostrar o status de comunicação etherFAX. Configurações de envio de fax Itens e descrições do menu  Configurações de envio de fax Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Resolução Padrão * Alto Superalta Ultra-alta Define a resolução da imagem digitalizada. Padrão  e  Superalta  aparecem somente quando a configuração  Ativar digitalização de fax colorido  está definida como  Desativado por padrão . Uma resolução mais alta aumenta o tempo de transmissão de fax e exige mais memória. Tamanho original [Lista de tamanhos de papel] (Tamanhos mistos*) Especifica o tamanho do documento original. Orientação Retrato * Paisagem Especifica a orientação do documento original. Lados Desativado * Margem curta Margem longa Especifica a orientação do documento original ao digitalizar em ambos os lados do documento. Tipo de conteúdo Texto * Texto/Fotografia Fotografia Gráficos Melhora o resultado de saída com base no conteúdo do documento original. Origem do conteúdo Laser preto e branco * Laser colorida Jato de tinta Fotografia/Filme Revista Jornal Imprensa Outros Melhorar o resultado da saída com base na fonte do documento original. Tonalidade 1-9 (5*) Ajusta a tonalidade da imagem digitalizada. Por PABX Ativado Desativado * Define que a impressora disque o número do fax sem aguardar o reconhecimento do tom de discagem. A PABX (Private Automated Branch Exchange, troca automática de ramais privados) é uma rede de telefonia que permite que um único número de acesso ofereça várias linhas para outros chamadores externos. Modo de discagem Tom * Pulso Especifica o modo de discagem para faxes recebidos ou enviados. Imagem avançada Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Equilíbrio de cores Ciano - Vermelho -4 a 4 (0*) Magenta - Verde -4 a 4 (0*) Amarelo - Azul -4 a 4 (0*) Ajusta a intensidade da cor durante a digitalização. Diminuição de cor Diminuição de cor  ( Nenhuma *) Percentual mínimo vermelho padrão  (128*) Percentual mínimo verde padrão  (128*) Percentual mínimo azul padrão  (128*) Especificar qual cor será diminuída durante a digitalização e ajustar a configuração de diminuição dessa cor. Contraste A melhor opção para o conteúdo * 0 1 2 3 4 5 Define o contraste da saída. Remoção de plano de fundo Nível ‑4 a 4 (0*) Ajustar a quantidade de plano de fundo visível em uma imagem digitalizada. Imagem espelhada Desativado * Ativado Criar uma imagem espelhada do documento original. Imagem negativa Desativado * Ativado Criar uma imagem negativa do documento original. Detalhes de sombras ‑4 a 4 (0*) Ajustar a quantidade de detalhes de sombras visíveis em uma imagem digitalizada. Digitalizar de margem a margem Ativado Desativado * Permitir a digitalização borda a borda do documento original. Nitidez 1–5 (3*) Ajuste a nitidez da imagem digitalizada. Temperatura ‑4 a 4 (0*) Especifique se deseja gerar uma saída mais fria ou quente. Controles do administrador Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Rediscagem automática 0-9 (5*) Ajusta o número de tentativas de rediscagem com base nos níveis de atividade das máquinas de fax do destinatário. Frequência de rediscagem 1 a 200 minutos (3*) Aumenta o tempo entre tentativas de rediscagem para aumentar as chances de enviar um fax com êxito. Ativar ECM Ativado * Desativado Ativa o ECM (Error Correction Mode, modo de correção de erros) para trabalhos de fax. O ECM detecta e corrige os erros no processo de transmissão de fax causados por ruídos na linha telefônica e fraca potência do sinal. Ativar digitalização de fax Ativado * Desativado Envia por fax documentos digitalizados na impressora. Driver para fax Ativado * Desativado Permite que o driver da impressora envie trabalhos de fax. Permitir salvar como atalho Ativado * Desativado Salva os números de fax como atalhos na impressora. Velocidade máxima 33600 * 14400 9600 4800 2400 Define a velocidade máxima de envio de fax. Digitalização de trabalho personalizado Desativado * Ativado Ativar digitalização de trabalhos personalizados por padrão. Este item de menu é exibido somente quando um disco rígido ou uma unidade de armazenamento inteligente (ISD) está instalada. Visualização de digitalização Desativado * Ativado Mostre uma visualização da digitalização no monitor. Este item de menu é exibido apenas quando há um disco rígido ou ISD instalado. Ativar digitalização de fax colorido Desativado por padrão * Ativado por padrão Nunca usar Sempre usar Ativa as digitalizações coloridas para fax. Converter automaticamente fax colorido em fax monocromático Ativado * Desativado Converte todos os faxes coloridos enviados em preto-e-branco. Confirmar o número do fax Desativado * Ativado Solicita ao usuário a confirmação do número do fax. Prefixo de discagem Define um prefixo de discagem. Regras de prefixo de discagem Estabelecer uma regra de prefixo de discagem. Configurações de recebimento de fax Itens e descrições do menu  Configurações de recebimento de fax Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Aguardando trabalhos de fax Nenhum * Toner Toner e suprimentos Remover trabalhos de fax que solicitam recursos indisponíveis específicos da fila de impressão. Toques para responder 1-25 (3*) Defina o número de toques até o dispositivo responder chamadas recebidas. Redução automática Ativado * Desativado Ajusta o tamanho do fax recebido para caber na página. Origem do papel Bandeja  [X] Automático * Define a origem do papel para imprimir os faxes recebidos. Lados Ativado Desativado * Imprime nos dois lados do papel. Folhas separadoras Nenhum * Antes do trabalho Após o trabalho Especifica se folhas separadoras em branco serão inseridas durante a impressão. Origem das folhas separadoras Bandeja  [X] (1*) Especifica a origem do papel da folha separadora. Bandeja de saída Bandeja padrão Especificar a bandeja de saída para os faxes recebidos. Rodapé do fax Ativado Desativado * Imprime as informações de transmissão na parte inferior de cada página de um fax recebido. Registro de data/hora do rodapé do fax Receber * Print Imprime o registro de hora na parte inferior de cada página de um fax recebido. Perfurar Desativado * 2 furos 3 furos 4 furos Especifique a função de perfuração para faxes recebidos. Este item de menu só é exibido quando um encadernador com perfurador e grampeador está instalado. Grampear Desativado * 1 grampo 2 grampos 4 grampos Especifique a função de grampeamento para faxes recebidos. Esse item de menu só é exibido quando um finalizador está instalado. Reter fax Modo de fax retido Desativado * Sempre ativado Manual Programado Retenha a impressão dos faxes recebidos até que sejam liberados. Reter fax Programação de retenção de fax Atribua uma programação para reter faxes. Essa configuração será exibida somente se o  Modo de fax retido  estiver definido como  Programado . Controles do administrador Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Ativar recebimento de fax Ativado * Desativado Define a impressora para receber fax. Ativar recebimento de fax colorido Ativado * Desativado Define a impressora para receber fax colorido. Ativar ID do chamador Ativado Desativado * Mostrar o número de telefone da chamada recebida no painel de controle. Bloquear fax sem nome Ativado Desativado * Bloqueia faxes recebidos de dispositivos sem um ID de estação ou ID de fax especificado. Lista de fax bloqueados Adicionar fax bloqueado Especifique os números de telefone que deseja bloquear. Atender com Todos os toques * Somente um toque Somente dois toques Somente três toques Somente um ou dois toques Somente um ou três toques Somente dois ou três toques Define um padrão de toque distinto para faxes recebidos. Resposta automática Ativado * Desativado Define a impressora para receber faxes automaticamente. Código do atendimento manual 0-9 (9*) Inseri manualmente um código no teclado numérico do telefone para começar a receber faxes. Esse item de menu é exibido somente quando a impressora compartilha uma linha com um telefone. Esse item de menu é exibido apenas quando a impressora está configurada para receber faxes manualmente. Encaminhamento de fax Imprimir * Imprimir e encaminhar Encaminhar Especifica se um fax recebido deve ser encaminhado. Encaminhar para Destino 1 Destino 2 Especifica o destino de encaminhamento de um fax recebido. Esse item de menu é exibido apenas quando  Encaminhamento de fax  estiver definido como  Imprimir e encaminhar  ou  Encaminhar . Velocidade máxima 33600* 14400 9600 4800 2400 Define a velocidade máxima de transmissão de um fax. Folha de rosto do fax Itens e descrições do menu  Folha de rosto do fax Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Folha de rosto do fax Desativado por padrão * Ativado por padrão Nunca usar Sempre usar Configure as definições para a folha de rosto do fax. Campo Incluir em Desativado * Ativado Campo Incluir de Desativado * Ativado Em Campo Incluir mensagem Desativado * Ativado Mensagem: Incluir logotipo Desativado * Ativado Incluir rodapé [x] Desativado * Ativado Rodapé [x] Definições de registro de fax Itens e descrições do menu  Configurações de log de fax Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Frequência de log de transmissão Sempre * Nunca Apenas para erros Especifica com que frequência a impressora cria um registro de transmissão. Ação do log de transmissão Print Desativado Ativado * E-mail Desativado * Ativado Imprime ou envia por e-mail um registro para transmissão de fax bem-sucedida ou erro de transmissão. Log de erros de recebimento Nunca imprimir * Imprimir após erro Imprime um registro de falhas de recebimentos de faxes. Imprimir logs automaticamente Ativado * Desativado Imprime todas as atividades de fax. Origem do papel de registro Bandeja  [x] (1*) Especifica a origem do papel para imprimir registros. Exibição de logs Nome do fax remoto * Número discado Identifica o remetente por nome ou número do fax remoto. Ativar log de trabalhos Ativado * Desativado Exibe um resumo de todos os trabalhos de fax. Ativar log de chamadas Ativado * Desativado Exibe um resumo do histórico de chamadas de fax. Bandeja de saída do registro Bandeja padrão * Bandeja [x] Especifique a bandeja de saída para registros impressos. Definições de alto-falante Itens e descrições do menu  Configurações do alto-falante Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Modo de alto-falante Sempre desativado * Sempre ativado Ativado até a conexão Define o modo de alto-falante do fax. Volume do alto-falante Baixo * Alto Ajusta o volume do alto-falante do fax. Volume do toque Desativado * Ativado Ativa o volume do toque. Definições de VoIP Itens e descrições do menu  Configurações do VoIP Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Protocolo VoIP SIP * H.323 Defina o protocolo Voice over Internet Protocol (VoIP). Servidor STUN Especifique o servidor STUN para atravessar um firewall. Forçar modo fax Desativado Ativado * Alterne o gateway VoIP de analógico para T.38 no início de uma chamada de fax. Forçar atraso Modo fax De 0 a 15 (7*) Defina o tempo de atraso em segundos ao enviar outro convite do  Forçar modo fax . Definições de SIP Itens e descrições do menu  Configurações de SIP Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Proxy Especifique o endereço IP do sistema que lida com a conversão do número de telefone em um endereço IP para o qual o fax é enviado. Registrar Especifique um nome ou endereço IP do sistema que lida com o registro do cliente SIP. Usuário Especifique o nome de usuário para o servidor proxy SIP. Senha Especifique a senha usada no Registrar SIP. ID de aut. Especifica um nome de usuário para Registrar SIP. Se a configuração do ID de autorização não estiver definida, a configuração usará o nome de usuário do campo  Usuário . Transportar para registro UDP * TCP Defina o tipo de transporte SIP para registro. Transportar para chamadas recebidas UDP * TCP UDP e TCP Defina o tipo de transporte SIP para chamadas recebidas. Transportar para chamadas realizadas UDP * TCP Defina o tipo de transporte SIP para chamadas efetuadas. Proxy de saída Especifique um proxy de saída para encaminhar todas as comunicações SIP. Contato Especifica um nome de contato para SIP. Domínio Especifica um nome de realm para SIP. Se a configuração Realm não estiver definida, a configuração usará o nome do  Contato . Status de registro do SIP Exibe o status do registro SIP. Definições de H.323 Itens e descrições do menu  Configurações H.323 Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Gateway Especifique o endereço IP do gateway H.323. Gatekeeper Especifique gatekeeper H.323. Usuário Especifique o nome de usuário usado com o gateway H.323. Senha Especifique a senha para o gateway H.323. Ativar Início rápido Desativado * Ativado Ativar Início rápido. Desabilitar perfuração de túneis de H.245 Desativado * Ativado Desabilitar perfuração de túneis de H.323. Desabilitar descoberta de gatekeeper Desativado Ativado * Desabilitar descoberta de gatekeeper H.323. Definições de T.38 Itens e descrições do menu  Configurações T.38 Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Redundância do indicador 0-5 (3*) Defina o número de vezes que um indicador de fax é repetido na comunicação T.38. Redundância de baixa velocidade 0-5 (3*) Defina o número de vezes que os dados de baixa velocidade são repetidos na comunicação T.38. Redundância de alta velocidade 0–5 (1*) Defina o número de vezes que os dados de alta velocidade são repetidos na comunicação T.38. menu Configuração de fax"},{"UUID":"4708a666-8ec7-47b4-bf3b-7fc2f9a22e2c","title":"Padrões de fax","link":"fax-defaults-subgroup.html","desc":"Configuração de servidor de fax","descFull":"Configuração de servidor de fax Configuração de servidor de fax Definições gerais do fax Itens e descrições do menu  Configurações gerais de fax Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Formato de destino Especifique um destinatário de fax. Caso deseje utilizar o número de fax, digite o sinal de número (#) antes de um número. Endereço de resposta Especificar um endereço de resposta para enviar o fax. Assunto Especifique o assunto e a mensagem do fax. Mensagem Ativar recebimento analógico Desativado * Ativado Configure a impressora para receber faxes analógicos. Configurações de e-mail do servidor de fax Itens e descrições do menu  Configurações de e-mail do servidor de fax Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Utilizar servidor SMTP de e-mail Ativado Desativado * Use as configurações SMTP (Simple Mail Transfer Protocol) para receber e-mails e enviar faxes. Quando definida como  Ativada , todas as outras configurações do menu  Configurações de e-mail do servidor de fax  não são exibidas. Gateway SMTP primário Digitar o endereço IP ou o nome do host do servidor SMTP primário. Porta do gateway SMTP primário 1 – 65535 (25*) Digitar o número da porta do servidor SMTP primário. Gateway SMTP secundário Digitar o endereço IP ou o nome do host do servidor SMTP secundário ou de backup. Porta do gateway SMTP secundário 1 – 65535 (25*) Digitar o número da porta do servidor SMTP secundário ou de backup. Tempo limite SMTP 5 - 30 (30*) Configure a hora antes que a impressora atinja o tempo limite se o servidor SMTP não responder. Endereço de resposta Especificar um endereço de resposta para enviar o fax. Usar SSL/TLS Desativado * Negociar Obrigatório Especificar se deseja enviar um fax utilizando um link criptografado. Certificado de confiança obrigatório Desativado Ativado * Especificar um certificado de confiança ao acessar o servidor SMTP. Autenticação do servidor SMTP Não é necessária autenticação * Login/Comum NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Configure o tipo de autenticação para o servidor SMTP. E-mail iniciado por dispositivo Nenhum * Utilizar credenciais de dispositivo SMTP Especificar se são necessárias credenciais para um e-mail iniciado por dispositivo. E-mail iniciado por usuário Nenhum * Utilizar credenciais de dispositivo SMTP Utilizar senha e ID do usuário de sessão Utilizar endereço de e-mail e senha da sessão Avisar usuário Especificar se são necessárias credenciais para um e-mail iniciado pelo usuário. Usar Creden. Dispos. Active Directory Desativado * Ativado Ativar as credenciais de usuário e os destinos do grupo para se conectar ao servidor SMTP. ID do usuário do dispositivo Especificar o ID do usuário e a senha para se conectar ao servidor SMTP. Senha do dispositivo DOMÍNIO Kerberos 5 Especificar o domínio para o protocolo de autenticação Kerberos 5. Domínio NTLM Especificar o nome do domínio para o protocolo de segurança NTLM. Desativar o erro \"Servidor SMTP não está configurado\" Desativado* Ativado Ocultar a mensagem de erro \"Servidor SMTP não está configurado\". Configurações de digitalização do servidor de fax Itens e descrições do menu  Configurações de digitalização do servidor de fax Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Formato da imagem TIFF (.tif) PDF (.pdf) * XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Especifica o formato do arquivo da imagem digitalizada. Tipo de conteúdo Texto * Texto/Fotografia Fotografia Gráficos Melhora o resultado de saída com base no conteúdo do documento original. Origem do conteúdo Laser preto e branco * Laser colorida Jato de tinta Fotografia/Filme Revista Jornal Imprensa Outros Melhorar o resultado da saída com base na fonte do documento original. Resolução do fax Padrão * Alto Superalta Ultra-alta Configure a resolução do fax. Lados Desativado * Margem curta Margem longa Especifica a orientação do documento original ao digitalizar em ambos os lados do documento. Tonalidade 1-9 (5*) Configure a tonalidade da saída. Orientação Retrato * Paisagem Especifica a orientação do texto e dos gráficos na página. Tamanho original [Lista de tamanhos de papel] Define o tamanho do papel do documento original. Tamanhos mistos  é a configuração padrão norte-americana. de fábrica nos EUA. A4 é a configuração padrão internacional de fábrica. Essa configuração pode variar dependendo do modelo de sua impressora. Usar TIFF de várias páginas Desativado Ativado * Escolha entre arquivos TIFF de uma ou várias páginas. menu Configuração de servidor de fax"},{"UUID":"d71a873e-5331-417c-98ab-cec872bcf0da","title":"E-mail","link":"email-setup-topic.html","desc":"Configuração de e-mail Itens e","descFull":"Configuração de e-mail Itens e descrições do menu  Configuração de e-mail Item do menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Gateway SMTP primário Digitar o endereço IP ou o nome de host do servidor SMTP primário para envio de e-mails. Porta do gateway SMTP primário 1 – 65535 (25*) Digitar o número da porta do servidor SMTP primário. Gateway SMTP secundário Digitar o endereço IP ou o nome do host do servidor SMTP secundário ou de backup. Porta do gateway SMTP secundário 1 – 65535 (25*) Digitar o número da porta do servidor SMTP secundário ou de backup. Tempo limite SMTP 5 – 30 segundos (30*) Configure a hora antes que a impressora atinja o tempo limite se o servidor SMTP não responder. Endereço de resposta Especificar um endereço de resposta no e-mail. Sempre utilizar o endereço de resposta padrão SMTP Ativado Desativado * Sempre utilize o endereço de resposta padrão no servidor SMTP. Usar SSL/TLS Desativado * Negociar Obrigatório Especificar se deseja enviar um e-mail utilizando um link criptografado. Certificado de confiança obrigatório Desativado Ativado * Exija um certificado de confiança ao acessar o servidor SMTP. Autenticação do servidor SMTP Não é necessária autenticação * Login/Comum NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Configure o tipo de autenticação para o servidor SMTP. E-mail iniciado por dispositivo Nenhum * Utilizar credenciais de dispositivo SMTP Especificar se são necessárias credenciais para um e-mail iniciado por dispositivo. E-mail iniciado por usuário Nenhum * Utilizar credenciais de dispositivo SMTP Utilizar senha e ID do usuário de sessão Utilizar endereço de e-mail e senha da sessão Avisar usuário Especificar se são necessárias credenciais para um e-mail iniciado pelo usuário. Usar Creden. Dispos. Active Directory Desativado * Ativado Especificar se são necessárias credenciais para um e-mail iniciado pelo usuário. ID do usuário do dispositivo Especificar o ID do usuário e a senha para se conectar ao servidor SMTP. Senha do dispositivo DOMÍNIO Kerberos 5 Especificar o domínio para o protocolo de autenticação Kerberos 5. Domínio NTLM Especificar o nome do domínio para o protocolo de segurança NTLM. Desativar o erro \"Servidor SMTP não está configurado\" Desativado * Ativado Ocultar a mensagem de erro \"Servidor SMTP não está configurado\". menu Configuração de e-mail"},{"UUID":"5fa2cc6b-6520-40bc-a3d3-1a4b6beca031","title":"E-mail","link":"email-setup-topic.html","desc":"Padrões de e-mail Itens e","descFull":"Padrões de e-mail Itens e descrições do menu  Padrões de e-mail Item do menu Descrição um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Assunto: Especificar o assunto e a mensagem do e-mail. Mensagem: Nome do arquivo Especifica o nome do arquivo do documento digitalizado. Formato JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) Especifica o formato do arquivo do documento digitalizado. Este item de menu pode variar, dependendo do modelo da impressora. Definições globais de OCR Idiomas reconhecidos Rotação automática Eliminar mancha Aprimoramento de contraste automático Configure as definições para reconhecimento óptico de caracteres (OCR). Este item de menu será exibido apenas se você tiver adquirido e instalado uma solução OCR. Configurações de PDF Versão do PDF  (1.5*) Versão de arquivamento  (A‑1a*) Altamente compactado  ( Desativado *) Seguro  ( Desativado *) Arquivamento (PDF/A)  ( Desativado *) Define as configurações de PDF do documento digitalizado. Só há suporte para  Versão de arquivamento  e  Arquivamento (PDF/A)  quando a  Versão do PDF  está definida como 1.4. Altamente compactado  está disponível somente quando há um disco rígido instalado. Tipo de conteúdo Texto Texto/Fotografia * Fotográfico Gráficos Aprimora o resultado da saída com base no tipo de conteúdo do documento original. Origem do conteúdo Laser preto e branco * Laser colorida Jato de tinta Fotografia/Filme Revista Jornal Imprensa Outro Aprimora o resultado da saída com base na origem do conteúdo do documento original. Colorida Preto-e-branco Cinza Colorida * Automático Configura a impressora para capturar o conteúdo do arquivo no modo colorido ou monocromático. Resolução 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Definir a resolução da imagem digitalizada. Tonalidade 1-9 (5*) Ajustar a tonalidade da imagem digitalizada. Orientação Retrato * Paisagem Especificar a orientação do documento original. Tamanho original Tamanhos mistos * Definir o tamanho do papel do documento original. Laterais Desligado * Margem curta Margem longa Especificar a orientação do documento original ao digitalizar em ambos os lados do documento. Criação de imagens avançada Item do menu Descrição um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Equilíbrio de cores Ciano  (0*) Magenta  (0*) Amarelo  (0*) Ajusta a intensidade das cores ciano, magenta e amarelo. Diminuição de cor Diminuição de cor Nenhum * Vermelho Verde Azul Percentual mínimo vermelho padrão 0-255 (128*) Percentual mínimo verde padrão 0-255 (128*) Percentual mínimo azul padrão 0-255 (128*) Especificar qual cor será diminuída durante a digitalização e ajustar a configuração de diminuição dessa cor. Detecção automática de cor Sensibilidade de cor 1-9 (5*) Sensibilidade de área 1-9 (5*) Profundidade de bits do e‑mail 1 bit * 8 bits Resolução mínima de digitalização 75 dpi 150 dpi 200 dpi 300 dpi * Define a configuração de detecção automática de cor. Qualidade JPEG O melhor para o conteúdo * 5 - 95 Define a qualidade JPEG da imagem digitalizada. Contraste O melhor para o conteúdo * 0–5 Especifica o contraste da imagem digitalizada. Remoção de plano de fundo Detecção de fundo Com base em conteúdo * Corrigido Nível  ‑4 a 4 (0*) Remove a cor do plano de fundo ou o ruído da imagem do documento original. Com base em conteúdo  remove a cor do plano de fundo do documento original. Corrigido  remove o ruído da imagem de uma fotografia. Imagem espelhada Desligado * Ativado Criar uma imagem espelhada do documento original. Imagem negativa Desligado * Ativado Criar uma imagem negativa do documento original. Detalhes de sombra ‑4 a 4 (0*) Ajusta os detalhes de sombra na imagem digitalizada. Digitalizar de margem a margem Desligado * Ativado Digitaliza o documento original de uma margem a outra. Nitidez 1-5 (3*) Ajusta a nitidez na imagem digitalizada. Temperatura ‑4 a 4 (0*) Gera uma saída mais azulada ou mais avermelhada do documento original. Páginas em branco Remoção da página em branco  ( Não remover *) Sensibilidade da página em branco  (5*) Define a sensibilidade das digitalizações em relação às páginas em branco no documento original. Controles do administrador Item do menu Descrição um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Tamanho máx. do e-mail 0-65535 (0*) Definir o tamanho de arquivo permitido para cada e-mail. Mensagem de erro de tamanho Especificar uma mensagem de erro enviada pela impressora quando um e-mail excede o tamanho de arquivo permitido. É possível inserir até 1.024 caracteres. Limitar destinos Limite o envio de e-mails somente para a lista específica do nome de domínio. Utilize uma vírgula para separar cada domínio. Enviar-me uma cópia Nunca exibir * Ativado por padrão Desativado por padrão Sempre ativado Enviar uma cópia do e-mail para si mesmo. Permitir apenas e-mails para si Desligado * Ativado Configura a impressora para só enviar e-mails para você. Use cc:/bcc: Desligado * Ativado Ativar uma cópia e uma cópia oculta no e-mail. Usar TIFF de várias páginas Desativado Ligado * Permite digitalizar várias imagens TIFF em um só arquivo TIFF. Compactação TIFF JPEG LZW * Especifica o tipo de compactação para arquivos TIFF. Padrão de texto 5-95 (75*) Define a qualidade de texto do conteúdo que está sendo digitalizado. Padrão de texto/fotografia 5-95 (75*) Define a qualidade de texto e fotografia do conteúdo que está sendo digitalizado. Padrão de fotografia 5-95 (50*) Define a qualidade de fotografia do conteúdo que está sendo digitalizado. Ajustar inclinação do ADF Desligado * Ativado Configura a impressora para ajustar imagens distorcidas de documentos digitalizados pelo ADF. Registro de transmissão Imprimir registro * Não imprimir registro Imprimir apenas erros Imprime um log de transmissão para digitalizações de e‑mail. Log de origem do papel Bandeja  [x] (1*) Alimentador multiúso Especifica a origem do papel para impressão de logs de e-mail. Digitalização de trabalho personalizado Desligado * Ativado Programar a impressora para digitalizar o primeiro conjunto de documentos originais usando as configurações especificadas e, depois, digitalizar o próximo conjunto com as mesmas configurações ou com configurações diferentes. Este item de menu é exibido apenas quando há um disco rígido instalado. Visualização de digitalização Desativado Ligado * Mostra uma visualização de digitalização do documento original. Este item de menu é exibido apenas quando há um disco rígido instalado. Permitir salvar como atalho Desativado Ligado * Salva um endereço de e‑mail como atalho. Imagens de e-mail enviadas como Anexo * Link da Web Especifica como enviar as imagens que estão incluídas no e‑mail. Redefinir as informações de e-mail após o envio Desativado Ligado * Restaurar os valores padrão dos campos Para, Assunto, Mensagem, e Nome do arquivo depois que um e-mail é enviado. menu Padrões de e-mail"},{"UUID":"405a813d-4ac7-4b60-a761-f4f4bd8a024e","title":"E-mail","link":"email-setup-topic.html","desc":"Configuração de link da Web","descFull":"Configuração de link da Web Itens do menu  Configuração de link da Web  com as respectivas descrições Item do menu Descrição Servidor Especifica as credenciais do servidor que está hospedando as imagens incluídas no e-mail. Login Senha Caminho Nome do arquivo Link da Web menu Configuração de link da Web"},{"UUID":"98d5a12a-37a6-451e-8cd1-8530724c4bd6","title":"FTP","link":"ftp-defaults-topic.html","desc":"Padrões de FTP Itens e","descFull":"Padrões de FTP Itens e descrições do menu  Padrões de FTP Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Formato JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) Especifica o formato do arquivo da imagem digitalizada. Este item de menu pode variar, dependendo do modelo da impressora. Definições globais de OCR Idiomas reconhecidos Rotação automática Eliminar mancha Aprimoramento de contraste automático Configure as definições para reconhecimento óptico de caracteres (OCR). Este item de menu será exibido apenas se você tiver adquirido e instalado uma solução OCR. Configurações de PDF Versão do PDF  (1.5*) Versão de arquivamento  ( A‑1a *) Altamente compactado  ( Desativado *) Seguro  ( Desativado *) Arquivamento (PDF/A)  ( Desativado *) Define as configurações de PDF para a imagem digitalizada. Só há suporte para  Versão de arquivamento  e  Arquivamento (PDF/A)  quando a  Versão do PDF  está definida como 1.4. Altamente compactado  está disponível somente quando há um disco rígido instalado. Tipo de conteúdo Texto Texto/Fotografia * Fotografia Gráficos Aprimora o resultado da saída com base no tipo de conteúdo do documento original. Origem do conteúdo Laser preto e branco * Laser colorida Jato de tinta Fotografia/Filme Revista Jornal Imprensa Outros Aprimora o resultado da saída com base na origem do conteúdo do documento original. Cor Preto-e-branco Cinza Colorida * Automático Configura a impressora para capturar o conteúdo do arquivo no modo colorido ou monocromático. Resolução 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Define a resolução da imagem digitalizada. Tonalidade 1-9 (5*) Ajusta a tonalidade da imagem digitalizada. Orientação Retrato * Paisagem Especifica a orientação do documento original. Tamanho original Tamanhos mistos * Define o tamanho do papel do documento original. Lados Desativado * Margem longa Margem curta Especificar a orientação ao digitalizar ambos os lados do documento. Nome do arquivo Especifica o nome do arquivo da imagem digitalizada. Imagem avançada Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Equilíbrio de cores Ciano  (0*) Magenta  (0*) Amarelo  (0*) Ajusta a intensidade das cores ciano, magenta e amarelo. Diminuição de cor Diminuição de cor Nenhum * Vermelho * Verde * Azul * Percentual mínimo vermelho padrão 0-255 (128*) Percentual mínimo verde padrão 0-255 (128*) Percentual mínimo azul padrão 0-255 (128*) Especificar qual cor será diminuída durante a digitalização e ajustar a configuração de diminuição dessa cor. Detecção automática de cor Sensibilidade de cor 1-9 (5*) Sensibilidade de área 1-9 (5*) Profundidade de bits do FTP 1 bit * 8 bits Resolução mínima de digitalização 75 dpi 150 dpi 200 dpi 300 dpi * Define a configuração de detecção automática de cor. Qualidade JPEG A melhor opção para o conteúdo * 5 - 95 Define a qualidade JPEG da imagem digitalizada. Contraste A melhor opção para o conteúdo * 0 1 2 3 4 5 Especifica o contraste da imagem digitalizada. Remoção de plano de fundo Detecção de fundo  Com base em conteúdo * Corrigido Nível -4 a 4 (0*) Remover a cor do plano de fundo ou o ruído da imagem do documento original. Com base em conteúdo  remove a cor do plano de fundo do documento original. Corrigido  remove o ruído da imagem de uma fotografia. Imagem espelhada Desativado * Ativado Criar uma imagem espelhada do documento original. Imagem negativa Desativado * Ativado Criar uma imagem negativa do documento original. Detalhes de sombras ‑4 a 4 (0*) Ajusta os detalhes de sombra na imagem digitalizada. Digitalizar de margem a margem Desativado * Ativado Permitir a digitalização borda a borda do documento original. Nitidez 1–5 (3*) Ajusta a nitidez na imagem digitalizada. Temperatura ‑4 a 4 (0*) Gera uma saída mais azulada ou mais avermelhada do documento original. Páginas em branco Remoção da página em branco Não remover * Remover Sensibilidade da página em branco 1-9 (5*) Define a sensibilidade das digitalizações em relação às páginas em branco no documento original. Controles do administrador Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Padrão de texto 5-95 (75*) Define a qualidade de texto na imagem digitalizada. Padrão de texto/fotografia 5-95 (75*) Define a qualidade de texto ou fotografia na imagem digitalizada. Padrão de fotografia 5-95 (50*) Define a qualidade da fotografia da imagem digitalizada. Usar TIFF de várias páginas Ativado * Desativado Permite digitalizar várias imagens TIFF em um só arquivo TIFF. Compactação TIFF LZW * JPEG Especifica o tipo de compactação para arquivos TIFF. Log de transmissão Imprimir log * Não imprimir registro Imprimir apenas erros Imprime um log de transmissão para digitalizações FTP. Origem do papel de registro Bandeja  [x] (1*) Alimentador multiuso Especifica a origem do papel para imprimir registros de FTP. Bandeja de saída do registro Bandeja padrão * Bandeja [x] Especificar a bandeja de saída para os registros impressos de FTP. Digitalização de trabalho personalizado Desativado * Ativado Ativar digitalização de trabalhos personalizados por padrão. Este item de menu é exibido apenas quando há um disco rígido instalado. Visualização de digitalização Desativado Ativado * Mostre uma visualização da digitalização no monitor. Este item de menu é exibido apenas quando há um disco rígido instalado. Permitir salvar como atalho Desativado Ativado * Salvar um endereço FTP como um atalho. menu Padrões de FTP"},{"UUID":"3deda67b-d61a-4056-b043-699bea5a31d3","title":"Unidade USB","link":"flash-drive-scan-topic.html","desc":"Digitalização para a unidade flash","descFull":"Digitalização para a unidade flash Itens e descrições do menu  Digitalização para a unidade flash Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Formato JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) Especifica o formato do arquivo da imagem digitalizada. Definições globais de OCR Idiomas reconhecidos Rotação automática Eliminar mancha Aprimoramento de contraste automático Configure as definições para reconhecimento óptico de caracteres (OCR). Este menu é exibido apenas se você tiver adquirido e instalado uma solução OCR. Configurações de PDF Versão do PDF  (1.5*) Versão de arquivamento  (A‑1a*) Altamente compactado  ( Desativado *) Seguro  ( Desativado *) Arquivamento (PDF/A)  ( Desativado *) Define as configurações de PDF da imagem digitalizada. Só há suporte para  Versão de arquivamento  e  Arquivamento (PDF/A)  quando a  Versão do PDF  está definida como 1.4. Altamente compactado  está disponível somente quando há um disco rígido instalado. Tipo de conteúdo Texto Texto/Fotografia * Gráficos Fotografia Aprimora o resultado da saída com base no tipo de conteúdo do documento original. Origem do conteúdo Laser preto e branco * Laser colorida Jato de tinta Fotografia/Filme Revista Jornal Imprensa Outros Aprimora o resultado da saída com base na origem do conteúdo do documento original. Cor Preto-e-branco Cinza Colorida * Automático Configura a impressora para capturar o conteúdo do arquivo no modo colorido ou monocromático. Resolução 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Define a resolução da imagem digitalizada. Tonalidade 1-9 (5*) Ajusta a tonalidade da imagem digitalizada. Orientação Retrato * Paisagem Especifica a orientação do documento original. Tamanho original Tamanhos mistos * Define o tamanho do papel do documento original. Lados Desativado * Margem longa Margem curta Especifica a orientação do documento original ao digitalizar em ambos os lados do documento. Nome do arquivo Especifica o nome do arquivo da imagem digitalizada. Imagem avançada Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Equilíbrio de cores Ciano (0*) Magenta (0*) Amarelo (0*) Ajusta a intensidade das cores ciano, magenta e amarelo. Diminuição de cor Diminuição de cor  ( Nenhuma *) Percentual mínimo vermelho padrão (128*) Percentual mínimo verde padrão (128*) Percentual mínimo azul padrão (128*) Especificar qual cor será diminuída durante a digitalização e ajustar a configuração de diminuição dessa cor. Detecção automática de cor Sensibilidade de cor (5*) Sensibilidade de área  (5*) Profundidade de bits da digitalização  (1 bit*) Resolução mínima de digitalização  (300 dpi*) Define a configuração de detecção automática de cor. Qualidade JPEG A melhor opção para o conteúdo * 5 - 95 Define a qualidade JPEG da imagem digitalizada. Contraste A melhor opção para o conteúdo * 0–5 Especifica o contraste da imagem digitalizada. Remoção de plano de fundo Detecção de plano de fundo ( Com base em conteúdo * Corrigido Nível (0*) Remover a cor do plano de fundo ou o ruído da imagem do documento original. Com base em conteúdo  remove a cor do plano de fundo do documento original. Corrigido  remove o ruído da imagem de uma fotografia. Imagem espelhada Desativado * Ativado Criar uma imagem espelhada do documento original. Imagem negativa Desativado * Ativado Criar uma imagem negativa do documento original. Detalhes de sombras ‑4 a 4 (0*) Ajusta os detalhes de sombra na imagem digitalizada. Digitalizar de margem a margem Desativado * Ativado Digitaliza o documento original de uma margem a outra. Nitidez 1–5 (3*) Ajusta a nitidez na imagem digitalizada. Temperatura ‑4 a 4 (0*) Gera uma saída mais azulada ou mais avermelhada do documento original. Páginas em branco Remoção da página em branco  ( Remover *) Sensibilidade da página em branco  (5*) Define a sensibilidade das digitalizações em relação às páginas em branco no documento original. Controles do administrador Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Padrão de texto 5-95 (75*) Define a qualidade de texto na imagem digitalizada. Padrão de texto/fotografia 5-95 (75*) Define a qualidade de texto ou fotografia na imagem digitalizada. Padrão de fotografia 5-95 (50*) Define a qualidade de fotografia na imagem digitalizada. Usar TIFF de várias páginas Desativado Ativado * Permite digitalizar várias imagens TIFF em um só arquivo TIFF. Compactação TIFF LZW * JPEG Especifica o tipo de compactação para arquivos TIFF. Digitalização de trabalho personalizado Desativado * Ativado Programa a impressora para digitalizar o primeiro conjunto de documentos originais usando as configurações especificadas e, depois, digitaliza o próximo conjunto com as mesmas configurações ou com configurações diferentes. Este item de menu é exibido apenas quando há um disco rígido instalado. Visualização de digitalização Desativado Ativado * Mostra uma visualização de digitalização do documento original. Este item de menu é exibido apenas quando há um disco rígido instalado. menu Digitalização para a unidade flash"},{"UUID":"2d7cd820-73b9-4804-8207-7295ee1ad68b","title":"Unidade USB","link":"flash-drive-scan-topic.html","desc":"Impressão da unidade flash Itens","descFull":"Impressão da unidade flash Itens e descrições do menu  Impressão da unidade flash Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Número de cópias 1–9999 (1*) Configurar o número de cópias. Origem do papel Bandeja  [x] (1*) Alimentador multiuso Papel manual Envelope manual Configurar a origem do papel para o trabalho de impressão. Agrupar (1,1,1) (2,2,2) (1,2,3) (1,2,3)* Manter as páginas de um trabalho de impressão empilhadas em sequência, especialmente ao imprimir diversas cópias do trabalho. Lados Simples * Frente e verso Especifica se a impressão deve ser feita em apenas um lado do papel ou em ambos. Grampear Desativado * 1 grampo, canto sup. esq 2 grampos, esquerda 1 grampo, canto sup. direito 2 grampos, sup 1 grampo, canto inf. esq 2 grampos, inf 1 grampo, canto inf. direito 2 grampos, dir 4 grampos Especifique a posição de grampeamento de todos os trabalhos de impressão. Esse item de menu só é exibido quando um encadernador está instalado. Caixa de perfuração Desativado * 2 furos 3 furos 4 furos Define o modo de perfuração para todos os trabalhos de impressão. Este item de menu só é exibido quando um encadernador com perfurador e grampeador está instalado. Separar páginas Nenhum * Entre cópias Entre trabalhos Separe a saída de cada trabalho de impressão ou cada cópia de um trabalho de impressão. Entre cópias  separa cada cópia de um trabalho de impressão se  Agrupar  estiver definido como  Ativado  [1,2,1,2,1,2]. Caso a opção  Agrupar  esteja definida como  Desativado  [1,1,1,2,2,2], cada conjunto de páginas impressas será separado, por exemplo, como todas as páginas designadas como 1 e todas as páginas designadas como 2. Entre trabalhos  define a mesma posição de separação para o trabalho inteiro de impressão, independentemente do número de cópias impressas. Estilo de inversão Margem longa * Margem curta Determina qual lado do papel é encadernado durante a impressão em frente e verso. Páginas por lado Desativado * 2 páginas por lado 3 páginas por lado 4 páginas por lado 6 páginas por lado 9 páginas por lado 12 páginas por lado 16 páginas por lado Imprime imagens de várias páginas em um lado da folha de papel. Páginas organizadas por lado Horizontal * Horizontal inversa Vertical inversa Vertical Especifica o posicionamento de imagens de várias páginas quando a opção  Páginas por lado  é usada. Orientação de páginas por lado Automático * Paisagem Retrato Especifica a orientação de imagens de várias páginas quando a opção  Páginas por lado  é usada. Páginas por margem lateral Nenhum * Sólida Imprime uma borda ao redor de cada imagem de página quando a opção  Páginas por lado  é usada. Folhas separadoras Desativado * Entre cópias Entre trabalhos Entre páginas Inserir folhas separadoras em branco ao imprimir. Origem das folhas separadoras Bandeja  [x] (1*) Alimentador multiuso Especifica a origem do papel da folha separadora. Páginas em branco Não imprimir * Print Imprime páginas em branco em um trabalho de impressão. menu Impressão da unidade flash"},{"UUID":"3d61232b-792a-45f0-84e1-6ff6a0eea65d","title":"Rede/portas","link":"network-overview-topic.html","desc":"Visão geral da rede Itens","descFull":"Visão geral da rede Itens e descrições do menu  Visão geral de rede Item do menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Adaptador ativo Automático * Rede padrão Sem fio Especifique o tipo de conexão de rede. A função  Sem fio  está disponível somente em impressoras conectadas a uma rede sem fio. Status da rede Exibe o status de conexão da rede da impressora. Exibir o status da rede na impressora Desativado Ativado * Mostra o status da rede no monitor. Velocidade, Frente e verso Exibe a velocidade da placa de rede atualmente ativa. IPv4 Mostra o endereço IPv4. Todos os endereços IPv6 Mostra todos os endereços IPv6. Redefinir servidor de impressão Redefine todas as conexões de rede ativas para a impressora. Essa configuração remove todas as definições de configuração de rede. Tempo limite do trabalho na rede Desativado Ativado * (90  segundos ) Define o tempo antes de a impressora cancelar um trabalho de impressão na rede. Página de banner Desativado * Ativado Imprime uma página de banner. Digitalizar para a faixa de portas do PC Especifica a faixa de portas válida para impressoras que estão atrás de um firewall de bloqueio de porta. Ativar conexões de rede Desativado Ativado * Permite que a impressora se conecte a uma rede. Ativar LLDP Desativado * Ativado Ativa o Link Layer Discovery Protocol (LLDP) na impressora. menu Visão geral da rede"},{"UUID":"67669c0f-e6bb-4a29-aaaa-14d8fbe14465","title":"Rede/portas","link":"network-overview-topic.html","desc":"Sem fio Este menu está","descFull":"Sem fio Este menu está disponível somente em impressoras conectadas a uma rede Wi-Fi ou em impressoras com um adaptador de rede sem fio. Configurações  Sem fio  e suas descrições Item do menu Descrição Configurar utilizando o aplicativo móvel Configure a conexão Wi-Fi usando o Lexmark Mobile Assistant. Configurar no painel da impressora Escolher rede Adicionar rede Wi-Fi Nome da rede Modo de rede Infraestrutura Modo de segurança sem fio Desativado * WEP WPA2/WPA – Personal WPA2 – Personal 802.1x – RADIUS Configure a conexão Wi-Fi usando o painel de controle. 802.1x – RADIUS  pode ser configurado somente no Embedded Web Server. Wi-Fi Protected Setup Detecção automática de WPS Desativado Ativado * Iniciar método de botão de controle Iniciar método PIN Estabeleça uma rede sem fio e ative a segurança de rede. A  Detecção automática de WPS  é exibida apenas quando o  Modo de segurança sem fio  é definido como  WEP . Iniciar o método de botão de controle  conecta a impressora a uma rede Wi-Fi quando se pressiona os botões da impressora e do ponto de acesso (roteador sem fio) em um determinado período de tempo. Iniciar o método PIN  conecta a impressora a uma rede Wi-Fi usando um PIN na impressora e inserindo-o nas configurações sem fio do ponto de acesso. Modo de rede Tipo de BSS Infraestrutura * Especificar o modo da rede. Compatibilidade 802.11b/g/n (2,4 GHz) * 802.11a/b/g/n/ac (2,4 GHz/5 GHz) 802.11a/n/ac (5 GHz) Especifique o padrão para a rede Wi-Fi. 802.11a/b/g/n/ac (2,4 GHz/5 GHz)  e  802.11a/n/ac (5 GHz)  são exibidos somente quando uma opção Wi-Fi está instalada. Modo de segurança sem fio Desativado * WEP WPA2/WPA – Personal WPA2 – Personal 802.1x – RADIUS Defina o modo de segurança para conectar a impressora a dispositivos Wi-Fi. 802.1x – RADIUS  pode ser configurado somente no Embedded Web Server. Modo de autenticação WEP Automático * Aberto Compartilhado Define o tipo de Wireless Encryption Protocol (WEP) para a impressora. Esse item de menu será exibido somente quando o  Modo de segurança sem fio  for definido como  WEP . Definir chave de WEP Especificar uma senha de WEP para conexão Wi-Fi segura. WPA2/WPA – Personal AES Ativar segurança de Wi-Fi por meio de Wi-Fi Protected Access (WPA). Esse item de menu será exibido somente quando o  Modo de segurança sem fio  for definido como  WPA2/WPA – Personal . Definir chave pré-compartilhada Define a senha para conexão Wi-Fi segura. WPA2 – Personal AES Ativar segurança de Wi-Fi por meio de WPA2. Esse item de menu será exibido somente quando o  Modo de segurança sem fio  for definido como  WPA2 – Personal . Modo de criptografia 802.1x WPA+ WPA2 * Ativar segurança de Wi-Fi por meio de 802.1x padrão. Esse item de menu será exibido somente quando o  Modo de segurança sem fio  for definido como  802.1x - RADIUS . 802.1x – RADIUS  pode ser configurado somente no Embedded Web Server. IPv4 Ativar DHCP Ativado * Desativado Definir endereço IP estático Endereço IP Máscara de rede Gateway Habilitar e definir as configurações IPv4 na impressora. IPv6 Ativar IPv6 Ativado * Desativado Ativar DHCPv6 Ativado Desativado * Configuração automática de endereço sem monitoração de estado Ativado * Desativado Endereço do servidor DNS Endereço IPv6 atribuído manualmente Roteador IPv6 atribuído manualmente Prefixo do endereço Todos os endereços IPv6 Todos os endereços do roteador IPv6 Habilitar e definir as configurações IPv6 na impressora. Endereço de rede UAA LAA Exibir os endereços da rede. PCL SmartSwitch Desativado Ativado * Define que a impressora alterne automaticamente para a emulação PCL quando um trabalho de impressão exigir isso, independentemente do idioma padrão da impressora. Se o  PCL SmartSwitch  estiver desligado, a impressora não examinará os dados recebidos e utilizará o idioma padrão da impressora no menu  Configuração . PS SmartSwitch Desativado Ativado * Define que a impressora alterne automaticamente para a emulação PS quando um trabalho de impressão exigir isso, independentemente do idioma padrão da impressora. Se o  PS SmartSwitch  estiver desligado, a impressora não examinará os dados recebidos e utilizará o idioma padrão da impressora no menu  Configuração . Buffer de trabalhos Ativado Desativado * Armazenar trabalhos de impressão temporariamente no disco rígido da impressora antes de imprimir. Este item de menu é exibido apenas quando há um disco rígido instalado. PS binário Mac Automático * Ativado Desativado Configurar o processamento de trabalhos de impressão PostScript binários do Macintosh na impressora. Se a opção estiver definida como  Ativado , processa os trabalhos de impressão PostScript binários brutos. Se a opção estiver definida como  Desativado , filtra os trabalhos de impressão usando o protocolo padrão. menu Sem fio"},{"UUID":"379ded93-3c7b-4680-baf4-401ec69cf652","title":"Rede/portas","link":"network-overview-topic.html","desc":"Wi-Fi Direct Itens e descrições","descFull":"Wi-Fi Direct Itens e descrições do menu  Wi-Fi Direct Item do menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Ativar Wi‑Fi Direct Ativado Desativado * Configurar a conexão direta da impressora aos dispositivos Wi-Fi. Nome do Wi‑Fi Direct Especifique o nome da rede do Wi-Fi Direct. Senha do Wi‑Fi Direct Defina a senha para autenticar e validar usuários em uma conexão Wi-Fi. Mostrar senha na página de configuração Desativado Ativado * Visualize a  Senha do Wi‑Fi Direct  na  Página de configuração de rede . Número do canal preferido 1-11 Automático * Define o canal preferido da rede Wi-Fi. Endereço IP do proprietário do grupo Especifica o endereço IP do proprietário do grupo. Aceitar automaticamente as solicitações do botão de controle Desativado * Ativado Aceita solicitações para fazer a conexão com a rede automaticamente. Aceitar clientes automaticamente não é seguro. menu Wi-Fi Direct"},{"UUID":"a481fd80-47ed-4f52-bc76-6b76e6e2a801","title":"Rede/portas","link":"network-overview-topic.html","desc":"AirPrint Este menu é exibido","descFull":"AirPrint Este menu é exibido somente no Embedded Web Server. Itens do menu  AirPrint  e suas descrições Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Todas as funções do AirPrint Exibir o status do AirPrint da impressora. Ativar AirPrint Ativado * Desativado Ativar a função AirPrint. Este item de menu aparece apenas se o Protocolo IPP (Internet Printing Protocol) ou o mDNS estiver desativado. Nome Bonjour Identificar a designação e o local da impressora. Nome da organização Unidade organizacional Local da impressora Latitude da impressora Longitude da impressora Altitude da impressora mais opções menu AirPrint"},{"UUID":"90feb9bf-1632-4e2e-b758-c90194585528","title":"Rede/portas","link":"network-overview-topic.html","desc":"Gerenciamento de serviços móveis Este","descFull":"Gerenciamento de serviços móveis Este menu é exibido somente no Embedded Web Server. Itens do menu  Gerenciamento de serviços móveis  e suas descrições Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Ativar impressão IPP Ativado * Desativado Permitir a impressão a partir de dispositivos móveis usando o Protocolo IPP (Internet Printing Protocol). Ativar fax IPP Ativado * Desativado Permitir o envio de faxes usando o Protocolo IPP (Internet Printing Protocol). Ativar IPP via USB Ativado * Desativado Permitir trabalhos de impressão ou digitalização usando conexão USB. Ativar digitalização Ativado * Desativado Permitir varredura usando o protocolo eSCL. Ativar descoberta Mopria Ativado * Desativado Permitir que a impressora seja detectada por dispositivos habilitados para Mopria. menu Gerenciamento de serviços móveis"},{"UUID":"4a6cc038-d569-4b01-8508-327a6f04db32","title":"Rede/portas","link":"network-overview-topic.html","desc":"Ethernet Itens e descrições do","descFull":"Ethernet Itens e descrições do menu  Ethernet Item do menu Descrição Um asterisco (*) próximo ao valor indica a definição padrão de fábrica. Velocidade da rede Exibir a velocidade de um adaptador de rede ativo. IPv4 Ativar DHCP  ( Ativado *) Definir endereço IP estático Configurar as definições de IPv4. IPv6 Ativar IPv6  ( Ativado *) Ativar DHCPv6  ( Desativado *) Configuração automática de endereço sem estado  ( Ativado *) Endereço do servidor DNS Endereço IPv6 atribuído manualmente Roteador IPv6 atribuído manualmente Prefixo do endereço (64*) Todos os endereços IPv6 Todos os endereços do roteador IPv6 Configurar as definições de IPv6. Endereço de rede UAA LAA Especificar o endereço da rede. PCL SmartSwitch Desativado Ativado * Definir que a impressora alterne automaticamente para a emulação PCL quando um trabalho de impressão exigir isso, independentemente do idioma da impressora padrão. Quando essa definição está desativada, a impressora não examina os dados recebidos e usa o idioma padrão especificado no menu  Configurar . PS SmartSwitch Desativado Ativado * Definir que a impressora alterne automaticamente para a emulação PostScript quando um trabalho de impressão exigir isso, independentemente do idioma da impressora padrão. Quando essa definição está desativada, a impressora não examina os dados recebidos e usa o idioma padrão especificado no menu  Configurar . Buffer de trabalhos Desativado * Ativado Armazenar trabalhos temporariamente no disco rígido antes de imprimir. Este item de menu é exibido apenas quando há um disco rígido instalado. PS binário Mac Automático * Ativado Desativado Definir que a impressora processe trabalhos de impressão PostScript binários do Macintosh. Automático  processa os trabalhos de impressão de computadores com os sistemas operacionais Windows ou Macintosh. Desativado  filtra os trabalhos de impressão PostScript usando o protocolo padrão. Energy Efficient Ethernet Ativado Desativado Automático * Reduzir o consumo de energia quando a impressora não receber dados da rede Ethernet. menu Ethernet"},{"UUID":"3efdb592-d9b1-4532-819b-064e625e26c5","title":"Rede/portas","link":"network-overview-topic.html","desc":"TCP/IP Este item de menu","descFull":"TCP/IP Este item de menu será exibido apenas em impressoras de rede ou em impressoras que estejam conectadas a servidores de impressão. Itens e descrições do menu  TCP/IP Item do menu Descrição um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Definir nome de host Definir o nome do host TCP/IP atual. Nome do domínio Definir nome do domínio. Permitir que o DHCP/BOOTP atualize o servidor NTP Ligado * Desativado Permitir que os clientes de DHCP e BOOTP atualizem as configurações NTP da impressora. Nome da configuração zero Especificar um nome de serviço para a rede de configuração zero. Ativar IP automático Ligado * Desativado Atribuir um endereço IP automaticamente. Endereço do servidor DNS Especificar o atual endereço do servidor DNS (Domain Name System). Endereço do serv. DNS de backup Especificar os endereços do servidor DNS de backup. Endereço 2 do servidor DNS de backup Endereço 3 do servidor DNS de backup Ordem de pesquisa de domínio Especificar uma lista de nomes de domínio para localizar a impressora e seus recursos que residem em domínios diferentes na rede. Ativar DDNS Desligado * Ativado Atualizar as configurações do DNS dinâmico. Vida útil do DDNS 300 a 31.536.000 segundos (3600*) Especificar as atuais configurações do DDNS. Vida útil padrão 5 a 254 segundos (254*) Tempo de atualização do DDNS 300 a 31.536.000 segundos (604800*) Ativar mDNS Ligado * Desativado Atualizar as configurações do multicast DNS. Endereço do servidor WINS Especificar um endereço do servidor para o WINS (Windows Internet Name Service). Ativar BOOTP Desligado * Ativado Permitir que o BOOTP atribua um endereço IP da impressora. Lista de servidores restritos Especificar um endereço IP para as conexões TCP. Utilize uma vírgula para separar cada endereço IP. É possível adicionar até 50 endereços IP. Opções da lista de servidores restritos Bloquear todas as portas * Bloquear apenas impressão Bloquear apenas impressão e HTTP Especificar como os endereços IP na lista podem acessar a funcionalidade da impressora. MTU 256 a 1.500 (1500*) Especificar um parâmetro da unidade máxima de transmissão (MTU) para as conexões TCP. Porta de impressão bruta 1–65535 (9100*) Especificar um número de porta bruta para impressoras conectadas em uma rede. Velocidade máxima do tráfego de saída Desativado * Ativado 100 a 1.000.000 (100000*) Ativar a taxa máxima de transferência da impressora. Ativar TLSv1.0 Ligado * Desativado Ativar o protocolo TLSv1.0. Ativar TLSv1.1 Ligado * Desativado Ativar o protocolo TLSv1.1. Lista de cifras SSL Especificar os algoritmos de cifra a serem usados para as conexões SSL ou TLS. menu TCP/IP"},{"UUID":"67586e5e-eda2-477f-af47-d6bb33f7544c","title":"Rede/portas","link":"network-overview-topic.html","desc":"SNMP Este menu é exibido","descFull":"SNMP Este menu é exibido somente em impressoras de rede ou impressoras conectadas a servidores de impressão. Itens e descrições do menu  SNMP Item do menu Descrição um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Versões 1 e 2c do SNMP Ativado Desligado Ligado * Permitir configuração do SNMP Desligado Ligado * Enable PPM MIB Desligado Ligado * Comunidade SNMP Configure as versões 1 e 2c do Protocolo Simples de Gerenciamento de Rede (SNMP) para instalar drivers e aplicativos de impressão. Versão 3 do SNMP Ativado Desligado Ligado * Nome do contexto Configure as credenciais de Leitura/Registro Nome do usuário Senha de autenticação Senha de privacidade Configure somente as credenciais de Leitura Nome do usuário Senha de autenticação Senha de privacidade Autenticação de hash MD5 SHA1 * Nível de autenticação mínimo Nenhuma autenticação, Nenhuma privacidade Autenticação, Nenhuma privacidade Autenticação, Privacidade * Algoritmo de privacidade DES AES‑128 * Configure a versão 3 do SNMP para instalar e atualizar a segurança da impressora. menu SNMP"},{"UUID":"f1ddac98-571e-498e-89b2-40890d2e8f61","title":"Rede/portas","link":"network-overview-topic.html","desc":"IPSec Este menu é exibido","descFull":"IPSec Este menu é exibido somente em impressoras de rede ou impressoras conectadas a servidores de impressão. Itens e descrições do menu  IPSec Item do menu Descrição um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Ativar IPSec (Internet Protocol Security) Desligado * Ligado Ativar IPSec. Configuração de base Padrão * Compatibilidade Seguro Definir a configuração base do IPSec. Este item de menu será exibido somente quando  Ativar IPSec  for definido como  Ativado . Proposta do grupo DH (Diffie-Hellman) modp2048 (14) * modp3072 (15) modp4096 (16) modp6144 (17) Definir a configuração base do IPSec. Este item de menu será exibido somente quando a opção  Configuração de base  estiver definida como  Compatibilidade . Método de criptografia proposto 3DES AES * Define o método de criptografia. Este item de menu será exibido somente quando a opção  Configuração de base  estiver definida como  Compatibilidade . Método de autenticação proposto SHA1 SHA256 * SHA512 Configure o método de autenticação. Este item de menu será exibido somente quando a opção  Configuração de base  estiver definida como  Compatibilidade . Total de páginas impressas SA IKE (horas) 1 2 4 8 24* Especifique o período de validade do SA IKE. Este item de menu será exibido somente quando a opção  Configuração de base  estiver definida como  Segura . Total de páginas impressas IPsec SA (horas) 1 2 4 8* 24 Especifique o período de validade do IPSec SA. Este item de menu será exibido somente quando a opção  Configuração de base  estiver definida como  Segura . Certificado de dispositivo IPsec Especificar um certificado de IPSec. Este item de menu será exibido somente quando  Ativar IPSec  for definido como  Ativado . Principais conexões autenticadas pré-compartilhadas Host  [x] Configurar as conexões autenticadas da impressora. Estes itens de menu serão exibidos somente quando  Ativar IPSec  for definido como  Ativado . Conexões autenticadas certificadas Host  [x]  Endereço[/subrede] menu IPSec"},{"UUID":"247e0a8b-0eeb-434e-9a54-d38e35dc2d7c","title":"Rede/portas","link":"network-overview-topic.html","desc":"802.1x Este menu é exibido","descFull":"802.1x Este menu é exibido somente em impressoras de rede ou impressoras conectadas a servidores de impressão. Itens e descrições do menu  802.1x Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Ativo Desativado * Ativado Permitir que a impressora ingresse em redes que exigem autenticação antes de permitir o acesso. Autenticação 802.1x Nome de login do dispositivo Senha de login do dispositivo Validar certificado do servidor  ( Ativado *) Ativar registro de eventos  ( Desativado *) Certificado 802.1x do dispositivo Defina as configurações para autenticar a conexão 802.1x. Mecanismos de autenticação admissíveis EAP ‑ MD5  ( Ativado *) EAP - MSCHAPv2  ( Ativado *) LEAP  ( Ativado *) PEAP  ( Ativado *) EAP - TLS  ( Ativado *) EAP - TTLS  ( Ativado *) Método de autenticação TTLS  ( MSCHAPv2 *) Configure os mecanismos de autenticação permitidos para a conexão 802.1x. menu 802.1x"},{"UUID":"d68f8e28-8d9f-4abd-bb8d-badba4e72bab","title":"Rede/portas","link":"network-overview-topic.html","desc":"Configuração LPD Este menu é","descFull":"Configuração LPD Este menu é exibido somente em impressoras de rede ou impressoras conectadas a servidores de impressão. Itens e descrições do menu  Configuração LPD Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração-padrão de fábrica. Tempo limite LPD 0 a 65535 segundos (90*) Configure o valor de tempo limite para interromper o servidor Daemon de Impressora de Linha (LPD) de esperar indefinidamente para trabalhos de impressão parados ou inválidos. Página de faixa LPD Desativar * Ativar Imprima uma página de banner para todos os trabalhos de impressão LPD. Uma página de banner é a primeira página de um trabalho de impressão utilizada como separador de trabalhos de impressão e para identificar a origem de sua solicitação. Página marcadora LPD Desativar * Ativar Imprima uma página marcadora para todos os trabalhos de impressão LPD. Uma página marcadora é a última página de um trabalho de impressão. Conversão de retorno de carro LPD Desativar * Ativar Permita a conversão de retorno de carro. Retorno de carro é um mecanismo que comanda a impressora para mover a posição do cursor para a primeira posição na mesma linha. menu Configuração LPD"},{"UUID":"0d970ea9-226c-46d0-a9e2-11792ea036e7","title":"Rede/portas","link":"network-overview-topic.html","desc":"Configurações de HTTP/FTP Itens e","descFull":"Configurações de HTTP/FTP Itens e descrições do menu  Configurações de HTTP/FTP Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Proxy Endereço IP de proxy HTTP Porta IP padrão HTTP Endereço IP de proxy FTP Porta IP padrão FTP Autenticação Nome de usuário Senha Domínios locais Defina as configurações dos servidores HTTP e FTP. Outras definições Ativar servidor HTTP  ( Ativado *) Acesse o Embedded Web Server para monitorar e gerenciar a impressora. Outras definições Ativar HTTPS  ( Ativado *) Ativar o Hypertext Transfer Protocol Secure (HTTPS) para criptografar a transferência de dados de e para o servidor de impressão. Outras definições Forçar conexões HTTPS  ( Desativado *) Forçar conexões HTTPS na impressora. Outras definições Ativar FTP/TFTP  ( Ativado *) Enviar arquivos utilizando FTP/TFTP. Outras definições Certificado de dispositivo HTTPS  ( padrão *) Exibir o certificado de dispositivo HTTP usado na impressora. Outras definições Tempo limite para solicitações HTTP/FTP  (30*) Especificar o período antes de a conexão do servidor parar. Outras definições Tentativas de solicitação HTTP/FTP  (3*) Configure o número de novas tentativas de conexão ao servidor HTTP/FTP. menu Configurações de HTTP/FTP"},{"UUID":"02face1c-8d38-42bf-b84e-bb562a8b9b0c","title":"Rede/portas","link":"network-overview-topic.html","desc":"ThinPrint Itens do menu ","descFull":"ThinPrint Itens do menu  ThinPrint  com as respectivas descrições Item do menu Descrição Um asterisco (*) próximo ao valor indica a definição padrão de fábrica. Ativar ThinPrint Desativado * Ativado Imprimir utilizando ThinPrint. Número da porta 4000 a 4999 (4000*) Configure o número da porta para o servidor ThinPrint. Largura de banda (bits/s.) 100-1000000 (0*) Configure a velocidade para transmitir os dados em um ambiente ThinPrint. Tamanho do pacote (kbytes) 0 a 64000 (0*) Configure o tamanho do pacote para a transmissão de dados. menu ThinPrint"},{"UUID":"12231e32-32fd-41f3-9f69-d58f16f8879b","title":"Rede/portas","link":"network-overview-topic.html","desc":"USB Itens e descrições do","descFull":"USB Itens e descrições do menu  USB Item do menu Descrição Um asterisco (*) próximo ao valor indica a definição padrão de fábrica. PCL SmartSwitch Desativado Ativado * Configurar a impressora para alternar para a emulação PCL quando um trabalho de impressão recebido por uma porta USB exigi-lo, independentemente do idioma da impressora padrão. Quando essa definição está desativada, a impressora não examina os dados recebidos e usa o idioma padrão especificado no menu  Configurar . PS SmartSwitch Desativado Ativado * Configurar a impressora para alternar para a emulação PostScript quando um trabalho de impressão recebido por uma porta USB exigi-lo, independentemente do idioma da impressora padrão. Quando essa definição está desativada, a impressora não examina os dados recebidos e usa o idioma padrão especificado no menu  Configurar . Buffer de trabalhos Desativado * Ativado Armazenar trabalhos temporariamente no disco rígido antes de imprimir. Este item de menu é exibido apenas quando há um disco rígido instalado. PS binário Mac Automático * Ativado Desativado Definir que a impressora processe trabalhos de impressão PostScript binários do Macintosh. Automático  processa os trabalhos de impressão de computadores com os sistemas operacionais Windows ou Macintosh. Desativado  filtra os trabalhos de impressão PostScript usando o protocolo padrão. Ativar porta USB Desativado Ativado * Ativar a porta da unidade USB frontal. menu USB"},{"UUID":"bd772dd0-a145-4956-aa42-e57468460f41","title":"Rede/portas","link":"network-overview-topic.html","desc":"Restringir acesso externo à rede","descFull":"Restringir acesso externo à rede Itens e descrições do menu de configurações  Restringir acesso à rede externo Item do menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Restringir acesso externo à rede Desativado * Ativar Acesso restrito aos locais de rede. Endereço de rede externa Especifique os endereços de rede com acesso restrito. Endereço de e-mail para notificação Especifique um endereço de e-mail para enviar uma notificação de eventos registrados. Frequência de ping 1-300 (10*) Especifique o intervalo da pesquisa de rede em segundos. Assunto Especifique o assunto e mensagem da notificação e-mail. Mensagem menu Restringir acesso externo à rede"},{"UUID":"7b55f881-6824-4508-963a-f151bdd6d333","title":"Serviços na nuvem","link":"cloud-services-enrollment-topic.html","desc":"Registro nos serviços na nuvem","descFull":"Registro nos serviços na nuvem Itens e descrições do menu  Registro nos serviços na nuvem Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Exibir mais informações Exibir informações adicionais sobre o uso dos Lexmark Cloud Services. Ativar a comunicação com o Lexmark Cloud Services Desativado * Ativado Ative a impressora para comunicar-se com o Lexmark Cloud Services. Exibir estado atual Exibir o status da conexão entre a impressora e o Lexmark Cloud Services. menu Registro nos serviços na nuvem"},{"UUID":"528c3a61-6e27-4cf0-b3f3-5962415ad681","title":"Métodos de login","link":"login-methods-subgroup.html","desc":"Gerenciar permissões Itens e descrições","descFull":"Gerenciar permissões Itens e descrições do menu  Gerenciar permissões Item de menu Descrição Acesso a funções Acessar o catálogo de endereços em Aplicativos Modificar Catálogo de endereços Gerenciar atalhos Criar perfis Gerenciar Marcadores Impressão da unidade flash Impressão colorida da unidade flash Digitalização para a unidade flash Função Copiar Impressão de cópia colorida Diminuição de cor Função de e-mail Função de fax Função de FTP Liberar faxes retidos Acesso a trabalhos suspensos Usar perfis Cancelar trabalhos no dispositivo Alterar idioma Protocolo IPP (Internet Printing Protocol) Iniciar digitalizações remotamente Impressão P/B Impressão colorida Pasta de rede – Digitalização Disco rígido – Impressão Disco rígido – Impressão colorida Disco rígido – Digitalização Controla o acesso às funções da impressora. Alguns itens do menu são exibidos apenas quando há um disco rígido ou uma unidade de armazenamento inteligente instalado. Menus administrativos Menu de segurança Menu Rede/Portas Menu Papel Menu Relatórios Configuração das funções do menu Menu Suprimentos Menu Placa opcional Menu SE Menu do dispositivo Controla o acesso às configurações do menu da impressora. Gerenciamento de dispositivo Gerenciamento remoto Atualizações de firmware Configuração de aplicativos Bloquear painel do operador Acesso ao Embedded Web Server Importar/Exportar todas as configurações Apagamento fora de serviço Registro nos serviços na nuvem Controla o acesso às opções de gerenciamento da impressora. Aplicativos Novos aplicativos Apresentação de slides Alterar o papel de parede Proteção de tela Cópia de cartão Scan Center Scan Center personalizado  [x] Controla o acesso aos aplicativos da impressora. menu Gerenciar permissões"},{"UUID":"fa1d0ae5-709b-4c9a-9255-d4a708d3893f","title":"Métodos de login","link":"login-methods-subgroup.html","desc":"Contas locais Itens e descrições","descFull":"Contas locais Itens e descrições do menu  Contas locais Item do menu Descrição Gerenciar Grupos/Permissões Mostrar uma lista de todos os grupos salvos na impressora. Adicionar usuário Nome de usuário/Senha Nome do usuário Senha PIN Criar contas locais e especificar o acesso às funções da impressora, aos menus administrativos, às opções de gerenciamento da impressora e aos aplicativos. menu Contas locais"},{"UUID":"4946c3d4-e169-4e8c-b9a2-aaa634fcb5cd","title":"Métodos de login","link":"login-methods-subgroup.html","desc":"Métodos de login padrão Esse","descFull":"Métodos de login padrão Esse menu é exibido somente ao configurar as definições no menu  Contas locais . Itens e descrições do menu  Métodos de login padrão Item de menu Descrição Painel de controle Nome de usuário/Senha User Name (Nome do usuário) Senha PIN Especificar o método de login padrão para acessar o painel de controle. Navegador Nome de usuário/Senha User Name (Nome do usuário) Senha PIN Especificar o método de login padrão para acessar o navegador. menu Métodos de login padrão"},{"UUID":"e99d0cc5-5695-4ccf-a2b5-04b861144484","title":"Segurança","link":"login-methods-subgroup.html","desc":"Programar dispositivos USB Item e","descFull":"Programar dispositivos USB Item e descrição do menu  Programar dispositivos USB Item do menu Descrição Programações Adicionar nova programação Programe acesso à porta USB frontal. menu Programar dispositivos USB"},{"UUID":"58235d93-3e8f-4b8d-a2ed-c3ce840d5d7e","title":"Segurança","link":"login-methods-subgroup.html","desc":"Log de auditoria de segurança","descFull":"Log de auditoria de segurança Itens do menu  Log de auditoria de segurança  com as respectivas descrições Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Ativar auditoria Desativado * Ativado Registre os eventos no registro de auditoria seguro e no syslog remoto. Ativar syslog remoto Desativado * Ativado Envie os registros de auditoria para um servidor remoto. Servidor de syslog remoto Especificar o servidor de syslog remoto. Porta de syslog remoto 1-65535 (514*) Especificar a porta de syslog remoto. Método de syslog remoto UDP normal * Stunnel Especifique um método de syslog para transmitir eventos registrados para um servidor remoto. Instalação de syslog remoto 0 - Mensagens kernel 1 - Mensagens de nível do usuário 2 - Sistema de correspondência 3 - Sistema daemon 4 – Mensagens de segurança/autorização * 5 - Mensagens geradas internamente pelo syslogd 6 - Subsistema da impressora de linha 7 - Subsistema de notícias de rede 8 - Subsistema UUCP 9 - Daemon do relógio 10 - Mensagens de segurança/autorização 11 - Daemon do FTP 12 - Subsistema NTP 13 - Auditoria de registro 14 - Alerta de registro 15 - Daemon do relógio 16 - Utilização local 0 (local0) 17 - Utilização local 1 (local1) 18 - Utilização local 2 (local2) 19 - Utilização local 3 (local3) 20 - Utilização local 4 (local4) 21 - Utilização local 5 (local5) 22 - Utilização local 6 (local6) 23 - Utilização local 7 (local7) Especifique um código de instalação que a impressora utiliza ao enviar eventos de registro para um servidor remoto. Gravidade de eventos no log 0 - Emergência 1 - Alerta 2- Crítico 3 - Erro 4 – Aviso * 5 - Aviso 6 - Informativo 7 - Depuração Especifique o limite do nível de prioridade para registrar mensagens e eventos. Eventos sem registro de syslog remoto Desativado * Ativado Envie todos os eventos, independentemente do nível de gravidade, ao servidor remoto. Endereço de e-mail do administrador Envie uma notificação por e-mail dos eventos registrados ao administrador. Alerta de registro de e-mail apagado Desativado * Ativado Envie uma notificação por e-mail ao administrador quando uma entrada de registro for excluída. Alerta de registro de e-mail substituído Desativado * Ativado Envie uma notificação por e-mail ao administrador quando o registro se tornar completo e começar a substituir as entradas mais antigas. Comportamento completo do registro Ocultar entradas mais antigas * Envie o registro por e-mail e, em seguida, exclua todas as entradas Resolva problemas de armazenamento de registro quando este preencher sua memória estabelecida. Alerta de e-mail % cheio Desativado * Ativado Envie uma notificação por e-mail ao administrador quando o registro preencher sua memória estabelecida. Nível de % cheio 1 a 99 (90*) Alerta de registro de e-mail exportado Desativado * Ativado Envie uma notificação por e-mail ao administrador quando um registro for exportado. Alerta de configurações de registro de e-mail alteradas Desativado * Ativado Envia uma notificação por e-mail ao administrador quando o item  Ativar auditoria  está ativado. Registrar finais de linha LF (\\n) * CR (\\r) CRLF (\\r\\n) Especifique como o arquivo de registro interrompe o fim de cada linha. Assine exportações digitalmente Desativado * Ativado Adicione uma assinatura digital para cada arquivo de registro exportado. Apagar log Exclua todos os registros de auditoria. Exportar log Syslog (RFC 5424) Syslog (RFC 3164) CSV Exporte um registro de segurança para uma unidade flash. menu Log de auditoria de segurança"},{"UUID":"29d88795-cc08-4809-993b-f35490818981","title":"Segurança","link":"login-methods-subgroup.html","desc":"Restrições de login Itens e","descFull":"Restrições de login Itens e descrições do menu  Restrições de login Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração-padrão de fábrica. Falhas de login 1-10 (3*) Especifique o número de tentativas falhas de login antes que os usuários sejam bloqueados. Falha no tempo de execução 1 a 60 minutos (5*) Especifique o intervalo de tempo entre tentativas falhas de login antes que os usuários sejam bloqueados. Tempo de bloqueio 1 a 60 minutos (5*) Especifique o tempo de bloqueio. Tempo limite de login da Web 1 a 120 minutos (10*) Especifique o atraso para um login remoto antes que o usuário seja desconectado automaticamente. menu Restrições de login"},{"UUID":"6f6e642b-d723-4fa0-90f7-605ea4e865a9","title":"Segurança","link":"login-methods-subgroup.html","desc":"Configuração de impressão confidencial Itens","descFull":"Configuração de impressão confidencial Itens e descrições do menu  Configuração de impressão confidencial Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Máximo de PINs inválidos 2 a 10 Defina o limite para inserir um PIN inválido. Quando o limite é alcançado, os trabalhos de impressão desse nome de usuário são excluídos. Expiração de trabalho confidencial Desativado * 1 hora 4 horas 24 horas 1 semana Defina individualmente o tempo de expiração para cada trabalho suspenso antes que ele seja excluído automaticamente da memória ou do disco rígido da impressora. Um trabalho suspenso pode estar com o status  Confidencial ,  Repetir ,  Reservar  ou  Verificar . Expiração de trabalho para repetição Desativado * 1 hora 4 horas 24 horas 1 semana Configure o tempo de expiração para um trabalho de impressão que talvez deseje repetir. Expiração de trabalho para verificação Desativado * 1 hora 4 horas 24 horas 1 semana Defina o tempo de expiração para a impressão da cópia de um trabalho para que você verifique a qualidade antes de imprimir as cópias restantes. Expiração de trabalho para reserva Desativado * 1 hora 4 horas 24 horas 1 semana Defina o tempo de expiração para os trabalhos que deseja armazenar na impressora para impressões posteriores. Exigir que todos os trabalhos sejam mantidos Desativado * Ativado Configure a impressora para suportar todos os trabalhos de impressão. Manter documentos duplicados Desativado * Ativado Programe a impressora para manter todos os documentos com o mesmo nome de arquivo. menu Configuração de impressão confidencial"},{"UUID":"4d3a7ec0-56b0-496a-96b0-ab4d80d1b269","title":"Segurança","link":"login-methods-subgroup.html","desc":"Criptografia de disco Esse menu","descFull":"Criptografia de disco Esse menu é exibido apenas quando há um disco rígido ou uma unidade de armazenamento inteligente instalados. Itens do menu  Criptografia de disco  com as respectivas descrições Item de menu Descrição Disco rígido Mostra o status de criptografia do disco rígido. Unidade de armazenamento inteligente Mostra o status de criptografia da unidade de armazenamento inteligente (ISD). O ISD é desativado automaticamente quando um disco rígido é instalado. menu Criptografia de disco"},{"UUID":"c2809777-9cd5-4c0b-94da-b0ac9ba9322c","title":"Segurança","link":"login-methods-subgroup.html","desc":"Apagar arquivos de dados temporários","descFull":"Apagar arquivos de dados temporários Itens do menu Apagar arquivos de dados temporários e suas respectivas descrições Item do menu Descrição Um asterisco (*) próximo ao valor indica a definição padrão de fábrica. Armazenado na memória de carregamento Desativado * Ativado Exclua todos os arquivos armazenados na memória da impressora. Armazenado em disco rígido 1 passagem – Apagar * 3 passagens - Apagar 7 passagens - Apagar Exclua todos os arquivos armazenados no disco rígido da impressora. Este item de menu é exibido apenas quando há um disco rígido instalado na impressora. menu Apagar arquivos de dados temporários"},{"UUID":"c6fe750c-e66b-431c-8a7c-e4308dccb6d6","title":"Segurança","link":"login-methods-subgroup.html","desc":"Configurações de Soluções LDAP Itens","descFull":"Configurações de Soluções LDAP Itens do menu  Configurações de soluções LDAP  com as respectivas descrições Item do menu Descrição Seguir referências LDAP Desativado * Ativado Pesquisar os servidores diferentes no domínio para a conta do usuário conectado. Verificação de certificado LDAP Sim Não * Ativar a verificação de certificados LDAP. menu Configurações de Soluções LDAP"},{"UUID":"76ad1554-95a0-4a06-be63-99d7262ff988","title":"Segurança","link":"login-methods-subgroup.html","desc":"Diversos Itens e descrições do","descFull":"Diversos Itens e descrições do menu  Diversos Item de menu Descrição Um asterisco (*) próximo a um valor indica a configuração padrão de fábrica. Recursos protegidos Mostrar * Ocultar Mostrar todos os recursos que o Controle de acesso a funções (FAC) protege, independentemente da permissão de segurança que o usuário tenha. Ocultar  exibe apenas os recursos protegidos pelo Controle de acesso a funções aos quais o usuário tem acesso. Permissão de impressão Desativado * Ativado Permitir que o usuário efetue login antes de imprimir. Login padrão de permissão de impressão Nome de usuário/Senha * Nome de usuário Define o login padrão para  Permissão de impressão . Jumper de reconfiguração de segurança Ativar acesso de \"Convidado\" * Sem efeito Especifica o acesso do usuário à impressora. Ativar acesso de \"Convidado\"  concede a qualquer pessoa acesso a todos os aspectos da impressora. Sem efeito  pode impossibilitar o acesso à impressora quando as informações de segurança necessárias estiverem indisponíveis. Use a unidade de armazenamento inteligente para dados do usuário Desativado Ativado * Ative a unidade de armazenamento inteligente para armazenar dados do usuário. Este item de menu é desativado quando há um disco rígido instalado. Extensão mínima da senha 0-32 (0*) Especifica o comprimento da senha. Ativar revelação de senha/PIN Desativado * Ativado Mostra a senha ou o número de identificação pessoal. menu Diversos"},{"UUID":"2b5b3f55-2fc6-47a0-943e-9e6bedd35d5e","title":"Relatórios","link":"menu-settings-page-topic.html","desc":"Página de definições de menu","descFull":"Página de definições de menu Item e descrição do menu  Página de definições de menu Item de menu Descrição Página de definições de menu Imprima um relatório que contenha os menus da impressora. menu Página de definições de menu"},{"UUID":"a810858b-9528-4d1d-8d93-d2110e1a304f","title":"Relatórios","link":"menu-settings-page-topic.html","desc":"Dispositivo Dispositivo Itens e descrições","descFull":"Dispositivo Dispositivo Itens e descrições do menu  Dispositivo Item de menu Descrição Informações do dispositivo Imprimir um relatório que contenha informações sobre a impressora. Estatísticas do dispositivo Imprimir um relatório sobre a utilização da impressora e o status dos suprimentos. Lista de perfis Imprimir uma lista dos perfis armazenados na impressora. Relatório de ativos Imprima uma ferramenta de diagnóstico para problemas de impressão. Para evitar cortar o conteúdo, imprima o relatório em papel de tamanho carta ou A4. menu Dispositivo"},{"UUID":"2af86679-563a-45ec-8c2d-9d19c277c4e0","title":"Relatórios","link":"menu-settings-page-topic.html","desc":"Impressão Itens e descrições do","descFull":"Impressão Itens e descrições do menu Imprimir Item do menu Descrição Imprimir fontes Fontes PCL Fontes PS Imprimir amostras e informações sobre as fontes que estão disponíveis em cada idioma de impressora. Imprimir demonstração Página de demonstração Imprimir uma página que mostra os recursos da impressora e as soluções compatíveis. Imprimir diretório Imprimir os recursos que estão armazenados na unidade flash ou no disco rígido da impressora. Este item de menu é exibido apenas quando há uma unidade flash ou um disco rígido instalados na impressora. menu Impressão"},{"UUID":"86fef373-d0b9-4041-8000-45b5887acfcb","title":"Relatórios","link":"menu-settings-page-topic.html","desc":"Atalhos Itens e descrições do","descFull":"Atalhos Itens e descrições do menu  Atalhos Item de menu Descrição Todos os atalhos Imprimir um relatório que lista os atalhos armazenados na impressora. Atalhos de fax  aparecem somente quando o fax está instalado. Atalhos de fax Copiar atalhos Atalhos de e-mail Atalhos de FTP Atalhos para a pasta de rede menu Atalhos"},{"UUID":"20239b80-fb8f-48c9-a71f-66f79fabba4f","title":"Relatórios","link":"menu-settings-page-topic.html","desc":"Fax Esse menu é exibido","descFull":"Fax Esse menu é exibido somente se o fax estiver configurado e a opção  Ativar registro de trabalho  estiver definida como  Ativado . Itens e descrições do menu  Fax Item do menu Descrição Log de trabalhos de fax Imprima um relatório sobre os últimos 200 trabalhos de fax concluídos. Log de chamadas de fax Imprima um relatório sobre as últimas 100 tentativas de chamada, chamadas recebidas e chamadas bloqueadas. menu Fax"},{"UUID":"eb059fb8-3660-434f-90af-503ab70d68e9","title":"Relatórios","link":"menu-settings-page-topic.html","desc":"Rede Item e descrição do","descFull":"Rede Item e descrição do menu  Rede Item de menu Descrição Pág. config. de rede Imprima uma página que exiba a rede configurada e as configurações sem fio na impressora. este item de menu será exibido apenas em impressoras de rede ou em impressoras que estejam conectadas a servidores de impressão. Clientes conectados ao Wi-Fi Direct Imprima uma página que mostra a lista de dispositivos que estão conectados à impressora usando o Wi-Fi Direct. Este item de menu só será exibido quando  Ativar Wi‑Fi Direct  for definido como  Ativado . menu Rede"},{"UUID":"dc738399-3591-46a3-948e-0851e07e3ae3","title":"Uso dos menus da impressora","link":"troubleshooting-menu-topic.html","desc":"Solução de problemas Itens e","descFull":"Solução de problemas Itens e descrições do menu Solução de problemas Item de menu Descrição Imprimir páginas de teste de qualidade Imprimir páginas de amostra para identificar e corrigir defeitos de qualidade de impressão. Limpeza do scanner Instruções impressas para limpar o scanner. menu Solução de problemas Imprimir páginas de teste de qualidade Limpeza do scanner"},{"UUID":"f3c1e90e-b057-4aab-b0a6-809e5754d757","title":"Uso dos menus da impressora","link":"printing-menu-settings-page-topic.html","desc":"Impressão da  Página de","descFull":"Impressão da  Página de definições de menu Na tela inicial, toque em  Configurações Relatórios  Página de definições de menu . impressão Página de configurações de menu Página de configurações de menu impressão menus da impressora"},{"UUID":"7eabbdb6-b700-48aa-bf85-22929d1c9450","title":"Manutenção da impressora","link":"checking-status-of-parts-and-supplies-topic.html","desc":"Verificação do status de peças","descFull":"Verificação do status de peças e suprimentos Na tela inicial, toque em  Status/Suprimentos . Selecione as peças ou suprimentos que você deseja verificar. Você também pode acessar essa definição tocando na parte superior da tela inicial. verificação do status das peças e dos suprimentos status dos suprimentos verificação status das peças verificação"},{"UUID":"ce0808e5-46a5-4491-afc7-ded508120c33","title":"Manutenção da impressora","link":"configuring-supply-notifications-topic.html","desc":"Configuração de notificações de suprimento","descFull":"Configuração de notificações de suprimento Abra o navegador da Internet e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para carregar a página da web corretamente. Clique em  Configurações Dispositivo Notificações . No menu Suprimentos, clique em  Notificações de suprimento personalizadas . Selecione uma notificação para cada item de suprimento. Aplique as alterações. notificações de suprimento configuração configuração de notificação de suprimentos"},{"UUID":"37bbe0c2-47e6-420c-b0f5-d1434dc80da1","title":"Manutenção da impressora","link":"setting-up-e-mail-alert-topic.html","desc":"Configurando os alertas de e-mail","descFull":"Configurando os alertas de e-mail Configure a impressora para enviar alertas por e-mail quando os suprimentos estiverem acabando, quando o papel precisar ser trocado ou adicionado, ou quando houver papel preso. Abra o navegador da Web e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial da impressora. O endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Clique em  Configurações Dispositivo Notificações Configuração de alerta por e‑mail  e defina as configurações. Para obter mais informações sobre as configurações de SMTP, entre em contato com o provedor de e‑mail. Aplique as alterações. Clique em  Configurar listas e alertas de e-mail  e defina as configurações. Aplique as alterações. alertas de e-mail configuração configuração de alertas de e-mail"},{"UUID":"869c1ac0-4279-4dd4-880b-d1475754d28f","title":"Manutenção da impressora","link":"viewing-reports-topic.html","desc":"Exibindo relatórios Na tela inicial,","descFull":"Exibindo relatórios Na tela inicial, toque em  Configurações Relatórios . Selecione o relatório que deseja exibir. exibir relatórios relatórios status da impressora relatórios uso da impressora"},{"UUID":"125c372a-09d2-433f-bdf3-a0b849bb1126","title":"Solicitação de peças e suprimentos","link":"ordering-parts-and-supplies-group.html","desc":"Para fazer pedidos de suprimentos","descFull":"Para fazer pedidos de suprimentos nos EUA, entre em contato com a Lexmark pelo telefone 1-800-539-6275 e obtenha informações sobre os revendedores autorizados de suprimentos Lexmark em sua área. Em outros países ou regiões, vá até  www.lexmark.com  ou entre em contato com o local em que você adquiriu a impressora. Para fazer o pedido de suprimentos, entre em contato com o local em que você adquiriu a impressora. Todas as estimativas de vida útil dos suprimentos da impressora consideram a impressão em papel comum tamanho Carta ou A4. Se o desempenho ideal da impressora não for mantido ou as peças e os suprimentos não forem substituídos quando necessário, a impressora poderá ser danificada. peças e suprimentos originais"},{"UUID":"fe0ff6b4-37c8-463c-a6a1-e6b826cbc472","title":"Solicitação de peças e suprimentos","link":"ordering-parts-and-supplies-group.html","desc":"Usando peças e suprimentos genuínos","descFull":"Usando peças e suprimentos genuínos da Lexmark A impressora Lexmark foi criada p/ melhor funcionar c/ suprimentos/peças Lexmark genuínos. O uso de suprimentos ou peças de terceiros afeta o desempenho, a confiabilidade ou a vida da impressora e de seus componentes de criação de imagens. Também pode afetar a cobertura de garantia. A garantia não cobre danos causados pelo uso de suprimento e peças de terceiros. Todos os indicadores de vida foram projetados para funcionar com suprimentos e peças Lexmark e podem apresentar resultados imprevisíveis se forem usados suprimentos e peças de terceiros. O uso de componentes de criação de imagens além da vida útil pretendida pode danificar a impressora Lexmark ou componentes associados. Suprimentos e peças sem termos de contrato do Programa de Devolução podem ser reconfigurados e remanufaturados. No entanto, a garantia do fabricante não cobre danos causados por suprimentos ou peças que não sejam originais. Redefinir o contador do suprimento ou peça sem a remanufatura adequada pode danificar sua impressora. Após redefinir o suprimento ou o contador de peças, sua impressora pode exibir um erro indicando a presença do item redefinido. usando peças e suprimentos originais da Lexmark peças e suprimentos originais da Lexmark"},{"UUID":"2f0ea961-68fe-4fd3-80b5-780463b5eea1","title":"Solicitação de peças e suprimentos","link":"ordering-parts-and-supplies-group.html","desc":"Solicitação do cartucho de toner","descFull":"Solicitação do cartucho de toner O rendimento estimado do cartucho é baseado no padrão ISO/IEC 19752. Uma cobertura de impressão extremamente baixa por longos períodos pode afetar negativamente o rendimento real. Para solicitar o cartucho de toner, entre em contato com o local em que você adquiriu a impressora. Cartucho de toner e número de peça Item Global Cartucho de toner de 37K 63D0H00 suprimentos, pedido cartucho de toner cartucho de toner pedido"},{"UUID":"7c01e262-a4d2-4852-a8db-f8928a272b87","title":"Solicitação de peças e suprimentos","link":"ordering-parts-and-supplies-group.html","desc":"Solicitação da unidade de imagem","descFull":"Solicitação da unidade de imagem Uma cobertura de impressão extremamente baixa por períodos prolongados pode fazer com que as peças da unidade de imagem apresentem falhas antes de o toner se esgotar. Para solicitar uma unidade de imagem, entre em contato com o local em que comprou a impressora. Unidade de imagem e número de peça Item Número de peça Unidade de imagem 63D0Z00 unidade de imagem pedido pedido de suprimentos unidade de imagem"},{"UUID":"031cf459-33f8-4938-90f7-e4ca31e84f8f","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Substituir o cartucho de toner","descFull":"Substituir o cartucho de toner Abra a porta frontal. Remova o cartucho de toner usado. Remova toda a embalagem do novo cartucho de toner. Agite o cartucho de toner para redistribuir o toner. Insira o novo cartucho de toner. Remova o limpador do cabeçote de impressão e limpe a lente do cabeçote de impressão. Coloque o cabeçote de impressão de volta no lugar. Feche a porta. cartucho de toner substituição como substituir suprimentos cartucho de toner"},{"UUID":"53cddf39-6e6d-499b-9718-a3fb96592501","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Substituir a unidade de imagem","descFull":"Substituir a unidade de imagem Abra a porta A. Abra a porta frontal. Remova a unidade de imagem usada. Remova toda a embalagem da nova unidade de imagem. Não exponha a unidade de imagem à luz direta por mais de dez minutos. A longa exposição à luz pode causar problemas na qualidade de impressão. Não toque no cilindro fotocondutor. Fazer isso pode afetar a qualidade dos trabalhos de impressão futuros. Insira a nova unidade de imagem e fixe-a em seu lugar. Remova o limpador do cabeçote de impressão e limpe a lente do cabeçote de impressão. Coloque o cabeçote de impressão de volta no lugar e, em seguida, feche a porta frontal. Feche a porta A. unidade de imagem substituição como substituir suprimentos unidade de imagem"},{"UUID":"90c2d22e-02a2-425f-902b-04c6cf7e0956","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Substituição da bandeja para 520","descFull":"Substituição da bandeja para 520 folhas Substituição da bandeja para 520 folhas Remova a bandeja usada. Desembale o novo encaixe da bandeja e remova o material de embalagem. Instale a nova bandeja. como substituir peças Encaixe da bandeja para 520 folhas Encaixe da bandeja para 520 folhas substituição"},{"UUID":"edd61086-b04b-4433-9b20-f33345677c33","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Substituição do fusor Desligue a","descFull":"Substituição do fusor Desligue a impressora. Abra a porta A. A parte interna da impressora pode estar quente. Para reduzir o risco de ferimentos devido a um componente quente, espere a superfície esfriar antes de tocá-la. Desbloqueie o fusor usado. Remova o fusor usado. Desembale o novo fusor. Insira o novo fusor. Bloqueie o novo fusor. Feche a porta. Ligue a impressora. fusor substituição como substituir peças fusor"},{"UUID":"077db787-5315-41dc-b638-d925139c8084","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Substituição do rolo de transferência","descFull":"Substituição do rolo de transferência Desligue a impressora. Abra a porta A. A parte interna da impressora pode estar quente. Para reduzir o risco de ferimentos devido a um componente quente, espere a superfície esfriar antes de tocá-la. Remova o rolo de transferência usado. Abra a embalagem do novo rolo de transferência. Insira o novo rolo de transferência até que ele  se encaixe  no lugar. Feche a porta A e, em seguida, feche a porta frontal. Ligue a impressora. como substituir peças rolo de transferência rolo de transferência substituição"},{"UUID":"0515651d-a457-4175-8359-4d15d6f0357d","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Substituição do kit de rolos","descFull":"Substituição do kit de rolos da bandeja Substituição do kit de rolos da bandeja Desligue a impressora. Remova a bandeja padrão. Remova o kit de rolos de bandeja usado. Para evitar danos de descarga eletrostática, toque nas partes metálicas expostas da impressora antes de acessar ou tocar nas áreas interiores da impressora. Desembale o novo kit de rolos da bandeja. Insira o novo kit de rolos da bandeja até que  encaixar  no lugar. Insira a bandeja. Ligue a impressora. kit de rolos da Lexmark substituição como substituir peças kit de rolos da Lexmark"},{"UUID":"4e2c7c5e-e1c2-4e2c-97ac-696a1a4d5303","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Substituindo o kit de rolos","descFull":"Substituindo o kit de rolos do ADF Desligue a impressora. Abra a tampa superior do ADF. s Remova a tampa do rolo de separação. Remova o rolo de separação usado. Desembale o novo rolo de separação. Insira o novo rolo de separação. Insira a tampa do rolo de separação do ADF até ela  encaixar  no lugar. Remova o conjunto do rolo de separação usado. Desembale o novo conjunto do rolo de separação. Insira o conjunto do rolo de separação até ela  encaixar  no lugar. Feche a tampa superior do ADF. Ligue a impressora. Kit de rolos do ADF substituição como substituir peças Kit de rolos do ADF rolo separador substituição conjunto do rolo de separação substituição"},{"UUID":"aac28320-0549-4578-9cda-f131dbcf66ee","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Substituição do limpador do cabeçote","descFull":"Substituição do limpador do cabeçote de impressão Abra a porta frontal. Remova o limpador do cabeçote de impressão. Desembale o novo limpador do cabeçote de impressão. Insira o novo limpador do cabeçote de impressão. Feche a porta. como substituir peças limpador do cabeçote de impressão limpador do cabeçote de impressão substituição"},{"UUID":"f26da492-ac0d-4b21-a590-c3e65825bce8","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Substituição do kit de rolos","descFull":"Substituição do kit de rolos da bandeja para 2.000 folhas Substituição do kit de rolos da bandeja para 2.000 folhas Desligue a impressora. Deslize a bandeja para a esquerda. Abra a porta J e, em seguida, abra a tampa do kit de rolos. Localize e remova o kit de rolos usado. Desembale o novo kit de rolos. Insira o novo kit de rolos. Feche a tampa do kit de rolos e, em seguida, feche a porta J. Deslize a bandeja de volta para o lugar. Ligue a impressora. Kit de rolos da bandeja para 2000 folhas substituição como substituir peças Kit de rolos da bandeja para 2000 folhas"},{"UUID":"8297b05a-16e5-4436-b25f-000e9fe88546","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Remoção da tampa do rolo","descFull":"Remoção da tampa do rolo de separação do ADF Remoção da tampa do rolo de separação do ADF Abra a tampa superior do ADF. Remova a tampa do rolo de separação do ADF. Desembale a tampa do novo rolo de separação. Insira a tampa do novo rolo de separação até ela  encaixar  no lugar. Feche a tampa superior do ADF. Rolo de separação do ADF substituição como substituir peças Rolo de separação do ADF"},{"UUID":"e6826802-e985-4698-9a0b-55432a50b4b9","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Como recolocar a tampa do","descFull":"Como recolocar a tampa do conector traseiro inferior Como recolocar a tampa do conector traseiro inferior Remova a tampa do conector traseiro inferior usada. Desembale a nova tampa do conector traseiro inferior. Insira a nova tampa do conector traseiro inferior até ela  encaixar  no lugar. como substituir peças tampa do conector traseiro inferior tampa do conector traseiro inferior substituição"},{"UUID":"c81fa55b-0566-495d-a37d-fea74469bb1e","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Como recolocar a trava do","descFull":"Como recolocar a trava do papel da bandeja do ADF Remova a tampa de papel da bandeja do ADF usada. Desembale a nova trava de papel da bandeja do ADF. Insira a nova trava de papel da bandeja do ADF. como substituir peças Trava de papel da bandeja do ADF Trava de papel da bandeja do ADF substituição"},{"UUID":"8450c765-4424-4b2a-ac5c-5db58d189e06","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Redefinindo o contador de manutenção","descFull":"Redefinindo o contador de manutenção Na tela inicial, toque em  Configurações Dispositivo Manutenção Menu de Configuração Utilização e Contadores de Suprimentos . Toque em  Redefinir contador de manutenção . contador de manutenção reconfiguração redefinindo o contador de manutenção"},{"UUID":"e1d03795-7c4d-4a69-8675-37fe3a112ae6","title":"Troca de peças e suprimentos","link":"replacing-toner-cartridge-topic.html","desc":"Como redefinir os contadores de","descFull":"Como redefinir os contadores de uso de suprimentos Na tela inicial, toque em  Configurações Dispositivo Manutenção Menu de Configuração Utilização e Contadores de Suprimentos . Selecione o contador que deseja redefinir. Suprimentos e peças sem termos de contrato do Programa de devolução podem ser redefinidos e remanufaturados. No entanto, a garantia do fabricante não cobre danos causados por suprimentos ou peças que não sejam originais. Redefinir o contador de suprimentos ou peças sem a remanufatura adequada pode danificar sua impressora. Após redefinir o suprimento ou o contador, sua impressora pode exibir um erro indicando a presença do item redefinido. Suprimentos e peças sem termos de contrato do programa de coleta podem ser reconfigurados e remanufaturados. No entanto, a garantia do fabricante não cobre danos causados por suprimentos ou peças que não sejam originais. Redefinir o contador de suprimentos ou peças sem a remanufatura adequada pode danificar sua impressora. Após redefinir o suprimento ou o contador, sua impressora pode exibir um erro indicando a presença do item redefinido. contadores de uso de suprimentos reconfiguração como redefinir os contadores de uso de suprimento"},{"UUID":"5bf91ce3-876b-44aa-9a50-baaa2cedfbf3","title":"Substituição do cartucho de grampos","link":"replacing-toner-cartridge-topic.html","desc":"Substituição do cartucho de grampos","descFull":"Substituição do cartucho de grampos no encadernador Abra a porta do encadernador. Remova o suporte do cartucho de grampos. Remova o cartucho de grampos vazio. Desembale o novo cartucho de grampos. Insira o novo cartucho de grampos no suporte até ele  encaixar  no lugar. Insira o suporte do cartucho de grampos até ele  encaixar  no lugar. Feche a porta. substituindo suprimentos cartuchos de grampos cartuchos de grampos substituição"},{"UUID":"987e660c-afd8-4272-9f0c-ad9c33f611f8","title":"Substituição do cartucho de grampos","link":"replacing-toner-cartridge-topic.html","desc":"Substituição do cartucho de grampos","descFull":"Substituição do cartucho de grampos no grampeador e perfurador Abra a porta do encadernador. Remova o suporte do cartucho de grampos. Remova o cartucho de grampos vazio. Desembale o novo cartucho de grampos. Insira o novo cartucho de grampos até que ele  se encaixe  no lugar. Insira o suporte do cartucho de grampos. Feche a porta. substituindo suprimentos cartuchos de grampos cartuchos de grampos substituição"},{"UUID":"4b953fc7-246d-4994-8510-582c47c0f48d","title":"Substituição do cartucho de grampos","link":"replacing-toner-cartridge-topic.html","desc":"Substituição do suporte do cartucho","descFull":"Substituição do suporte do cartucho de grampos padrão Substituição do suporte do cartucho de grampos padrão Abra a porta do encadernador. Remova o suporte do cartucho de grampos usado. Remova o cartucho de grampos. Desembale o novo suporte do cartucho de grampos. Insira o cartucho de grampos no novo suporte do cartucho de grampos até que ele  se encaixe  no lugar. Insira o suporte do novo cartucho de grampos até ele  encaixar  no lugar. Feche a porta do encadernador. como substituir peças suporte do cartucho de grampos suporte do cartucho de grampos substituição"},{"UUID":"ffe23260-1651-4677-b262-2b620c091c1e","title":"Como limpar peças da impressora","link":"cleaning-printer-topic.html","desc":"Limpeza da impressora Para evitar","descFull":"Limpeza da impressora Para evitar o risco de choque elétrico ao limpar a parte externa da impressora, desconecte o cabo de energia da tomada e todos os cabos da impressora antes de prosseguir. Realize esta tarefa em intervalos de alguns meses. Os danos causados à impressora por manuseio incorreto não são cobertos pela garantia. Desligue a impressora e desconecte o cabo de energia da tomada elétrica. Remova o papel da bandeja padrão e do alimentador multifunção. Remova toda poeira, fiapos e pedaços de papel ao redor da impressora usando uma escova macia ou aspirador de pó. Limpe a parte externa da impressora com um pano úmido, macio e sem fiapos. não use detergentes ou produtos de limpeza domésticos, pois eles podem danificar o acabamento da impressora. Certifique-se de que todas as áreas da impressora estão secas após a limpeza. Conecte o cabo de energia à tomada elétrica e ligue a impressora. Para evitar o risco de incêndio ou choque elétrico, conecte o cabo de energia em uma tomada elétrica adequadamente aterrada que esteja perto do produto e possa ser facilmente acessada. limpeza da impressora limpeza interior da impressora limpeza parte externa da impressora"},{"UUID":"1f059c65-a8bf-4208-9a3f-7f3e468ca827","title":"Como limpar peças da impressora","link":"cleaning-printer-topic.html","desc":"Como limpar a tela sensível","descFull":"Como limpar a tela sensível ao toque Para evitar o risco de choque elétrico ao limpar a parte externa da impressora, desconecte o cabo de energia da tomada e todos os cabos da impressora antes de prosseguir. Desligue a impressora e desconecte o cabo de energia da tomada elétrica. Usando um pano úmido, macio e sem fiapos, limpe a tela sensível ao toque. Não use produtos de limpeza domésticos ou detergentes, pois eles podem danificar a tela sensível ao toque. Certifique-se de que a tela sensível ao toque esteja seca após a limpeza. Conecte o cabo de energia à tomada elétrica e ligue a impressora. Para evitar riscos de incêndio ou choque elétrico, conecte o cabo de energia a uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja próxima ao produto. tela sensível ao toque limpeza como limpar a tela sensível ao toque"},{"UUID":"244a9430-f9ac-4642-8b5e-047990410abd","title":"Como limpar peças da impressora","link":"cleaning-printer-topic.html","desc":"Limpeza do scanner Abra a","descFull":"Limpeza do scanner Abra a tampa do scanner. Usando um pano úmido, macio e sem fiapos, limpe as áreas a seguir: Almofada do vidro do ADF Almofada do vidro do scanner Vidro do ADF Vidro do scanner Feche a tampa do scanner. scanner limpeza qualidade de impressão como limpar o scanner como limpar o scanner"},{"UUID":"ad491374-b020-4f79-827a-4689a7e8f7f8","title":"Como limpar peças da impressora","link":"cleaning-printer-topic.html","desc":"Limpeza das lentes do cabeçote","descFull":"Limpeza das lentes do cabeçote de impressão Limpeza das lentes do cabeçote de impressão Abra a porta frontal. Remova o limpador do cabeçote de impressão e limpe a lente do cabeçote de impressão. Coloque o cabeçote de impressão de volta no lugar. Feche a porta frontal. lente do cabeçote de impressão limpeza limpeza da lente da cabeça de impressão"},{"UUID":"6953b07d-5cb1-42c5-aac2-263ab734a451","title":"Como limpar peças da impressora","link":"cleaning-printer-topic.html","desc":"Limpeza do kit de rolos","descFull":"Limpeza do kit de rolos da bandeja Desligue a impressora. Remova a bandeja padrão. Remova o kit de rolos da bandeja. Para evitar danos de descarga eletrostática, toque nas partes metálicas expostas da impressora antes de acessar ou tocar nas áreas interiores da impressora. Aplique água em um pano macio e sem fiapos e limpe os rolos de alimentação. Insira o kit de rolos até ele  encaixar  no lugar. Insira a bandeja. Ligue a impressora. kit de rolos da Lexmark limpeza limpeza do kit de rolos da bandeja"},{"UUID":"0d070b2c-d240-43fd-ade1-a5d8c96a5006","title":"Como limpar peças da impressora","link":"cleaning-printer-topic.html","desc":"Limpeza dos rolos do ADF","descFull":"Limpeza dos rolos do ADF Desligue a impressora. Abra a tampa superior do ADF. Remova a tampa do rolo de separação. Remova o rolo de separação. Aplique água em um pano macio e sem fiapos e limpe o conjunto do rolo de coleta. Insira novo rolo de separação. Insira a tampa do rolo de separação do ADF até ela  encaixar  no lugar. Remova o conjunto do rolo de separação. Aplique água em um pano macio e sem fiapos e limpe o conjunto do rolo de coleta. Insira o conjunto do rolo de separação do ADF até ela  encaixar  no lugar. Feche a tampa superior do ADF. Ligue a impressora. Kit de rolos do ADF limpeza limpeza dos rolos do ADF"},{"UUID":"379d3b1a-b61c-4e5b-a55a-79f4c3096587","title":"Como limpar peças da impressora","link":"cleaning-printer-topic.html","desc":"Limpeza do kit de rolos","descFull":"Limpeza do kit de rolos da bandeja para 2.000 folhas Desligue a impressora. Deslize a bandeja para a esquerda. Abra a porta J e, em seguida, abra a tampa do kit de rolos. Localize e remova o kit de rolos da bandeja. Aplique água em um pano macio e sem fiapos e limpe o conjunto do rolo de coleta. Insira o kit de rolos. Feche a tampa do kit de rolos e, em seguida, feche a porta J. Deslize a bandeja de volta para o lugar. Ligue a impressora. Rolos de alimentação da bandeja para 2000 folhas limpeza limpeza dos rolos de alimentação da bandeja para 2000 folhas"},{"UUID":"5703c94f-8103-4d8d-974b-99e91632461c","title":"Como limpar peças da impressora","link":"cleaning-printer-topic.html","desc":"Esvaziando a caixa de perfuração","descFull":"Esvaziando a caixa de perfuração Levante a tampa do transportador de papel F. Retire e, em seguida, esvazie a caixa de perfuração. Insira a caixa de perfuração. Feche a tampa. caixa de perfuração esvaziando esvaziando a caixa de perfuração"},{"UUID":"18e41d45-e352-4eb1-b26e-4c5008620a62","title":"Como economizar energia e papel","link":"configuring-power-save-mode-settings-topic.html","desc":"Definição das configurações do modo","descFull":"Definição das configurações do modo de economia de energia Modo de suspensão Na tela inicial, toque em  Configurações Dispositivo Gerenciamento de energia Limites de tempo Modo de suspensão . Especifique o período durante o qual a impressora permanece no modo ocioso antes de entrar no  Modo de suspensão . Modo de hibernação Na tela inicial, toque em  Configurações Dispositivo Gerenciamento de energia Limites de tempo Limite de tempo para hibernação . Selecione o período durante o qual a impressora permanece no modo ocioso antes de entrar no modo de hibernação. Para o  Tempo limite de hibernação  funcionar, defina o  Tempo limite de hibernação na conexão  como  Hibernar . O Embedded Web Server é desativado quando a impressora está no modo  Hibernação . Modo de suspensão configuração Modo de hibernação configuração configurações ambientais modos de economia de energia configuração"},{"UUID":"cee00f31-7e8a-4f0c-a5b8-4664357b41c3","title":"Como economizar energia e papel","link":"configuring-power-save-mode-settings-topic.html","desc":"Ajuste do brilho do visor","descFull":"Ajuste do brilho do visor Na tela inicial, toque em  Configurações Dispositivo Preferências . No menu  Brilho da tela , ajuste a configuração. brilho do monitor ajuste como ajustar o brilho da tela"},{"UUID":"3f606769-7e4e-4e83-b14d-9710cb19ae46","title":"Como economizar energia e papel","link":"configuring-power-save-mode-settings-topic.html","desc":"Economia de suprimentos Imprima em","descFull":"Economia de suprimentos Imprima em frente e verso. A impressão frente e verso é a configuração padrão no driver de impressão. Imprimir várias páginas em um lado de uma folha de papel. Use o recurso de pré-visualização para ver a aparência do documento antes de imprimi-lo. Imprima uma cópia do documento para verificar seu conteúdo e formato para maior precisão. economia de suprimentos suprimentos economia"},{"UUID":"aa509da6-b6ce-44ef-a611-5c687f7f890c","title":"Manutenção da impressora","link":"moving-printer-topic.html","desc":"Para mover a impressora para","descFull":"Para mover a impressora para outro local Para mover a impressora para outro local Se o peso da impressora for superior a 20 kg (44 lb), então podem ser necessárias duas ou mais pessoas para movê-la com segurança. Para evitar o risco de incêndio ou choque elétrico, utilize somente o cabo de energia fornecido com este produto ou um cabo de energia de substituição fornecido por um fabricante autorizado. Ao mover a impressora, siga estas diretrizes para evitar danos a você ou à impressora: Certifique-se de que todas as portas e bandejas estejam fechadas. Desligue a impressora e desconecte o cabo de energia da tomada elétrica. Desconecte todos os fios e cabos da impressora. Se a impressora tiver bandejas opcionais de chão separadas ou opções de saída conectadas a ela, desconecte-as antes de mover a impressora. Se a impressora tiver uma base com rodinhas, empurre-a com cuidado até o novo local. Cuidado ao passar por soleiras e falhas no piso. Se a impressora não tiver uma base com rodinhas, mas estiver configurada com bandejas opcionais ou opções de saída, remova as opções de saída e retire a impressora das bandejas. Não tente levantar a impressora e as opções ao mesmo tempo. Sempre use as alças da impressora para levantá-la. Qualquer carrinho usado para mover a impressora deve possuir uma superfície capaz de suportar a base completa da impressora. Qualquer carrinho usado para mover as opções de hardware deve ter uma superfície capaz de suportar as dimensões das opções. Mantenha a impressora na posição vertical. Evite movimentos bruscos. Tome cuidado para que seus dedos não fiquem embaixo da impressora ao abaixá-la. Verifique se há espaço suficiente ao redor da impressora. Os danos causados à impressora por movimentação incorreta não são cobertos pela garantia. transportando a impressora"},{"UUID":"8b5b3110-6b46-42ee-ae9a-8bd37ae62b33","title":"Manutenção da impressora","link":"shipping-printer-topic.html","desc":"Transporte da impressora Para obter","descFull":"Transporte da impressora Para obter instruções de transporte, visite o site  http://support.lexmark.com  ou entre em contato com o suporte ao cliente. Ao transportar a impressora, use a embalagem original ou entre em contato com o local no qual você adquiriu a impressora. impressora transporte transportando a impressora"},{"UUID":"f90374c1-2db3-44f5-91d1-23de7637553d","title":"Solução de problemas","link":"print-quality-problems-picker-topic.html","desc":"Problemas de qualidade de impressão","descFull":"Problemas de qualidade de impressão Localize a imagem que se assemelhe ao problema na qualidade de impressão e, em seguida, clique no link abaixo para ler as etapas de solução de problemas. problemas de qualidade de impressão solução de problemas problemas de qualidade de impressão solução de problemas de impressão problemas de qualidade de impressão"},{"UUID":"ee047805-2dfb-47cf-b8c8-971229584331","title":"Solução de problemas","link":"printer-error-codes-topic.html","desc":"Códigos de erro da impressora","descFull":"Códigos de erro da impressora Códigos de erro da impressora Códigos de erro e como resolvê-los Códigos de erro Mensagem de erro Solução 2.01 Suprimento necessário. Toque em  Cancelar trabalho  e encomende o suprimento necessário. Para mais informações, consulte  . 3.01 A bandeja de saída padrão está cheia. Remova o papel da bandeja e toque em  Continuar . 3.21, 3.22, 3.23, 3.24 Remova o papel atrás da bandeja [x]. Remova a bandeja indicada. Remova qualquer papel atolado na área.  Insira a bandeja. 7.13, 7.23, 7.33, 7.43, 7.53 Insira a bandeja [x]. Execute um dos seguintes procedimentos: Insira a bandeja indicada. Cancele o trabalho de impressão atual. 8,01 Feche a porta frontal. Mantenha a porta frontal fechada, a menos que esteja fazendo uma manutenção. 8.02, 8.03, 8.04, 8.05 Feche a porta [x]. Mantenha a porta indicada fechada, a menos que esteja fazendo uma manutenção. 8.06 Conecte a bandeja 5. Deslize a bandeja para a esquerda e, em seguida, coloque-a de volta no lugar. 8.07 Feche a tampa F do transportador de papel. Mantenha a tampa do transportador de papel F fechada, a menos que esteja fazendo uma manutenção. 8.08 Feche a porta frontal do grampeador. Mantenha a porta frontal do grampeador fechada, a menos que esteja fazendo uma manutenção. 8.09 Feche a tampa superior do grampeador e perfurador. Mantenha a tampa superior do grampeador fechada, a menos que esteja fazendo uma manutenção. 9.00 Foi necessário reiniciar a impressora. O último trabalho pode estar incompleto. Toque em  Continuar  para limpar a mensagem e continuar a impressão. 11.11, 11.21, 11.31, 11.41, 11.51 Carregue [fonte] com [tipo] [tamanho]. Carregue a bandeja indicada com papel. Para mais informações, consulte  . 11.12, 11.22, 11.32, 11.42, 11.52 Carregar [fonte] com [tipo] [tamanho] [orientação]. 11.81, 11.91 Carregar o alimentador multiúso com [tipo] [tamanho]. Carregue papel no alimentador multiuso. Para mais informações, consulte  . 11.82, 11.92 Carregar o alimentador multiúso com [tipo] [tamanho] [orientação]. 12.11, 12.21, 12.31, 12.41, 12.51 Alterar [fonte] para [tipo] [tamanho]. Retire a bandeja indicada, remova o papel e carregue o tipo e o tamanho corretos de papel. Para mais informações, consulte  . 12.12, 12.22, 12.32, 12.42, 12.52 Alterar [fonte] para [tipo] [tamanho] [orientação]. 12.91 Alterar alimentador multiúso para [tipo] [tamanho]. Remova o papel e, em seguida, carregue o tipo e o tamanho de papel corretos. Para mais informações, consulte  . 12.92 Alterar o alimentador multiúso para [tipo] [tamanho] [orientação]. 31.00 Insira a caixa de perfuração. Abra a tampa F do transportador de papel. Remova a caixa de perfuração. Insira a caixa de perfuração. 31.40 Reinstalar cartucho preto em falta ou não correspondente. Abra a porta frontal. Remova o cartucho. Insira o cartucho. Feche a porta frontal. 31.60 Reinstalar a unidade de imagem preta em falta ou não correspondente. Abra a porta A. Abra a porta frontal. Destrave e remova a unidade de imagem. Insira a unidade de imagem e fixe-a no lugar. Feche a porta frontal e a porta A. 32.40 Substituir cartucho preto não suportado. Consulte  . 34.00 Papel muito curto. Ajuste o tamanho e a configuração do papel para que correspondam ao papel carregado na bandeja. Na tela inicial, toque em  Configurações Papel Bandeja Configuração Tamanho/Tipo de papel . 34.10, 34.20, 34.30, 34.40, 34.50 Verifique [origem], ajuste as guias e a orientação. Retire a bandeja indicada e verifique se o papel está colocado corretamente. Para mais informações, consulte  . 34.90 Verifique o alimentador multiuso, ajuste as guias e a orientação. Verifique se o papel foi carregado corretamente. Para mais informações, consulte  . 37.10 Memória insuficiente para agrupamento. Execute um dos seguintes procedimentos: Para imprimir a parte do trabalho já armazenada e iniciar o agrupamento do restante do trabalho, toque em  Continuar . Cancele o trabalho de impressão atual. 37.30 Memória insuficiente, alguns trabalhos retidos foram excluídos. Toque em  Continuar  para limpar a mensagem e continuar a impressão. 38.10 Memória cheia. Experimente uma ou mais das seguintes opções: Toque em  Continuar  para limpar a mensagem e continuar a impressão. Cancele o trabalho de impressão atual. Instale mais memória na impressora. Reduza o número de páginas no trabalho de impressão. 39.10 Página complexa, alguns dados podem não ter sido impressos. Experimente uma ou mais das seguintes opções: Toque em  Continuar  para limpar a mensagem e continuar a impressão. Cancele o trabalho de impressão atual. Instale mais memória na impressora. Reduza a complexidade e o tamanho do trabalho de impressão antes de enviá-lo para impressão novamente. Reduza o número de páginas no trabalho de impressão. Reduza o número e o tamanho de qualquer fonte baixada. Exclua todas as fontes ou macros desnecessárias do trabalho de impressão. Reduza o número de gráficos no trabalho de impressão. 51 Flash danificado detectado. Experimente uma ou mais das seguintes opções: Substitua o cartão flash. Toque em  Continuar  para limpar a mensagem e continuar a impressão. Cancele o trabalho de impressão atual. 52 Sem espaço livre suficiente na memória flash para recursos. Experimente uma ou mais das seguintes opções: Toque em  Continuar  para limpar a mensagem e continuar a impressão. Exclua fontes, macros e outros dados armazenados na memória flash. Instale um disco rígido. Para mais informações, consulte  . As fontes e macros carregadas e não armazenadas previamente na memória flash serão excluídas. 55.1 Erro ao ler a unidade USB. Remova a unidade USB Remova a unidade flash para continuar. 55.2 Erro de leitura do hub USB. Remova o hub. Remova o hub USB para continuar. 55.3 Desconecte e altere o modo. 61 Remova o disco defeituoso. Substitua a unidade de armazenamento defeituosa. 62 Disco cheio. Experimente uma ou mais das seguintes opções: Toque em  Continuar  para limpar a mensagem e continuar a impressão. Exclua fontes, macros e outros dados armazenados no disco rígido. Instale um disco rígido. Para mais informações, consulte  . 63 Formate o disco. A formatação agora apaga todas as informações da unidade de armazenamento. Para formatar a unidade de armazenamento, faça o seguinte: Toque em  Configurações Dispositivo Manutenção Apagamento fora de serviço . Toque em  Apagar todas as informações no disco rígido  e toque em  APAGAR . 71.01 Nome da estação de fax não configurado. Entre em contato com o administrador do sistema. Consulte  . 71.02 Número da estação de fax não configurado. Entre em contato com o administrador do sistema. 71.03 Nenhuma linha de telefone analógica está conectada ao modem, o fax está desativado. Verifique a conexão e a linha para saber se há um sinal. Para mais informações, consulte  . 71.06 Não foi possível estabelecer conexão com o servidor de fax HTTPS. A conexão com o servidor de fax HTTPS está desativada. Verifique a conexão com a Internet da impressora. 71.07 A impressora não está registrada no servidor de fax HTTPS. Verifique se a impressora foi adicionada à lista de dispositivos no portal do servidor de fax HTTPS. Entre em contato com o administrador do sistema. 71.11 Partição de fax. A partição de fax não está funcionando. Entre em contato com o administrador do sistema. 71.12 Memória cheia, não é possível imprimir faxes. Escolha  Imprimir tudo  para imprimir todos os faxes salvos. 71.13 Memória cheia. Não é possível enviar faxes. Execute um dos seguintes procedimentos: Continue e tente enviar o fax novamente. Digitalize o documento original uma página por vez, disque o número do fax e depois envio o documento por fax. 71.40 O horário da impressora está incorreto. Configure o horário da impressora. Na tela inicial, toque em  Configurações Dispositivo Preferências Data e hora Configurar . 72.01 Servidor SMTP de e-mail não configurado. Entre em contato com o administrador do sistema.  Execute um dos seguintes procedimentos: Configure a função de e-mail. Para mais informações, consulte  . Desative a mensagem de erro. Para mais informações, consulte  . 72.02 Servidor de links da Web não configurado. Entre em contato com o administrador do sistema. Entre em contato com o administrador de sistema. 72.04 A definição “Para formatar” do servidor de fax não está configurada. Entre em contato com o administrador do sistema. Execute um dos seguintes procedimentos: Toque em  Configurações Fax Configuração do servidor de fax Configurações de fax gerais .  Configure a definição  Para formatar . Entre em contato com o administrador de sistema. 81.31 Substitua o kit de rolos, pois a vida útil recomendada já expirou. Consulte  . 83.20 Poucos grampos ou não há grampos. Execute um dos seguintes procedimentos: Remova e, em seguida, insira o cartucho de grampos. Substitua o cartucho de grampos. Para mais informações, consulte  . 83.30 Grampos mal colocados ou não há grampos. Execute um dos seguintes procedimentos: Remova e, em seguida, insira o cartucho de grampos. Substitua o cartucho de grampos. Para mais informações, consulte  . 84.01 Unidade de imagem quase baixa.  Toque em  Continuar  para limpar a mensagem. 84.11 Unid. de imagem baixa.  84.21 Unidade de imagem muito baixa.  84.31 Substituir unidade de imagem, a vida útil recomendada expirou. Consulte  . 86.23 A manutenção do digitalizador será necessária em breve. Toque em  Continuar  para limpar a mensagem. 86.33 Substitua o kit ADF, pois a vida útil recomendada expirou. Consulte  . 87.20 Caixa de perfuração quase cheia. Toque em  Continuar  para limpar a mensagem. 87.30 Esvazie a caixa de perfuração. Abra a tampa F do transportador de papel.  Remova a caixa de perfuração e esvazie-a. Insira a caixa de perfuração. Feche a tampa. 200.03, 240.06 Atolamentos de papel [cabeçalho do atolamento]. Consulte  . 200.16[x], 241.16a Atolamentos de papel [cabeçalho do atolamento]. Consulte  . 200.26[x], 200.36[x], 200.46[x], 200.56a, 202.95[x], 242.26, 242.33, 242.43, 243.33, 243.36, 243,43, 244,43, 244,46 Atolamentos de papel [cabeçalho do atolamento]. Consulte  . 200.56a, 245.53[x], 245,56 Atolamentos de papel [cabeçalho do atolamento]. Consulte  . 200.95, 201.96, 202.93, 202.94, 221.93, 221.95, 232.93, 240.25, 240.35, 240.55 Atolamentos de papel [cabeçalho do atolamento]. Consulte  . 280.06 Recarregue os originais no ADF e reinicie o trabalho. Experimente uma ou mais das seguintes opções: Remova e depois recarregue o documento no ADF. Digitalize o documento no vidro do scanner. Conclua o trabalho sem digitalizar as páginas restantes. Cancele o trabalho. 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 281.11, 281.15, 281.16, 281.91, 281.95,\t281.96, 282.11, 282.13, 282.15, 282.91, 282.93, 282.95, 283.11, 283.13,\t283.15, 283.91, 283.93, 283.95, 284.11, 284.13, 284.15, 284.91, 284.93,\t284.95, 288.10,\t288.90, 295.01, 680.10 Atolamento no scanner. Consulte  . 280.13Q, 280.15Q, 295.01Q, 680.20Q Substitua os originais atolados. Experimente uma ou mais das seguintes opções: Remova e depois carregue o documento no ADF. Digitalize o documento no vidro do scanner. Conclua o trabalho sem digitalizar as páginas restantes. Cancele o trabalho. 280.13K, 280.15K, 680.20K, 680.40K, 295.01K,  Recarregue os originais e reinicie. Execute um dos seguintes procedimentos: Remova e depois recarregue o documento no ADF ou no vidro do scanner. Cancele o trabalho. 420.11a, 420.13a, 420.15a, 420.15b, 420.54a, 420.54b, 425.13a Atolamentos de papel [cabeçalho do atolamento]. Consulte  . 400,13, 400.13b, 420.13b, 420.15b, 420.54c, 450.23b, 450.91b, 451.33b, 454.23b, 454.25b, 457.25b Atolamentos de papel [cabeçalho do atolamento]. Consulte  . 457.35b Atolamentos de papel [cabeçalho do atolamento]. Se você instalou o grampeador, consulte  . Se você instalou o finalizador de grampeamento e perfuração, consulte  . códigos de erro mensagens de erro"},{"UUID":"bc92e40e-1080-4b8a-8f4a-a4c47be32584","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Páginas em branco ou brancas","descFull":"Páginas em branco ou brancas Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solução de problemas  Páginas de teste de qualidade de impressão . Etapas para solução de problemas Ação Sim Não Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho não for compatível, instale um cartucho compatível. Imprima o documento. A impressora imprime páginas em branco ou brancas? O problema foi solucionado. Remova a unidade de imagem. Não exponha a unidade de imagem à luz direta. A longa exposição à luz pode causar problemas na qualidade de impressão. Não toque no cilindro fotocondutor. Fazer isso pode afetar a qualidade dos trabalhos de impressão futuros. Insira a unidade de imagem. Imprima o documento. A impressora imprime páginas em branco ou brancas? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, qualidade de impressão páginas em branco solução de problemas, qualidade de impressão páginas brancas solução de problemas de qualidade de impressão páginas brancas solução de problemas de qualidade de impressão páginas em preto páginas em branco páginas brancas"},{"UUID":"693af233-d393-4cc4-b306-c9d6da00337a","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Impressão escura Antes de solucionar","descFull":"Impressão escura Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solução de problemas  Páginas de teste de qualidade de impressão . Etapas para solução de problemas Ação Sim Não Dependendo de seu sistema operacional, reduza a tonalidade do toner em Preferências de impressão ou na caixa de diálogo de Impressão. Você também pode alterar as configurações no painel de controle da impressora. Na tela inicial, toque em  Configurações Impressão Qualidade Intensidade do toner . Imprima o documento. A impressão está muito escura? O problema foi solucionado. Dependendo de seu sistema operacional, especifique o tipo de papel em Preferências de impressão ou na caixa de diálogo de Impressão. Verifique se as definições correspondem ao papel carregado na bandeja. Você também pode alterar as configurações no painel de controle da impressora. Na tela inicial, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Imprima o documento. A impressão está muito escura? Vá para a etapa 6. Verifique se a textura ou o acabamento do papel são ásperos. Você está imprimindo em papel áspero ou texturizado? Vá para a etapa 6. Substitua o papel texturizado ou áspero por papel comum. Imprima o documento. A impressão está muito escura? O problema foi solucionado. Carregue papel de um pacote novo. O papel absorve umidade se essa estiver alta. Armazene o papel em sua embalagem original até utilizá-lo. Imprima o documento. A impressão está muito escura? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, qualidade de impressão impressão escura solução de problemas de qualidade de impressão impressão escura impressão escura"},{"UUID":"71072501-e5c7-4b06-89cc-33ac2279c80f","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"As linhas finas não são","descFull":"As linhas finas não são impressas corretamente Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho não for compatível, instale um cartucho compatível. Imprima o documento. As linhas finas estão sendo impressas corretamente? O problema foi solucionado. Aumente a intensidade do toner. Na tela inicial, toque em  Configurações Impressão Qualidade Intensidade do toner . Imprima o documento. As linhas finas estão sendo impressas corretamente? O problema foi solucionado. Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . solução de problemas, qualidade de impressão linhas finas não são impressas corretamente solução de problemas de qualidade de impressão linhas finas não são impressas corretamente linhas finas não são impressas corretamente"},{"UUID":"63cf2ff7-3649-4560-9e27-b6d7f621c33f","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Papel dobrado ou enrugado Antes","descFull":"Papel dobrado ou enrugado Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho não for compatível, instale um cartucho compatível. Imprima o documento. O papel está dobrado ou enrugado? O problema foi solucionado. Carregue papel de um pacote novo. O papel absorve umidade se essa estiver alta. Armazene o papel em sua embalagem original até utilizá-lo. Imprima o documento. O papel está dobrado ou enrugado? O problema foi solucionado. Dependendo de seu sistema operacional, especifique o tipo de papel em Preferências de impressão ou na caixa de diálogo de Impressão. Verifique se as definições correspondem ao papel carregado. Você também pode alterar as configurações a partir do painel de controle da impressora. Na tela inicial, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Imprima o documento. O papel está dobrado ou enrugado? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, qualidade de impressão papel dobrado ou enrugado solução de problemas de qualidade de impressão papel dobrado ou enrugado papel dobrado papel enrugado"},{"UUID":"220e72c0-3c75-4dd2-972a-749696a1d943","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Plano de fundo cinza Antes","descFull":"Plano de fundo cinza Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Desligue a impressora, aguarde por cerca de 10 segundos e, em seguida, ligue-a novamente. Diminui a intensidade do toner. Na tela inicial, toque em  Configurações Impressão Qualidade Intensidade do toner . Imprima o documento. Aparece um fundo cinza nas impressões? O problema foi solucionado. Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho de toner não for compatível, instale um cartucho compatível. Imprima o documento. Aparece um fundo cinza nas impressões? O problema foi solucionado. Dependendo de seu sistema operacional, especifique o tipo de papel em Preferências de impressão ou na caixa de diálogo de Impressão. Verifique se as definições correspondem ao papel carregado. Você também pode alterar as configurações a partir do painel de controle da impressora. Na tela inicial, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Imprima o documento. Aparece um fundo cinza nas impressões? O problema foi solucionado. Remova e, em seguida, reinstale a unidade de imagem. Não exponha a unidade de imagem à luz direta. A longa exposição à luz pode causar problemas na qualidade de impressão. Não toque no cilindro fotocondutor. Fazer isso pode afetar a qualidade dos trabalhos de impressão futuros. Imprima o documento. Aparece um fundo cinza nas impressões? O problema foi solucionado. Atualize o firmware da impressora. Para obter mais informações, consulte  . Imprima o documento. Aparece um fundo cinza nas impressões? O problema foi solucionado. Substitua a unidade de imagem. Imprima o documento. Aparece um fundo cinza nas impressões? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. plano de fundo cinza em impressões solução de problemas, qualidade de impressão plano de fundo cinza em impressões solução de problemas de qualidade de impressão plano de fundo cinza em impressões"},{"UUID":"ff8da65f-af88-4097-9782-ec55224e2646","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Margens incorretas Etapas para solução","descFull":"Margens incorretas Etapas para solução de problemas Ação Sim Não Ajuste as guias de papel na bandeja para a posição correta de acordo com o papel carregado. Imprima o documento. As margens estão corretas? O problema foi solucionado. Dependendo de seu sistema operacional, especifique o tamanho do papel em Preferências de impressão ou na caixa de diálogo de Impressão. Verifique se as definições correspondem ao papel carregado. Você também pode alterar as configurações no painel de controle da impressora. Na tela inicial, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Imprima o documento. As margens estão corretas? O problema foi solucionado. Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . margens incorretas solução de problemas de impressão margens incorretas solução de problemas, impressão margens incorretas"},{"UUID":"f6ef1ab4-bcd7-47d0-b2c0-fcd7cc65accd","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Impressão clara Antes de solucionar","descFull":"Impressão clara Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho não for compatível, instale um cartucho compatível. Imprima o documento. A impressão está clara? O problema foi solucionado. Desligue a impressora, aguarde por cerca de 10 segundos e ligue-a novamente. Aumente a intensidade do toner. Na tela inicial, toque em  Configurações Impressão Qualidade Intensidade do toner . Imprima o documento. A impressão está clara? O problema foi solucionado. Dependendo de seu sistema operacional, especifique o tipo de papel em Preferências de impressão ou na caixa de diálogo de Impressão. Verifique se as definições correspondem ao papel carregado. Você também pode alterar as configurações no painel de controle da impressora. Na tela inicial, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Imprima o documento. A impressão está clara? O problema foi solucionado. Dependendo de seu sistema operacional, especifique a resolução de impressão em Preferências de impressão ou na caixa de diálogo Imprimir. Defina a resolução como  600 dpi . Imprima o documento. A impressão está clara? O problema foi solucionado. Remova a unidade de imagem. Não exponha a unidade de imagem à luz direta. A exposição prolongada à luz pode causar problemas na qualidade da impressão. Não toque no cilindro fotocondutor. Fazer isso pode afetar a qualidade dos trabalhos de impressão futuros. Agite firmemente a unidade de imagem para redistribuir o toner. Insira a unidade de imagem. Desligue a impressora, aguarde por cerca de 10 segundos e, em seguida, ligue-a novamente. Imprima o documento. A impressão está clara? O problema foi solucionado. Verifique o status do cartucho de toner. Na tela inicial, toque em  Configurações Relatórios Dispositivo Estatísticas do dispositivo . Na seção de Informações sobre suprimentos das páginas impressas, verifique o status do cartucho de toner. O cartucho de toner está quase no fim da vida útil? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . Troque o cartucho de toner. Imprima o documento. A impressão está clara? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. impressão clara solução de problemas, qualidade de impressão impressão clara solução de problemas de qualidade de impressão impressão clara"},{"UUID":"82bcd51f-a868-41aa-962e-ef5edc410c95","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Impressão manchada e com pontos","descFull":"Impressão manchada e com pontos Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho não for compatível, instale um cartucho compatível. Imprima o documento. A impressão está manchada? O problema foi solucionado. Verifique se o toner com vazamento na impressora está contaminado. O toner da impressora está com vazamento? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . Verifique o status da unidade de imagem. Na tela inicial, toque em  Configurações Relatórios Dispositivo Estatísticas do dispositivo . Na seção de Informações sobre suprimentos das páginas impressas, verifique o status da unidade de imagem. Unidade de imagem está quase no fim de sua vida útil? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . Substitua a unidade de imagem. Imprima o documento. A impressão está manchada? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, qualidade de impressão impressão manchada e com pontos solução de problemas de qualidade de impressão impressão manchada e com pontos impressão manchada impressão com pontos"},{"UUID":"a8fb3900-dc36-4a26-b857-8203802ea2c1","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Papel ondulado Etapas para solução","descFull":"Papel ondulado Etapas para solução de problemas Ação Sim Não Ajuste as guias da bandeja para as posições corretas de acordo com o tamanho de papel carregado. Imprima o documento. O papel ainda está curvado? O problema foi solucionado. Dependendo de seu sistema operacional, especifique o tipo de papel em Preferências de impressão ou na caixa de diálogo de Impressão. Verifique se as definições correspondem ao papel carregado. Você também pode alterar as configurações no painel de controle da impressora. Na tela inicial, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Imprima o documento. O papel ainda está curvado? O problema foi solucionado. Imprima no outro lado do papel. Retire o papel, vire-o e, em seguida, insira-o novamente. Imprima o documento. O papel ainda está curvado? O problema foi solucionado. Carregue papel de um pacote novo. O papel absorve umidade se essa estiver alta. Armazene o papel em sua embalagem original até utilizá-lo. Imprima o documento. O papel ainda está curvado? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, qualidade de impressão papel curvado solução de problemas de qualidade de impressão papel curvado"},{"UUID":"f7f4f0ed-d0bd-4a7d-b014-8f39a6495052","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Impressão torta ou distorcida Antes","descFull":"Impressão torta ou distorcida Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Puxe a bandeja para fora. Remova o papel e, em seguida, carregue o papel de um pacote novo. O papel absorve umidade se essa estiver alta. Armazene o papel em sua embalagem original até utilizá-lo. Ajuste as guias de papel na bandeja para a posição correta de acordo com o papel carregado. Insira a bandeja. Imprima o documento. A impressão está torta ou distorcida? O problema foi solucionado. Certifique-se de que está imprimindo em um papel suportado. Imprima o documento. A impressão está torta ou distorcida? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, qualidade de impressão impressão enviesada solução de problemas de qualidade de impressão impressão enviesada solução de problemas, qualidade de impressão impressão torta solução de problemas de qualidade de impressão impressão torta impressão torta impressão enviesada"},{"UUID":"73fc94f8-3e86-4379-a9a5-a7d2a94e8d64","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Páginas em preto Antes de","descFull":"Páginas em preto Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho de toner não for compatível, instale um cartucho compatível. Imprima o documento. A impressora está imprimindo páginas em preto sólido? O problema foi solucionado. Remova e, em seguida, reinstale a unidade de imagem. Não exponha a unidade de imagem à luz direta. A longa exposição à luz pode causar problemas na qualidade de impressão. Não toque no cilindro fotocondutor. Fazer isso pode afetar a qualidade dos trabalhos de impressão futuros. Imprima o documento. A impressora está imprimindo páginas em preto sólido? O problema foi solucionado. Verifique a unidade de imagem e observe a ocorrência de danos. Certifique-se de que o contato do cilindro fotocondutor não esteja torto ou fora de lugar. A unidade de imagem apresenta danos? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . Substitua a unidade de imagem. Imprima o documento. A impressora está imprimindo páginas em preto sólido? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. páginas em preto solução de problemas, qualidade de impressão páginas em preto solução de problemas de qualidade de impressão páginas em preto"},{"UUID":"b7599763-5b57-442c-bc9b-0eca922a7e42","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Textos ou imagens cortadas Antes","descFull":"Textos ou imagens cortadas Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho de toner não for compatível, instale um cartucho compatível. Imprima o documento. O texto ou a imagem está cortada? O problema foi solucionado. Remova e, em seguida, reinstale a unidade de imagem. Não exponha a unidade de imagem à luz direta. A longa exposição à luz pode causar problemas na qualidade de impressão. Não toque no cilindro fotocondutor. Fazer isso pode afetar a qualidade dos trabalhos de impressão futuros. Imprima o documento. O texto ou a imagem está cortada? O problema foi solucionado. Dependendo de seu sistema operacional, especifique o tamanho do papel em Preferências de impressão ou na caixa de diálogo de Impressão. Verifique se as definições correspondem ao papel carregado na bandeja. Você também pode alterar as configurações no painel de controle da impressora. Na tela inicial, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Imprima o documento. O texto ou a imagem está cortada? O problema foi solucionado. Substitua a unidade de imagem. Imprima o documento. O texto ou a imagem está cortada? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, qualidade de impressão textos ou imagens cortados solução de problemas de qualidade de impressão textos ou imagens cortados texto cortado na impressão imagens cortadas na impressão"},{"UUID":"ddd053ae-cb4d-4c7a-84f7-55b6ce86ea15","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"O toner sai facilmente do","descFull":"O toner sai facilmente do papel Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho de toner não for compatível, instale um cartucho compatível. Imprima o documento. O toner sai facilmente do papel? O problema foi solucionado. Dependendo de seu sistema operacional, especifique o tipo de papel em Preferências de impressão ou na caixa de diálogo de Impressão. Verifique se as definições correspondem ao papel carregado. Você também pode alterar as configurações no painel de controle da impressora. Na tela inicial, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Imprima o documento. O toner sai facilmente do papel? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, qualidade de impressão toner sai facilmente do papel solução de problemas de qualidade de impressão toner sai facilmente do papel toner sai facilmente do papel"},{"UUID":"44b019aa-71d2-44aa-be93-e49d6991df28","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"faixas horizontais claras Antes de","descFull":"faixas horizontais claras Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho não for compatível, instale um cartucho compatível. Imprima o documento. Faixas brancas horizontais aparecem nas impressões? O problema foi solucionado. Remova o limpador do cabeçote de impressão e limpe a lente do cabeçote de impressão. Imprima o documento. Faixas brancas horizontais aparecem nas impressões? O problema foi solucionado. Remova e, em seguida, reinstale a unidade de imagem. Não exponha a unidade de imagem à luz direta. A longa exposição à luz pode causar problemas na qualidade de impressão. Não toque no cilindro fotocondutor. Fazer isso pode afetar a qualidade dos trabalhos de impressão futuros. Imprima o documento. Faixas brancas horizontais aparecem nas impressões? O problema foi solucionado. Substitua a unidade de imagem. Imprima o documento. Faixas brancas horizontais aparecem nas impressões? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, qualidade de impressão faixas horizontais claras solução de problemas de qualidade de impressão faixas horizontais claras faixas horizontais claras"},{"UUID":"0233ea2c-fd84-46b3-b5db-496e4548031d","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Faixas verticais claras Antes de","descFull":"Faixas verticais claras Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Remova o limpador do cabeçote de impressão e limpe a lente do cabeçote de impressão. Imprima o documento. Faixas brancas horizontais aparecem nas impressões? O problema foi solucionado. Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho não for compatível, instale um cartucho compatível. Imprima o documento. Faixas brancas verticais aparecem nas impressões? O problema foi solucionado. Verifique o status do cartucho de toner. Na tela inicial, toque em  Configurações Relatórios Dispositivo Estatísticas do dispositivo . Na seção de Informações sobre suprimentos das páginas impressas, verifique o status do cartucho de toner. Faixas brancas verticais aparecem nas impressões? O problema foi solucionado. Troque o cartucho de toner. Imprima o documento. Faixas brancas verticais aparecem nas impressões? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, qualidade de impressão faixas verticais claras solução de problemas de qualidade de impressão faixas verticais claras faixas verticais claras"},{"UUID":"510c3607-ff13-4905-9e58-9b92e277dcc8","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Linhas brancas verticais Antes de","descFull":"Linhas brancas verticais Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho não for compatível, instale um cartucho compatível. Imprima o documento. Linhas brancas verticais aparecem nas impressões? O problema foi solucionado. Dependendo de seu sistema operacional, especifique o tipo de papel em Preferências de impressão ou na caixa de diálogo de Impressão. Verifique se as definições correspondem ao papel carregado. Você também pode alterar as configurações no painel de controle da impressora. Na tela inicial, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Imprima o documento. Linhas brancas verticais aparecem nas impressões? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. linhas verticais brancas solução de problemas, qualidade de impressão linhas verticais brancas solução de problemas de qualidade de impressão linhas verticais brancas linhas brancas"},{"UUID":"28c24ac4-2cdd-4212-b279-be1993e79c79","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Faixas verticais escuras Antes de","descFull":"Faixas verticais escuras Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho de toner não for compatível, instale um cartucho compatível. Imprima o documento. Faixas escuras verticais aparecem nas impressões? O problema foi solucionado. Remova o limpador do cabeçote de impressão e limpe a lente do cabeçote de impressão. Imprima o documento. Faixas escuras verticais aparecem nas impressões? O problema foi solucionado. Remova e, em seguida, reinstale a unidade de imagem. Não exponha a unidade de imagem à luz direta. A longa exposição à luz pode causar problemas na qualidade de impressão. Não toque no cilindro fotocondutor. Fazer isso pode afetar a qualidade dos trabalhos de impressão futuros. Imprima o documento. Faixas escuras verticais aparecem nas impressões? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. faixas verticais escuras solução de problemas, qualidade de impressão faixas verticais escuras solução de problemas de qualidade de impressão faixas verticais escuras"},{"UUID":"dcd68fad-deb7-4c1e-bb95-1457b5afacfa","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Listras ou linhas escuras verticais","descFull":"Listras ou linhas escuras verticais Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho de toner não for compatível, instale um cartucho compatível. Imprima o documento. Listras ou linhas escuras verticais aparecem nas impressões? O problema foi solucionado. Remova o limpador do cabeçote de impressão e limpe a lente do cabeçote de impressão. Imprima o documento. Listras ou linhas escuras verticais aparecem nas impressões? O problema foi solucionado. Remova e, em seguida, reinstale a unidade de imagem. Não exponha a unidade de imagem à luz direta. A exposição prolongada à luz pode causar problemas na qualidade da impressão. Não toque no cilindro fotocondutor. Fazer isso pode afetar a qualidade dos trabalhos de impressão futuros. Imprima o documento. Listras ou linhas escuras verticais aparecem nas impressões? O problema foi solucionado. Substitua a unidade de imagem. Imprima o documento. Listras ou linhas escuras verticais aparecem nas impressões? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, qualidade de impressão listras ou linhas verticais escuras solução de problemas de qualidade de impressão listras ou linhas verticais escuras linhas verticais escuras nas impressões listras verticais nas impressões"},{"UUID":"3fcc0e50-7bc1-47d0-a0f2-92f1b8765022","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Listras escuras verticais com impressão","descFull":"Listras escuras verticais com impressão faltante Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Remova o limpador do cabeçote de impressão e limpe a lente do cabeçote de impressão. Imprima o documento. Aparecem listras escuras verticais com imagens faltantes nas impressões? O problema foi solucionado. Remova e, em seguida, reinstale a unidade de imagem. Não exponha a unidade de imagem à luz direta. A longa exposição à luz pode causar problemas na qualidade de impressão. Não toque no cilindro fotocondutor. Fazer isso pode afetar a qualidade dos trabalhos de impressão futuros. Imprima o documento. Aparecem listras escuras verticais com imagens faltantes nas impressões? O problema foi solucionado. Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho de toner não for compatível, instale um cartucho compatível. Imprima o documento. Aparecem listras escuras verticais com imagens faltantes nas impressões? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. listras verticais escuras impressão ausente solução de problemas, qualidade de impressão listras verticais escuras com impressão ausente solução de problemas de qualidade de impressão listras verticais escuras com impressão ausente"},{"UUID":"0851671b-446c-4c48-9402-0479ed0b1f58","title":"Baixa qualidade de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Defeitos repetitivos Antes de solucionar","descFull":"Defeitos repetitivos Antes de solucionar o problema, imprima as páginas de teste de qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Etapas para solução de problemas Ação Sim Não Usando as páginas de teste de qualidade de impressão, verifique se a distância entre os defeitos repetitivos é igual a qualquer uma das opções a seguir: Unidade de imagem 94,2 mm (3,7 pol.) 37,7 mm (1,48 pol) 31,8 mm (1,25 pol.) Segundo rolo de transferência 50,3 mm (1,98 pol.) Fusor 95,1 mm (3,74 pol.) 82,5 mm (3,25 pol.) A distância entre as repetições dos defeitos corresponde às medidas? Se os defeitos repetitivos corresponderem às medidas do rolo de transferência ou do fusor, entre em contato com o  suporte ao cliente . Se os defeitos repetitivos corresponderem às medidas do rolo de transferência ou do fusor, entre em contato com o  suporte técnico . Anote a distância e contate o  suporte ao cliente . Anote a distância e contate o  suporte técnico . Substitua o item de suprimento afetado. Imprima o documento. Os defeitos repetitivos aparecem? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas de qualidade de impressão defeitos repetitivos solução de problemas, qualidade de impressão defeitos repetitivos defeitos repetitivos na impressão"},{"UUID":"de4e847e-4241-4dbe-90df-a78a356198d3","title":"Problemas de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Os trabalhos de impressão não","descFull":"Os trabalhos de impressão não são impressos Etapas para solução de problemas Ação Sim Não A partir do documento que você está tentando imprimir, abra a caixa de diálogo Imprimir e verifique se você selecionou a impressora correta. Imprima o documento. O documento foi impresso? O problema foi solucionado. Certifique-se de que a impressora esteja ligada. Resolva as mensagens de erro que aparecem no visor. Imprima o documento. O documento foi impresso? O problema foi solucionado. Verifique se as portas estão funcionando e se os cabos estão bem conectados no computador e na impressora. Para obter mais informações, consulte a documentação de configuração fornecida com a impressora. Imprima o documento. O documento foi impresso? O problema foi solucionado. Desligue a impressora, aguarde por cerca de 10 segundos e ligue-a novamente. Imprima o documento. O documento foi impresso? O problema foi solucionado. Remova e reinstale o driver da impressora. Imprima o documento. O documento foi impresso? O problema foi solucionado. Contate  suporte ao cliente . solução de problemas, impressão os trabalhos de impressão não são impressos solução de problemas de impressão os trabalhos de impressão não são impressos os trabalhos de impressão não impressos"},{"UUID":"ddacd0ee-e673-4988-a438-917636d81b46","title":"Problemas de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Documentos confidenciais e outros documentos","descFull":"Documentos confidenciais e outros documentos suspensos não são impressos Etapas para solução de problemas Ação Sim Não No painel de controle, verifique se os documentos aparecem na lista  Trabalhos suspensos . Se os documentos não estiverem listados, imprima-os usando as opções de Imprimir e reter. Imprima os documentos. Os documentos foram impressos? O problema foi solucionado. O trabalho de impressão pode conter um erro de formatação ou dados inválidos. Exclua o trabalho de impressão e o envie novamente. Para arquivos PDF, gere um novo arquivo e depois imprima os documentos. Os documentos foram impressos? O problema foi solucionado. Se você estiver imprimindo a partir da Internet, a impressora pode estar lendo os vários títulos de trabalho como duplicatas. Para usuários do Windows Abra a caixa de diálogo Preferências de impressão. Na guia Imprimir e reter, clique em  Usar a opção Imprimir e Reter  e, em seguida, clique em  Manter documentos duplicados . Digite um PIN e salve as alterações. Envie o trabalho de impressão. Para usuários do Macintosh Salve e nomeie cada trabalho de forma diferente. Envie o trabalho individualmente. Os documentos foram impressos? O problema foi solucionado. Exclua alguns trabalhos suspensos para liberar memória da impressora. Imprima os documentos. Os documentos foram impressos? O problema foi solucionado. Adicione memória à impressora. Imprima os documentos. Os documentos foram impressos? O problema foi solucionado. Contato  suporte ao cliente . Contato  suporte técnico . solução de problemas, impressão trabalhos confidenciais e outros documentos suspensos não são impressos solução de problemas de impressão trabalhos confidenciais e outros documentos suspensos não são impressos documentos confidenciais não são impressos documentos suspensos não são impressos"},{"UUID":"42f98170-b031-449f-80c7-69595e3475e9","title":"Problemas de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Trabalhos de impressão na bandeja","descFull":"Trabalhos de impressão na bandeja errada ou no papel errado Etapas para solução de problemas Ação Sim Não Verifique se você está imprimindo em papel correto. Imprima o documento. O documento está impresso no papel correto? Carregue o tamanho e o tipo de papel corretos. Dependendo do seu sistema operacional, especifique o tipo e o tamanho do papel nas Preferências de impressão ou na caixa de diálogo de impressão. Você também pode alterar as configurações no painel de controle da impressora. Na tela bem-vindo, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Verifique se as configurações correspondem ao papel carregado. Imprima o documento. O documento está impresso no papel correto? O problema foi solucionado. Verifique se as bandejas estão vinculadas. Para mais informações, consulte  . Imprima o documento. O documento foi impresso na bandeja correta? O problema foi solucionado. Contato  suporte ao cliente . Contato  suporte técnico . solução de problemas de impressão trabalho impresso da bandeja errada solução de problemas de impressão trabalho impresso no papel errado solução de problemas, impressão trabalho impresso da bandeja errada solução de problemas, impressão trabalho impresso no papel errado trabalho impresso da bandeja errada trabalho impresso no papel errado"},{"UUID":"1d1d7ceb-397c-475f-8506-009d929f6079","title":"Problemas de impressão","link":"print-quality-is-poor-subgroup.html","desc":"Impressão lenta Etapas para solução","descFull":"Impressão lenta Etapas para solução de problemas Ação Sim Não Certifique-se de que o cabo da impressora está firmemente conectado nela e no computador, no servidor de impressão, no opcional ou em outro dispositivo de rede. A impressora está imprimindo lentamente? O problema foi solucionado. Certifique-se de que a impressora não esteja no  Modo silencioso . Na tela inicial, toque em  Configurações Dispositivo Manutenção Menu Config Operações do dispositivo Modo silencioso . Imprima o documento. A impressora está imprimindo lentamente? O problema foi solucionado. Dependendo de seu sistema operacional, especifique a resolução de impressão em Preferências de impressão ou na caixa de diálogo Imprimir. Configure a resolução para 4800 CQ. Imprima o documento. A impressora está imprimindo lentamente? O problema foi solucionado. Dependendo de seu sistema operacional, especifique o tipo de papel em Preferências de impressão ou na caixa de diálogo de Impressão. Verifique se as definições correspondem ao papel carregado. Você também pode alterar as configurações no painel de controle da impressora. Na tela inicial, toque em  Configurações Papel Configurações de bandeja Tamanho/Tipo de papel . Papéis pesados são impressos mais lentamente. Papéis mais finos que carta, A4 ou ofício podem imprimir mais lentamente. Imprima o documento. A impressora está imprimindo lentamente? O problema foi solucionado. Certifique-se de que as configurações de textura e gramatura da impressora correspondem ao papel que está sendo carregado. Na tela inicial, toque em  Configurações Papel Configurações de mídia Tipos de mídia . A textura áspera e a gramatura pesada do papel podem ser impressas mais lentamente. Imprima o documento. A impressora está imprimindo lentamente? O problema foi solucionado. Remova trabalhos suspensos. A impressora está imprimindo lentamente? O problema foi solucionado. Certifique-se de que a impressora não está superaquecida. Deixe-a esfriar após um trabalho de impressão muito longo. Observe a temperatura ambiente recomendada para a impressora. Para obter mais informações, consulte  . Imprima o documento. A impressora está imprimindo lentamente? Contate o  suporte ao cliente . Contate o  suporte técnico . O problema foi solucionado. solução de problemas de impressão impressão lenta solução de problemas, impressão impressão lenta impressão lenta"},{"UUID":"f78cae30-50dd-4eb2-933f-1a26ef86a8e8","title":"Solução de problemas","link":"trb-printer-not-responding-topic.html","desc":"A impressora não está respondendo","descFull":"A impressora não está respondendo Etapas para solução de problemas Ação Sim Não Verifique se o cabo de energia está conectado à tomada elétrica. Para evitar risco de incêndio ou choque elétrico, conecte o cabo de energia em uma tomada elétrica adequadamente aterrada que esteja perto do produto e possa ser facilmente acessada. A impressora está respondendo? O problema foi solucionado. Verifique se a tomada elétrica está desligada por uma chave ou um disjuntor. A tomada elétrica está desligada por uma chave ou um disjuntor? Ligue a chave ou reinicie o disjuntor. Certifique-se de que a impressora esteja ligada. A impressora está ligada? Ligue a impressora. Verifique se a impressora está no modo de suspensão ou no de hibernação. A impressora está no modo de suspensão ou no de hibernação? Pressione o botão liga/desliga para ativar a impressora. Verifique se os cabos que conectam a impressora e o computador estão inseridos nas portas corretas. Os cabos estão inseridos nas portas corretas? Insira os cabos nas portas corretas. Desligue a impressora, reinstale as opções de hardware e ligue a impressora. Para obter mais informações, consulte a documentação fornecida com a impressora. A impressora está respondendo? O problema foi solucionado. Instale o driver de impressão correto. A impressora está respondendo? O problema foi solucionado. Desligue a impressora, aguarde por cerca de 10 segundos e ligue-a novamente. A impressora está respondendo? O problema foi solucionado. Contate  suporte ao cliente . Contate  suporte técnico . solução de problemas impressora não está respondendo impressora não está respondendo"},{"UUID":"0c8fba51-a747-4497-8b68-da0a83ad4206","title":"Solução de problemas","link":"trb-unable-to-read-flash-drive-topic.html","desc":"Não foi possível ler unidade","descFull":"Não foi possível ler unidade flash Etapas para solução de problemas Ação Sim Não Verifique se a impressora não está ocupada processando outro trabalho de impressão, cópia, digitalização ou fax. A impressora está pronta? Vá para a etapa 3. Aguarde até que a impressora termine de processar o outro trabalho. Remova e insira a unidade flash. A impressora reconhece a unidade flash? O problema foi solucionado. Verifique se a unidade flash foi inserida na porta USB frontal. A unidade flash não funciona se estiver inserida na porta USB posterior. A unidade flash foi inserida na porta correta? Vá para a etapa 5. Insira a unidade flash na porta correta. A impressora reconhece a unidade flash? O problema foi solucionado. Verifique se a unidade flash é suportada. Para obter mais informações, consulte  . A unidade flash é suportada? Vá para a etapa 7. Insira uma unidade flash suportada. A impressora reconhece a unidade flash? O problema foi solucionado. Remova e insira a unidade flash. A impressora reconhece a unidade flash? O problema foi solucionado. Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . não foi possível ler unidade flash solução de problemas, impressão solução de problemas de impressão não foi possível ler unidade flash"},{"UUID":"13fea837-24a6-4287-ab72-b23b1d0cbc1c","title":"Solução de problemas","link":"enabling-usb-port-topic.html","desc":"Ativando a porta USB Na","descFull":"Ativando a porta USB Na tela inicial, toque em  Configurações Rede/Portas USB Ativar porta USB . Porta USB ativando ativando a porta USB"},{"UUID":"63ab50d8-6d05-40c1-a832-1e3c4efbc031","title":"Limpeza de atolamentos","link":"avoiding-jams-topic.html","desc":"Para evitar atolamentos Coloque o","descFull":"Para evitar atolamentos Coloque o papel corretamente Verifique se o papel está plano na bandeja. Colocação correta e incorreta do papel Carregamento correto do papel Carregamento incorreto do papel Não coloque nem remova uma bandeja durante a impressão. Não carregue papel em excesso. Certifique-se de que a altura da pilha de papel esteja abaixo dos indicadores de carregamento máximo de papel. Não deslize o papel na bandeja. Carregue o papel de acordo com a ilustração. Certifique-se de que as guias de papel estejam posicionadas corretamente e não estejam pressionando fortemente papéis ou envelopes. Empurre a bandeja firmemente na impressora após colocar o papel. Use os papéis recomendados Use apenas os papéis e a mídia especial recomendados. Não coloque papel enrugado, amassado, úmido, dobrado ou enrolado. Flexione, ventile e alinhe as margens do papel antes de carregá-lo. Não use papel que tenha sido cortado ou aparado à mão. Não misture tamanhos, pesos ou tipos de papel na mesma bandeja. Assegure-se de que o tamanho e o tipo de papel estão definidos corretamente no computador ou painel de controle da impressora. Guarde o papel de acordo com as recomendações do fabricante. atolamentos de papel para evitar atolamentos, papel para evitar evitando atolamentos de papel"},{"UUID":"8dfa4199-d27c-4a08-ac2b-1872a10100dd","title":"Limpeza de atolamentos","link":"avoiding-jams-topic.html","desc":"Como identificar os locais de","descFull":"Como identificar os locais de atolamento Quando o  Assistente de atolamento  está definido como  Ativar , a impressora descarrega páginas em branco ou páginas parcialmente impressas depois que um atolamento de papel for solucionado. Verifique a sua impressão por páginas em branco. Quando a  Recuperação de atolamento  está definida em  Ativar  ou  Automático , a impressora imprime novamente as páginas atoladas. Locais do atolamento Locais do atolamento 1 Alimentador multiúso 2 Porta A 3 Alimentador automático de documentos 4 Bandeja padrão 5 Unidade de transporte horizontal 6 Encadernador, perfurador 7 Bandeja padrão 8 Bandeja de 2000 folhas 9 Encadernador 10 Bandejas opcionais atolamentos de papel localização locais do atolamento identificando"},{"UUID":"d8eb6da3-f33f-4fda-98ce-25ff5ce703f2","title":"Limpeza de atolamentos","link":"avoiding-jams-topic.html","desc":"Atolamento de papel na bandeja","descFull":"Atolamento de papel na bandeja padrão Abra a porta A. A parte interna da impressora pode estar quente. Para reduzir o risco de ferimentos devido a um componente quente, espere a superfície esfriar antes de tocá-la. Remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Puxe a bandeja padrão para fora. Remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Insira a bandeja e feche a porta A. como remover atolamentos na bandeja padrão como remover papel atolado na bandeja padrão atolamento de papel na bandeja padrão"},{"UUID":"f4f9fb47-f8e1-478c-a9fc-3c62003b56d8","title":"Limpeza de atolamentos","link":"avoiding-jams-topic.html","desc":"Atolamento de papel nas bandejas","descFull":"Atolamento de papel nas bandejas opcionais Abra a porta B. Remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Feche a porta. Puxe a bandeja opcional para 520 folhas ou a bandeja dupla para 2000 folhas para fora. Remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Em bandejas duplas, puxe a alça C para fora e, em seguida, abra a tampa interna. Remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Feche a tampa e insira a alça C. Insira a bandeja. como remover atolamentos na porta B como remover atolamentos na bandeja para 520 folhas como remover atolamentos na bandeja dupla para 2000 folhas como remover papel atolado na porta B como remover papel atolado na bandeja para 520 folhas como remover papel atolado na bandeja dupla para 2000 folhas atolamento de papel na porta B atolamento de papel na bandeja para 520 folhas atolamento de papel na bandeja dupla para 2000 folhas atolamento de papel nas bandejas opcionais como remover atolamentos nas bandejas opcionais como remover papel atolado nas bandejas opcionais"},{"UUID":"5f7f135c-dca1-4066-9c3a-57ba200af2d3","title":"Limpeza de atolamentos","link":"avoiding-jams-topic.html","desc":"Atolamento de papel no alimentador","descFull":"Atolamento de papel no alimentador multi-uso Remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. como remover atolamentos no alimentador multiuso como remover papel atolado no alimentador multiuso atolamentos de papel no alimentador multiuso"},{"UUID":"3cf32770-1d04-423b-8d9f-d647a1198057","title":"Limpeza de atolamentos","link":"avoiding-jams-topic.html","desc":"Atolamento de papel na bandeja","descFull":"Atolamento de papel na bandeja para 2000 folhas Deslize a bandeja para a esquerda. Abra a porta J e remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Feche a porta e deslize a bandeja de volta ao lugar. Puxe o encaixe da bandeja e remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Pressione o encaixe da bandeja de volta no lugar. como remover atolamentos na bandeja para 2000 folhas como remover papel atolado na bandeja para 2000 folhas atolamento de papel na bandeja para 2000 folhas"},{"UUID":"5b638f50-7f93-425e-a89f-6c48bb6f75d0","title":"Limpeza de atolamentos","link":"avoiding-jams-topic.html","desc":"Atolamento de papel na porta","descFull":"Atolamento de papel na porta A Atolamento de papel na porta A Abra a porta A. A parte interna da impressora pode estar quente. Para reduzir o risco de ferimentos devido a um componente quente, espere a superfície esfriar antes de tocá-la. Remova o papel atolado de qualquer uma das seguintes áreas: Certifique-se de que todos os fragmentos de papel sejam removidos. Área do fusor Unidade frente e verso Porta C Feche a porta A. como remover atolamentos na porta A como remover atolamentos na unidade frente e verso como remover atolamentos na porta C como remover atolamentos na área do fusor como remover papel atolado na área do fusor como remover papel atolado na porta C como remover papel atolado na unidade frente e verso como remover papel atolado na porta A atolamento de papel na porta A atolamento de papel na unidade frente e verso Atolamentos de papel na área do fusor atolamento de papel na porta C"},{"UUID":"e705e3d7-c3a9-4dfd-aab6-9e4ae9cba09d","title":"Limpeza de atolamentos","link":"avoiding-jams-topic.html","desc":"Atolamento de papel na bandeja","descFull":"Atolamento de papel na bandeja padrão Abra a porta A. A parte interna da impressora pode estar quente. Para reduzir o risco de ferimentos devido a um componente quente, espere a superfície esfriar antes de tocá-la. Abra a porta C e remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Feche a porta C e, em seguida, a porta A. Papel atolado removido da bandeja padrão. Certifique-se de que todos os fragmentos de papel sejam removidos. como remover atolamentos na bandeja padrão como remover papel atolado bandeja padrão atolamento de papel na bandeja padrão"},{"UUID":"39c386c6-719b-4b05-9081-8896ddbceff8","title":"Limpeza de atolamentos","link":"avoiding-jams-topic.html","desc":"Atolamento de papel no alimentador","descFull":"Atolamento de papel no alimentador automático de documentos Remova todos os documentos originais da bandeja do ADF. Abra a tampa do ADF. Remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Feche a tampa do ADF. como remover atolamentos Usando o alimentador automático de documentos atolamento de papel Usando o alimentador automático de documentos como remover papel atolado Usando o alimentador automático de documentos"},{"UUID":"ff129a09-078f-42ee-b017-402ac7a2fbf9","title":"Limpeza de atolamentos","link":"avoiding-jams-topic.html","desc":"Atolamento de papel no grampeador","descFull":"Atolamento de papel no grampeador Abra a porta A. A parte interna da impressora pode estar quente. Para reduzir o risco de ferimentos devido a um componente quente, espere a superfície esfriar antes de tocá-la. Abra a porta A1 e remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Feche a porta A1 e, em seguida, a porta A. Abra a tampa superior do finalizador e remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Feche a tampa. Abra a tampa do finalizador, gire o botão e remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Feche a tampa. Abra a porta A. A parte interna da impressora pode estar quente. Para reduzir o risco de ferimentos devido a um componente quente, espere a superfície esfriar antes de tocá-la. Abra a porta C e remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Feche a porta C e, em seguida, a porta A. como remover atolamentos no encadernador como remover papel atolado no encadernador atolamento de papel no encadernador"},{"UUID":"05637c58-2ae8-49b8-b61d-bd0f0235ed1e","title":"Limpeza de atolamentos","link":"avoiding-jams-topic.html","desc":"Atolamento de papel no grampeador","descFull":"Atolamento de papel no grampeador e perfurador Abra a porta A. A parte interna da impressora pode estar quente. Para reduzir o risco de ferimentos devido a um componente quente, espere a superfície esfriar antes de tocá-la. Abra a porta A1 e remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Feche a porta A1 e, em seguida, a porta A. Abra a tampa F do transportador de papel e remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Feche a tampa do transportador de papel. Puxe a alavanca no finalizador de grampeamento e perfuração e abra a tampa. Remova o papel atolado. Certifique-se de que todos os fragmentos de papel sejam removidos. Feche a tampa do finalizador. como remover atolamentos no finalizador de grampeamento e perfuração como remover papel atolado no finalizador de grampeamento e perfuração atolamentos de papel, finalizador de grampeamento e perfuração"},{"UUID":"8ca34d2d-e684-4b50-9fc0-a750e0ed15da","title":"Problemas de conexão de rede","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Não é possível abrir o","descFull":"Não é possível abrir o Embedded Web Server Etapas para solução de problemas Ação Sim Não Certifique-se de que a impressora esteja ligada. Acesse o Embedded Web Server (EWS) da impressora. Você pode abrir o EWS? O problema foi solucionado. Verifique se o Endereço IP da impressora está correto. Veja o endereço IP na tela inicial. Um endereço IP é exibido como quatro conjuntos de números separados por pontos, por exemplo, 123.123.123.123. Acesse o EWS. Você pode abrir o EWS? O problema foi solucionado. Verifique se você instalou um navegador compatível: Internet Explorer versão 11 ou posterior Microsoft Edge Safari versão 6 ou posterior Google Chrome  versão 32 ou posterior Mozilla Firefox versão 24 ou posterior Acesse o EWS. Você pode abrir o EWS? O problema foi solucionado. Verifique se a conexão de rede está ativa. Se a conexão não estiver funcionando, entre em contato com o administrador. Acesse o EWS. Você pode abrir o EWS? O problema foi solucionado. Verifique os cabos conectados à impressora e ao servidor de impressão para garantir que estejam seguros. Para obter mais informações, consulte a documentação fornecida com o servidor de impressão. Acesse o EWS. Você pode abrir o EWS? O problema foi solucionado. Verifique se os servidores proxy da Web estão desativados. Se os servidores estiverem desativados, entre em contato com o administrador. Acesse o EWS. Você pode abrir o EWS? O problema foi solucionado. Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . não é possível abrir o Embedded Web Server solução de problemas não é possível abrir o Embedded Web Server"},{"UUID":"16dda150-5d17-4b26-8198-f85bc03d679f","title":"Problemas de conexão de rede","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Não é possível conectar a","descFull":"Não é possível conectar a impressora à rede Wi-Fi Etapas para solução de problemas Ação Sim Não Certifique-se de que a opção  Adaptador ativo  esteja definida como  Automático . Na tela inicial, toque em  Configurações Rede/Portas Visão geral da rede Adaptador ativo Automático . É possível conectar a impressora à rede Wi-Fi? O problema foi solucionado. Verifique se a rede Wi‑Fi correta está selecionada. alguns roteadores poderão compartilhar o SSID padrão. Você está se conectando à rede Wi‑Fi correta? Vá para a etapa 4. Conecte-se à rede Wi‑Fi correta. Para mais informações, consulte  . É possível conectar a impressora à rede Wi-Fi? O problema foi solucionado. Verifique o modo de segurança sem fio. Na tela inicial, toque em  Configurações Rede/Portas Sem fio Modo de segurança sem fio . O modo de segurança sem fio correto está selecionado? Vá para a etapa 6. Selecione o modo de segurança sem fio correto. É possível conectar a impressora à rede Wi-Fi? O problema foi solucionado. Verifique se digitou a chave de rede correta. preste atenção aos espaços, números e letras maiúsculas da senha. É possível conectar a impressora à rede Wi-Fi? O problema foi solucionado. Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . não é possível conectar a impressora ao Wi‑Fi solução de problemas não é possível conectar a impressora ao Wi‑Fi"},{"UUID":"37dbe9d8-d9bd-4902-b7f9-efa509ceddc1","title":"Problemas de opções de hardware","link":"trb-cannot-detect-internal-option-topic.html","desc":"A opção interna não foi","descFull":"A opção interna não foi detectada Etapas para solução de problemas Ação Sim Não Desligue a impressora, aguarde por cerca de 10 segundos e ligue-a novamente. A impressora detecta a opção interna? O problema foi solucionado. Imprima a página de Definições de menu e veja se a opção interna aparece na lista de Recursos instalados. A opção interna está listada? Vá para a etapa 4. Verifique se a opção interna está instalada corretamente na placa do controlador. Desligue a impressora e desconecte o cabo de energia da tomada elétrica. Verifique se a opção interna está instalada no conector apropriado na placa do controlador. Conecte o cabo de energia à tomada elétrica e ligue a impressora. Para evitar riscos de incêndio ou choque elétrico, conecte o cabo de energia a uma tomada elétrica adequadamente classificada e aterrada que seja de fácil acesso e esteja próxima ao produto. A impressora detecta a opção interna? O problema foi solucionado. Verifique se a opção interna está disponível no driver de impressão. Se necessário, adicione manualmente a opção interna no driver de impressão para que ela fique disponível para os trabalhos de impressão. Para obter mais informações, consulte  . Imprima o documento. A impressora detecta a opção interna? O problema foi solucionado. Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . solução de problemas, opções da impressora não foi possível detectar a opção interna solução de problemas de opções da impressora não foi possível detectar a opção interna opção interna não foi detectada"},{"UUID":"a0c31e8d-0961-4a14-9ef3-57c845336f34","title":"Problemas de opções de hardware","link":"trb-cannot-detect-internal-option-topic.html","desc":"Flash danificado detectado Experimente uma","descFull":"Flash danificado detectado Experimente uma ou mais das seguintes opções: Substitua a unidade de armazenamento inteligente defeituosa. Na tela inicial, toque em  Continuar  para ignorar a mensagem e continuar a impressão. Cancele o trabalho de impressão atual. mensagens da impressora Flash danificado detectado unidade de armazenamento inteligente defeituosa"},{"UUID":"df3b1323-46ae-48fb-8472-b5d53ce93531","title":"Problemas de opções de hardware","link":"trb-cannot-detect-internal-option-topic.html","desc":"Sem espaço livre suficiente na","descFull":"Sem espaço livre suficiente na memória flash para recurso Experimente uma ou mais das seguintes opções: Toque em  Continuar  para limpar a mensagem e continuar a impressão. Exclua fontes, macros e outros dados armazenados na memória flash. Instale um disco rígido. As fontes e macros carregadas e não armazenadas previamente na memória flash serão excluídas. mensagens da impressora Sem espaço livre suficiente na memória flash para recurso Sem espaço livre suficiente na memória flash para recurso"},{"UUID":"a802a7d7-16c3-40f7-8935-7ea973db0587","title":"Problemas com suprimentos","link":"trb-missing-or-unresponsive-toner-cartridge-topic.html","desc":"Cartucho de toner ausente ou","descFull":"Cartucho de toner ausente ou que não responde Etapas para solução de problemas Ação Sim Não Abra a porta frontal. Remova e, em seguida, insira o cartucho de toner. O cartucho de toner está ausente ou não responde? O problema foi solucionado. Verifique se a impressora está usando um cartucho de toner Lexmark original e compatível. Verifique se a impressora está usando um cartucho de toner original e compatível. Se o cartucho de toner não for compatível, instale um cartucho compatível. O cartucho de toner está ausente ou não responde? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, suprimentos cartucho de toner ausente ou que não responde cartucho de toner ausente ou que não responde solução de problemas de suprimentos cartucho de toner ausente ou que não responde"},{"UUID":"d8fde41e-cb80-4298-8cbe-88b381475785","title":"Problemas com suprimentos","link":"trb-missing-or-unresponsive-toner-cartridge-topic.html","desc":"Suprimento não-Lexmark Suprimento não-Dell Suprimento","descFull":"Suprimento não-Lexmark Suprimento não-Dell Suprimento de fabricante diferente do da impressora A impressora detectou um suprimento ou peça não Lexmark instalado na impressora. A impressora detectou um suprimento ou peça que não é da Dell instalado(a) na impressora. A impressora detectou um suprimento ou peça não reconhecidos instalados na impressora. A impressora Lexmark apresenta melhor funcionamento com peças e suprimentos genuínos Lexmark. O uso de suprimentos ou peças de terceiros afeta o desempenho, a confiabilidade ou a vida da impressora e de seus componentes de criação de imagens. A impressora Dell apresenta melhor funcionamento com peças e suprimentos genuínos Dell. O uso de suprimentos ou peças de terceiros afeta o desempenho, a confiabilidade ou a vida da impressora e de seus componentes de criação de imagens. Sua impressora apresenta melhor funcionamento com peças e suprimentos genuínos produzidos pelo fabricante da impressora. O uso de suprimentos ou peças de terceiros afeta o desempenho, a confiabilidade ou a vida da impressora e de seus componentes de criação de imagens. Todos os indicadores de vida foram projetados para funcionar com suprimentos e peças Lexmark e podem apresentar resultados imprevisíveis se forem usados suprimentos ou peças de terceiros. O uso de componentes de criação de imagens além da vida útil pretendida pode danificar a impressora Lexmark ou componentes associados. Todos os indicadores de vida útil foram projetados para funcionar com suprimentos e peças Dell e podem apresentar resultados imprevisíveis se forem usados suprimentos ou peças de terceiros. O uso de componentes de criação de imagens além da vida útil pretendida pode danificar a impressora Dell ou componentes associados. Todos os indicadores de vida foram projetados para funcionar com suprimentos e peças do fabricante da impressora e podem apresentar resultados imprevisíveis se forem usados suprimentos ou peças de terceiros. O uso de componentes de criação de imagens além da vida útil pretendida pode danificar a impressora ou componentes associados. O uso de suprimentos ou peças de terceiros pode afetar a cobertura de garantia. A garantia pode não cobrir danos causados pelo uso de suprimento ou peças de terceiros. Para aceitar estes e todos os demais riscos e continuar com o uso de suprimentos ou peças não genuínos na impressora, toque na mensagem de erro no monitor usando dois dedos e mantendo pressionado por 15 segundos. Quando uma caixa de diálogo de confirmação for exibida, toque em  Continuar . Se não quiser aceitar esses riscos, então remova o suprimento ou peça de terceiros da impressora e instale o suprimento ou uma peça original da Lexmark. Para obter mais informações, consulte  . Se não quiser aceitar esses riscos, então remova o suprimento ou peça de terceiros da impressora e instale o suprimento ou uma peça original da Dell. Caso contrário, remova o suprimento ou peça de terceiros da impressora e instale uma opção original do mesmo fabricante da impressora. Se a impressora não imprimir depois de limpar a mensagem de erro, reinicie o contador de uso de suprimento. Na tela inicial, toque em  Configurações Dispositivo Manutenção Menu de Configuração Utilização e Contadores de Suprimentos . Selecione a peça ou suprimento que deseja redefinir e toque em  Iniciar . Leia a mensagem de aviso e toque em  Continuar . Com dois dedos, toque no monitor por 15 segundos para limpar a mensagem. Caso não tenha certeza sobre como reiniciar os contadores de uso de suprimento, devolva o item de suprimento para o local de compra. mensagens da impressora suprimento não Lexmark suprimento não Lexmark mensagens da impressora suprimento não Dell suprimento não Dell mensagens da impressora suprimento de fabricante diferente do da impressora suprimento de fabricante diferente do da impressora reconfiguração contadores de uso de suprimentos contadores de uso de suprimentos reconfiguração como reconfigurar contadores de uso de suprimentos"},{"UUID":"72c4cabb-9dab-4821-897a-245190fb9c21","title":"Problemas na bandeja de papel","link":"trb-envelope-seals-when-printing-topic.html","desc":"O envelope se fecha durante","descFull":"O envelope se fecha durante a impressão Etapas para solução de problemas Ação Sim Não Use um envelope que tenha sido armazenado em um ambiente seco. A impressão em envelopes com conteúdo alto de umidade pode fechar as abas. Envie o trabalho de impressão. O envelope fecha ao imprimir? O problema foi solucionado. Certifique-se de que o tipo de papel esteja definido como Envelope. Na tela inicial, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Envie o trabalho de impressão. O envelope fecha ao imprimir? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, impressão envelope se fecha durante a impressão solução de problemas de impressão envelope se fecha durante a impressão envelope se fecha durante a impressão"},{"UUID":"4ddab3e7-d913-4119-a567-4f21cc8041e3","title":"Problemas na bandeja de papel","link":"trb-envelope-seals-when-printing-topic.html","desc":"A impressão Agrupada não funciona","descFull":"A impressão Agrupada não funciona Etapas para solução de problemas Ação Sim Não Na tela inicial, toque em  Configurações Imprimir Layout Agrupar . Toque em  Ativado [1,2,1,2,1,2 ] . Imprima o documento. O documento foi agrupado corretamente? O problema foi solucionado. No documento que deseja imprimir, abra a caixa de diálogo Imprimir e, em seguida, selecione  Agrupar . Imprima o documento. O documento foi agrupado corretamente? O problema foi solucionado. Reduza o número de cópias a serem impressas. Imprima o documento. As páginas estão agrupadas corretamente? O problema foi solucionado. Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . solução de problemas de impressão impressão agrupada não funciona solução de problemas, impressão impressão agrupada não funciona impressão agrupada não funciona"},{"UUID":"c44ac4cc-21ed-482a-9586-1cc4d98e33a9","title":"Problemas na bandeja de papel","link":"trb-envelope-seals-when-printing-topic.html","desc":"A vinculação de bandejas não","descFull":"A vinculação de bandejas não funciona Etapas para solucionar o problema Ação Sim Não Verifique se as bandejas contêm o mesmo tamanho e tipo de papel. Verifique se as guias de papel estão posicionadas corretamente. Imprima o documento. A vinculação das bandejas funciona corretamente? O problema foi solucionado. Na tela bem-vindo, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Ajuste o tamanho e o tipo de papel para corresponderem ao papel carregado nas bandejas vinculadas. Imprima o documento. A vinculação das bandejas funciona corretamente? O problema foi solucionado. Certifique-se de que  Vincular bandejas  esteja definido como  Automático . Para mais informações, consulte  . Imprima o documento. A vinculação das bandejas funciona corretamente? O problema foi solucionado. Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . solução de problemas, impressão a vinculação de bandejas não funciona solução de problemas de impressão a vinculação de bandejas não funciona"},{"UUID":"ad4fe30d-a73c-4b26-9815-fcd37b12e3c5","title":"Problemas na bandeja de papel","link":"trb-envelope-seals-when-printing-topic.html","desc":"O papel atola com frequência","descFull":"O papel atola com frequência Etapas para solução de problemas Ação Sim Não Remova a bandeja. Verifique se o papel foi colocado corretamente. Certifique-se de que as guias de papel estejam posicionadas corretamente. Certifique-se de que a altura da pilha de papel esteja abaixo dos indicadores de carregamento máximo de papel. Certifique-se de usar tamanho e tipo de papel recomendados. Insira a bandeja. Imprima o documento. Os atolamentos de papel ocorrem com frequência? O problema foi solucionado. Na tela inicial, toque em  Configurações Papel Configuração de bandeja Tamanho/Tipo de papel . Defina o tamanho e o tipo de papel padrão. Imprima o documento. Os atolamentos de papel ocorrem com frequência? O problema foi solucionado. Carregue papel de um pacote novo. O papel absorve umidade se essa estiver alta. Armazene o papel em sua embalagem original até utilizá-lo. Imprima o documento. Os atolamentos de papel ocorrem com frequência? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, impressão o papel atola com frequência solução de problemas de impressão o papel atola com frequência o papel atola com frequência"},{"UUID":"12aa304d-20b6-41b1-aa2d-67ece6c1bafa","title":"Problemas na bandeja de papel","link":"trb-envelope-seals-when-printing-topic.html","desc":"As páginas atoladas não são","descFull":"As páginas atoladas não são impressas novamente Etapa para solução de problemas Ação Sim Não Na tela inicial, toque em  Configurações Dispositivo Notificações Recuperação de conteúdo atolado . No menu Recuperação de atolamento, toque em  Ativada  ou  Automática . Imprima o documento. As páginas atoladas foram impressas novamente? O problema foi solucionado. Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . solução de problemas, impressão as páginas atoladas não são impressas novamente as páginas atoladas não são impressas novamente"},{"UUID":"ec77423f-6db0-4ee4-82d4-1a325257b8a6","title":"Problemas de envio de e-mail","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Como desativar a mensagem de","descFull":"Como desativar a mensagem de erro \"Servidor SMTP não está configurado\" Na tela inicial, toque em  Configurações E‑mail Configuração de e-mail Desativar o erro \"Servidor SMTP não está configurado\" Ativado . Para impedir que o erro ocorra novamente, execute um ou mais dos seguintes procedimentos: Atualize o firmware da impressora. Para mais informações, consulte  . Definas as configurações de SMTP do e-mail. Para mais informações, consulte  . erro de servidor SMTP não configurado desativando solução de problemas erro de servidor SMTP não configurado desativar o erro de servidor SMTP não configurado"},{"UUID":"7d5b6cff-87e3-4efe-993b-da107449bfd8","title":"Problemas de envio de e-mail","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Não é possível enviar e-mails","descFull":"Não é possível enviar e-mails Etapas para solução de problemas Ação Sim Não Certifique-se de que as configurações de SMTP do e-mail estejam configuradas corretamente. Para mais informações, consulte  . É possível enviar um e-mail? O problema foi solucionado. Certifique-se de que esteja usando a senha correta. Dependendo do provedor de serviços de e-mail, use a senha da conta, a senha do aplicativo ou a senha de autenticação. Para mais informações, consulte  . É possível enviar um e-mail? O problema foi solucionado. Certifique-se que a impressora esteja conectada a uma rede, e de que a rede esteja conectada à Internet. É possível enviar um e-mail? O problema foi solucionado. Contato  suporte ao cliente . Contato  suporte técnico . solução de problemas de e-mail não é possível enviar e-mails solução de problemas, e-mail não é possível enviar e-mails não é possível enviar e-mails"},{"UUID":"72aa46eb-bff1-48d1-84ab-e8aa997d2736","title":"Problemas de envio de fax","link":"trb-caller-id-not-shown-topic.html","desc":"O ID do chamador não","descFull":"O ID do chamador não é exibido Estas instruções são aplicáveis somente a impressoras compatíveis com o fax analógico. Para obter mais informações, consulte os  Configuração da impressora para envio de fax  a seção. Etapas para solução de problemas Ação Sim Não Ativar ID do chamador. Na tela inicial, toque em  Definições Fax Configuração de fax Configurações de recebimento de fax Controles do administrador Ativar ID do chamador . O ID do chamador é exibido? O problema foi solucionado. Contato  suporte ao cliente . Contato  suporte técnico . solução de problemas, fax o Identificador de chamadas não é exibido solução de problemas de fax o Identificador de chamadas não é exibido o Identificador de chamadas não é exibido"},{"UUID":"256e8437-c021-45a6-bd19-d4131b430d63","title":"Problemas de envio de fax","link":"trb-caller-id-not-shown-topic.html","desc":"Não é possível enviar ou","descFull":"Não é possível enviar ou receber faxes usando o fax analógico Etapas para solução de problemas Ação Sim Não Resolva as mensagens de erro que aparecem no visor. É possível enviar ou receber um fax? O problema foi solucionado. Verifique se as conexões de cabo dos seguintes equipamentos estão seguras: Telefone Fone Secretária eletrônica É possível enviar ou receber um fax? O problema foi solucionado. Verifique se há tom de discagem. Ligue para o número de fax para verificar se está funcionando adequadamente. Se você estiver usando o recurso de discagem no gancho, aumente o volume para verificar se há um tom de discagem. É possível escutar o tom de discagem? Vá para a etapa 5. Verifique a tomada do telefone. Conecte o telefone analógico diretamente à tomada. Verifique se há tom de discagem. Se não houver um tom de discagem, use um cabo telefônico diferente. Se ainda não ouvir um tom de discagem, conecte o telefone analógico em uma tomada diferente. Se ouvir um tom de discagem, conecte a impressora a essa tomada. É possível enviar ou receber um fax? O problema foi solucionado. Verifique se a impressora está conectada a um serviço de telefone analógico ou com o conector digital correto. Se você estiver usando um serviço telefônico do tipo Serviços Integrados de Rede Digital (ISDN, Integrated Services Digital Network), conecte a uma porta telefônica analógica de um adaptador de terminal ISDN. Para obter mais informações, contate seu fornecedor de ISDN. Se estiver usando DSL, conecte a impressora a um filtro ou roteador DSL que ofereça suporte ao uso analógico. Para obter mais informações, contate seu fornecedor de DSL. Se estiver usando um serviço de telefonia de Central Privada de Comutação Telefônica (PBX), certifique-se de estar usando uma conexão analógica no PBX. Se não houver uma conexão, considere a instalação de uma linha telefônica analógica para a máquina de fax. É possível enviar ou receber um fax? O problema foi solucionado. Desligue temporariamente outros equipamentos e desative outros serviços telefônicos. Desligue outros equipamentos (como secretárias eletrônicas, computadores, modems ou separadores de linha telefônica) entre a impressora e a linha telefônica. Desative chamada em espera e correio de voz. Para obter mais informações, entre em contato com a companhia telefônica. É possível enviar ou receber um fax? O problema foi solucionado. Digitalize uma página por vez do documento original. Disque o número do fax. Digitalize o documento. É possível enviar ou receber um fax? O problema foi solucionado. Contato  suporte ao cliente . Contato  suporte técnico . solução de problemas de fax não é possível enviar ou receber faxes usando o fax analógico solução de problemas, fax não é possível enviar ou receber faxes usando o fax analógico não é possível enviar ou receber faxes usando o fax analógico"},{"UUID":"cc329dc7-bba2-45a8-b2a1-25aa92a7d10c","title":"Problemas de envio de fax","link":"trb-caller-id-not-shown-topic.html","desc":"É possível receber, mas não","descFull":"É possível receber, mas não é possível enviar faxes usando o fax analógico Etapas para solução de problemas Ação Sim Não Coloque um documento original corretamente na bandeja do ADF ou no vidro do scanner. Você consegue enviar faxes? O problema foi solucionado. Configure apropriadamente o número do atalho. Certifique-se de que o número do atalho está programado com o número de telefone para o qual você deseja discar. Disque manualmente o número de telefone. Você consegue enviar faxes? O problema foi solucionado. Contato  suporte ao cliente . Configure apropriadamente o número do atalho. Certifique-se de que o número do atalho está programado com o número de telefone para o qual você deseja discar. Disque manualmente o número de telefone. Você consegue enviar faxes? O problema foi solucionado. Contato  suporte técnico . solução de problemas de fax não é possível enviar faxes usando o fax analógico solução de problemas, fax não é possível enviar faxes usando o fax analógico"},{"UUID":"71785e70-d0ec-4306-881b-ef9c2b2f9e2d","title":"Problemas de envio de fax","link":"trb-caller-id-not-shown-topic.html","desc":"É possível enviar, mas não","descFull":"É possível enviar, mas não é possível receber faxes usando o fax analógico Etapas para solução de problemas Ação Sim Não Verifique se a origem do papel não está vazia. Você consegue receber faxes? O problema foi solucionado. Verifique as configurações de atraso de contagem de toques. Na tela inicial, toque em  Configurações Fax Configuração de fax Configurações de recebimento de fax Toques para responder . Você consegue receber faxes? O problema foi solucionado. Se a impressora estiver entregando páginas em branco, consulte  . Você consegue receber faxes? O problema foi solucionado. Contato  suporte ao cliente . Contato  suporte técnico . solução de problemas de fax é possível enviar, mas não é possível receber faxes usando o fax analógico solução de problemas, fax é possível enviar, mas não é possível receber faxes usando o fax analógico não é possível receber faxes usando o fax analógico"},{"UUID":"40fc837f-b517-4c0d-898e-50fb68830e5b","title":"Problemas de envio de fax","link":"trb-caller-id-not-shown-topic.html","desc":"Não é possível configurar o","descFull":"Não é possível configurar o etherFAX Etapas para solução de problemas Ação Sim Não Verifique a conectividade da impressora. Imprima a  Página de configuração de rede . Na tela inicial, toque em  Configurações Relatórios Rede Página de configurações de rede . Verifique o status da rede. A impressora está conectada à rede? Vá para a etapa 3. Certifique-se que a impressora esteja conectada a uma rede, e de que a rede esteja conectada à Internet. Você consegue configurar o etherFAX? O problema foi solucionado. Certifique-se de que o etherFAX esteja configurado corretamente. Para mais informações, consulte  . Você consegue configurar o etherFAX? O problema foi solucionado. Acesse  https://www.etherfax.net/lexmark . solução de problemas de fax não é possível configurar o etherFAX solução de problemas, fax não é possível configurar o etherFAX"},{"UUID":"5526cc8e-86af-41af-81f5-f5aafe50c3be","title":"Problemas de envio de fax","link":"trb-caller-id-not-shown-topic.html","desc":"Não é possível enviar ou","descFull":"Não é possível enviar ou receber faxes usando o etherFAX Etapas para solução de problemas Ação Sim Não Certifique-se que a impressora esteja conectada a uma rede, e de que a rede esteja conectada à Internet. Você consegue enviar ou receber faxes usando o etherFAX? O problema foi solucionado. Certifique-se de que o etherFAX esteja configurado corretamente. Na tela inicial, toque em  Configurações Fax Configuração de fax Configurações gerais de fax . Certifique-se de que você tenha o número correto do fax. Certifique-se de que a opção  Transporte de fax  esteja definida como  etherFAX . Este menu é exibido apenas quando há mais de um transporte de fax disponível. Se a impressora tiver apenas etherFAX instalado, ela será configurada automaticamente. Você consegue enviar ou receber faxes usando o etherFAX? O problema foi solucionado. Divida documentos grandes em arquivos menores. Você consegue enviar ou receber faxes usando o etherFAX? O problema foi solucionado. Acesse  https://www.etherfax.net/lexmark . solução de problemas de fax não é possível enviar ou receber faxes usando o etherFAX solução de problemas, fax não é possível enviar ou receber faxes usando o etherFAX não é possível enviar ou receber faxes usando o etherFAX"},{"UUID":"7ff7dbed-d622-4719-bd2a-9bb6e1a8774e","title":"Problemas de envio de fax","link":"trb-caller-id-not-shown-topic.html","desc":"Qualidade de impressão de fax","descFull":"Qualidade de impressão de fax ruim Etapas para solução de problemas Ação Sim Não Verifique se não há problemas com a qualidade de impressão. Na tela inicial, toque em  Configurações Solucionar problemas Imprimir as páginas de teste de qualidade . Corrija os problemas com a qualidade da impressão. Para obter mais informações, consulte  . A qualidade da impressão do fax está satisfatória? O problema foi solucionado. Se estiver usando um fax analógico, diminua a velocidade de transmissão de fax recebido. Na tela inicial, toque em  Configurações Fax Configuração de fax  Configurações de recebimento de fax Controles do administrador . No menu Velocidade máxima, selecione uma velocidade de transmissão mais baixa. A qualidade da impressão do fax está satisfatória? O problema foi solucionado. Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . solução de problemas de fax baixa qualidade de impressão qualidade de impressão de fax ruim solução de problemas, fax baixa qualidade de impressão"},{"UUID":"950e03db-43fa-44fe-9f9e-d390a32cf891","title":"Problemas de envio de fax","link":"trb-caller-id-not-shown-topic.html","desc":"Informações ausentes na folha de","descFull":"Informações ausentes na folha de rosto do fax Etapas para solução de problemas Ação Não Sim Desligue a impressora, aguarde por cerca de 10 segundos e ligue-a novamente. Envie ou recupere o fax. Há informações ausentes na folha de rosto do fax? O problema foi solucionado. Contato  suporte ao cliente . Contato  suporte técnico . solução de problemas de fax informações ausentes na folha de rosto do fax solução de problemas, fax informações ausentes na folha de rosto do fax informações ausentes na folha de rosto do fax"},{"UUID":"2b76e89a-8835-481c-bf1e-685452e4f146","title":"Problemas de envio de fax","link":"trb-caller-id-not-shown-topic.html","desc":"Não é possível enviar a","descFull":"Não é possível enviar a folha de rosto do fax a partir do computador Etapas para solução de problemas Ação Sim Não Certifique-se de que o driver da impressora esteja atualizado. Para mais informações, consulte  . Envie o fax. Você consegue enviar a folha de rosto do fax? O problema foi solucionado. No documento que você está tentando enviar por fax, abra a caixa de diálogo  Imprimir . Selecione a impressora e clique em  Propriedades ,  Preferências ,  Opções  ou  Configurar . Clique em  Fax  e desmarque a configuração  Sempre exibir configurações de fax antes de enviá-lo . Envie o fax. Você consegue enviar a folha de rosto do fax? O problema foi solucionado. Contato  suporte ao cliente . Contato  suporte técnico . solução de problemas de fax não é possível enviar a folha de rosto do fax a partir do computador solução de problemas, fax não é possível enviar a folha de rosto do fax a partir do computador não é possível enviar a folha de rosto do fax a partir do computador"},{"UUID":"a867d61e-bd5a-45cf-81ca-1547d65e6444","title":"Problemas de digitalização","link":"trb-cannot-scan-to-computer-topic.html","desc":"Não é possível digitalizar para","descFull":"Não é possível digitalizar para um computador Etapas para solução de problemas Ação Sim Não Execute um trabalho de cópia. O trabalho de cópia foi bem-sucedido? Vá para a etapa 3. Desligue a impressora, aguarde cerca de 10 segundos e ligue-a novamente. Digitalize o documento. É possível digitalizar o documento para um computador? O problema foi solucionado. Verifique a conectividade da impressora. Imprima a  Página de configuração de rede . Na tela inicial, toque em  Configurações Relatórios Rede Página de configurações de rede . Verifique o status da rede. A impressora está conectada à rede? Vá para a etapa 5. Conecte a impressora à rede. Digitalize o documento. É possível digitalizar o documento para um computador? O problema foi solucionado. Verifique se a impressora e o computador e estão conectados à mesma rede. Digitalize o documento. É possível digitalizar o documento para um computador? O problema foi solucionado. Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . solução de problemas de digitalização não é possível digitalizar para um computador solução de problemas, digitalização não é possível digitalizar para um computador não é possível digitalizar para um computador"},{"UUID":"6fb042f7-43bb-47a8-a40d-010e8c9e806a","title":"Problemas de digitalização","link":"trb-cannot-scan-to-computer-topic.html","desc":"Não é possível digitalizar para","descFull":"Não é possível digitalizar para uma pasta de rede Etapas para solução de problemas Ação Sim Não Crie um atalho para a pasta de rede. Digitalize um documento usando o atalho. Para mais informações, consulte  . É possível digitalizar um documento e salvá-lo em uma pasta de rede? O problema foi solucionado. Certifique-se de que o caminho da pasta de rede e o formato estejam corretos. Por exemplo,  // server_hostname /foldername/path , em que  server_hostname  é um domínio totalmente qualificado (FQDN) ou endereço IP. O caminho da pasta de rede e o formato estão corretos? Vá para a etapa 4. Certifique-se de que você tenha permissão de gravação na pasta de rede. É possível digitalizar um documento e salvá-lo em uma pasta de rede? O problema foi solucionado. Atualize o atalho para a pasta de rede. Abra o navegador da Web e digite o endereço IP da impressora no campo de endereço. Veja o endereço IP da impressora na tela inicial. O endereço IP é exibido em quatro conjuntos de números separados por pontos, por exemplo: 123.123.123.123. Se você estiver usando um servidor proxy, desative-o temporariamente para que a página da Web seja carregada corretamente. Clique em  Atalhos  e selecione um atalho. Se você tiver vários tipos de atalho, selecione  Pasta de rede . No campo  Caminho do compartilhamento , digite o caminho da pasta de rede. Se o caminho do compartilhamento for  \\\\server_hostname\\foldername\\path , digite  //server_hostname/foldername/path . Certifique-se de que tenha usado barras \"/\" ao digitar o caminho do compartilhamento. No menu  Autenticação , selecione o método de autenticação. Se a opção  Autenticação  estiver definida como \" Usar nome de usuário e senha atribuídos \", digite suas credenciais nos campos  Nome de usuário  e  Senha . Clique em  Salvar . É possível digitalizar um documento e salvá-lo em uma pasta de rede? O problema foi solucionado. Certifique-se que de a impressora e a pasta de rede estejam conectadas à mesma rede. É possível digitalizar um documento e salvá-lo em uma pasta de rede? O problema foi solucionado. Contato  suporte ao cliente . Contato  suporte técnico . não é possível digitalizar para uma pasta de rede solução de problemas, digitalização não é possível digitalizar para uma pasta de rede solução de problemas de digitalização não é possível digitalizar para a pasta de rede"},{"UUID":"030a41f2-b853-49a7-b67b-b6c14324f347","title":"Problemas de digitalização","link":"trb-cannot-scan-to-computer-topic.html","desc":"Cópias parciais do documento ou","descFull":"Cópias parciais do documento ou fotografia Etapas para solução de problemas Ação Sim Não Coloque o documento ou a foto voltada para baixo no canto superior esquerdo do vidro do scanner. Copiar o documento ou foto. O documento ou a fotografia foi copiado corretamente? O problema foi solucionado. A definição de tamanho do papel deve corresponder ao papel carregado na bandeja. Copiar o documento ou foto. O documento ou a fotografia foi copiado corretamente? O problema foi solucionado. Contate  suporte ao cliente . A definição de tamanho do papel deve corresponder ao papel carregado na bandeja. Copiar o documento ou foto. O documento ou a fotografia foi copiado corretamente? O problema foi solucionado. Contate  suporte técnico . solução de problemas, cópia cópias parciais do documento ou fotografia solução de problemas de cópia cópias parciais do documento ou fotografia solução de problemas, digitalização cópias parciais do documento ou fotografia solução de problemas de digitalização cópias parciais do documento ou fotografia"},{"UUID":"48a1fabf-c64f-471e-9e30-a6f3c8d22037","title":"Problemas de digitalização","link":"trb-cannot-scan-to-computer-topic.html","desc":"A qualidade da cópia não","descFull":"A qualidade da cópia não é boa Etapas para solução de problemas Ação Sim Não Limpe o vidro do scanner e o vidro do ADF com um pano úmido, macio e sem fiapos. Se a sua impressora tiver um segundo vidro do ADF dentro do ADF, limpe também esse vidro. Para obter mais informações, consulte  . Coloque o documento ou a foto voltada para baixo no canto superior esquerdo do vidro do scanner. Copiar o documento ou foto. A qualidade da cópia está satisfatória? O problema foi solucionado. Verifique a qualidade do documento ou fotografia original. Ajuste as definições de qualidade de digitalização. Copiar o documento ou foto. A qualidade da cópia está satisfatória? O problema foi solucionado. Contate  suporte ao cliente . Verifique a qualidade do documento ou fotografia original. Ajuste as definições de qualidade de digitalização. Copiar o documento ou foto. A qualidade da cópia está satisfatória? O problema foi solucionado. Contate  suporte técnico . solução de problemas de cópia a qualidade da cópia não é boa solução de problemas, cópia a qualidade da cópia não é boa solução de problemas de digitalização a qualidade da cópia não é boa solução de problemas, digitalização a qualidade da cópia não é boa"},{"UUID":"780ffff9-24f0-4055-b645-f4fffbd47787","title":"Problemas de digitalização","link":"trb-cannot-scan-to-computer-topic.html","desc":"Listras escuras verticais na saída","descFull":"Listras escuras verticais na saída ao digitalizar a partir do ADF Etapas para solução de problemas Ação Sim Não Abra a tampa do scanner. Limpe o vidro do ADF e o próprio ADF usando um pano úmido, macio e sem fiapos. Feche a tampa do scanner. Digitalize o documento. As listras verticais aparecem nos documentos digitalizados? Contate o  suporte ao cliente . Contate o  suporte técnico . O problema foi solucionado. solução de problemas, digitalização listras escuras verticais na saída ao digitalizar a partir do ADF solução de problemas de digitalização listras escuras verticais na saída ao digitalizar a partir do ADF listras escuras verticais na saída ao digitalizar a partir do ADF problema de qualidade na digitalização"},{"UUID":"c3c45de3-f789-4f5d-8a23-4968ce94d861","title":"Problemas de digitalização","link":"trb-cannot-scan-to-computer-topic.html","desc":"Imagem ou texto irregular ao","descFull":"Imagem ou texto irregular ao digitalizar pelo ADF Etapas para solução de problemas Ação Sim Não Carregue 50 folhas de papel comum e limpo no ADF. O papel comum ajuda a limpar ou remover poeira e outros resíduos dos rolos de alimentação do ADF. Na tela inicial, toque em  . Coloque um documento original no ADF. Digitalize o documento. Aparecem imagens ou textos irregulares na saída? Entre em contato com o  suporte ao cliente . Entre em contato com o  suporte técnico . O problema foi solucionado. solução de problemas, digitalização imagem irregular ao digitalizar pelo ADF solução de problemas, digitalização texto irregular ao digitalizar pelo ADF solução de problemas de digitalização imagem irregular ao digitalizar pelo ADF solução de problemas de digitalização texto irregular ao digitalizar pelo ADF imagem irregular como digitalizar pelo ADF texto irregular como digitalizar pelo ADF como digitalizar pelo ADF imagem irregular como digitalizar pelo ADF texto irregular"},{"UUID":"b009051a-6e07-45ee-b32b-cc7315390f26","title":"Problemas de digitalização","link":"trb-cannot-scan-to-computer-topic.html","desc":"A digitalização não foi concluída","descFull":"A digitalização não foi concluída com êxito Etapas para solução de problemas Ação Sim Não Verifique as conexões dos cabos. Certifique-se de que o cabo Ethernet ou USB esteja conectado corretamente ao computador e à impressora. Reenvie o trabalho de digitalização. O trabalho de digitalização foi bem-sucedido? O problema foi solucionado. Verifique o arquivo que deseja digitalizar. Certifique-se de que o nome do arquivo não está sendo utilizado na pasta de destino. Certifique-se de que o documento ou fotografia que deseja digitalizar não esteja aberto em outro aplicativo. Reenvie o trabalho de digitalização. O trabalho de digitalização foi bem-sucedido? O problema foi solucionado. Verifique se a caixa de seleção  Anexar marca de hora  ou  Sobrescrever o arquivo existente  está marcada nas definições da configuração de destino. Reenvie o trabalho de digitalização. O trabalho de digitalização foi bem-sucedido? O problema foi solucionado. Contate  suporte ao cliente . Verifique se a caixa de seleção  Anexar marca de hora  ou  Sobrescrever o arquivo existente  está marcada nas definições da configuração de destino. Reenvie o trabalho de digitalização. O trabalho de digitalização foi bem-sucedido? O problema foi solucionado. Contate  suporte técnico . solução de problemas de digitalização a digitalização não foi concluída com êxito solução de problemas, digitalização a digitalização não foi concluída com êxito"},{"UUID":"868c2c7f-eba5-47b5-8227-8a6bdab36148","title":"Problemas de digitalização","link":"trb-cannot-scan-to-computer-topic.html","desc":"O scanner não fecha Etapa","descFull":"O scanner não fecha Etapa para solução de problemas Ação Sim Não Remova obstruções que estejam mantendo a tampa do scanner aberta. A tampa do scanner fecha corretamente? O problema foi solucionado. Contate o  suporte ao cliente . Contate o  suporte técnico . solução de problemas, cópia o scanner não fecha solução de problemas, digitalização o scanner não fecha o scanner não fecha"},{"UUID":"83955567-ad89-49ec-8087-7ab68f8c17f6","title":"Problemas de digitalização","link":"trb-cannot-scan-to-computer-topic.html","desc":"A digitalização é muito demorada","descFull":"A digitalização é muito demorada ou congela o computador Etapas para solução de problemas Ação Sim Não Feche todos os aplicativos interferindo com a digitalização. A digitalização leva tempo demais ou trava o computador? Contate  suporte ao cliente . Contate  suporte técnico . O problema foi solucionado. solução de problemas de digitalização a digitalização leva um longo tempo solução de problemas de digitalização a digitalização trava o computador"},{"UUID":"811fc2cc-eef1-4819-b07e-c8b2d5857057","title":"Problemas de digitalização","link":"trb-cannot-scan-to-computer-topic.html","desc":"O scanner não responde Etapas","descFull":"O scanner não responde Etapas para solução de problemas Ação Sim Não Verifique se o cabo de energia está conectado adequadamente na impressora e na tomada elétrica. Para evitar risco de incêndio ou choque elétrico, conecte o cabo de energia em uma tomada elétrica adequadamente aterrada que esteja perto do produto e possa ser facilmente acessada. Copiar ou digitalizar o documento. O scanner está respondendo? O problema foi solucionado. Certifique-se de que a impressora esteja ligada. Resolva as mensagens de erro que aparecem no visor. Copiar ou digitalizar o documento. O scanner está respondendo? O problema foi solucionado. Desligar a impressora, aguardar cerca de 10 segundos e ligá-la novamente. Copiar ou digitalizar o documento. O scanner está respondendo? O problema foi solucionado. Contate  suporte ao cliente . Desligar a impressora, aguardar cerca de 10 segundos e ligá-la novamente. Copiar ou digitalizar o documento. O scanner está respondendo? O problema foi solucionado. Contate  suporte técnico . solução de problemas, cópia o scanner não responde solução de problemas de cópia o scanner não responde solução de problemas, digitalização o scanner não responde solução de problemas de digitalização o scanner não responde"},{"UUID":"0e44345f-2dc5-4a17-b332-6e03029c7985","title":"Problemas de digitalização","link":"trb-cannot-scan-to-computer-topic.html","desc":"Ajustando o registro do scanner","descFull":"Ajustando o registro do scanner Na tela inicial, toque em  Configurações Dispositivo Manutenção Menu de configuração Scanner Configuração do scanner Registro manual do scanner . No menu de Teste de impressão rápido, toque em  Iniciar . Coloque a página do Teste de impressão rápido no vidro do scanner e, em seguida, toque em  Registro da base de cópia . No menu de Teste de cópia rápida, toque em  Iniciar . Compare a página do Teste de cópia rápido com o documento original. Caso as margens da página de teste estejam diferentes do documento original, configure a Margem esquerda e a Margem superior. Repita   e   até que as margens da página de Teste de cópia rápido se aproxime o máximo do documento original. ajuste registro do scanner"},{"UUID":"37ab008e-104c-4c3a-9091-2380631915fa","title":"Problemas de digitalização","link":"trb-cannot-scan-to-computer-topic.html","desc":"Ajustando o registro do ADF","descFull":"Ajustando o registro do ADF Na tela inicial, toque em  Configurações Dispositivo Manutenção Menu de configuração Scanner Configuração do scanner Registro manual do scanner . No menu de Teste de impressão rápido, toque em  Iniciar . Coloque a página do Teste de impressão rápido na bandeja do ADF. Toque em  Registro do ADF dianteiro  ou  Registro do ADF traseiro . Para alinhar o Registro do ADF dianteiro, coloque a página do teste voltada para cima, com a margem curta entrando primeiro no ADF. Para alinhar o Registro do ADF traseiro, coloque a página do teste voltada para baixo, com a margem curta entrando primeiro no ADF. No menu de Teste de cópia rápida, toque em  Iniciar . Compare a página do Teste de cópia rápido com o documento original. Caso as margens da página de teste estejam diferentes do documento original, configure o Ajuste horizontal e a Margem superior. Repita   e   até que as margens da página de Teste de cópia rápido se aproxime o máximo do documento original. Registro do ADF ajuste ajustando o registro do ADF"},{"UUID":"69cdba94-fedc-49bb-93d2-8be5c27aa2a9","title":"Solução de problemas","link":"trb-contacting-customer-support-topic.html","desc":"Entrando em contato com o","descFull":"Entrando em contato com o suporte ao cliente Antes de entrar em contato com Suporte ao cliente, certifique-se de ter as seguintes informações: Problemas com a impressora Mensagem de erro Modelo e o número de série da impressora Acesse  http://support.lexmark.com  para receber e-mail ou suporte via bate-papo, ou navegar pela biblioteca de manuais, documentação de suporte, drivers e outros downloads. Suporte técnico via telefone também está disponível. Nos Estados Unidos ou no Canadá, ligue para 1- 800- 539-6275. Em outros países ou regiões, acesse  http://support.lexmark.com . Visite o local onde você comprou sua impressora. entrando em contato com o suporte ao cliente suporte ao cliente para entrar em contato"},{"UUID":"c2fc4a5f-e3eb-4e25-b729-71ae4a8da731","title":"Solução de problemas","link":"troubleshoot-problem-chapter.html","desc":"Entrando em contato com o","descFull":"Entrando em contato com o suporte técnico Ao entrar em contato com o suporte técnico, descreva o problema, a mensagem exibida no visor da impressora e as etapas que você já executou para tentar solucionar o problema. Verifique a etiqueta dentro da tampa frontal superior ou na parte traseira da impressora e observe o seguinte: Modelo da impressora Número da etiqueta de serviço ou código de serviço expresso Para obter mais informações, acesse  www.dell.com/support . solução de problemas entrando em contato com o suporte técnico entrando em contato com o suporte técnico"},{"UUID":"556dbceb-a856-4b7a-ac7a-6d01e82482ba","title":"Reciclagem e descarte","link":"recycling-lexmark-products-topic.html","desc":"Reciclagem de produtos da Lexmark","descFull":"Reciclagem de produtos da Lexmark Para enviar seus produtos da Lexmark para reciclagem: Acesse  www.lexmark.com/recycle . Selecione o produto que deseja reciclar. O hardware e os suprimentos da impressora não listados no Programa de Coleta e Reciclagem da Lexmark podem ser reciclados por outro centro de reciclagem local. reciclagem produtos da Lexmark"},{"UUID":"18707e5c-d02c-4ccb-8641-3e389f4d3d0c","title":"Reciclagem e descarte","link":"recycling-lexmark-packaging-topic.html","desc":"Reciclagem de embalagens da Lexmark","descFull":"Reciclagem de embalagens da Lexmark A Lexmark se esforça continuamente para minimizar as embalagens. Menos embalagens ajudam a garantir que as impressoras da Lexmark sejam transportadas da maneira mais eficiente e ecologicamente correta e que haja menos embalagens para descarte. Essas eficiências resultam em menos emissões de efeito estufa, economia de energia e economia de recursos naturais. A Lexmark também oferece reciclagem de componentes de embalagem em alguns países ou regiões. Para mais informações, visite  www.lexmark.com/recycle  e escolha o país ou a região. As informações sobre os programas de reciclagem de embalagem disponíveis estão incluídas nas informações sobre reciclagem dos produtos. As caixas de papelão da Lexmark são 100% recicláveis quando existem instalações de reciclagem de papelão ondulado. Podem não existir instalações desse tipo na sua área. A espuma usada nas embalagens da Lexmark é reciclável quando existem instalações de reciclagem de espuma. Podem não existir instalações desse tipo na sua área.  Quando você retorna um cartucho da Lexmark, pode reutilizar a caixa com a qual o cartucho veio. A Lexmark recicla a caixa. reciclagem Embalagem Lexmark"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"MX931 MFP"}},[_vm._v("\n    MX931 MFP\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_pt","title":"Informa&ccedil;&otilde;es sobre seguran&ccedil;a"}},[_vm._v("\n    Informações sobre segurança\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"Conven&ccedil;&otilde;es"}},[_vm._v("\n     Convenções\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e40","title":"Declara&ccedil;&otilde;es de produtos"}},[_vm._v("\n     Declarações de produtos\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learn-about-printer-chapter.html#learn-about-printer-chapter_pt","title":"Informa&ccedil;&otilde;es sobre a impressora"}},[_vm._v("\n    Informações sobre a impressora\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e170"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_pt","title":"Localizando informa&ccedil;&otilde;es sobre a impressora"}},[_vm._v("\n     Localizando informações sobre a impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_pt","title":"Localiza&ccedil;&atilde;o do n&uacute;mero de s&eacute;rie da impressora"}},[_vm._v("\n     Localização do número de série da impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_pt","title":"Configura&ccedil;&otilde;es da impressora"}},[_vm._v("\n     Configurações da impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_pt","title":"Uso do painel de controle"}},[_vm._v("\n     Uso do painel de controle\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_pt","title":"Compreendendo o status da luz indicadora"}},[_vm._v("\n     Compreendendo o status da luz indicadora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-paper-group.html#d0e562","title":"Como selecionar o papel"}},[_vm._v("\n     Como selecionar o papel\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_pt","title":"Instala&ccedil;&atilde;o e configura&ccedil;&atilde;o"}},[_vm._v("\n    Instalação e configuração\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e3841"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_pt","title":"Sele&ccedil;&atilde;o de um local para a impressora"}},[_vm._v("\n     Seleção de um local para a impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"attaching-cables-topic.html#attaching-cables_pt","title":"Conectando os cabos"}},[_vm._v("\n     Conectando os cabos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#d0e4029","title":"Configura&ccedil;&atilde;o e uso dos aplicativos da tela inicial"}},[_vm._v("\n     Configuração e uso dos aplicativos da tela inicial\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e4646","title":"Configura&ccedil;&atilde;o e uso dos recursos de acessibilidade"}},[_vm._v("\n     Configuração e uso dos recursos de acessibilidade\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e4949","title":"Configurando a impressora para enviar fax"}},[_vm._v("\n     Configurando a impressora para enviar fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_pt","title":"Como configurar o SMTP de e-mail"}},[_vm._v("\n     Como configurar o SMTP de e-mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-trays-group.html#d0e6744","title":"Carregamento de papel e m&iacute;dia especial"}},[_vm._v("\n     Carregamento de papel e mídia especial\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e7137","title":"Como instalar e atualizar software, drivers e firmware"}},[_vm._v("\n     Como instalar e atualizar software, drivers e firmware\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-envelope-tray-topic.html#d0e7419","title":"Instala&ccedil;&atilde;o de hardware opcional"}},[_vm._v("\n     Instalação de hardware opcional\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"networking-intro-topic.html#d0e8091","title":"Colocando em rede"}},[_vm._v("\n     Colocando em rede\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-serial-printing-topic.html#setting-up-serial-printing_pt","title":"Configura&ccedil;&atilde;o da impress&atilde;o serial (somente no Windows)"}},[_vm._v("\n     Configuração da impressão serial (somente no Windows)\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_pt","title":"Prote&ccedil;&atilde;o da impressora"}},[_vm._v("\n    Proteção da impressora\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e8488"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_pt","title":"Localiza&ccedil;&atilde;o do slot de seguran&ccedil;a"}},[_vm._v("\n     Localização do slot de segurança\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_pt","title":"Apagar a mem&oacute;ria da impressora"}},[_vm._v("\n     Apagar a memória da impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_pt","title":"Como apagar a unidade de armazenamento da impressora"}},[_vm._v("\n     Como apagar a unidade de armazenamento da impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_pt","title":"Restaura&ccedil;&atilde;o das configura&ccedil;&otilde;es padr&atilde;o de f&aacute;brica"}},[_vm._v("\n     Restauração das configurações padrão de fábrica\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_pt","title":"Declara&ccedil;&atilde;o de volatilidade"}},[_vm._v("\n     Declaração de volatilidade\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"print-chapter.html#print-chapter_pt","title":"Print"}},[_vm._v("\n    Print\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e8681"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-h2-topic.html#printing-from-computer-h2_pt","title":"Impress&atilde;o de um computador"}},[_vm._v("\n     Impressão de um computador\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-topic.html#d0e8707","title":"Impress&atilde;o a partir de um dispositivo m&oacute;vel"}},[_vm._v("\n     Impressão a partir de um dispositivo móvel\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_pt","title":"Impress&atilde;o a partir de uma unidade flash"}},[_vm._v("\n     Impressão a partir de uma unidade flash\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_pt","title":"Unidades flash e tipos de arquivo suportados"}},[_vm._v("\n     Unidades flash e tipos de arquivo suportados\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_pt","title":"Configurar trabalhos confidenciais"}},[_vm._v("\n     Configurar trabalhos confidenciais\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_pt","title":"Como imprimir trabalhos confidenciais e outros trabalhos suspensos"}},[_vm._v("\n     Como imprimir trabalhos confidenciais e outros trabalhos suspensos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_pt","title":"Imprimindo uma lista de amostras de fontes"}},[_vm._v("\n     Imprimindo uma lista de amostras de fontes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-h2-topic.html#printing-directory-list-h2_pt","title":"Impress&atilde;o de uma lista de diret&oacute;rios"}},[_vm._v("\n     Impressão de uma lista de diretórios\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-topic.html#placing-separator-sheets_pt","title":"Folhas separadoras entre as c&oacute;pias"}},[_vm._v("\n     Folhas separadoras entre as cópias\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"stapling-printed-sheets-topic.html#stapling-printed-sheets_pt","title":"Grampeamento de folhas impressas"}},[_vm._v("\n     Grampeamento de folhas impressas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"punching-holes-printed-sheets-topic.html#punching-holes-printed-sheets_pt","title":"Perfura&ccedil;&atilde;o em folhas impressas"}},[_vm._v("\n     Perfuração em folhas impressas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacking-printed-sheets-topic.html#using-offset-stacking-printed-sheets_pt","title":"Como usar o empilhamento de separa&ccedil;&atilde;o em folhas impressas"}},[_vm._v("\n     Como usar o empilhamento de separação em folhas impressas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_pt","title":"Cancelamento de um trabalho de impress&atilde;o"}},[_vm._v("\n     Cancelamento de um trabalho de impressão\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_pt","title":"Ajustando a tonalidade do toner"}},[_vm._v("\n     Ajustando a tonalidade do toner\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying-chapter.html#copying-chapter_pt","title":"Copiar"}},[_vm._v("\n    Copiar\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9472"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_pt","title":"Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner"}},[_vm._v("\n     Usando o alimentador automático de documentos e o vidro do scanner\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_pt","title":"C&oacute;pias"}},[_vm._v("\n     Cópias\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_pt","title":"C&oacute;pia de fotos"}},[_vm._v("\n     Cópia de fotos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_pt","title":"Copiando em papel timbrado"}},[_vm._v("\n     Copiando em papel timbrado\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_pt","title":"C&oacute;pia nos dois lados do papel"}},[_vm._v("\n     Cópia nos dois lados do papel\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-enlarging-copies-topic.html#reducing-enlarging-copies_pt","title":"Redu&ccedil;&atilde;o ou amplia&ccedil;&atilde;o de c&oacute;pias"}},[_vm._v("\n     Redução ou ampliação de cópias\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_pt","title":"Agrupamento de c&oacute;pias"}},[_vm._v("\n     Agrupamento de cópias\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_pt","title":"Folhas separadoras entre as c&oacute;pias"}},[_vm._v("\n     Folhas separadoras entre as cópias\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"saving-paper-topic.html#saving-paper_pt","title":"Para copiar v&aacute;rias p&aacute;ginas em uma &uacute;nica folha"}},[_vm._v("\n     Para copiar várias páginas em uma única folha\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_pt","title":"C&oacute;pia de cart&otilde;es"}},[_vm._v("\n     Cópia de cartões\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"stapling-copies-topic.html#stapling-copies_pt","title":"Grampeamento de c&oacute;pias"}},[_vm._v("\n     Grampeamento de cópias\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"punching-holes-copies-topic.html#punching-holes-copies_pt","title":"Perfura&ccedil;&atilde;o em c&oacute;pias"}},[_vm._v("\n     Perfuração em cópias\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacking-copies-topic.html#using-offset-stacking-copies_pt","title":"Usando empilhamento de separa&ccedil;&atilde;o em c&oacute;pias"}},[_vm._v("\n     Usando empilhamento de separação em cópias\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_pt","title":"Criando um atalho de c&oacute;pia"}},[_vm._v("\n     Criando um atalho de cópia\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"e-mailing-chapter.html#e-mailing-chapter_pt","title":"E-mail"}},[_vm._v("\n    E-mail\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9851"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_pt","title":"Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner"}},[_vm._v("\n     Usando o alimentador automático de documentos e o vidro do scanner\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_pt","title":"Como enviar e- mail"}},[_vm._v("\n     Como enviar e- mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_pt","title":"Cria&ccedil;&atilde;o de um atalho de e-mail"}},[_vm._v("\n     Criação de um atalho de e-mail\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"faxing-chapter.html#faxing-chapter_pt","title":"Fax"}},[_vm._v("\n    Fax\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9945"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_pt","title":"Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner"}},[_vm._v("\n     Usando o alimentador automático de documentos e o vidro do scanner\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_pt","title":"Como enviar um fax"}},[_vm._v("\n     Como enviar um fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_pt","title":"Programa&ccedil;&atilde;o do envio de um fax"}},[_vm._v("\n     Programação do envio de um fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_pt","title":"Criando um atalho de destino de fax"}},[_vm._v("\n     Criando um atalho de destino de fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_pt","title":"Como alterar a resolu&ccedil;&atilde;o do fax"}},[_vm._v("\n     Como alterar a resolução do fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_pt","title":"Como ajustar a tonalidade do fax"}},[_vm._v("\n     Como ajustar a tonalidade do fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_pt","title":"Impress&atilde;o de um log de fax"}},[_vm._v("\n     Impressão de um log de fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_pt","title":"Como bloquear faxes indesejados"}},[_vm._v("\n     Como bloquear faxes indesejados\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_pt","title":"Como reter fax"}},[_vm._v("\n     Como reter fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_pt","title":"Como encaminhar fax"}},[_vm._v("\n     Como encaminhar fax\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"ftp-chapter.html#ftp-chapter_pt","title":"Examinar"}},[_vm._v("\n    Examinar\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10309"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_pt","title":"Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner"}},[_vm._v("\n     Usando o alimentador automático de documentos e o vidro do scanner\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_pt","title":"Digitaliza&ccedil;&atilde;o para um computador"}},[_vm._v("\n     Digitalização para um computador\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_pt","title":"Digitaliza&ccedil;&atilde;o para um servidor FTP"}},[_vm._v("\n     Digitalização para um servidor FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_pt","title":"Cria&ccedil;&atilde;o de um atalho de FTP"}},[_vm._v("\n     Criação de um atalho de FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_pt","title":"Digitaliza&ccedil;&atilde;o em uma pasta de rede"}},[_vm._v("\n     Digitalização em uma pasta de rede\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_pt","title":"Criando um atalho para a pasta da rede"}},[_vm._v("\n     Criando um atalho para a pasta da rede\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_pt","title":"Como digitalizar para uma unidade flash"}},[_vm._v("\n     Como digitalizar para uma unidade flash\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"use-printer-menus-chapter.html#use-printer-menus-chapter_pt","title":"Uso dos menus da impressora"}},[_vm._v("\n    Uso dos menus da impressora\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10612"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-mfp-topic.html#menus-map-mfp_pt","title":"Mapa de menus"}},[_vm._v("\n     Mapa de menus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e10975","title":"Dispositivo"}},[_vm._v("\n     Dispositivo\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e13263","title":"Print"}},[_vm._v("\n     Print\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e14531","title":"Papel"}},[_vm._v("\n     Papel\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e14900","title":"Copiar"}},[_vm._v("\n     Copiar\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e15489","title":"Fax"}},[_vm._v("\n     Fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e17895","title":"E-mail"}},[_vm._v("\n     E-mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e18945","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e19623","title":"Unidade USB"}},[_vm._v("\n     Unidade USB\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e20468","title":"Rede/portas"}},[_vm._v("\n     Rede/portas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e22659","title":"Servi&ccedil;os na nuvem"}},[_vm._v("\n     Serviços na nuvem\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e22716","title":"Seguran&ccedil;a"}},[_vm._v("\n     Segurança\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e23905","title":"Relat&oacute;rios"}},[_vm._v("\n     Relatórios\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_pt","title":"Solu&ccedil;&atilde;o de problemas"}},[_vm._v("\n     Solução de problemas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_pt","title":"Impress&atilde;o da P&aacute;gina de defini&ccedil;&otilde;es de menu"}},[_vm._v("\n     Impressão da Página de definições de menu\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_pt","title":"Manuten&ccedil;&atilde;o da impressora"}},[_vm._v("\n    Manutenção da impressora\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e24245"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_pt","title":"Verifica&ccedil;&atilde;o do status de pe&ccedil;as e suprimentos"}},[_vm._v("\n     Verificação do status de peças e suprimentos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_pt","title":"Configura&ccedil;&atilde;o de notifica&ccedil;&otilde;es de suprimento"}},[_vm._v("\n     Configuração de notificações de suprimento\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_pt","title":"Configurando os alertas de e-mail"}},[_vm._v("\n     Configurando os alertas de e-mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-reports-topic.html#viewing-reports_pt","title":"Exibindo relat&oacute;rios"}},[_vm._v("\n     Exibindo relatórios\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-parts-and-supplies-group.html#ordering-supplies-group_pt","title":"Solicita&ccedil;&atilde;o de pe&ccedil;as e suprimentos"}},[_vm._v("\n     Solicitação de peças e suprimentos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e24446","title":"Troca de pe&ccedil;as e suprimentos"}},[_vm._v("\n     Troca de peças e suprimentos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e24991","title":"Como limpar pe&ccedil;as da impressora"}},[_vm._v("\n     Como limpar peças da impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e25244","title":"Como economizar energia e papel"}},[_vm._v("\n     Como economizar energia e papel\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_pt","title":"Para mover a impressora para outro local"}},[_vm._v("\n     Para mover a impressora para outro local\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"shipping-printer-topic.html#shipping-printer_pt","title":"Transporte da impressora"}},[_vm._v("\n     Transporte da impressora\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_pt","title":"Solu&ccedil;&atilde;o de problemas"}},[_vm._v("\n    Solução de problemas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e25398"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-picker-topic.html#print-quality-problems-picker_pt","title":"Problemas de qualidade de impress&atilde;o"}},[_vm._v("\n     Problemas de qualidade de impressão\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_pt","title":"C&oacute;digos de erro da impressora"}},[_vm._v("\n     Códigos de erro da impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-is-poor-subgroup.html#d0e26352","title":"Problemas de impress&atilde;o"}},[_vm._v("\n     Problemas de impressão\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_pt","title":"A impressora n&atilde;o est&aacute; respondendo"}},[_vm._v("\n     A impressora não está respondendo\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_pt","title":"N&atilde;o foi poss&iacute;vel ler unidade flash"}},[_vm._v("\n     Não foi possível ler unidade flash\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_pt","title":"Ativando a porta USB"}},[_vm._v("\n     Ativando a porta USB\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"avoiding-jams-topic.html#d0e28917","title":"Limpeza de atolamentos"}},[_vm._v("\n     Limpeza de atolamentos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e29427","title":"Problemas de conex&atilde;o de rede"}},[_vm._v("\n     Problemas de conexão de rede\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e29655","title":"Problemas de op&ccedil;&otilde;es de hardware"}},[_vm._v("\n     Problemas de opções de hardware\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-missing-or-unresponsive-toner-cartridge-topic.html#d0e29781","title":"Problemas com suprimentos"}},[_vm._v("\n     Problemas com suprimentos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-envelope-seals-when-printing-topic.html#d0e29886","title":"Problemas na bandeja de papel"}},[_vm._v("\n     Problemas na bandeja de papel\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e30252","title":"Problemas de envio de e-mail"}},[_vm._v("\n     Problemas de envio de e-mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e30346","title":"Problemas de envio de fax"}},[_vm._v("\n     Problemas de envio de fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e30991","title":"Problemas de digitaliza&ccedil;&atilde;o"}},[_vm._v("\n     Problemas de digitalização\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_pt","title":"Entrando em contato com o suporte ao cliente"}},[_vm._v("\n     Entrando em contato com o suporte ao cliente\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_pt","title":"Reciclagem e descarte"}},[_vm._v("\n    Reciclagem e descarte\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e31787"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_pt","title":"Reciclagem de produtos da Lexmark"}},[_vm._v("\n     Reciclagem de produtos da Lexmark\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_pt","title":"Reciclagem de embalagens da Lexmark"}},[_vm._v("\n     Reciclagem de embalagens da Lexmark\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_pt","title":"Avisos"}},[_vm._v("\n    Avisos\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e31822"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e31825","title":"Informa&ccedil;&otilde;es sobre o produto"}},[_vm._v("\n     Informações sobre o produto\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e31842","title":"Aviso de edi&ccedil;&atilde;o"}},[_vm._v("\n     Aviso de edição\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_pt","title":"Marcas comerciais"}},[_vm._v("\n     Marcas comerciais\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_pt","title":"Avisos de licenciamento"}},[_vm._v("\n     Avisos de licenciamento\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_pt","title":"N&iacute;veis de emiss&atilde;o de ru&iacute;do"}},[_vm._v("\n     Níveis de emissão de ruído\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#weee-directive_pt","title":"Diretiva de res&iacute;duos de equipamentos el&eacute;tricos e eletr&ocirc;nicos (WEEE, Waste from Electrical and Electronic Equipment)"}},[_vm._v("\n     Diretiva de resíduos de equipamentos elétricos e eletrônicos (WEEE, Waste from Electrical and Electronic Equipment)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e31947","title":"Bateria recarreg&aacute;vel de &iacute;ons de l&iacute;tio"}},[_vm._v("\n     Bateria recarregável de íons de lítio\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_pt","title":"Descarte do produto"}},[_vm._v("\n     Descarte do produto\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_pt","title":"A devolu&ccedil;&atilde;o de cartuchos Lexmark para reutiliza&ccedil;&atilde;o ou reciclagem"}},[_vm._v("\n     A devolução de cartuchos Lexmark para reutilização ou reciclagem\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_pt","title":"Aviso de sensibilidade &agrave; est&aacute;tica"}},[_vm._v("\n     Aviso de sensibilidade à estática\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_pt","title":"ENERGY STAR"}},[_vm._v("\n     ENERGY STAR\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_pt","title":"Informa&ccedil;&otilde;es sobre temperatura"}},[_vm._v("\n     Informações sobre temperatura\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_pt","title":"Consumo de energia"}},[_vm._v("\n     Consumo de energia\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#notice-to-users-of-products-in-brazil_pt","title":"Aviso aos usu&aacute;rios de produtos no Brasil"}},[_vm._v("\n     Aviso aos usuários de produtos no Brasil\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_pt","title":"Avisos regulamentares para equipamentos de terminal de telecomunica&ccedil;&atilde;o"}},[_vm._v("\n     Avisos regulamentares para equipamentos de terminal de telecomunicação\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#notice-to-users-of-class-a-products-in-brazil_pt","title":"Aviso aos usu&aacute;rios de produtos de Classe A no Brasil"}},[_vm._v("\n     Aviso aos usuários de produtos de Classe A no Brasil\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#european-community-ec-directives-conformity-class-a_pt","title":"Conformidade com as diretivas da Comunidade Europeia (CE)"}},[_vm._v("\n     Conformidade com as diretivas da Comunidade Europeia (CE)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_pt","title":"Aviso de radiointerfer&ecirc;ncia"}},[_vm._v("\n     Aviso de radiointerferência\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js